function _typeof(e) {
  return (_typeof =
    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
      ? function (e) {
          return typeof e;
        }
      : function (e) {
          return e &&
            "function" == typeof Symbol &&
            e.constructor === Symbol &&
            e !== Symbol.prototype
            ? "symbol"
            : typeof e;
        })(e);
}
!(function (e, t) {
  "use strict";
  "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) &&
  "object" == _typeof(module.exports)
    ? (module.exports = e.document
        ? t(e, !0)
        : function (e) {
            if (!e.document)
              throw new Error("jQuery requires a window with a document");
            return t(e);
          })
    : t(e);
})("undefined" != typeof window ? window : this, function (S, e) {
  "use strict";
  function m(e) {
    return null != e && e === e.window;
  }
  var t = [],
    n = Object.getPrototypeOf,
    a = t.slice,
    g = t.flat
      ? function (e) {
          return t.flat.call(e);
        }
      : function (e) {
          return t.concat.apply([], e);
        },
    l = t.push,
    s = t.indexOf,
    i = {},
    r = i.toString,
    v = i.hasOwnProperty,
    o = v.toString,
    d = o.call(Object),
    y = {},
    b = function (e) {
      return "function" == typeof e && "number" != typeof e.nodeType;
    },
    C = S.document,
    c = { type: !0, src: !0, nonce: !0, noModule: !0 };
  function w(e, t, i) {
    var n,
      s,
      r = (i = i || C).createElement("script");
    if (((r.text = e), t))
      for (n in c)
        (s = t[n] || (t.getAttribute && t.getAttribute(n))) &&
          r.setAttribute(n, s);
    i.head.appendChild(r).parentNode.removeChild(r);
  }
  function x(e) {
    return null == e
      ? e + ""
      : "object" == _typeof(e) || "function" == typeof e
      ? i[r.call(e)] || "object"
      : _typeof(e);
  }
  var u = "3.5.1",
    E = function e(t, i) {
      return new e.fn.init(t, i);
    };
  function p(e) {
    var t = !!e && "length" in e && e.length,
      i = x(e);
    return (
      !b(e) &&
      !m(e) &&
      ("array" === i ||
        0 === t ||
        ("number" == typeof t && 0 < t && t - 1 in e))
    );
  }
  (E.fn = E.prototype =
    {
      jquery: u,
      constructor: E,
      length: 0,
      toArray: function () {
        return a.call(this);
      },
      get: function (e) {
        return null == e
          ? a.call(this)
          : e < 0
          ? this[e + this.length]
          : this[e];
      },
      pushStack: function (e) {
        var t = E.merge(this.constructor(), e);
        return (t.prevObject = this), t;
      },
      each: function (e) {
        return E.each(this, e);
      },
      map: function (i) {
        return this.pushStack(
          E.map(this, function (e, t) {
            return i.call(e, t, e);
          })
        );
      },
      slice: function () {
        return this.pushStack(a.apply(this, arguments));
      },
      first: function () {
        return this.eq(0);
      },
      last: function () {
        return this.eq(-1);
      },
      even: function () {
        return this.pushStack(
          E.grep(this, function (e, t) {
            return (t + 1) % 2;
          })
        );
      },
      odd: function () {
        return this.pushStack(
          E.grep(this, function (e, t) {
            return t % 2;
          })
        );
      },
      eq: function (e) {
        var t = this.length,
          i = +e + (e < 0 ? t : 0);
        return this.pushStack(0 <= i && i < t ? [this[i]] : []);
      },
      end: function () {
        return this.prevObject || this.constructor();
      },
      push: l,
      sort: t.sort,
      splice: t.splice,
    }),
    (E.extend = E.fn.extend =
      function () {
        var e,
          t,
          i,
          n,
          s,
          r,
          o = arguments[0] || {},
          a = 1,
          l = arguments.length,
          d = !1;
        for (
          "boolean" == typeof o && ((d = o), (o = arguments[a] || {}), a++),
            "object" == _typeof(o) || b(o) || (o = {}),
            a === l && ((o = this), a--);
          a < l;
          a++
        )
          if (null != (e = arguments[a]))
            for (t in e)
              (n = e[t]),
                "__proto__" !== t &&
                  o !== n &&
                  (d && n && (E.isPlainObject(n) || (s = Array.isArray(n)))
                    ? ((i = o[t]),
                      (r =
                        s && !Array.isArray(i)
                          ? []
                          : s || E.isPlainObject(i)
                          ? i
                          : {}),
                      (s = !1),
                      (o[t] = E.extend(d, r, n)))
                    : void 0 !== n && (o[t] = n));
        return o;
      }),
    E.extend({
      expando: "jQuery" + (u + Math.random()).replace(/\D/g, ""),
      isReady: !0,
      error: function (e) {
        throw new Error(e);
      },
      noop: function () {},
      isPlainObject: function (e) {
        var t, i;
        return !(
          !e ||
          "[object Object]" !== r.call(e) ||
          ((t = n(e)) &&
            ("function" !=
              typeof (i = v.call(t, "constructor") && t.constructor) ||
              o.call(i) !== d))
        );
      },
      isEmptyObject: function (e) {
        var t;
        for (t in e) return !1;
        return !0;
      },
      globalEval: function (e, t, i) {
        w(e, { nonce: t && t.nonce }, i);
      },
      each: function (e, t) {
        var i,
          n = 0;
        if (p(e))
          for (i = e.length; n < i && !1 !== t.call(e[n], n, e[n]); n++);
        else for (n in e) if (!1 === t.call(e[n], n, e[n])) break;
        return e;
      },
      makeArray: function (e, t) {
        var i = t || [];
        return (
          null != e &&
            (p(Object(e))
              ? E.merge(i, "string" == typeof e ? [e] : e)
              : l.call(i, e)),
          i
        );
      },
      inArray: function (e, t, i) {
        return null == t ? -1 : s.call(t, e, i);
      },
      merge: function (e, t) {
        for (var i = +t.length, n = 0, s = e.length; n < i; n++) e[s++] = t[n];
        return (e.length = s), e;
      },
      grep: function (e, t, i) {
        for (var n = [], s = 0, r = e.length, o = !i; s < r; s++)
          !t(e[s], s) != o && n.push(e[s]);
        return n;
      },
      map: function (e, t, i) {
        var n,
          s,
          r = 0,
          o = [];
        if (p(e))
          for (n = e.length; r < n; r++)
            null != (s = t(e[r], r, i)) && o.push(s);
        else for (r in e) null != (s = t(e[r], r, i)) && o.push(s);
        return g(o);
      },
      guid: 1,
      support: y,
    }),
    "function" == typeof Symbol && (E.fn[Symbol.iterator] = t[Symbol.iterator]),
    E.each(
      "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
        " "
      ),
      function (e, t) {
        i["[object " + t + "]"] = t.toLowerCase();
      }
    );
  var h = (function (i) {
    function u(e, t) {
      var i = "0x" + e.slice(1) - 65536;
      return (
        t ||
        (i < 0
          ? String.fromCharCode(65536 + i)
          : String.fromCharCode((i >> 10) | 55296, (1023 & i) | 56320))
      );
    }
    function s() {
      T();
    }
    var e,
      h,
      w,
      r,
      o,
      f,
      p,
      m,
      x,
      l,
      d,
      T,
      S,
      a,
      C,
      g,
      c,
      v,
      y,
      E = "sizzle" + +new Date(),
      b = i.document,
      k = 0,
      n = 0,
      $ = le(),
      A = le(),
      z = le(),
      M = le(),
      D = function (e, t) {
        return e === t && (d = !0), 0;
      },
      _ = {}.hasOwnProperty,
      t = [],
      P = t.pop,
      L = t.push,
      O = t.push,
      I = t.slice,
      N = function (e, t) {
        for (var i = 0, n = e.length; i < n; i++) if (e[i] === t) return i;
        return -1;
      },
      H =
        "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
      j = "[\\x20\\t\\r\\n\\f]",
      R =
        "(?:\\\\[\\da-fA-F]{1,6}" +
        j +
        "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
      q =
        "\\[" +
        j +
        "*(" +
        R +
        ")(?:" +
        j +
        "*([*^$|!~]?=)" +
        j +
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
        R +
        "))|)" +
        j +
        "*\\]",
      F =
        ":(" +
        R +
        ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
        q +
        ")*)|.*)\\)|)",
      B = new RegExp(j + "+", "g"),
      W = new RegExp("^" + j + "+|((?:^|[^\\\\])(?:\\\\.)*)" + j + "+$", "g"),
      G = new RegExp("^" + j + "*," + j + "*"),
      X = new RegExp("^" + j + "*([>+~]|" + j + ")" + j + "*"),
      Y = new RegExp(j + "|>"),
      U = new RegExp(F),
      V = new RegExp("^" + R + "$"),
      K = {
        ID: new RegExp("^#(" + R + ")"),
        CLASS: new RegExp("^\\.(" + R + ")"),
        TAG: new RegExp("^(" + R + "|[*])"),
        ATTR: new RegExp("^" + q),
        PSEUDO: new RegExp("^" + F),
        CHILD: new RegExp(
          "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
            j +
            "*(even|odd|(([+-]|)(\\d*)n|)" +
            j +
            "*(?:([+-]|)" +
            j +
            "*(\\d+)|))" +
            j +
            "*\\)|)",
          "i"
        ),
        bool: new RegExp("^(?:" + H + ")$", "i"),
        needsContext: new RegExp(
          "^" +
            j +
            "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
            j +
            "*((?:-\\d)?\\d*)" +
            j +
            "*\\)|)(?=[^-]|$)",
          "i"
        ),
      },
      Z = /HTML$/i,
      Q = /^(?:input|select|textarea|button)$/i,
      J = /^h\d$/i,
      ee = /^[^{]+\{\s*\[native \w/,
      te = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
      ie = /[+~]/,
      ne = new RegExp("\\\\[\\da-fA-F]{1,6}" + j + "?|\\\\([^\\r\\n\\f])", "g"),
      se = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
      re = function (e, t) {
        return t
          ? "\0" === e
            ? "�"
            : e.slice(0, -1) +
              "\\" +
              e.charCodeAt(e.length - 1).toString(16) +
              " "
          : "\\" + e;
      },
      oe = we(
        function (e) {
          return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
        },
        { dir: "parentNode", next: "legend" }
      );
    try {
      O.apply((t = I.call(b.childNodes)), b.childNodes),
        t[b.childNodes.length].nodeType;
    } catch (e) {
      O = {
        apply: t.length
          ? function (e, t) {
              L.apply(e, I.call(t));
            }
          : function (e, t) {
              for (var i = e.length, n = 0; (e[i++] = t[n++]); );
              e.length = i - 1;
            },
      };
    }
    function ae(e, t, i, n) {
      var s,
        r,
        o,
        a,
        l,
        d,
        c,
        u = t && t.ownerDocument,
        p = t ? t.nodeType : 9;
      if (
        ((i = i || []),
        "string" != typeof e || !e || (1 !== p && 9 !== p && 11 !== p))
      )
        return i;
      if (!n && (T(t), (t = t || S), C)) {
        if (11 !== p && (l = te.exec(e)))
          if ((s = l[1])) {
            if (9 === p) {
              if (!(o = t.getElementById(s))) return i;
              if (o.id === s) return i.push(o), i;
            } else if (u && (o = u.getElementById(s)) && y(t, o) && o.id === s)
              return i.push(o), i;
          } else {
            if (l[2]) return O.apply(i, t.getElementsByTagName(e)), i;
            if (
              (s = l[3]) &&
              h.getElementsByClassName &&
              t.getElementsByClassName
            )
              return O.apply(i, t.getElementsByClassName(s)), i;
          }
        if (
          h.qsa &&
          !M[e + " "] &&
          (!g || !g.test(e)) &&
          (1 !== p || "object" !== t.nodeName.toLowerCase())
        ) {
          if (((c = e), (u = t), 1 === p && (Y.test(e) || X.test(e)))) {
            for (
              ((u = (ie.test(e) && ve(t.parentNode)) || t) === t && h.scope) ||
                ((a = t.getAttribute("id"))
                  ? (a = a.replace(se, re))
                  : t.setAttribute("id", (a = E))),
                r = (d = f(e)).length;
              r--;

            )
              d[r] = (a ? "#" + a : ":scope") + " " + be(d[r]);
            c = d.join(",");
          }
          try {
            return O.apply(i, u.querySelectorAll(c)), i;
          } catch (t) {
            M(e, !0);
          } finally {
            a === E && t.removeAttribute("id");
          }
        }
      }
      return m(e.replace(W, "$1"), t, i, n);
    }
    function le() {
      var n = [];
      return function e(t, i) {
        return (
          n.push(t + " ") > w.cacheLength && delete e[n.shift()],
          (e[t + " "] = i)
        );
      };
    }
    function de(e) {
      return (e[E] = !0), e;
    }
    function ce(e) {
      var t = S.createElement("fieldset");
      try {
        return !!e(t);
      } catch (e) {
        return !1;
      } finally {
        t.parentNode && t.parentNode.removeChild(t), (t = null);
      }
    }
    function ue(e, t) {
      for (var i = e.split("|"), n = i.length; n--; ) w.attrHandle[i[n]] = t;
    }
    function pe(e, t) {
      var i = t && e,
        n =
          i &&
          1 === e.nodeType &&
          1 === t.nodeType &&
          e.sourceIndex - t.sourceIndex;
      if (n) return n;
      if (i) for (; (i = i.nextSibling); ) if (i === t) return -1;
      return e ? 1 : -1;
    }
    function he(t) {
      return function (e) {
        return "input" === e.nodeName.toLowerCase() && e.type === t;
      };
    }
    function fe(i) {
      return function (e) {
        var t = e.nodeName.toLowerCase();
        return ("input" === t || "button" === t) && e.type === i;
      };
    }
    function me(t) {
      return function (e) {
        return "form" in e
          ? e.parentNode && !1 === e.disabled
            ? "label" in e
              ? "label" in e.parentNode
                ? e.parentNode.disabled === t
                : e.disabled === t
              : e.isDisabled === t || (e.isDisabled !== !t && oe(e) === t)
            : e.disabled === t
          : "label" in e && e.disabled === t;
      };
    }
    function ge(o) {
      return de(function (r) {
        return (
          (r = +r),
          de(function (e, t) {
            for (var i, n = o([], e.length, r), s = n.length; s--; )
              e[(i = n[s])] && (e[i] = !(t[i] = e[i]));
          })
        );
      });
    }
    function ve(e) {
      return e && void 0 !== e.getElementsByTagName && e;
    }
    for (e in ((h = ae.support = {}),
    (o = ae.isXML =
      function (e) {
        var t = e.namespaceURI,
          i = (e.ownerDocument || e).documentElement;
        return !Z.test(t || (i && i.nodeName) || "HTML");
      }),
    (T = ae.setDocument =
      function (e) {
        var t,
          i,
          n = e ? e.ownerDocument || e : b;
        return (
          n != S &&
            9 === n.nodeType &&
            n.documentElement &&
            ((a = (S = n).documentElement),
            (C = !o(S)),
            b != S &&
              (i = S.defaultView) &&
              i.top !== i &&
              (i.addEventListener
                ? i.addEventListener("unload", s, !1)
                : i.attachEvent && i.attachEvent("onunload", s)),
            (h.scope = ce(function (e) {
              return (
                a.appendChild(e).appendChild(S.createElement("div")),
                void 0 !== e.querySelectorAll &&
                  !e.querySelectorAll(":scope fieldset div").length
              );
            })),
            (h.attributes = ce(function (e) {
              return (e.className = "i"), !e.getAttribute("className");
            })),
            (h.getElementsByTagName = ce(function (e) {
              return (
                e.appendChild(S.createComment("")),
                !e.getElementsByTagName("*").length
              );
            })),
            (h.getElementsByClassName = ee.test(S.getElementsByClassName)),
            (h.getById = ce(function (e) {
              return (
                (a.appendChild(e).id = E),
                !S.getElementsByName || !S.getElementsByName(E).length
              );
            })),
            h.getById
              ? ((w.filter.ID = function (e) {
                  var t = e.replace(ne, u);
                  return function (e) {
                    return e.getAttribute("id") === t;
                  };
                }),
                (w.find.ID = function (e, t) {
                  if (void 0 !== t.getElementById && C) {
                    var i = t.getElementById(e);
                    return i ? [i] : [];
                  }
                }))
              : ((w.filter.ID = function (e) {
                  var i = e.replace(ne, u);
                  return function (e) {
                    var t =
                      void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                    return t && t.value === i;
                  };
                }),
                (w.find.ID = function (e, t) {
                  if (void 0 !== t.getElementById && C) {
                    var i,
                      n,
                      s,
                      r = t.getElementById(e);
                    if (r) {
                      if ((i = r.getAttributeNode("id")) && i.value === e)
                        return [r];
                      for (s = t.getElementsByName(e), n = 0; (r = s[n++]); )
                        if ((i = r.getAttributeNode("id")) && i.value === e)
                          return [r];
                    }
                    return [];
                  }
                })),
            (w.find.TAG = h.getElementsByTagName
              ? function (e, t) {
                  return void 0 !== t.getElementsByTagName
                    ? t.getElementsByTagName(e)
                    : h.qsa
                    ? t.querySelectorAll(e)
                    : void 0;
                }
              : function (e, t) {
                  var i,
                    n = [],
                    s = 0,
                    r = t.getElementsByTagName(e);
                  if ("*" !== e) return r;
                  for (; (i = r[s++]); ) 1 === i.nodeType && n.push(i);
                  return n;
                }),
            (w.find.CLASS =
              h.getElementsByClassName &&
              function (e, t) {
                if (void 0 !== t.getElementsByClassName && C)
                  return t.getElementsByClassName(e);
              }),
            (c = []),
            (g = []),
            (h.qsa = ee.test(S.querySelectorAll)) &&
              (ce(function (e) {
                var t;
                (a.appendChild(e).innerHTML =
                  "<a id='" +
                  E +
                  "'></a><select id='" +
                  E +
                  "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                  e.querySelectorAll("[msallowcapture^='']").length &&
                    g.push("[*^$]=" + j + "*(?:''|\"\")"),
                  e.querySelectorAll("[selected]").length ||
                    g.push("\\[" + j + "*(?:value|" + H + ")"),
                  e.querySelectorAll("[id~=" + E + "-]").length || g.push("~="),
                  (t = S.createElement("input")).setAttribute("name", ""),
                  e.appendChild(t),
                  e.querySelectorAll("[name='']").length ||
                    g.push("\\[" + j + "*name" + j + "*=" + j + "*(?:''|\"\")"),
                  e.querySelectorAll(":checked").length || g.push(":checked"),
                  e.querySelectorAll("a#" + E + "+*").length ||
                    g.push(".#.+[+~]"),
                  e.querySelectorAll("\\\f"),
                  g.push("[\\r\\n\\f]");
              }),
              ce(function (e) {
                e.innerHTML =
                  "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                var t = S.createElement("input");
                t.setAttribute("type", "hidden"),
                  e.appendChild(t).setAttribute("name", "D"),
                  e.querySelectorAll("[name=d]").length &&
                    g.push("name" + j + "*[*^$|!~]?="),
                  2 !== e.querySelectorAll(":enabled").length &&
                    g.push(":enabled", ":disabled"),
                  (a.appendChild(e).disabled = !0),
                  2 !== e.querySelectorAll(":disabled").length &&
                    g.push(":enabled", ":disabled"),
                  e.querySelectorAll("*,:x"),
                  g.push(",.*:");
              })),
            (h.matchesSelector = ee.test(
              (v =
                a.matches ||
                a.webkitMatchesSelector ||
                a.mozMatchesSelector ||
                a.oMatchesSelector ||
                a.msMatchesSelector)
            )) &&
              ce(function (e) {
                (h.disconnectedMatch = v.call(e, "*")),
                  v.call(e, "[s!='']:x"),
                  c.push("!=", F);
              }),
            (g = g.length && new RegExp(g.join("|"))),
            (c = c.length && new RegExp(c.join("|"))),
            (t = ee.test(a.compareDocumentPosition)),
            (y =
              t || ee.test(a.contains)
                ? function (e, t) {
                    var i = 9 === e.nodeType ? e.documentElement : e,
                      n = t && t.parentNode;
                    return (
                      e === n ||
                      !(
                        !n ||
                        1 !== n.nodeType ||
                        !(i.contains
                          ? i.contains(n)
                          : e.compareDocumentPosition &&
                            16 & e.compareDocumentPosition(n))
                      )
                    );
                  }
                : function (e, t) {
                    if (t) for (; (t = t.parentNode); ) if (t === e) return !0;
                    return !1;
                  }),
            (D = t
              ? function (e, t) {
                  if (e === t) return (d = !0), 0;
                  var i =
                    !e.compareDocumentPosition - !t.compareDocumentPosition;
                  return (
                    i ||
                    (1 &
                      (i =
                        (e.ownerDocument || e) == (t.ownerDocument || t)
                          ? e.compareDocumentPosition(t)
                          : 1) ||
                    (!h.sortDetached && t.compareDocumentPosition(e) === i)
                      ? e == S || (e.ownerDocument == b && y(b, e))
                        ? -1
                        : t == S || (t.ownerDocument == b && y(b, t))
                        ? 1
                        : l
                        ? N(l, e) - N(l, t)
                        : 0
                      : 4 & i
                      ? -1
                      : 1)
                  );
                }
              : function (e, t) {
                  if (e === t) return (d = !0), 0;
                  var i,
                    n = 0,
                    s = e.parentNode,
                    r = t.parentNode,
                    o = [e],
                    a = [t];
                  if (!s || !r)
                    return e == S
                      ? -1
                      : t == S
                      ? 1
                      : s
                      ? -1
                      : r
                      ? 1
                      : l
                      ? N(l, e) - N(l, t)
                      : 0;
                  if (s === r) return pe(e, t);
                  for (i = e; (i = i.parentNode); ) o.unshift(i);
                  for (i = t; (i = i.parentNode); ) a.unshift(i);
                  for (; o[n] === a[n]; ) n++;
                  return n
                    ? pe(o[n], a[n])
                    : o[n] == b
                    ? -1
                    : a[n] == b
                    ? 1
                    : 0;
                })),
          S
        );
      }),
    (ae.matches = function (e, t) {
      return ae(e, null, null, t);
    }),
    (ae.matchesSelector = function (e, t) {
      if (
        (T(e),
        h.matchesSelector &&
          C &&
          !M[t + " "] &&
          (!c || !c.test(t)) &&
          (!g || !g.test(t)))
      )
        try {
          var i = v.call(e, t);
          if (
            i ||
            h.disconnectedMatch ||
            (e.document && 11 !== e.document.nodeType)
          )
            return i;
        } catch (e) {
          M(t, !0);
        }
      return 0 < ae(t, S, null, [e]).length;
    }),
    (ae.contains = function (e, t) {
      return (e.ownerDocument || e) != S && T(e), y(e, t);
    }),
    (ae.attr = function (e, t) {
      (e.ownerDocument || e) != S && T(e);
      var i = w.attrHandle[t.toLowerCase()],
        n = i && _.call(w.attrHandle, t.toLowerCase()) ? i(e, t, !C) : void 0;
      return void 0 !== n
        ? n
        : h.attributes || !C
        ? e.getAttribute(t)
        : (n = e.getAttributeNode(t)) && n.specified
        ? n.value
        : null;
    }),
    (ae.escape = function (e) {
      return (e + "").replace(se, re);
    }),
    (ae.error = function (e) {
      throw new Error("Syntax error, unrecognized expression: " + e);
    }),
    (ae.uniqueSort = function (e) {
      var t,
        i = [],
        n = 0,
        s = 0;
      if (
        ((d = !h.detectDuplicates),
        (l = !h.sortStable && e.slice(0)),
        e.sort(D),
        d)
      ) {
        for (; (t = e[s++]); ) t === e[s] && (n = i.push(s));
        for (; n--; ) e.splice(i[n], 1);
      }
      return (l = null), e;
    }),
    (r = ae.getText =
      function (e) {
        var t,
          i = "",
          n = 0,
          s = e.nodeType;
        if (s) {
          if (1 === s || 9 === s || 11 === s) {
            if ("string" == typeof e.textContent) return e.textContent;
            for (e = e.firstChild; e; e = e.nextSibling) i += r(e);
          } else if (3 === s || 4 === s) return e.nodeValue;
        } else for (; (t = e[n++]); ) i += r(t);
        return i;
      }),
    ((w = ae.selectors =
      {
        cacheLength: 50,
        createPseudo: de,
        match: K,
        attrHandle: {},
        find: {},
        relative: {
          ">": { dir: "parentNode", first: !0 },
          " ": { dir: "parentNode" },
          "+": { dir: "previousSibling", first: !0 },
          "~": { dir: "previousSibling" },
        },
        preFilter: {
          ATTR: function (e) {
            return (
              (e[1] = e[1].replace(ne, u)),
              (e[3] = (e[3] || e[4] || e[5] || "").replace(ne, u)),
              "~=" === e[2] && (e[3] = " " + e[3] + " "),
              e.slice(0, 4)
            );
          },
          CHILD: function (e) {
            return (
              (e[1] = e[1].toLowerCase()),
              "nth" === e[1].slice(0, 3)
                ? (e[3] || ae.error(e[0]),
                  (e[4] = +(e[4]
                    ? e[5] + (e[6] || 1)
                    : 2 * ("even" === e[3] || "odd" === e[3]))),
                  (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                : e[3] && ae.error(e[0]),
              e
            );
          },
          PSEUDO: function (e) {
            var t,
              i = !e[6] && e[2];
            return K.CHILD.test(e[0])
              ? null
              : (e[3]
                  ? (e[2] = e[4] || e[5] || "")
                  : i &&
                    U.test(i) &&
                    (t = f(i, !0)) &&
                    (t = i.indexOf(")", i.length - t) - i.length) &&
                    ((e[0] = e[0].slice(0, t)), (e[2] = i.slice(0, t))),
                e.slice(0, 3));
          },
        },
        filter: {
          TAG: function (e) {
            var t = e.replace(ne, u).toLowerCase();
            return "*" === e
              ? function () {
                  return !0;
                }
              : function (e) {
                  return e.nodeName && e.nodeName.toLowerCase() === t;
                };
          },
          CLASS: function (e) {
            var t = $[e + " "];
            return (
              t ||
              ((t = new RegExp("(^|" + j + ")" + e + "(" + j + "|$)")) &&
                $(e, function (e) {
                  return t.test(
                    ("string" == typeof e.className && e.className) ||
                      (void 0 !== e.getAttribute && e.getAttribute("class")) ||
                      ""
                  );
                }))
            );
          },
          ATTR: function (i, n, s) {
            return function (e) {
              var t = ae.attr(e, i);
              return null == t
                ? "!=" === n
                : !n ||
                    ((t += ""),
                    "=" === n
                      ? t === s
                      : "!=" === n
                      ? t !== s
                      : "^=" === n
                      ? s && 0 === t.indexOf(s)
                      : "*=" === n
                      ? s && -1 < t.indexOf(s)
                      : "$=" === n
                      ? s && t.slice(-s.length) === s
                      : "~=" === n
                      ? -1 < (" " + t.replace(B, " ") + " ").indexOf(s)
                      : "|=" === n &&
                        (t === s || t.slice(0, s.length + 1) === s + "-"));
            };
          },
          CHILD: function (f, e, t, m, g) {
            var v = "nth" !== f.slice(0, 3),
              y = "last" !== f.slice(-4),
              b = "of-type" === e;
            return 1 === m && 0 === g
              ? function (e) {
                  return !!e.parentNode;
                }
              : function (e, t, i) {
                  var n,
                    s,
                    r,
                    o,
                    a,
                    l,
                    d = v != y ? "nextSibling" : "previousSibling",
                    c = e.parentNode,
                    u = b && e.nodeName.toLowerCase(),
                    p = !i && !b,
                    h = !1;
                  if (c) {
                    if (v) {
                      for (; d; ) {
                        for (o = e; (o = o[d]); )
                          if (
                            b
                              ? o.nodeName.toLowerCase() === u
                              : 1 === o.nodeType
                          )
                            return !1;
                        l = d = "only" === f && !l && "nextSibling";
                      }
                      return !0;
                    }
                    if (((l = [y ? c.firstChild : c.lastChild]), y && p)) {
                      for (
                        h =
                          (a =
                            (n =
                              (s =
                                (r = (o = c)[E] || (o[E] = {}))[o.uniqueID] ||
                                (r[o.uniqueID] = {}))[f] || [])[0] === k &&
                            n[1]) && n[2],
                          o = a && c.childNodes[a];
                        (o = (++a && o && o[d]) || (h = a = 0) || l.pop());

                      )
                        if (1 === o.nodeType && ++h && o === e) {
                          s[f] = [k, a, h];
                          break;
                        }
                    } else if (
                      (p &&
                        (h = a =
                          (n =
                            (s =
                              (r = (o = e)[E] || (o[E] = {}))[o.uniqueID] ||
                              (r[o.uniqueID] = {}))[f] || [])[0] === k && n[1]),
                      !1 === h)
                    )
                      for (
                        ;
                        (o = (++a && o && o[d]) || (h = a = 0) || l.pop()) &&
                        ((b
                          ? o.nodeName.toLowerCase() !== u
                          : 1 !== o.nodeType) ||
                          !++h ||
                          (p &&
                            ((s =
                              (r = o[E] || (o[E] = {}))[o.uniqueID] ||
                              (r[o.uniqueID] = {}))[f] = [k, h]),
                          o !== e));

                      );
                    return (h -= g) === m || (h % m == 0 && 0 <= h / m);
                  }
                };
          },
          PSEUDO: function (e, r) {
            var t,
              o =
                w.pseudos[e] ||
                w.setFilters[e.toLowerCase()] ||
                ae.error("unsupported pseudo: " + e);
            return o[E]
              ? o(r)
              : 1 < o.length
              ? ((t = [e, e, "", r]),
                w.setFilters.hasOwnProperty(e.toLowerCase())
                  ? de(function (e, t) {
                      for (var i, n = o(e, r), s = n.length; s--; )
                        e[(i = N(e, n[s]))] = !(t[i] = n[s]);
                    })
                  : function (e) {
                      return o(e, 0, t);
                    })
              : o;
          },
        },
        pseudos: {
          not: de(function (e) {
            var n = [],
              s = [],
              a = p(e.replace(W, "$1"));
            return a[E]
              ? de(function (e, t, i, n) {
                  for (var s, r = a(e, null, n, []), o = e.length; o--; )
                    (s = r[o]) && (e[o] = !(t[o] = s));
                })
              : function (e, t, i) {
                  return (n[0] = e), a(n, null, i, s), (n[0] = null), !s.pop();
                };
          }),
          has: de(function (t) {
            return function (e) {
              return 0 < ae(t, e).length;
            };
          }),
          contains: de(function (t) {
            return (
              (t = t.replace(ne, u)),
              function (e) {
                return -1 < (e.textContent || r(e)).indexOf(t);
              }
            );
          }),
          lang: de(function (i) {
            return (
              V.test(i || "") || ae.error("unsupported lang: " + i),
              (i = i.replace(ne, u).toLowerCase()),
              function (e) {
                var t;
                do {
                  if (
                    (t = C
                      ? e.lang
                      : e.getAttribute("xml:lang") || e.getAttribute("lang"))
                  )
                    return (
                      (t = t.toLowerCase()) === i || 0 === t.indexOf(i + "-")
                    );
                } while ((e = e.parentNode) && 1 === e.nodeType);
                return !1;
              }
            );
          }),
          target: function (e) {
            var t = i.location && i.location.hash;
            return t && t.slice(1) === e.id;
          },
          root: function (e) {
            return e === a;
          },
          focus: function (e) {
            return (
              e === S.activeElement &&
              (!S.hasFocus || S.hasFocus()) &&
              !!(e.type || e.href || ~e.tabIndex)
            );
          },
          enabled: me(!1),
          disabled: me(!0),
          checked: function (e) {
            var t = e.nodeName.toLowerCase();
            return (
              ("input" === t && !!e.checked) || ("option" === t && !!e.selected)
            );
          },
          selected: function (e) {
            return (
              e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
            );
          },
          empty: function (e) {
            for (e = e.firstChild; e; e = e.nextSibling)
              if (e.nodeType < 6) return !1;
            return !0;
          },
          parent: function (e) {
            return !w.pseudos.empty(e);
          },
          header: function (e) {
            return J.test(e.nodeName);
          },
          input: function (e) {
            return Q.test(e.nodeName);
          },
          button: function (e) {
            var t = e.nodeName.toLowerCase();
            return ("input" === t && "button" === e.type) || "button" === t;
          },
          text: function (e) {
            var t;
            return (
              "input" === e.nodeName.toLowerCase() &&
              "text" === e.type &&
              (null == (t = e.getAttribute("type")) ||
                "text" === t.toLowerCase())
            );
          },
          first: ge(function () {
            return [0];
          }),
          last: ge(function (e, t) {
            return [t - 1];
          }),
          eq: ge(function (e, t, i) {
            return [i < 0 ? i + t : i];
          }),
          even: ge(function (e, t) {
            for (var i = 0; i < t; i += 2) e.push(i);
            return e;
          }),
          odd: ge(function (e, t) {
            for (var i = 1; i < t; i += 2) e.push(i);
            return e;
          }),
          lt: ge(function (e, t, i) {
            for (var n = i < 0 ? i + t : t < i ? t : i; 0 <= --n; ) e.push(n);
            return e;
          }),
          gt: ge(function (e, t, i) {
            for (var n = i < 0 ? i + t : i; ++n < t; ) e.push(n);
            return e;
          }),
        },
      }).pseudos.nth = w.pseudos.eq),
    { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
      w.pseudos[e] = he(e);
    for (e in { submit: !0, reset: !0 }) w.pseudos[e] = fe(e);
    function ye() {}
    function be(e) {
      for (var t = 0, i = e.length, n = ""; t < i; t++) n += e[t].value;
      return n;
    }
    function we(a, e, t) {
      var l = e.dir,
        d = e.next,
        c = d || l,
        u = t && "parentNode" === c,
        p = n++;
      return e.first
        ? function (e, t, i) {
            for (; (e = e[l]); ) if (1 === e.nodeType || u) return a(e, t, i);
            return !1;
          }
        : function (e, t, i) {
            var n,
              s,
              r,
              o = [k, p];
            if (i) {
              for (; (e = e[l]); )
                if ((1 === e.nodeType || u) && a(e, t, i)) return !0;
            } else
              for (; (e = e[l]); )
                if (1 === e.nodeType || u)
                  if (
                    ((s =
                      (r = e[E] || (e[E] = {}))[e.uniqueID] ||
                      (r[e.uniqueID] = {})),
                    d && d === e.nodeName.toLowerCase())
                  )
                    e = e[l] || e;
                  else {
                    if ((n = s[c]) && n[0] === k && n[1] === p)
                      return (o[2] = n[2]);
                    if (((s[c] = o)[2] = a(e, t, i))) return !0;
                  }
            return !1;
          };
    }
    function xe(s) {
      return 1 < s.length
        ? function (e, t, i) {
            for (var n = s.length; n--; ) if (!s[n](e, t, i)) return !1;
            return !0;
          }
        : s[0];
    }
    function Te(e, t, i, n, s) {
      for (var r, o = [], a = 0, l = e.length, d = null != t; a < l; a++)
        (r = e[a]) && ((i && !i(r, n, s)) || (o.push(r), d && t.push(a)));
      return o;
    }
    function Se(h, f, m, g, v, e) {
      return (
        g && !g[E] && (g = Se(g)),
        v && !v[E] && (v = Se(v, e)),
        de(function (e, t, i, n) {
          var s,
            r,
            o,
            a = [],
            l = [],
            d = t.length,
            c =
              e ||
              (function (e, t, i) {
                for (var n = 0, s = t.length; n < s; n++) ae(e, t[n], i);
                return i;
              })(f || "*", i.nodeType ? [i] : i, []),
            u = !h || (!e && f) ? c : Te(c, a, h, i, n),
            p = m ? (v || (e ? h : d || g) ? [] : t) : u;
          if ((m && m(u, p, i, n), g))
            for (s = Te(p, l), g(s, [], i, n), r = s.length; r--; )
              (o = s[r]) && (p[l[r]] = !(u[l[r]] = o));
          if (e) {
            if (v || h) {
              if (v) {
                for (s = [], r = p.length; r--; )
                  (o = p[r]) && s.push((u[r] = o));
                v(null, (p = []), s, n);
              }
              for (r = p.length; r--; )
                (o = p[r]) &&
                  -1 < (s = v ? N(e, o) : a[r]) &&
                  (e[s] = !(t[s] = o));
            }
          } else (p = Te(p === t ? p.splice(d, p.length) : p)), v ? v(null, t, p, n) : O.apply(t, p);
        })
      );
    }
    function Ce(e) {
      for (
        var s,
          t,
          i,
          n = e.length,
          r = w.relative[e[0].type],
          o = r || w.relative[" "],
          a = r ? 1 : 0,
          l = we(
            function (e) {
              return e === s;
            },
            o,
            !0
          ),
          d = we(
            function (e) {
              return -1 < N(s, e);
            },
            o,
            !0
          ),
          c = [
            function (e, t, i) {
              var n =
                (!r && (i || t !== x)) || ((s = t).nodeType ? l : d)(e, t, i);
              return (s = null), n;
            },
          ];
        a < n;
        a++
      )
        if ((t = w.relative[e[a].type])) c = [we(xe(c), t)];
        else {
          if ((t = w.filter[e[a].type].apply(null, e[a].matches))[E]) {
            for (i = ++a; i < n && !w.relative[e[i].type]; i++);
            return Se(
              1 < a && xe(c),
              1 < a &&
                be(
                  e
                    .slice(0, a - 1)
                    .concat({ value: " " === e[a - 2].type ? "*" : "" })
                ).replace(W, "$1"),
              t,
              a < i && Ce(e.slice(a, i)),
              i < n && Ce((e = e.slice(i))),
              i < n && be(e)
            );
          }
          c.push(t);
        }
      return xe(c);
    }
    return (
      (ye.prototype = w.filters = w.pseudos),
      (w.setFilters = new ye()),
      (f = ae.tokenize =
        function (e, t) {
          var i,
            n,
            s,
            r,
            o,
            a,
            l,
            d = A[e + " "];
          if (d) return t ? 0 : d.slice(0);
          for (o = e, a = [], l = w.preFilter; o; ) {
            for (r in ((i && !(n = G.exec(o))) ||
              (n && (o = o.slice(n[0].length) || o), a.push((s = []))),
            (i = !1),
            (n = X.exec(o)) &&
              ((i = n.shift()),
              s.push({ value: i, type: n[0].replace(W, " ") }),
              (o = o.slice(i.length))),
            w.filter))
              !(n = K[r].exec(o)) ||
                (l[r] && !(n = l[r](n))) ||
                ((i = n.shift()),
                s.push({ value: i, type: r, matches: n }),
                (o = o.slice(i.length)));
            if (!i) break;
          }
          return t ? o.length : o ? ae.error(e) : A(e, a).slice(0);
        }),
      (p = ae.compile =
        function (e, t) {
          var i,
            g,
            v,
            y,
            b,
            n,
            s = [],
            r = [],
            o = z[e + " "];
          if (!o) {
            for (i = (t = t || f(e)).length; i--; )
              (o = Ce(t[i]))[E] ? s.push(o) : r.push(o);
            (o = z(
              e,
              ((g = r),
              (y = 0 < (v = s).length),
              (b = 0 < g.length),
              (n = function (e, t, i, n, s) {
                var r,
                  o,
                  a,
                  l = 0,
                  d = "0",
                  c = e && [],
                  u = [],
                  p = x,
                  h = e || (b && w.find.TAG("*", s)),
                  f = (k += null == p ? 1 : Math.random() || 0.1),
                  m = h.length;
                for (
                  s && (x = t == S || t || s);
                  d !== m && null != (r = h[d]);
                  d++
                ) {
                  if (b && r) {
                    for (
                      o = 0, t || r.ownerDocument == S || (T(r), (i = !C));
                      (a = g[o++]);

                    )
                      if (a(r, t || S, i)) {
                        n.push(r);
                        break;
                      }
                    s && (k = f);
                  }
                  y && ((r = !a && r) && l--, e && c.push(r));
                }
                if (((l += d), y && d !== l)) {
                  for (o = 0; (a = v[o++]); ) a(c, u, t, i);
                  if (e) {
                    if (0 < l) for (; d--; ) c[d] || u[d] || (u[d] = P.call(n));
                    u = Te(u);
                  }
                  O.apply(n, u),
                    s &&
                      !e &&
                      0 < u.length &&
                      1 < l + v.length &&
                      ae.uniqueSort(n);
                }
                return s && ((k = f), (x = p)), c;
              }),
              y ? de(n) : n)
            )).selector = e;
          }
          return o;
        }),
      (m = ae.select =
        function (e, t, i, n) {
          var s,
            r,
            o,
            a,
            l,
            d = "function" == typeof e && e,
            c = !n && f((e = d.selector || e));
          if (((i = i || []), 1 === c.length)) {
            if (
              2 < (r = c[0] = c[0].slice(0)).length &&
              "ID" === (o = r[0]).type &&
              9 === t.nodeType &&
              C &&
              w.relative[r[1].type]
            ) {
              if (!(t = (w.find.ID(o.matches[0].replace(ne, u), t) || [])[0]))
                return i;
              d && (t = t.parentNode), (e = e.slice(r.shift().value.length));
            }
            for (
              s = K.needsContext.test(e) ? 0 : r.length;
              s-- && ((o = r[s]), !w.relative[(a = o.type)]);

            )
              if (
                (l = w.find[a]) &&
                (n = l(
                  o.matches[0].replace(ne, u),
                  (ie.test(r[0].type) && ve(t.parentNode)) || t
                ))
              ) {
                if ((r.splice(s, 1), !(e = n.length && be(r))))
                  return O.apply(i, n), i;
                break;
              }
          }
          return (
            (d || p(e, c))(
              n,
              t,
              !C,
              i,
              !t || (ie.test(e) && ve(t.parentNode)) || t
            ),
            i
          );
        }),
      (h.sortStable = E.split("").sort(D).join("") === E),
      (h.detectDuplicates = !!d),
      T(),
      (h.sortDetached = ce(function (e) {
        return 1 & e.compareDocumentPosition(S.createElement("fieldset"));
      })),
      ce(function (e) {
        return (
          (e.innerHTML = "<a href='#'></a>"),
          "#" === e.firstChild.getAttribute("href")
        );
      }) ||
        ue("type|href|height|width", function (e, t, i) {
          if (!i) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
        }),
      (h.attributes &&
        ce(function (e) {
          return (
            (e.innerHTML = "<input/>"),
            e.firstChild.setAttribute("value", ""),
            "" === e.firstChild.getAttribute("value")
          );
        })) ||
        ue("value", function (e, t, i) {
          if (!i && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
        }),
      ce(function (e) {
        return null == e.getAttribute("disabled");
      }) ||
        ue(H, function (e, t, i) {
          var n;
          if (!i)
            return !0 === e[t]
              ? t.toLowerCase()
              : (n = e.getAttributeNode(t)) && n.specified
              ? n.value
              : null;
        }),
      ae
    );
  })(S);
  (E.find = h),
    (E.expr = h.selectors),
    (E.expr[":"] = E.expr.pseudos),
    (E.uniqueSort = E.unique = h.uniqueSort),
    (E.text = h.getText),
    (E.isXMLDoc = h.isXML),
    (E.contains = h.contains),
    (E.escapeSelector = h.escape);
  function f(e, t, i) {
    for (var n = [], s = void 0 !== i; (e = e[t]) && 9 !== e.nodeType; )
      if (1 === e.nodeType) {
        if (s && E(e).is(i)) break;
        n.push(e);
      }
    return n;
  }
  function T(e, t) {
    for (var i = []; e; e = e.nextSibling)
      1 === e.nodeType && e !== t && i.push(e);
    return i;
  }
  var k = E.expr.match.needsContext;
  function $(e, t) {
    return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
  }
  var A = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
  function z(e, i, n) {
    return b(i)
      ? E.grep(e, function (e, t) {
          return !!i.call(e, t, e) !== n;
        })
      : i.nodeType
      ? E.grep(e, function (e) {
          return (e === i) !== n;
        })
      : "string" != typeof i
      ? E.grep(e, function (e) {
          return -1 < s.call(i, e) !== n;
        })
      : E.filter(i, e, n);
  }
  (E.filter = function (e, t, i) {
    var n = t[0];
    return (
      i && (e = ":not(" + e + ")"),
      1 === t.length && 1 === n.nodeType
        ? E.find.matchesSelector(n, e)
          ? [n]
          : []
        : E.find.matches(
            e,
            E.grep(t, function (e) {
              return 1 === e.nodeType;
            })
          )
    );
  }),
    E.fn.extend({
      find: function (e) {
        var t,
          i,
          n = this.length,
          s = this;
        if ("string" != typeof e)
          return this.pushStack(
            E(e).filter(function () {
              for (t = 0; t < n; t++) if (E.contains(s[t], this)) return !0;
            })
          );
        for (i = this.pushStack([]), t = 0; t < n; t++) E.find(e, s[t], i);
        return 1 < n ? E.uniqueSort(i) : i;
      },
      filter: function (e) {
        return this.pushStack(z(this, e || [], !1));
      },
      not: function (e) {
        return this.pushStack(z(this, e || [], !0));
      },
      is: function (e) {
        return !!z(this, "string" == typeof e && k.test(e) ? E(e) : e || [], !1)
          .length;
      },
    });
  var M,
    D = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
  ((E.fn.init = function (e, t, i) {
    var n, s;
    if (!e) return this;
    if (((i = i || M), "string" != typeof e))
      return e.nodeType
        ? ((this[0] = e), (this.length = 1), this)
        : b(e)
        ? void 0 !== i.ready
          ? i.ready(e)
          : e(E)
        : E.makeArray(e, this);
    if (
      !(n =
        "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length
          ? [null, e, null]
          : D.exec(e)) ||
      (!n[1] && t)
    )
      return !t || t.jquery ? (t || i).find(e) : this.constructor(t).find(e);
    if (n[1]) {
      if (
        ((t = t instanceof E ? t[0] : t),
        E.merge(
          this,
          E.parseHTML(n[1], t && t.nodeType ? t.ownerDocument || t : C, !0)
        ),
        A.test(n[1]) && E.isPlainObject(t))
      )
        for (n in t) b(this[n]) ? this[n](t[n]) : this.attr(n, t[n]);
      return this;
    }
    return (
      (s = C.getElementById(n[2])) && ((this[0] = s), (this.length = 1)), this
    );
  }).prototype = E.fn),
    (M = E(C));
  var _ = /^(?:parents|prev(?:Until|All))/,
    P = { children: !0, contents: !0, next: !0, prev: !0 };
  function L(e, t) {
    for (; (e = e[t]) && 1 !== e.nodeType; );
    return e;
  }
  E.fn.extend({
    has: function (e) {
      var t = E(e, this),
        i = t.length;
      return this.filter(function () {
        for (var e = 0; e < i; e++) if (E.contains(this, t[e])) return !0;
      });
    },
    closest: function (e, t) {
      var i,
        n = 0,
        s = this.length,
        r = [],
        o = "string" != typeof e && E(e);
      if (!k.test(e))
        for (; n < s; n++)
          for (i = this[n]; i && i !== t; i = i.parentNode)
            if (
              i.nodeType < 11 &&
              (o
                ? -1 < o.index(i)
                : 1 === i.nodeType && E.find.matchesSelector(i, e))
            ) {
              r.push(i);
              break;
            }
      return this.pushStack(1 < r.length ? E.uniqueSort(r) : r);
    },
    index: function (e) {
      return e
        ? "string" == typeof e
          ? s.call(E(e), this[0])
          : s.call(this, e.jquery ? e[0] : e)
        : this[0] && this[0].parentNode
        ? this.first().prevAll().length
        : -1;
    },
    add: function (e, t) {
      return this.pushStack(E.uniqueSort(E.merge(this.get(), E(e, t))));
    },
    addBack: function (e) {
      return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
    },
  }),
    E.each(
      {
        parent: function (e) {
          var t = e.parentNode;
          return t && 11 !== t.nodeType ? t : null;
        },
        parents: function (e) {
          return f(e, "parentNode");
        },
        parentsUntil: function (e, t, i) {
          return f(e, "parentNode", i);
        },
        next: function (e) {
          return L(e, "nextSibling");
        },
        prev: function (e) {
          return L(e, "previousSibling");
        },
        nextAll: function (e) {
          return f(e, "nextSibling");
        },
        prevAll: function (e) {
          return f(e, "previousSibling");
        },
        nextUntil: function (e, t, i) {
          return f(e, "nextSibling", i);
        },
        prevUntil: function (e, t, i) {
          return f(e, "previousSibling", i);
        },
        siblings: function (e) {
          return T((e.parentNode || {}).firstChild, e);
        },
        children: function (e) {
          return T(e.firstChild);
        },
        contents: function (e) {
          return null != e.contentDocument && n(e.contentDocument)
            ? e.contentDocument
            : ($(e, "template") && (e = e.content || e),
              E.merge([], e.childNodes));
        },
      },
      function (n, s) {
        E.fn[n] = function (e, t) {
          var i = E.map(this, s, e);
          return (
            "Until" !== n.slice(-5) && (t = e),
            t && "string" == typeof t && (i = E.filter(t, i)),
            1 < this.length &&
              (P[n] || E.uniqueSort(i), _.test(n) && i.reverse()),
            this.pushStack(i)
          );
        };
      }
    );
  var O = /[^\x20\t\r\n\f]+/g;
  function I(e) {
    return e;
  }
  function N(e) {
    throw e;
  }
  function H(e, t, i, n) {
    var s;
    try {
      e && b((s = e.promise))
        ? s.call(e).done(t).fail(i)
        : e && b((s = e.then))
        ? s.call(e, t, i)
        : t.apply(void 0, [e].slice(n));
    } catch (e) {
      i.apply(void 0, [e]);
    }
  }
  (E.Callbacks = function (n) {
    var i;
    n =
      "string" == typeof n
        ? ((i = {}),
          E.each(n.match(O) || [], function (e, t) {
            i[t] = !0;
          }),
          i)
        : E.extend({}, n);
    function s() {
      for (o = o || n.once, t = r = !0; l.length; d = -1)
        for (e = l.shift(); ++d < a.length; )
          !1 === a[d].apply(e[0], e[1]) &&
            n.stopOnFalse &&
            ((d = a.length), (e = !1));
      n.memory || (e = !1), (r = !1), o && (a = e ? [] : "");
    }
    var r,
      e,
      t,
      o,
      a = [],
      l = [],
      d = -1,
      c = {
        add: function () {
          return (
            a &&
              (e && !r && ((d = a.length - 1), l.push(e)),
              (function i(e) {
                E.each(e, function (e, t) {
                  b(t)
                    ? (n.unique && c.has(t)) || a.push(t)
                    : t && t.length && "string" !== x(t) && i(t);
                });
              })(arguments),
              e && !r && s()),
            this
          );
        },
        remove: function () {
          return (
            E.each(arguments, function (e, t) {
              for (var i; -1 < (i = E.inArray(t, a, i)); )
                a.splice(i, 1), i <= d && d--;
            }),
            this
          );
        },
        has: function (e) {
          return e ? -1 < E.inArray(e, a) : 0 < a.length;
        },
        empty: function () {
          return (a = a && []), this;
        },
        disable: function () {
          return (o = l = []), (a = e = ""), this;
        },
        disabled: function () {
          return !a;
        },
        lock: function () {
          return (o = l = []), e || r || (a = e = ""), this;
        },
        locked: function () {
          return !!o;
        },
        fireWith: function (e, t) {
          return (
            o ||
              ((t = [e, (t = t || []).slice ? t.slice() : t]),
              l.push(t),
              r || s()),
            this
          );
        },
        fire: function () {
          return c.fireWith(this, arguments), this;
        },
        fired: function () {
          return !!t;
        },
      };
    return c;
  }),
    E.extend({
      Deferred: function (e) {
        var r = [
            [
              "notify",
              "progress",
              E.Callbacks("memory"),
              E.Callbacks("memory"),
              2,
            ],
            [
              "resolve",
              "done",
              E.Callbacks("once memory"),
              E.Callbacks("once memory"),
              0,
              "resolved",
            ],
            [
              "reject",
              "fail",
              E.Callbacks("once memory"),
              E.Callbacks("once memory"),
              1,
              "rejected",
            ],
          ],
          s = "pending",
          o = {
            state: function () {
              return s;
            },
            always: function () {
              return a.done(arguments).fail(arguments), this;
            },
            catch: function (e) {
              return o.then(null, e);
            },
            pipe: function () {
              var s = arguments;
              return E.Deferred(function (n) {
                E.each(r, function (e, t) {
                  var i = b(s[t[4]]) && s[t[4]];
                  a[t[1]](function () {
                    var e = i && i.apply(this, arguments);
                    e && b(e.promise)
                      ? e
                          .promise()
                          .progress(n.notify)
                          .done(n.resolve)
                          .fail(n.reject)
                      : n[t[0] + "With"](this, i ? [e] : arguments);
                  });
                }),
                  (s = null);
              }).promise();
            },
            then: function (t, i, n) {
              var l = 0;
              function d(s, r, o, a) {
                return function () {
                  function e() {
                    var e, t;
                    if (!(s < l)) {
                      if ((e = o.apply(i, n)) === r.promise())
                        throw new TypeError("Thenable self-resolution");
                      (t =
                        e &&
                        ("object" == _typeof(e) || "function" == typeof e) &&
                        e.then),
                        b(t)
                          ? a
                            ? t.call(e, d(l, r, I, a), d(l, r, N, a))
                            : (l++,
                              t.call(
                                e,
                                d(l, r, I, a),
                                d(l, r, N, a),
                                d(l, r, I, r.notifyWith)
                              ))
                          : (o !== I && ((i = void 0), (n = [e])),
                            (a || r.resolveWith)(i, n));
                    }
                  }
                  var i = this,
                    n = arguments,
                    t = a
                      ? e
                      : function () {
                          try {
                            e();
                          } catch (e) {
                            E.Deferred.exceptionHook &&
                              E.Deferred.exceptionHook(e, t.stackTrace),
                              l <= s + 1 &&
                                (o !== N && ((i = void 0), (n = [e])),
                                r.rejectWith(i, n));
                          }
                        };
                  s
                    ? t()
                    : (E.Deferred.getStackHook &&
                        (t.stackTrace = E.Deferred.getStackHook()),
                      S.setTimeout(t));
                };
              }
              return E.Deferred(function (e) {
                r[0][3].add(d(0, e, b(n) ? n : I, e.notifyWith)),
                  r[1][3].add(d(0, e, b(t) ? t : I)),
                  r[2][3].add(d(0, e, b(i) ? i : N));
              }).promise();
            },
            promise: function (e) {
              return null != e ? E.extend(e, o) : o;
            },
          },
          a = {};
        return (
          E.each(r, function (e, t) {
            var i = t[2],
              n = t[5];
            (o[t[1]] = i.add),
              n &&
                i.add(
                  function () {
                    s = n;
                  },
                  r[3 - e][2].disable,
                  r[3 - e][3].disable,
                  r[0][2].lock,
                  r[0][3].lock
                ),
              i.add(t[3].fire),
              (a[t[0]] = function () {
                return (
                  a[t[0] + "With"](this === a ? void 0 : this, arguments), this
                );
              }),
              (a[t[0] + "With"] = i.fireWith);
          }),
          o.promise(a),
          e && e.call(a, a),
          a
        );
      },
      when: function (e) {
        function t(t) {
          return function (e) {
            (s[t] = this),
              (r[t] = 1 < arguments.length ? a.call(arguments) : e),
              --i || o.resolveWith(s, r);
          };
        }
        var i = arguments.length,
          n = i,
          s = Array(n),
          r = a.call(arguments),
          o = E.Deferred();
        if (
          i <= 1 &&
          (H(e, o.done(t(n)).resolve, o.reject, !i),
          "pending" === o.state() || b(r[n] && r[n].then))
        )
          return o.then();
        for (; n--; ) H(r[n], t(n), o.reject);
        return o.promise();
      },
    });
  var j = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
  (E.Deferred.exceptionHook = function (e, t) {
    S.console &&
      S.console.warn &&
      e &&
      j.test(e.name) &&
      S.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t);
  }),
    (E.readyException = function (e) {
      S.setTimeout(function () {
        throw e;
      });
    });
  var R = E.Deferred();
  function q() {
    C.removeEventListener("DOMContentLoaded", q),
      S.removeEventListener("load", q),
      E.ready();
  }
  (E.fn.ready = function (e) {
    return (
      R.then(e).catch(function (e) {
        E.readyException(e);
      }),
      this
    );
  }),
    E.extend({
      isReady: !1,
      readyWait: 1,
      ready: function (e) {
        (!0 === e ? --E.readyWait : E.isReady) ||
          ((E.isReady = !0) !== e && 0 < --E.readyWait) ||
          R.resolveWith(C, [E]);
      },
    }),
    (E.ready.then = R.then),
    "complete" === C.readyState ||
    ("loading" !== C.readyState && !C.documentElement.doScroll)
      ? S.setTimeout(E.ready)
      : (C.addEventListener("DOMContentLoaded", q),
        S.addEventListener("load", q));
  function F(e, t, i, n, s, r, o) {
    var a = 0,
      l = e.length,
      d = null == i;
    if ("object" === x(i)) for (a in ((s = !0), i)) F(e, t, a, i[a], !0, r, o);
    else if (
      void 0 !== n &&
      ((s = !0),
      b(n) || (o = !0),
      d &&
        (t = o
          ? (t.call(e, n), null)
          : ((d = t),
            function (e, t, i) {
              return d.call(E(e), i);
            })),
      t)
    )
      for (; a < l; a++) t(e[a], i, o ? n : n.call(e[a], a, t(e[a], i)));
    return s ? e : d ? t.call(e) : l ? t(e[0], i) : r;
  }
  var B = /^-ms-/,
    W = /-([a-z])/g;
  function G(e, t) {
    return t.toUpperCase();
  }
  function X(e) {
    return e.replace(B, "ms-").replace(W, G);
  }
  function Y(e) {
    return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
  }
  function U() {
    this.expando = E.expando + U.uid++;
  }
  (U.uid = 1),
    (U.prototype = {
      cache: function (e) {
        var t = e[this.expando];
        return (
          t ||
            ((t = {}),
            Y(e) &&
              (e.nodeType
                ? (e[this.expando] = t)
                : Object.defineProperty(e, this.expando, {
                    value: t,
                    configurable: !0,
                  }))),
          t
        );
      },
      set: function (e, t, i) {
        var n,
          s = this.cache(e);
        if ("string" == typeof t) s[X(t)] = i;
        else for (n in t) s[X(n)] = t[n];
        return s;
      },
      get: function (e, t) {
        return void 0 === t
          ? this.cache(e)
          : e[this.expando] && e[this.expando][X(t)];
      },
      access: function (e, t, i) {
        return void 0 === t || (t && "string" == typeof t && void 0 === i)
          ? this.get(e, t)
          : (this.set(e, t, i), void 0 !== i ? i : t);
      },
      remove: function (e, t) {
        var i,
          n = e[this.expando];
        if (void 0 !== n) {
          if (void 0 !== t) {
            i = (t = Array.isArray(t)
              ? t.map(X)
              : (t = X(t)) in n
              ? [t]
              : t.match(O) || []).length;
            for (; i--; ) delete n[t[i]];
          }
          (void 0 !== t && !E.isEmptyObject(n)) ||
            (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
        }
      },
      hasData: function (e) {
        var t = e[this.expando];
        return void 0 !== t && !E.isEmptyObject(t);
      },
    });
  var V = new U(),
    K = new U(),
    Z = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    Q = /[A-Z]/g;
  function J(e, t, i) {
    var n, s;
    if (void 0 === i && 1 === e.nodeType)
      if (
        ((n = "data-" + t.replace(Q, "-$&").toLowerCase()),
        "string" == typeof (i = e.getAttribute(n)))
      ) {
        try {
          i =
            "true" === (s = i) ||
            ("false" !== s &&
              ("null" === s
                ? null
                : s === +s + ""
                ? +s
                : Z.test(s)
                ? JSON.parse(s)
                : s));
        } catch (e) {}
        K.set(e, t, i);
      } else i = void 0;
    return i;
  }
  E.extend({
    hasData: function (e) {
      return K.hasData(e) || V.hasData(e);
    },
    data: function (e, t, i) {
      return K.access(e, t, i);
    },
    removeData: function (e, t) {
      K.remove(e, t);
    },
    _data: function (e, t, i) {
      return V.access(e, t, i);
    },
    _removeData: function (e, t) {
      V.remove(e, t);
    },
  }),
    E.fn.extend({
      data: function (i, e) {
        var t,
          n,
          s,
          r = this[0],
          o = r && r.attributes;
        if (void 0 !== i)
          return "object" == _typeof(i)
            ? this.each(function () {
                K.set(this, i);
              })
            : F(
                this,
                function (e) {
                  var t;
                  if (r && void 0 === e)
                    return void 0 !== (t = K.get(r, i)) ||
                      void 0 !== (t = J(r, i))
                      ? t
                      : void 0;
                  this.each(function () {
                    K.set(this, i, e);
                  });
                },
                null,
                e,
                1 < arguments.length,
                null,
                !0
              );
        if (
          this.length &&
          ((s = K.get(r)), 1 === r.nodeType && !V.get(r, "hasDataAttrs"))
        ) {
          for (t = o.length; t--; )
            o[t] &&
              0 === (n = o[t].name).indexOf("data-") &&
              ((n = X(n.slice(5))), J(r, n, s[n]));
          V.set(r, "hasDataAttrs", !0);
        }
        return s;
      },
      removeData: function (e) {
        return this.each(function () {
          K.remove(this, e);
        });
      },
    }),
    E.extend({
      queue: function (e, t, i) {
        var n;
        if (e)
          return (
            (t = (t || "fx") + "queue"),
            (n = V.get(e, t)),
            i &&
              (!n || Array.isArray(i)
                ? (n = V.access(e, t, E.makeArray(i)))
                : n.push(i)),
            n || []
          );
      },
      dequeue: function (e, t) {
        t = t || "fx";
        var i = E.queue(e, t),
          n = i.length,
          s = i.shift(),
          r = E._queueHooks(e, t);
        "inprogress" === s && ((s = i.shift()), n--),
          s &&
            ("fx" === t && i.unshift("inprogress"),
            delete r.stop,
            s.call(
              e,
              function () {
                E.dequeue(e, t);
              },
              r
            )),
          !n && r && r.empty.fire();
      },
      _queueHooks: function (e, t) {
        var i = t + "queueHooks";
        return (
          V.get(e, i) ||
          V.access(e, i, {
            empty: E.Callbacks("once memory").add(function () {
              V.remove(e, [t + "queue", i]);
            }),
          })
        );
      },
    }),
    E.fn.extend({
      queue: function (t, i) {
        var e = 2;
        return (
          "string" != typeof t && ((i = t), (t = "fx"), e--),
          arguments.length < e
            ? E.queue(this[0], t)
            : void 0 === i
            ? this
            : this.each(function () {
                var e = E.queue(this, t, i);
                E._queueHooks(this, t),
                  "fx" === t && "inprogress" !== e[0] && E.dequeue(this, t);
              })
        );
      },
      dequeue: function (e) {
        return this.each(function () {
          E.dequeue(this, e);
        });
      },
      clearQueue: function (e) {
        return this.queue(e || "fx", []);
      },
      promise: function (e, t) {
        function i() {
          --s || r.resolveWith(o, [o]);
        }
        var n,
          s = 1,
          r = E.Deferred(),
          o = this,
          a = this.length;
        for (
          "string" != typeof e && ((t = e), (e = void 0)), e = e || "fx";
          a--;

        )
          (n = V.get(o[a], e + "queueHooks")) &&
            n.empty &&
            (s++, n.empty.add(i));
        return i(), r.promise(t);
      },
    });
  var ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
    te = new RegExp("^(?:([+-])=|)(" + ee + ")([a-z%]*)$", "i"),
    ie = ["Top", "Right", "Bottom", "Left"],
    ne = C.documentElement,
    se = function (e) {
      return E.contains(e.ownerDocument, e);
    },
    re = { composed: !0 };
  ne.getRootNode &&
    (se = function (e) {
      return (
        E.contains(e.ownerDocument, e) || e.getRootNode(re) === e.ownerDocument
      );
    });
  function oe(e, t) {
    return (
      "none" === (e = t || e).style.display ||
      ("" === e.style.display && se(e) && "none" === E.css(e, "display"))
    );
  }
  function ae(e, t, i, n) {
    var s,
      r,
      o = 20,
      a = n
        ? function () {
            return n.cur();
          }
        : function () {
            return E.css(e, t, "");
          },
      l = a(),
      d = (i && i[3]) || (E.cssNumber[t] ? "" : "px"),
      c =
        e.nodeType &&
        (E.cssNumber[t] || ("px" !== d && +l)) &&
        te.exec(E.css(e, t));
    if (c && c[3] !== d) {
      for (l /= 2, d = d || c[3], c = +l || 1; o--; )
        E.style(e, t, c + d),
          (1 - r) * (1 - (r = a() / l || 0.5)) <= 0 && (o = 0),
          (c /= r);
      (c *= 2), E.style(e, t, c + d), (i = i || []);
    }
    return (
      i &&
        ((c = +c || +l || 0),
        (s = i[1] ? c + (i[1] + 1) * i[2] : +i[2]),
        n && ((n.unit = d), (n.start = c), (n.end = s))),
      s
    );
  }
  var le = {};
  function de(e, t) {
    for (var i, n, s, r, o, a, l = [], d = 0, c = e.length; d < c; d++)
      (n = e[d]).style &&
        ((i = n.style.display),
        t
          ? ("none" === i &&
              ((l[d] = V.get(n, "display") || null),
              l[d] || (n.style.display = "")),
            "" === n.style.display &&
              oe(n) &&
              (l[d] =
                ((a = r = s = void 0),
                (r = n.ownerDocument),
                (o = n.nodeName),
                (a = le[o]) ||
                  ((s = r.body.appendChild(r.createElement(o))),
                  (a = E.css(s, "display")),
                  s.parentNode.removeChild(s),
                  "none" === a && (a = "block"),
                  (le[o] = a)))))
          : "none" !== i && ((l[d] = "none"), V.set(n, "display", i)));
    for (d = 0; d < c; d++) null != l[d] && (e[d].style.display = l[d]);
    return e;
  }
  E.fn.extend({
    show: function () {
      return de(this, !0);
    },
    hide: function () {
      return de(this);
    },
    toggle: function (e) {
      return "boolean" == typeof e
        ? e
          ? this.show()
          : this.hide()
        : this.each(function () {
            oe(this) ? E(this).show() : E(this).hide();
          });
    },
  });
  var ce,
    ue,
    pe = /^(?:checkbox|radio)$/i,
    he = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
    fe = /^$|^module$|\/(?:java|ecma)script/i;
  (ce = C.createDocumentFragment().appendChild(C.createElement("div"))),
    (ue = C.createElement("input")).setAttribute("type", "radio"),
    ue.setAttribute("checked", "checked"),
    ue.setAttribute("name", "t"),
    ce.appendChild(ue),
    (y.checkClone = ce.cloneNode(!0).cloneNode(!0).lastChild.checked),
    (ce.innerHTML = "<textarea>x</textarea>"),
    (y.noCloneChecked = !!ce.cloneNode(!0).lastChild.defaultValue),
    (ce.innerHTML = "<option></option>"),
    (y.option = !!ce.lastChild);
  var me = {
    thead: [1, "<table>", "</table>"],
    col: [2, "<table><colgroup>", "</colgroup></table>"],
    tr: [2, "<table><tbody>", "</tbody></table>"],
    td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
    _default: [0, "", ""],
  };
  function ge(e, t) {
    var i;
    return (
      (i =
        void 0 !== e.getElementsByTagName
          ? e.getElementsByTagName(t || "*")
          : void 0 !== e.querySelectorAll
          ? e.querySelectorAll(t || "*")
          : []),
      void 0 === t || (t && $(e, t)) ? E.merge([e], i) : i
    );
  }
  function ve(e, t) {
    for (var i = 0, n = e.length; i < n; i++)
      V.set(e[i], "globalEval", !t || V.get(t[i], "globalEval"));
  }
  (me.tbody = me.tfoot = me.colgroup = me.caption = me.thead),
    (me.th = me.td),
    y.option ||
      (me.optgroup = me.option =
        [1, "<select multiple='multiple'>", "</select>"]);
  var ye = /<|&#?\w+;/;
  function be(e, t, i, n, s) {
    for (
      var r,
        o,
        a,
        l,
        d,
        c,
        u = t.createDocumentFragment(),
        p = [],
        h = 0,
        f = e.length;
      h < f;
      h++
    )
      if ((r = e[h]) || 0 === r)
        if ("object" === x(r)) E.merge(p, r.nodeType ? [r] : r);
        else if (ye.test(r)) {
          for (
            o = o || u.appendChild(t.createElement("div")),
              a = (he.exec(r) || ["", ""])[1].toLowerCase(),
              l = me[a] || me._default,
              o.innerHTML = l[1] + E.htmlPrefilter(r) + l[2],
              c = l[0];
            c--;

          )
            o = o.lastChild;
          E.merge(p, o.childNodes), ((o = u.firstChild).textContent = "");
        } else p.push(t.createTextNode(r));
    for (u.textContent = "", h = 0; (r = p[h++]); )
      if (n && -1 < E.inArray(r, n)) s && s.push(r);
      else if (
        ((d = se(r)), (o = ge(u.appendChild(r), "script")), d && ve(o), i)
      )
        for (c = 0; (r = o[c++]); ) fe.test(r.type || "") && i.push(r);
    return u;
  }
  var we = /^key/,
    xe = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
    Te = /^([^.]*)(?:\.(.+)|)/;
  function Se() {
    return !0;
  }
  function Ce() {
    return !1;
  }
  function Ee(e, t) {
    return (
      (e ===
        (function () {
          try {
            return C.activeElement;
          } catch (e) {}
        })()) ==
      ("focus" === t)
    );
  }
  function ke(e, t, i, n, s, r) {
    var o, a;
    if ("object" == _typeof(t)) {
      for (a in ("string" != typeof i && ((n = n || i), (i = void 0)), t))
        ke(e, a, i, n, t[a], r);
      return e;
    }
    if (
      (null == n && null == s
        ? ((s = i), (n = i = void 0))
        : null == s &&
          ("string" == typeof i
            ? ((s = n), (n = void 0))
            : ((s = n), (n = i), (i = void 0))),
      !1 === s)
    )
      s = Ce;
    else if (!s) return e;
    return (
      1 === r &&
        ((o = s),
        ((s = function (e) {
          return E().off(e), o.apply(this, arguments);
        }).guid = o.guid || (o.guid = E.guid++))),
      e.each(function () {
        E.event.add(this, t, s, n, i);
      })
    );
  }
  function $e(e, s, r) {
    r
      ? (V.set(e, s, !1),
        E.event.add(e, s, {
          namespace: !1,
          handler: function (e) {
            var t,
              i,
              n = V.get(this, s);
            if (1 & e.isTrigger && this[s]) {
              if (n.length)
                (E.event.special[s] || {}).delegateType && e.stopPropagation();
              else if (
                ((n = a.call(arguments)),
                V.set(this, s, n),
                (t = r(this, s)),
                this[s](),
                n !== (i = V.get(this, s)) || t ? V.set(this, s, !1) : (i = {}),
                n !== i)
              )
                return (
                  e.stopImmediatePropagation(), e.preventDefault(), i.value
                );
            } else
              n.length &&
                (V.set(this, s, {
                  value: E.event.trigger(
                    E.extend(n[0], E.Event.prototype),
                    n.slice(1),
                    this
                  ),
                }),
                e.stopImmediatePropagation());
          },
        }))
      : void 0 === V.get(e, s) && E.event.add(e, s, Se);
  }
  (E.event = {
    global: {},
    add: function (t, e, i, n, s) {
      var r,
        o,
        a,
        l,
        d,
        c,
        u,
        p,
        h,
        f,
        m,
        g = V.get(t);
      if (Y(t))
        for (
          i.handler && ((i = (r = i).handler), (s = r.selector)),
            s && E.find.matchesSelector(ne, s),
            i.guid || (i.guid = E.guid++),
            (l = g.events) || (l = g.events = Object.create(null)),
            (o = g.handle) ||
              (o = g.handle =
                function (e) {
                  return void 0 !== E && E.event.triggered !== e.type
                    ? E.event.dispatch.apply(t, arguments)
                    : void 0;
                }),
            d = (e = (e || "").match(O) || [""]).length;
          d--;

        )
          (h = m = (a = Te.exec(e[d]) || [])[1]),
            (f = (a[2] || "").split(".").sort()),
            h &&
              ((u = E.event.special[h] || {}),
              (h = (s ? u.delegateType : u.bindType) || h),
              (u = E.event.special[h] || {}),
              (c = E.extend(
                {
                  type: h,
                  origType: m,
                  data: n,
                  handler: i,
                  guid: i.guid,
                  selector: s,
                  needsContext: s && E.expr.match.needsContext.test(s),
                  namespace: f.join("."),
                },
                r
              )),
              (p = l[h]) ||
                (((p = l[h] = []).delegateCount = 0),
                (u.setup && !1 !== u.setup.call(t, n, f, o)) ||
                  (t.addEventListener && t.addEventListener(h, o))),
              u.add &&
                (u.add.call(t, c), c.handler.guid || (c.handler.guid = i.guid)),
              s ? p.splice(p.delegateCount++, 0, c) : p.push(c),
              (E.event.global[h] = !0));
    },
    remove: function (e, t, i, n, s) {
      var r,
        o,
        a,
        l,
        d,
        c,
        u,
        p,
        h,
        f,
        m,
        g = V.hasData(e) && V.get(e);
      if (g && (l = g.events)) {
        for (d = (t = (t || "").match(O) || [""]).length; d--; )
          if (
            ((h = m = (a = Te.exec(t[d]) || [])[1]),
            (f = (a[2] || "").split(".").sort()),
            h)
          ) {
            for (
              u = E.event.special[h] || {},
                p = l[(h = (n ? u.delegateType : u.bindType) || h)] || [],
                a =
                  a[2] &&
                  new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                o = r = p.length;
              r--;

            )
              (c = p[r]),
                (!s && m !== c.origType) ||
                  (i && i.guid !== c.guid) ||
                  (a && !a.test(c.namespace)) ||
                  (n && n !== c.selector && ("**" !== n || !c.selector)) ||
                  (p.splice(r, 1),
                  c.selector && p.delegateCount--,
                  u.remove && u.remove.call(e, c));
            o &&
              !p.length &&
              ((u.teardown && !1 !== u.teardown.call(e, f, g.handle)) ||
                E.removeEvent(e, h, g.handle),
              delete l[h]);
          } else for (h in l) E.event.remove(e, h + t[d], i, n, !0);
        E.isEmptyObject(l) && V.remove(e, "handle events");
      }
    },
    dispatch: function (e) {
      var t,
        i,
        n,
        s,
        r,
        o,
        a = new Array(arguments.length),
        l = E.event.fix(e),
        d = (V.get(this, "events") || Object.create(null))[l.type] || [],
        c = E.event.special[l.type] || {};
      for (a[0] = l, t = 1; t < arguments.length; t++) a[t] = arguments[t];
      if (
        ((l.delegateTarget = this),
        !c.preDispatch || !1 !== c.preDispatch.call(this, l))
      ) {
        for (
          o = E.event.handlers.call(this, l, d), t = 0;
          (s = o[t++]) && !l.isPropagationStopped();

        )
          for (
            l.currentTarget = s.elem, i = 0;
            (r = s.handlers[i++]) && !l.isImmediatePropagationStopped();

          )
            (l.rnamespace &&
              !1 !== r.namespace &&
              !l.rnamespace.test(r.namespace)) ||
              ((l.handleObj = r),
              (l.data = r.data),
              void 0 !==
                (n = (
                  (E.event.special[r.origType] || {}).handle || r.handler
                ).apply(s.elem, a)) &&
                !1 === (l.result = n) &&
                (l.preventDefault(), l.stopPropagation()));
        return c.postDispatch && c.postDispatch.call(this, l), l.result;
      }
    },
    handlers: function (e, t) {
      var i,
        n,
        s,
        r,
        o,
        a = [],
        l = t.delegateCount,
        d = e.target;
      if (l && d.nodeType && !("click" === e.type && 1 <= e.button))
        for (; d !== this; d = d.parentNode || this)
          if (1 === d.nodeType && ("click" !== e.type || !0 !== d.disabled)) {
            for (r = [], o = {}, i = 0; i < l; i++)
              void 0 === o[(s = (n = t[i]).selector + " ")] &&
                (o[s] = n.needsContext
                  ? -1 < E(s, this).index(d)
                  : E.find(s, this, null, [d]).length),
                o[s] && r.push(n);
            r.length && a.push({ elem: d, handlers: r });
          }
      return (
        (d = this), l < t.length && a.push({ elem: d, handlers: t.slice(l) }), a
      );
    },
    addProp: function (t, e) {
      Object.defineProperty(E.Event.prototype, t, {
        enumerable: !0,
        configurable: !0,
        get: b(e)
          ? function () {
              if (this.originalEvent) return e(this.originalEvent);
            }
          : function () {
              if (this.originalEvent) return this.originalEvent[t];
            },
        set: function (e) {
          Object.defineProperty(this, t, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: e,
          });
        },
      });
    },
    fix: function (e) {
      return e[E.expando] ? e : new E.Event(e);
    },
    special: {
      load: { noBubble: !0 },
      click: {
        setup: function (e) {
          var t = this || e;
          return (
            pe.test(t.type) && t.click && $(t, "input") && $e(t, "click", Se),
            !1
          );
        },
        trigger: function (e) {
          var t = this || e;
          return (
            pe.test(t.type) && t.click && $(t, "input") && $e(t, "click"), !0
          );
        },
        _default: function (e) {
          var t = e.target;
          return (
            (pe.test(t.type) &&
              t.click &&
              $(t, "input") &&
              V.get(t, "click")) ||
            $(t, "a")
          );
        },
      },
      beforeunload: {
        postDispatch: function (e) {
          void 0 !== e.result &&
            e.originalEvent &&
            (e.originalEvent.returnValue = e.result);
        },
      },
    },
  }),
    (E.removeEvent = function (e, t, i) {
      e.removeEventListener && e.removeEventListener(t, i);
    }),
    (E.Event = function (e, t) {
      if (!(this instanceof E.Event)) return new E.Event(e, t);
      e && e.type
        ? ((this.originalEvent = e),
          (this.type = e.type),
          (this.isDefaultPrevented =
            e.defaultPrevented ||
            (void 0 === e.defaultPrevented && !1 === e.returnValue)
              ? Se
              : Ce),
          (this.target =
            e.target && 3 === e.target.nodeType
              ? e.target.parentNode
              : e.target),
          (this.currentTarget = e.currentTarget),
          (this.relatedTarget = e.relatedTarget))
        : (this.type = e),
        t && E.extend(this, t),
        (this.timeStamp = (e && e.timeStamp) || Date.now()),
        (this[E.expando] = !0);
    }),
    (E.Event.prototype = {
      constructor: E.Event,
      isDefaultPrevented: Ce,
      isPropagationStopped: Ce,
      isImmediatePropagationStopped: Ce,
      isSimulated: !1,
      preventDefault: function () {
        var e = this.originalEvent;
        (this.isDefaultPrevented = Se),
          e && !this.isSimulated && e.preventDefault();
      },
      stopPropagation: function () {
        var e = this.originalEvent;
        (this.isPropagationStopped = Se),
          e && !this.isSimulated && e.stopPropagation();
      },
      stopImmediatePropagation: function () {
        var e = this.originalEvent;
        (this.isImmediatePropagationStopped = Se),
          e && !this.isSimulated && e.stopImmediatePropagation(),
          this.stopPropagation();
      },
    }),
    E.each(
      {
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        code: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function (e) {
          var t = e.button;
          return null == e.which && we.test(e.type)
            ? null != e.charCode
              ? e.charCode
              : e.keyCode
            : !e.which && void 0 !== t && xe.test(e.type)
            ? 1 & t
              ? 1
              : 2 & t
              ? 3
              : 4 & t
              ? 2
              : 0
            : e.which;
        },
      },
      E.event.addProp
    ),
    E.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
      E.event.special[e] = {
        setup: function () {
          return $e(this, e, Ee), !1;
        },
        trigger: function () {
          return $e(this, e), !0;
        },
        delegateType: t,
      };
    }),
    E.each(
      {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout",
      },
      function (e, s) {
        E.event.special[e] = {
          delegateType: s,
          bindType: s,
          handle: function (e) {
            var t,
              i = e.relatedTarget,
              n = e.handleObj;
            return (
              (i && (i === this || E.contains(this, i))) ||
                ((e.type = n.origType),
                (t = n.handler.apply(this, arguments)),
                (e.type = s)),
              t
            );
          },
        };
      }
    ),
    E.fn.extend({
      on: function (e, t, i, n) {
        return ke(this, e, t, i, n);
      },
      one: function (e, t, i, n) {
        return ke(this, e, t, i, n, 1);
      },
      off: function (e, t, i) {
        var n, s;
        if (e && e.preventDefault && e.handleObj)
          return (
            (n = e.handleObj),
            E(e.delegateTarget).off(
              n.namespace ? n.origType + "." + n.namespace : n.origType,
              n.selector,
              n.handler
            ),
            this
          );
        if ("object" != _typeof(e))
          return (
            (!1 !== t && "function" != typeof t) || ((i = t), (t = void 0)),
            !1 === i && (i = Ce),
            this.each(function () {
              E.event.remove(this, e, i, t);
            })
          );
        for (s in e) this.off(s, t, e[s]);
        return this;
      },
    });
  var Ae = /<script|<style|<link/i,
    ze = /checked\s*(?:[^=]|=\s*.checked.)/i,
    Me = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
  function De(e, t) {
    return (
      ($(e, "table") &&
        $(11 !== t.nodeType ? t : t.firstChild, "tr") &&
        E(e).children("tbody")[0]) ||
      e
    );
  }
  function _e(e) {
    return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
  }
  function Pe(e) {
    return (
      "true/" === (e.type || "").slice(0, 5)
        ? (e.type = e.type.slice(5))
        : e.removeAttribute("type"),
      e
    );
  }
  function Le(e, t) {
    var i, n, s, r, o, a;
    if (1 === t.nodeType) {
      if (V.hasData(e) && (a = V.get(e).events))
        for (s in (V.remove(t, "handle events"), a))
          for (i = 0, n = a[s].length; i < n; i++) E.event.add(t, s, a[s][i]);
      K.hasData(e) && ((r = K.access(e)), (o = E.extend({}, r)), K.set(t, o));
    }
  }
  function Oe(i, n, s, r) {
    n = g(n);
    var e,
      t,
      o,
      a,
      l,
      d,
      c = 0,
      u = i.length,
      p = u - 1,
      h = n[0],
      f = b(h);
    if (f || (1 < u && "string" == typeof h && !y.checkClone && ze.test(h)))
      return i.each(function (e) {
        var t = i.eq(e);
        f && (n[0] = h.call(this, e, t.html())), Oe(t, n, s, r);
      });
    if (
      u &&
      ((t = (e = be(n, i[0].ownerDocument, !1, i, r)).firstChild),
      1 === e.childNodes.length && (e = t),
      t || r)
    ) {
      for (a = (o = E.map(ge(e, "script"), _e)).length; c < u; c++)
        (l = e),
          c !== p &&
            ((l = E.clone(l, !0, !0)), a && E.merge(o, ge(l, "script"))),
          s.call(i[c], l, c);
      if (a)
        for (d = o[o.length - 1].ownerDocument, E.map(o, Pe), c = 0; c < a; c++)
          (l = o[c]),
            fe.test(l.type || "") &&
              !V.access(l, "globalEval") &&
              E.contains(d, l) &&
              (l.src && "module" !== (l.type || "").toLowerCase()
                ? E._evalUrl &&
                  !l.noModule &&
                  E._evalUrl(
                    l.src,
                    { nonce: l.nonce || l.getAttribute("nonce") },
                    d
                  )
                : w(l.textContent.replace(Me, ""), l, d));
    }
    return i;
  }
  function Ie(e, t, i) {
    for (var n, s = t ? E.filter(t, e) : e, r = 0; null != (n = s[r]); r++)
      i || 1 !== n.nodeType || E.cleanData(ge(n)),
        n.parentNode &&
          (i && se(n) && ve(ge(n, "script")), n.parentNode.removeChild(n));
    return e;
  }
  E.extend({
    htmlPrefilter: function (e) {
      return e;
    },
    clone: function (e, t, i) {
      var n,
        s,
        r,
        o,
        a,
        l,
        d,
        c = e.cloneNode(!0),
        u = se(e);
      if (
        !(
          y.noCloneChecked ||
          (1 !== e.nodeType && 11 !== e.nodeType) ||
          E.isXMLDoc(e)
        )
      )
        for (o = ge(c), n = 0, s = (r = ge(e)).length; n < s; n++)
          (a = r[n]),
            "input" === (d = (l = o[n]).nodeName.toLowerCase()) &&
            pe.test(a.type)
              ? (l.checked = a.checked)
              : ("input" !== d && "textarea" !== d) ||
                (l.defaultValue = a.defaultValue);
      if (t)
        if (i)
          for (r = r || ge(e), o = o || ge(c), n = 0, s = r.length; n < s; n++)
            Le(r[n], o[n]);
        else Le(e, c);
      return (
        0 < (o = ge(c, "script")).length && ve(o, !u && ge(e, "script")), c
      );
    },
    cleanData: function (e) {
      for (var t, i, n, s = E.event.special, r = 0; void 0 !== (i = e[r]); r++)
        if (Y(i)) {
          if ((t = i[V.expando])) {
            if (t.events)
              for (n in t.events)
                s[n] ? E.event.remove(i, n) : E.removeEvent(i, n, t.handle);
            i[V.expando] = void 0;
          }
          i[K.expando] && (i[K.expando] = void 0);
        }
    },
  }),
    E.fn.extend({
      detach: function (e) {
        return Ie(this, e, !0);
      },
      remove: function (e) {
        return Ie(this, e);
      },
      text: function (e) {
        return F(
          this,
          function (e) {
            return void 0 === e
              ? E.text(this)
              : this.empty().each(function () {
                  (1 !== this.nodeType &&
                    11 !== this.nodeType &&
                    9 !== this.nodeType) ||
                    (this.textContent = e);
                });
          },
          null,
          e,
          arguments.length
        );
      },
      append: function () {
        return Oe(this, arguments, function (e) {
          (1 !== this.nodeType &&
            11 !== this.nodeType &&
            9 !== this.nodeType) ||
            De(this, e).appendChild(e);
        });
      },
      prepend: function () {
        return Oe(this, arguments, function (e) {
          if (
            1 === this.nodeType ||
            11 === this.nodeType ||
            9 === this.nodeType
          ) {
            var t = De(this, e);
            t.insertBefore(e, t.firstChild);
          }
        });
      },
      before: function () {
        return Oe(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this);
        });
      },
      after: function () {
        return Oe(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
        });
      },
      empty: function () {
        for (var e, t = 0; null != (e = this[t]); t++)
          1 === e.nodeType && (E.cleanData(ge(e, !1)), (e.textContent = ""));
        return this;
      },
      clone: function (e, t) {
        return (
          (e = null != e && e),
          (t = null == t ? e : t),
          this.map(function () {
            return E.clone(this, e, t);
          })
        );
      },
      html: function (e) {
        return F(
          this,
          function (e) {
            var t = this[0] || {},
              i = 0,
              n = this.length;
            if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
            if (
              "string" == typeof e &&
              !Ae.test(e) &&
              !me[(he.exec(e) || ["", ""])[1].toLowerCase()]
            ) {
              e = E.htmlPrefilter(e);
              try {
                for (; i < n; i++)
                  1 === (t = this[i] || {}).nodeType &&
                    (E.cleanData(ge(t, !1)), (t.innerHTML = e));
                t = 0;
              } catch (e) {}
            }
            t && this.empty().append(e);
          },
          null,
          e,
          arguments.length
        );
      },
      replaceWith: function () {
        var i = [];
        return Oe(
          this,
          arguments,
          function (e) {
            var t = this.parentNode;
            E.inArray(this, i) < 0 &&
              (E.cleanData(ge(this)), t && t.replaceChild(e, this));
          },
          i
        );
      },
    }),
    E.each(
      {
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith",
      },
      function (e, o) {
        E.fn[e] = function (e) {
          for (var t, i = [], n = E(e), s = n.length - 1, r = 0; r <= s; r++)
            (t = r === s ? this : this.clone(!0)),
              E(n[r])[o](t),
              l.apply(i, t.get());
          return this.pushStack(i);
        };
      }
    );
  function Ne(e, t, i) {
    var n,
      s,
      r = {};
    for (s in t) (r[s] = e.style[s]), (e.style[s] = t[s]);
    for (s in ((n = i.call(e)), t)) e.style[s] = r[s];
    return n;
  }
  var He,
    je,
    Re,
    qe,
    Fe,
    Be,
    We,
    Ge,
    Xe = new RegExp("^(" + ee + ")(?!px)[a-z%]+$", "i"),
    Ye = function (e) {
      var t = e.ownerDocument.defaultView;
      return (t && t.opener) || (t = S), t.getComputedStyle(e);
    },
    Ue = new RegExp(ie.join("|"), "i");
  function Ve(e, t, i) {
    var n,
      s,
      r,
      o,
      a = e.style;
    return (
      (i = i || Ye(e)) &&
        ("" !== (o = i.getPropertyValue(t) || i[t]) ||
          se(e) ||
          (o = E.style(e, t)),
        !y.pixelBoxStyles() &&
          Xe.test(o) &&
          Ue.test(t) &&
          ((n = a.width),
          (s = a.minWidth),
          (r = a.maxWidth),
          (a.minWidth = a.maxWidth = a.width = o),
          (o = i.width),
          (a.width = n),
          (a.minWidth = s),
          (a.maxWidth = r))),
      void 0 !== o ? o + "" : o
    );
  }
  function Ke(e, t) {
    return {
      get: function () {
        if (!e()) return (this.get = t).apply(this, arguments);
        delete this.get;
      },
    };
  }
  function Ze() {
    if (Ge) {
      (We.style.cssText =
        "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
        (Ge.style.cssText =
          "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
        ne.appendChild(We).appendChild(Ge);
      var e = S.getComputedStyle(Ge);
      (He = "1%" !== e.top),
        (Be = 12 === Qe(e.marginLeft)),
        (Ge.style.right = "60%"),
        (qe = 36 === Qe(e.right)),
        (je = 36 === Qe(e.width)),
        (Ge.style.position = "absolute"),
        (Re = 12 === Qe(Ge.offsetWidth / 3)),
        ne.removeChild(We),
        (Ge = null);
    }
  }
  function Qe(e) {
    return Math.round(parseFloat(e));
  }
  (We = C.createElement("div")),
    (Ge = C.createElement("div")).style &&
      ((Ge.style.backgroundClip = "content-box"),
      (Ge.cloneNode(!0).style.backgroundClip = ""),
      (y.clearCloneStyle = "content-box" === Ge.style.backgroundClip),
      E.extend(y, {
        boxSizingReliable: function () {
          return Ze(), je;
        },
        pixelBoxStyles: function () {
          return Ze(), qe;
        },
        pixelPosition: function () {
          return Ze(), He;
        },
        reliableMarginLeft: function () {
          return Ze(), Be;
        },
        scrollboxSize: function () {
          return Ze(), Re;
        },
        reliableTrDimensions: function () {
          var e, t, i, n;
          return (
            null == Fe &&
              ((e = C.createElement("table")),
              (t = C.createElement("tr")),
              (i = C.createElement("div")),
              (e.style.cssText = "position:absolute;left:-11111px"),
              (t.style.height = "1px"),
              (i.style.height = "9px"),
              ne.appendChild(e).appendChild(t).appendChild(i),
              (n = S.getComputedStyle(t)),
              (Fe = 3 < parseInt(n.height)),
              ne.removeChild(e)),
            Fe
          );
        },
      }));
  var Je = ["Webkit", "Moz", "ms"],
    et = C.createElement("div").style,
    tt = {};
  function it(e) {
    return (
      E.cssProps[e] ||
      tt[e] ||
      (e in et
        ? e
        : (tt[e] =
            (function (e) {
              for (
                var t = e[0].toUpperCase() + e.slice(1), i = Je.length;
                i--;

              )
                if ((e = Je[i] + t) in et) return e;
            })(e) || e))
    );
  }
  var nt = /^(none|table(?!-c[ea]).+)/,
    st = /^--/,
    rt = { position: "absolute", visibility: "hidden", display: "block" },
    ot = { letterSpacing: "0", fontWeight: "400" };
  function at(e, t, i) {
    var n = te.exec(t);
    return n ? Math.max(0, n[2] - (i || 0)) + (n[3] || "px") : t;
  }
  function lt(e, t, i, n, s, r) {
    var o = "width" === t ? 1 : 0,
      a = 0,
      l = 0;
    if (i === (n ? "border" : "content")) return 0;
    for (; o < 4; o += 2)
      "margin" === i && (l += E.css(e, i + ie[o], !0, s)),
        n
          ? ("content" === i && (l -= E.css(e, "padding" + ie[o], !0, s)),
            "margin" !== i &&
              (l -= E.css(e, "border" + ie[o] + "Width", !0, s)))
          : ((l += E.css(e, "padding" + ie[o], !0, s)),
            "padding" !== i
              ? (l += E.css(e, "border" + ie[o] + "Width", !0, s))
              : (a += E.css(e, "border" + ie[o] + "Width", !0, s)));
    return (
      !n &&
        0 <= r &&
        (l +=
          Math.max(
            0,
            Math.ceil(
              e["offset" + t[0].toUpperCase() + t.slice(1)] - r - l - a - 0.5
            )
          ) || 0),
      l
    );
  }
  function dt(e, t, i) {
    var n = Ye(e),
      s =
        (!y.boxSizingReliable() || i) &&
        "border-box" === E.css(e, "boxSizing", !1, n),
      r = s,
      o = Ve(e, t, n),
      a = "offset" + t[0].toUpperCase() + t.slice(1);
    if (Xe.test(o)) {
      if (!i) return o;
      o = "auto";
    }
    return (
      ((!y.boxSizingReliable() && s) ||
        (!y.reliableTrDimensions() && $(e, "tr")) ||
        "auto" === o ||
        (!parseFloat(o) && "inline" === E.css(e, "display", !1, n))) &&
        e.getClientRects().length &&
        ((s = "border-box" === E.css(e, "boxSizing", !1, n)),
        (r = a in e) && (o = e[a])),
      (o = parseFloat(o) || 0) +
        lt(e, t, i || (s ? "border" : "content"), r, n, o) +
        "px"
    );
  }
  function ct(e, t, i, n, s) {
    return new ct.prototype.init(e, t, i, n, s);
  }
  E.extend({
    cssHooks: {
      opacity: {
        get: function (e, t) {
          if (t) {
            var i = Ve(e, "opacity");
            return "" === i ? "1" : i;
          }
        },
      },
    },
    cssNumber: {
      animationIterationCount: !0,
      columnCount: !0,
      fillOpacity: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      gridArea: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnStart: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowStart: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
    },
    cssProps: {},
    style: function (e, t, i, n) {
      if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
        var s,
          r,
          o,
          a = X(t),
          l = st.test(t),
          d = e.style;
        if (
          (l || (t = it(a)), (o = E.cssHooks[t] || E.cssHooks[a]), void 0 === i)
        )
          return o && "get" in o && void 0 !== (s = o.get(e, !1, n)) ? s : d[t];
        "string" === (r = _typeof(i)) &&
          (s = te.exec(i)) &&
          s[1] &&
          ((i = ae(e, t, s)), (r = "number")),
          null != i &&
            i == i &&
            ("number" !== r ||
              l ||
              (i += (s && s[3]) || (E.cssNumber[a] ? "" : "px")),
            y.clearCloneStyle ||
              "" !== i ||
              0 !== t.indexOf("background") ||
              (d[t] = "inherit"),
            (o && "set" in o && void 0 === (i = o.set(e, i, n))) ||
              (l ? d.setProperty(t, i) : (d[t] = i)));
      }
    },
    css: function (e, t, i, n) {
      var s,
        r,
        o,
        a = X(t);
      return (
        st.test(t) || (t = it(a)),
        (o = E.cssHooks[t] || E.cssHooks[a]) &&
          "get" in o &&
          (s = o.get(e, !0, i)),
        void 0 === s && (s = Ve(e, t, n)),
        "normal" === s && t in ot && (s = ot[t]),
        "" === i || i
          ? ((r = parseFloat(s)), !0 === i || isFinite(r) ? r || 0 : s)
          : s
      );
    },
  }),
    E.each(["height", "width"], function (e, l) {
      E.cssHooks[l] = {
        get: function (e, t, i) {
          if (t)
            return !nt.test(E.css(e, "display")) ||
              (e.getClientRects().length && e.getBoundingClientRect().width)
              ? dt(e, l, i)
              : Ne(e, rt, function () {
                  return dt(e, l, i);
                });
        },
        set: function (e, t, i) {
          var n,
            s = Ye(e),
            r = !y.scrollboxSize() && "absolute" === s.position,
            o = (r || i) && "border-box" === E.css(e, "boxSizing", !1, s),
            a = i ? lt(e, l, i, o, s) : 0;
          return (
            o &&
              r &&
              (a -= Math.ceil(
                e["offset" + l[0].toUpperCase() + l.slice(1)] -
                  parseFloat(s[l]) -
                  lt(e, l, "border", !1, s) -
                  0.5
              )),
            a &&
              (n = te.exec(t)) &&
              "px" !== (n[3] || "px") &&
              ((e.style[l] = t), (t = E.css(e, l))),
            at(0, t, a)
          );
        },
      };
    }),
    (E.cssHooks.marginLeft = Ke(y.reliableMarginLeft, function (e, t) {
      if (t)
        return (
          (parseFloat(Ve(e, "marginLeft")) ||
            e.getBoundingClientRect().left -
              Ne(e, { marginLeft: 0 }, function () {
                return e.getBoundingClientRect().left;
              })) + "px"
        );
    })),
    E.each({ margin: "", padding: "", border: "Width" }, function (s, r) {
      (E.cssHooks[s + r] = {
        expand: function (e) {
          for (
            var t = 0, i = {}, n = "string" == typeof e ? e.split(" ") : [e];
            t < 4;
            t++
          )
            i[s + ie[t] + r] = n[t] || n[t - 2] || n[0];
          return i;
        },
      }),
        "margin" !== s && (E.cssHooks[s + r].set = at);
    }),
    E.fn.extend({
      css: function (e, t) {
        return F(
          this,
          function (e, t, i) {
            var n,
              s,
              r = {},
              o = 0;
            if (Array.isArray(t)) {
              for (n = Ye(e), s = t.length; o < s; o++)
                r[t[o]] = E.css(e, t[o], !1, n);
              return r;
            }
            return void 0 !== i ? E.style(e, t, i) : E.css(e, t);
          },
          e,
          t,
          1 < arguments.length
        );
      },
    }),
    (((E.Tween = ct).prototype = {
      constructor: ct,
      init: function (e, t, i, n, s, r) {
        (this.elem = e),
          (this.prop = i),
          (this.easing = s || E.easing._default),
          (this.options = t),
          (this.start = this.now = this.cur()),
          (this.end = n),
          (this.unit = r || (E.cssNumber[i] ? "" : "px"));
      },
      cur: function () {
        var e = ct.propHooks[this.prop];
        return e && e.get ? e.get(this) : ct.propHooks._default.get(this);
      },
      run: function (e) {
        var t,
          i = ct.propHooks[this.prop];
        return (
          this.options.duration
            ? (this.pos = t =
                E.easing[this.easing](
                  e,
                  this.options.duration * e,
                  0,
                  1,
                  this.options.duration
                ))
            : (this.pos = t = e),
          (this.now = (this.end - this.start) * t + this.start),
          this.options.step &&
            this.options.step.call(this.elem, this.now, this),
          i && i.set ? i.set(this) : ct.propHooks._default.set(this),
          this
        );
      },
    }).init.prototype = ct.prototype),
    ((ct.propHooks = {
      _default: {
        get: function (e) {
          var t;
          return 1 !== e.elem.nodeType ||
            (null != e.elem[e.prop] && null == e.elem.style[e.prop])
            ? e.elem[e.prop]
            : (t = E.css(e.elem, e.prop, "")) && "auto" !== t
            ? t
            : 0;
        },
        set: function (e) {
          E.fx.step[e.prop]
            ? E.fx.step[e.prop](e)
            : 1 !== e.elem.nodeType ||
              (!E.cssHooks[e.prop] && null == e.elem.style[it(e.prop)])
            ? (e.elem[e.prop] = e.now)
            : E.style(e.elem, e.prop, e.now + e.unit);
        },
      },
    }).scrollTop = ct.propHooks.scrollLeft =
      {
        set: function (e) {
          e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
        },
      }),
    (E.easing = {
      linear: function (e) {
        return e;
      },
      swing: function (e) {
        return 0.5 - Math.cos(e * Math.PI) / 2;
      },
      _default: "swing",
    }),
    (E.fx = ct.prototype.init),
    (E.fx.step = {});
  var ut,
    pt,
    ht,
    ft,
    mt = /^(?:toggle|show|hide)$/,
    gt = /queueHooks$/;
  function vt() {
    pt &&
      (!1 === C.hidden && S.requestAnimationFrame
        ? S.requestAnimationFrame(vt)
        : S.setTimeout(vt, E.fx.interval),
      E.fx.tick());
  }
  function yt() {
    return (
      S.setTimeout(function () {
        ut = void 0;
      }),
      (ut = Date.now())
    );
  }
  function bt(e, t) {
    var i,
      n = 0,
      s = { height: e };
    for (t = t ? 1 : 0; n < 4; n += 2 - t)
      s["margin" + (i = ie[n])] = s["padding" + i] = e;
    return t && (s.opacity = s.width = e), s;
  }
  function wt(e, t, i) {
    for (
      var n,
        s = (xt.tweeners[t] || []).concat(xt.tweeners["*"]),
        r = 0,
        o = s.length;
      r < o;
      r++
    )
      if ((n = s[r].call(i, t, e))) return n;
  }
  function xt(r, e, t) {
    var i,
      o,
      n = 0,
      s = xt.prefilters.length,
      a = E.Deferred().always(function () {
        delete l.elem;
      }),
      l = function () {
        if (o) return !1;
        for (
          var e = ut || yt(),
            t = Math.max(0, d.startTime + d.duration - e),
            i = 1 - (t / d.duration || 0),
            n = 0,
            s = d.tweens.length;
          n < s;
          n++
        )
          d.tweens[n].run(i);
        return (
          a.notifyWith(r, [d, i, t]),
          i < 1 && s
            ? t
            : (s || a.notifyWith(r, [d, 1, 0]), a.resolveWith(r, [d]), !1)
        );
      },
      d = a.promise({
        elem: r,
        props: E.extend({}, e),
        opts: E.extend(!0, { specialEasing: {}, easing: E.easing._default }, t),
        originalProperties: e,
        originalOptions: t,
        startTime: ut || yt(),
        duration: t.duration,
        tweens: [],
        createTween: function (e, t) {
          var i = E.Tween(
            r,
            d.opts,
            e,
            t,
            d.opts.specialEasing[e] || d.opts.easing
          );
          return d.tweens.push(i), i;
        },
        stop: function (e) {
          var t = 0,
            i = e ? d.tweens.length : 0;
          if (o) return this;
          for (o = !0; t < i; t++) d.tweens[t].run(1);
          return (
            e
              ? (a.notifyWith(r, [d, 1, 0]), a.resolveWith(r, [d, e]))
              : a.rejectWith(r, [d, e]),
            this
          );
        },
      }),
      c = d.props;
    for (
      (function (e, t) {
        var i, n, s, r, o;
        for (i in e)
          if (
            ((s = t[(n = X(i))]),
            (r = e[i]),
            Array.isArray(r) && ((s = r[1]), (r = e[i] = r[0])),
            i !== n && ((e[n] = r), delete e[i]),
            (o = E.cssHooks[n]) && ("expand" in o))
          )
            for (i in ((r = o.expand(r)), delete e[n], r))
              (i in e) || ((e[i] = r[i]), (t[i] = s));
          else t[n] = s;
      })(c, d.opts.specialEasing);
      n < s;
      n++
    )
      if ((i = xt.prefilters[n].call(d, r, c, d.opts)))
        return (
          b(i.stop) &&
            (E._queueHooks(d.elem, d.opts.queue).stop = i.stop.bind(i)),
          i
        );
    return (
      E.map(c, wt, d),
      b(d.opts.start) && d.opts.start.call(r, d),
      d
        .progress(d.opts.progress)
        .done(d.opts.done, d.opts.complete)
        .fail(d.opts.fail)
        .always(d.opts.always),
      E.fx.timer(E.extend(l, { elem: r, anim: d, queue: d.opts.queue })),
      d
    );
  }
  (E.Animation = E.extend(xt, {
    tweeners: {
      "*": [
        function (e, t) {
          var i = this.createTween(e, t);
          return ae(i.elem, e, te.exec(t), i), i;
        },
      ],
    },
    tweener: function (e, t) {
      for (
        var i, n = 0, s = (e = b(e) ? ((t = e), ["*"]) : e.match(O)).length;
        n < s;
        n++
      )
        (i = e[n]),
          (xt.tweeners[i] = xt.tweeners[i] || []),
          xt.tweeners[i].unshift(t);
    },
    prefilters: [
      function (e, t, i) {
        var n,
          s,
          r,
          o,
          a,
          l,
          d,
          c,
          u = "width" in t || "height" in t,
          p = this,
          h = {},
          f = e.style,
          m = e.nodeType && oe(e),
          g = V.get(e, "fxshow");
        for (n in (i.queue ||
          (null == (o = E._queueHooks(e, "fx")).unqueued &&
            ((o.unqueued = 0),
            (a = o.empty.fire),
            (o.empty.fire = function () {
              o.unqueued || a();
            })),
          o.unqueued++,
          p.always(function () {
            p.always(function () {
              o.unqueued--, E.queue(e, "fx").length || o.empty.fire();
            });
          })),
        t))
          if (((s = t[n]), mt.test(s))) {
            if (
              (delete t[n],
              (r = r || "toggle" === s),
              s === (m ? "hide" : "show"))
            ) {
              if ("show" !== s || !g || void 0 === g[n]) continue;
              m = !0;
            }
            h[n] = (g && g[n]) || E.style(e, n);
          }
        if ((l = !E.isEmptyObject(t)) || !E.isEmptyObject(h))
          for (n in (u &&
            1 === e.nodeType &&
            ((i.overflow = [f.overflow, f.overflowX, f.overflowY]),
            null == (d = g && g.display) && (d = V.get(e, "display")),
            "none" === (c = E.css(e, "display")) &&
              (d
                ? (c = d)
                : (de([e], !0),
                  (d = e.style.display || d),
                  (c = E.css(e, "display")),
                  de([e]))),
            ("inline" === c || ("inline-block" === c && null != d)) &&
              "none" === E.css(e, "float") &&
              (l ||
                (p.done(function () {
                  f.display = d;
                }),
                null == d && ((c = f.display), (d = "none" === c ? "" : c))),
              (f.display = "inline-block"))),
          i.overflow &&
            ((f.overflow = "hidden"),
            p.always(function () {
              (f.overflow = i.overflow[0]),
                (f.overflowX = i.overflow[1]),
                (f.overflowY = i.overflow[2]);
            })),
          (l = !1),
          h))
            l ||
              (g
                ? "hidden" in g && (m = g.hidden)
                : (g = V.access(e, "fxshow", { display: d })),
              r && (g.hidden = !m),
              m && de([e], !0),
              p.done(function () {
                for (n in (m || de([e]), V.remove(e, "fxshow"), h))
                  E.style(e, n, h[n]);
              })),
              (l = wt(m ? g[n] : 0, n, p)),
              n in g ||
                ((g[n] = l.start), m && ((l.end = l.start), (l.start = 0)));
      },
    ],
    prefilter: function (e, t) {
      t ? xt.prefilters.unshift(e) : xt.prefilters.push(e);
    },
  })),
    (E.speed = function (e, t, i) {
      var n =
        e && "object" == _typeof(e)
          ? E.extend({}, e)
          : {
              complete: i || (!i && t) || (b(e) && e),
              duration: e,
              easing: (i && t) || (t && !b(t) && t),
            };
      return (
        E.fx.off
          ? (n.duration = 0)
          : "number" != typeof n.duration &&
            (n.duration in E.fx.speeds
              ? (n.duration = E.fx.speeds[n.duration])
              : (n.duration = E.fx.speeds._default)),
        (null != n.queue && !0 !== n.queue) || (n.queue = "fx"),
        (n.old = n.complete),
        (n.complete = function () {
          b(n.old) && n.old.call(this), n.queue && E.dequeue(this, n.queue);
        }),
        n
      );
    }),
    E.fn.extend({
      fadeTo: function (e, t, i, n) {
        return this.filter(oe)
          .css("opacity", 0)
          .show()
          .end()
          .animate({ opacity: t }, e, i, n);
      },
      animate: function (t, e, i, n) {
        function s() {
          var e = xt(this, E.extend({}, t), o);
          (r || V.get(this, "finish")) && e.stop(!0);
        }
        var r = E.isEmptyObject(t),
          o = E.speed(e, i, n);
        return (
          (s.finish = s),
          r || !1 === o.queue ? this.each(s) : this.queue(o.queue, s)
        );
      },
      stop: function (s, e, r) {
        function o(e) {
          var t = e.stop;
          delete e.stop, t(r);
        }
        return (
          "string" != typeof s && ((r = e), (e = s), (s = void 0)),
          e && this.queue(s || "fx", []),
          this.each(function () {
            var e = !0,
              t = null != s && s + "queueHooks",
              i = E.timers,
              n = V.get(this);
            if (t) n[t] && n[t].stop && o(n[t]);
            else for (t in n) n[t] && n[t].stop && gt.test(t) && o(n[t]);
            for (t = i.length; t--; )
              i[t].elem !== this ||
                (null != s && i[t].queue !== s) ||
                (i[t].anim.stop(r), (e = !1), i.splice(t, 1));
            (!e && r) || E.dequeue(this, s);
          })
        );
      },
      finish: function (o) {
        return (
          !1 !== o && (o = o || "fx"),
          this.each(function () {
            var e,
              t = V.get(this),
              i = t[o + "queue"],
              n = t[o + "queueHooks"],
              s = E.timers,
              r = i ? i.length : 0;
            for (
              t.finish = !0,
                E.queue(this, o, []),
                n && n.stop && n.stop.call(this, !0),
                e = s.length;
              e--;

            )
              s[e].elem === this &&
                s[e].queue === o &&
                (s[e].anim.stop(!0), s.splice(e, 1));
            for (e = 0; e < r; e++)
              i[e] && i[e].finish && i[e].finish.call(this);
            delete t.finish;
          })
        );
      },
    }),
    E.each(["toggle", "show", "hide"], function (e, n) {
      var s = E.fn[n];
      E.fn[n] = function (e, t, i) {
        return null == e || "boolean" == typeof e
          ? s.apply(this, arguments)
          : this.animate(bt(n, !0), e, t, i);
      };
    }),
    E.each(
      {
        slideDown: bt("show"),
        slideUp: bt("hide"),
        slideToggle: bt("toggle"),
        fadeIn: { opacity: "show" },
        fadeOut: { opacity: "hide" },
        fadeToggle: { opacity: "toggle" },
      },
      function (e, n) {
        E.fn[e] = function (e, t, i) {
          return this.animate(n, e, t, i);
        };
      }
    ),
    (E.timers = []),
    (E.fx.tick = function () {
      var e,
        t = 0,
        i = E.timers;
      for (ut = Date.now(); t < i.length; t++)
        (e = i[t])() || i[t] !== e || i.splice(t--, 1);
      i.length || E.fx.stop(), (ut = void 0);
    }),
    (E.fx.timer = function (e) {
      E.timers.push(e), E.fx.start();
    }),
    (E.fx.interval = 13),
    (E.fx.start = function () {
      pt || ((pt = !0), vt());
    }),
    (E.fx.stop = function () {
      pt = null;
    }),
    (E.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
    (E.fn.delay = function (n, e) {
      return (
        (n = (E.fx && E.fx.speeds[n]) || n),
        (e = e || "fx"),
        this.queue(e, function (e, t) {
          var i = S.setTimeout(e, n);
          t.stop = function () {
            S.clearTimeout(i);
          };
        })
      );
    }),
    (ht = C.createElement("input")),
    (ft = C.createElement("select").appendChild(C.createElement("option"))),
    (ht.type = "checkbox"),
    (y.checkOn = "" !== ht.value),
    (y.optSelected = ft.selected),
    ((ht = C.createElement("input")).value = "t"),
    (ht.type = "radio"),
    (y.radioValue = "t" === ht.value);
  var Tt,
    St = E.expr.attrHandle;
  E.fn.extend({
    attr: function (e, t) {
      return F(this, E.attr, e, t, 1 < arguments.length);
    },
    removeAttr: function (e) {
      return this.each(function () {
        E.removeAttr(this, e);
      });
    },
  }),
    E.extend({
      attr: function (e, t, i) {
        var n,
          s,
          r = e.nodeType;
        if (3 !== r && 8 !== r && 2 !== r)
          return void 0 === e.getAttribute
            ? E.prop(e, t, i)
            : ((1 === r && E.isXMLDoc(e)) ||
                (s =
                  E.attrHooks[t.toLowerCase()] ||
                  (E.expr.match.bool.test(t) ? Tt : void 0)),
              void 0 !== i
                ? null === i
                  ? void E.removeAttr(e, t)
                  : s && "set" in s && void 0 !== (n = s.set(e, i, t))
                  ? n
                  : (e.setAttribute(t, i + ""), i)
                : !(s && "get" in s && null !== (n = s.get(e, t))) &&
                  null == (n = E.find.attr(e, t))
                ? void 0
                : n);
      },
      attrHooks: {
        type: {
          set: function (e, t) {
            if (!y.radioValue && "radio" === t && $(e, "input")) {
              var i = e.value;
              return e.setAttribute("type", t), i && (e.value = i), t;
            }
          },
        },
      },
      removeAttr: function (e, t) {
        var i,
          n = 0,
          s = t && t.match(O);
        if (s && 1 === e.nodeType) for (; (i = s[n++]); ) e.removeAttribute(i);
      },
    }),
    (Tt = {
      set: function (e, t, i) {
        return !1 === t ? E.removeAttr(e, i) : e.setAttribute(i, i), i;
      },
    }),
    E.each(E.expr.match.bool.source.match(/\w+/g), function (e, t) {
      var o = St[t] || E.find.attr;
      St[t] = function (e, t, i) {
        var n,
          s,
          r = t.toLowerCase();
        return (
          i ||
            ((s = St[r]),
            (St[r] = n),
            (n = null != o(e, t, i) ? r : null),
            (St[r] = s)),
          n
        );
      };
    });
  var Ct = /^(?:input|select|textarea|button)$/i,
    Et = /^(?:a|area)$/i;
  function kt(e) {
    return (e.match(O) || []).join(" ");
  }
  function $t(e) {
    return (e.getAttribute && e.getAttribute("class")) || "";
  }
  function At(e) {
    return Array.isArray(e) ? e : ("string" == typeof e && e.match(O)) || [];
  }
  E.fn.extend({
    prop: function (e, t) {
      return F(this, E.prop, e, t, 1 < arguments.length);
    },
    removeProp: function (e) {
      return this.each(function () {
        delete this[E.propFix[e] || e];
      });
    },
  }),
    E.extend({
      prop: function (e, t, i) {
        var n,
          s,
          r = e.nodeType;
        if (3 !== r && 8 !== r && 2 !== r)
          return (
            (1 === r && E.isXMLDoc(e)) ||
              ((t = E.propFix[t] || t), (s = E.propHooks[t])),
            void 0 !== i
              ? s && "set" in s && void 0 !== (n = s.set(e, i, t))
                ? n
                : (e[t] = i)
              : s && "get" in s && null !== (n = s.get(e, t))
              ? n
              : e[t]
          );
      },
      propHooks: {
        tabIndex: {
          get: function (e) {
            var t = E.find.attr(e, "tabindex");
            return t
              ? parseInt(t, 10)
              : Ct.test(e.nodeName) || (Et.test(e.nodeName) && e.href)
              ? 0
              : -1;
          },
        },
      },
      propFix: { for: "htmlFor", class: "className" },
    }),
    y.optSelected ||
      (E.propHooks.selected = {
        get: function (e) {
          var t = e.parentNode;
          return t && t.parentNode && t.parentNode.selectedIndex, null;
        },
        set: function (e) {
          var t = e.parentNode;
          t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
        },
      }),
    E.each(
      [
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable",
      ],
      function () {
        E.propFix[this.toLowerCase()] = this;
      }
    ),
    E.fn.extend({
      addClass: function (t) {
        var e,
          i,
          n,
          s,
          r,
          o,
          a,
          l = 0;
        if (b(t))
          return this.each(function (e) {
            E(this).addClass(t.call(this, e, $t(this)));
          });
        if ((e = At(t)).length)
          for (; (i = this[l++]); )
            if (((s = $t(i)), (n = 1 === i.nodeType && " " + kt(s) + " "))) {
              for (o = 0; (r = e[o++]); )
                n.indexOf(" " + r + " ") < 0 && (n += r + " ");
              s !== (a = kt(n)) && i.setAttribute("class", a);
            }
        return this;
      },
      removeClass: function (t) {
        var e,
          i,
          n,
          s,
          r,
          o,
          a,
          l = 0;
        if (b(t))
          return this.each(function (e) {
            E(this).removeClass(t.call(this, e, $t(this)));
          });
        if (!arguments.length) return this.attr("class", "");
        if ((e = At(t)).length)
          for (; (i = this[l++]); )
            if (((s = $t(i)), (n = 1 === i.nodeType && " " + kt(s) + " "))) {
              for (o = 0; (r = e[o++]); )
                for (; -1 < n.indexOf(" " + r + " "); )
                  n = n.replace(" " + r + " ", " ");
              s !== (a = kt(n)) && i.setAttribute("class", a);
            }
        return this;
      },
      toggleClass: function (s, t) {
        var r = _typeof(s),
          o = "string" === r || Array.isArray(s);
        return "boolean" == typeof t && o
          ? t
            ? this.addClass(s)
            : this.removeClass(s)
          : b(s)
          ? this.each(function (e) {
              E(this).toggleClass(s.call(this, e, $t(this), t), t);
            })
          : this.each(function () {
              var e, t, i, n;
              if (o)
                for (t = 0, i = E(this), n = At(s); (e = n[t++]); )
                  i.hasClass(e) ? i.removeClass(e) : i.addClass(e);
              else
                (void 0 !== s && "boolean" !== r) ||
                  ((e = $t(this)) && V.set(this, "__className__", e),
                  this.setAttribute &&
                    this.setAttribute(
                      "class",
                      (!e && !1 !== s && V.get(this, "__className__")) || ""
                    ));
            });
      },
      hasClass: function (e) {
        var t,
          i,
          n = 0;
        for (t = " " + e + " "; (i = this[n++]); )
          if (1 === i.nodeType && -1 < (" " + kt($t(i)) + " ").indexOf(t))
            return !0;
        return !1;
      },
    });
  var zt = /\r/g;
  E.fn.extend({
    val: function (i) {
      var n,
        e,
        s,
        t = this[0];
      return arguments.length
        ? ((s = b(i)),
          this.each(function (e) {
            var t;
            1 === this.nodeType &&
              (null == (t = s ? i.call(this, e, E(this).val()) : i)
                ? (t = "")
                : "number" == typeof t
                ? (t += "")
                : Array.isArray(t) &&
                  (t = E.map(t, function (e) {
                    return null == e ? "" : e + "";
                  })),
              ((n =
                E.valHooks[this.type] ||
                E.valHooks[this.nodeName.toLowerCase()]) &&
                "set" in n &&
                void 0 !== n.set(this, t, "value")) ||
                (this.value = t));
          }))
        : t
        ? (n = E.valHooks[t.type] || E.valHooks[t.nodeName.toLowerCase()]) &&
          "get" in n &&
          void 0 !== (e = n.get(t, "value"))
          ? e
          : "string" == typeof (e = t.value)
          ? e.replace(zt, "")
          : null == e
          ? ""
          : e
        : void 0;
    },
  }),
    E.extend({
      valHooks: {
        option: {
          get: function (e) {
            var t = E.find.attr(e, "value");
            return null != t ? t : kt(E.text(e));
          },
        },
        select: {
          get: function (e) {
            var t,
              i,
              n,
              s = e.options,
              r = e.selectedIndex,
              o = "select-one" === e.type,
              a = o ? null : [],
              l = o ? r + 1 : s.length;
            for (n = r < 0 ? l : o ? r : 0; n < l; n++)
              if (
                ((i = s[n]).selected || n === r) &&
                !i.disabled &&
                (!i.parentNode.disabled || !$(i.parentNode, "optgroup"))
              ) {
                if (((t = E(i).val()), o)) return t;
                a.push(t);
              }
            return a;
          },
          set: function (e, t) {
            for (
              var i, n, s = e.options, r = E.makeArray(t), o = s.length;
              o--;

            )
              ((n = s[o]).selected =
                -1 < E.inArray(E.valHooks.option.get(n), r)) && (i = !0);
            return i || (e.selectedIndex = -1), r;
          },
        },
      },
    }),
    E.each(["radio", "checkbox"], function () {
      (E.valHooks[this] = {
        set: function (e, t) {
          if (Array.isArray(t))
            return (e.checked = -1 < E.inArray(E(e).val(), t));
        },
      }),
        y.checkOn ||
          (E.valHooks[this].get = function (e) {
            return null === e.getAttribute("value") ? "on" : e.value;
          });
    }),
    (y.focusin = "onfocusin" in S);
  function Mt(e) {
    e.stopPropagation();
  }
  var Dt = /^(?:focusinfocus|focusoutblur)$/;
  E.extend(E.event, {
    trigger: function (e, t, i, n) {
      var s,
        r,
        o,
        a,
        l,
        d,
        c,
        u,
        p = [i || C],
        h = v.call(e, "type") ? e.type : e,
        f = v.call(e, "namespace") ? e.namespace.split(".") : [];
      if (
        ((r = u = o = i = i || C),
        3 !== i.nodeType &&
          8 !== i.nodeType &&
          !Dt.test(h + E.event.triggered) &&
          (-1 < h.indexOf(".") && ((h = (f = h.split(".")).shift()), f.sort()),
          (l = h.indexOf(":") < 0 && "on" + h),
          ((e = e[E.expando]
            ? e
            : new E.Event(h, "object" == _typeof(e) && e)).isTrigger = n
            ? 2
            : 3),
          (e.namespace = f.join(".")),
          (e.rnamespace = e.namespace
            ? new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)")
            : null),
          (e.result = void 0),
          e.target || (e.target = i),
          (t = null == t ? [e] : E.makeArray(t, [e])),
          (c = E.event.special[h] || {}),
          n || !c.trigger || !1 !== c.trigger.apply(i, t)))
      ) {
        if (!n && !c.noBubble && !m(i)) {
          for (
            a = c.delegateType || h, Dt.test(a + h) || (r = r.parentNode);
            r;
            r = r.parentNode
          )
            p.push(r), (o = r);
          o === (i.ownerDocument || C) &&
            p.push(o.defaultView || o.parentWindow || S);
        }
        for (s = 0; (r = p[s++]) && !e.isPropagationStopped(); )
          (u = r),
            (e.type = 1 < s ? a : c.bindType || h),
            (d =
              (V.get(r, "events") || Object.create(null))[e.type] &&
              V.get(r, "handle")) && d.apply(r, t),
            (d = l && r[l]) &&
              d.apply &&
              Y(r) &&
              ((e.result = d.apply(r, t)),
              !1 === e.result && e.preventDefault());
        return (
          (e.type = h),
          n ||
            e.isDefaultPrevented() ||
            (c._default && !1 !== c._default.apply(p.pop(), t)) ||
            !Y(i) ||
            (l &&
              b(i[h]) &&
              !m(i) &&
              ((o = i[l]) && (i[l] = null),
              (E.event.triggered = h),
              e.isPropagationStopped() && u.addEventListener(h, Mt),
              i[h](),
              e.isPropagationStopped() && u.removeEventListener(h, Mt),
              (E.event.triggered = void 0),
              o && (i[l] = o))),
          e.result
        );
      }
    },
    simulate: function (e, t, i) {
      var n = E.extend(new E.Event(), i, { type: e, isSimulated: !0 });
      E.event.trigger(n, null, t);
    },
  }),
    E.fn.extend({
      trigger: function (e, t) {
        return this.each(function () {
          E.event.trigger(e, t, this);
        });
      },
      triggerHandler: function (e, t) {
        var i = this[0];
        if (i) return E.event.trigger(e, t, i, !0);
      },
    }),
    y.focusin ||
      E.each({ focus: "focusin", blur: "focusout" }, function (i, n) {
        function s(e) {
          E.event.simulate(n, e.target, E.event.fix(e));
        }
        E.event.special[n] = {
          setup: function () {
            var e = this.ownerDocument || this.document || this,
              t = V.access(e, n);
            t || e.addEventListener(i, s, !0), V.access(e, n, (t || 0) + 1);
          },
          teardown: function () {
            var e = this.ownerDocument || this.document || this,
              t = V.access(e, n) - 1;
            t
              ? V.access(e, n, t)
              : (e.removeEventListener(i, s, !0), V.remove(e, n));
          },
        };
      });
  var _t = S.location,
    Pt = { guid: Date.now() },
    Lt = /\?/;
  E.parseXML = function (e) {
    var t;
    if (!e || "string" != typeof e) return null;
    try {
      t = new S.DOMParser().parseFromString(e, "text/xml");
    } catch (e) {
      t = void 0;
    }
    return (
      (t && !t.getElementsByTagName("parsererror").length) ||
        E.error("Invalid XML: " + e),
      t
    );
  };
  var Ot = /\[\]$/,
    It = /\r?\n/g,
    Nt = /^(?:submit|button|image|reset|file)$/i,
    Ht = /^(?:input|select|textarea|keygen)/i;
  function jt(i, e, n, s) {
    var t;
    if (Array.isArray(e))
      E.each(e, function (e, t) {
        n || Ot.test(i)
          ? s(i, t)
          : jt(
              i + "[" + ("object" == _typeof(t) && null != t ? e : "") + "]",
              t,
              n,
              s
            );
      });
    else if (n || "object" !== x(e)) s(i, e);
    else for (t in e) jt(i + "[" + t + "]", e[t], n, s);
  }
  (E.param = function (e, t) {
    function i(e, t) {
      var i = b(t) ? t() : t;
      s[s.length] =
        encodeURIComponent(e) + "=" + encodeURIComponent(null == i ? "" : i);
    }
    var n,
      s = [];
    if (null == e) return "";
    if (Array.isArray(e) || (e.jquery && !E.isPlainObject(e)))
      E.each(e, function () {
        i(this.name, this.value);
      });
    else for (n in e) jt(n, e[n], t, i);
    return s.join("&");
  }),
    E.fn.extend({
      serialize: function () {
        return E.param(this.serializeArray());
      },
      serializeArray: function () {
        return this.map(function () {
          var e = E.prop(this, "elements");
          return e ? E.makeArray(e) : this;
        })
          .filter(function () {
            var e = this.type;
            return (
              this.name &&
              !E(this).is(":disabled") &&
              Ht.test(this.nodeName) &&
              !Nt.test(e) &&
              (this.checked || !pe.test(e))
            );
          })
          .map(function (e, t) {
            var i = E(this).val();
            return null == i
              ? null
              : Array.isArray(i)
              ? E.map(i, function (e) {
                  return { name: t.name, value: e.replace(It, "\r\n") };
                })
              : { name: t.name, value: i.replace(It, "\r\n") };
          })
          .get();
      },
    });
  var Rt = /%20/g,
    qt = /#.*$/,
    Ft = /([?&])_=[^&]*/,
    Bt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
    Wt = /^(?:GET|HEAD)$/,
    Gt = /^\/\//,
    Xt = {},
    Yt = {},
    Ut = "*/".concat("*"),
    Vt = C.createElement("a");
  function Kt(r) {
    return function (e, t) {
      "string" != typeof e && ((t = e), (e = "*"));
      var i,
        n = 0,
        s = e.toLowerCase().match(O) || [];
      if (b(t))
        for (; (i = s[n++]); )
          "+" === i[0]
            ? ((i = i.slice(1) || "*"), (r[i] = r[i] || []).unshift(t))
            : (r[i] = r[i] || []).push(t);
    };
  }
  function Zt(t, s, r, o) {
    var a = {},
      l = t === Yt;
    function d(e) {
      var n;
      return (
        (a[e] = !0),
        E.each(t[e] || [], function (e, t) {
          var i = t(s, r, o);
          return "string" != typeof i || l || a[i]
            ? l
              ? !(n = i)
              : void 0
            : (s.dataTypes.unshift(i), d(i), !1);
        }),
        n
      );
    }
    return d(s.dataTypes[0]) || (!a["*"] && d("*"));
  }
  function Qt(e, t) {
    var i,
      n,
      s = E.ajaxSettings.flatOptions || {};
    for (i in t) void 0 !== t[i] && ((s[i] ? e : (n = n || {}))[i] = t[i]);
    return n && E.extend(!0, e, n), e;
  }
  (Vt.href = _t.href),
    E.extend({
      active: 0,
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: _t.href,
        type: "GET",
        isLocal:
          /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
            _t.protocol
          ),
        global: !0,
        processData: !0,
        async: !0,
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        accepts: {
          "*": Ut,
          text: "text/plain",
          html: "text/html",
          xml: "application/xml, text/xml",
          json: "application/json, text/javascript",
        },
        contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
        responseFields: {
          xml: "responseXML",
          text: "responseText",
          json: "responseJSON",
        },
        converters: {
          "* text": String,
          "text html": !0,
          "text json": JSON.parse,
          "text xml": E.parseXML,
        },
        flatOptions: { url: !0, context: !0 },
      },
      ajaxSetup: function (e, t) {
        return t ? Qt(Qt(e, E.ajaxSettings), t) : Qt(E.ajaxSettings, e);
      },
      ajaxPrefilter: Kt(Xt),
      ajaxTransport: Kt(Yt),
      ajax: function (e, t) {
        "object" == _typeof(e) && ((t = e), (e = void 0)), (t = t || {});
        var c,
          u,
          p,
          i,
          h,
          n,
          f,
          m,
          s,
          r,
          g = E.ajaxSetup({}, t),
          v = g.context || g,
          y = g.context && (v.nodeType || v.jquery) ? E(v) : E.event,
          b = E.Deferred(),
          w = E.Callbacks("once memory"),
          x = g.statusCode || {},
          o = {},
          a = {},
          l = "canceled",
          T = {
            readyState: 0,
            getResponseHeader: function (e) {
              var t;
              if (f) {
                if (!i)
                  for (i = {}; (t = Bt.exec(p)); )
                    i[t[1].toLowerCase() + " "] = (
                      i[t[1].toLowerCase() + " "] || []
                    ).concat(t[2]);
                t = i[e.toLowerCase() + " "];
              }
              return null == t ? null : t.join(", ");
            },
            getAllResponseHeaders: function () {
              return f ? p : null;
            },
            setRequestHeader: function (e, t) {
              return (
                null == f &&
                  ((e = a[e.toLowerCase()] = a[e.toLowerCase()] || e),
                  (o[e] = t)),
                this
              );
            },
            overrideMimeType: function (e) {
              return null == f && (g.mimeType = e), this;
            },
            statusCode: function (e) {
              var t;
              if (e)
                if (f) T.always(e[T.status]);
                else for (t in e) x[t] = [x[t], e[t]];
              return this;
            },
            abort: function (e) {
              var t = e || l;
              return c && c.abort(t), d(0, t), this;
            },
          };
        if (
          (b.promise(T),
          (g.url = ((e || g.url || _t.href) + "").replace(
            Gt,
            _t.protocol + "//"
          )),
          (g.type = t.method || t.type || g.method || g.type),
          (g.dataTypes = (g.dataType || "*").toLowerCase().match(O) || [""]),
          null == g.crossDomain)
        ) {
          n = C.createElement("a");
          try {
            (n.href = g.url),
              (n.href = n.href),
              (g.crossDomain =
                Vt.protocol + "//" + Vt.host != n.protocol + "//" + n.host);
          } catch (e) {
            g.crossDomain = !0;
          }
        }
        if (
          (g.data &&
            g.processData &&
            "string" != typeof g.data &&
            (g.data = E.param(g.data, g.traditional)),
          Zt(Xt, g, t, T),
          f)
        )
          return T;
        for (s in ((m = E.event && g.global) &&
          0 == E.active++ &&
          E.event.trigger("ajaxStart"),
        (g.type = g.type.toUpperCase()),
        (g.hasContent = !Wt.test(g.type)),
        (u = g.url.replace(qt, "")),
        g.hasContent
          ? g.data &&
            g.processData &&
            0 ===
              (g.contentType || "").indexOf(
                "application/x-www-form-urlencoded"
              ) &&
            (g.data = g.data.replace(Rt, "+"))
          : ((r = g.url.slice(u.length)),
            g.data &&
              (g.processData || "string" == typeof g.data) &&
              ((u += (Lt.test(u) ? "&" : "?") + g.data), delete g.data),
            !1 === g.cache &&
              ((u = u.replace(Ft, "$1")),
              (r = (Lt.test(u) ? "&" : "?") + "_=" + Pt.guid++ + r)),
            (g.url = u + r)),
        g.ifModified &&
          (E.lastModified[u] &&
            T.setRequestHeader("If-Modified-Since", E.lastModified[u]),
          E.etag[u] && T.setRequestHeader("If-None-Match", E.etag[u])),
        ((g.data && g.hasContent && !1 !== g.contentType) || t.contentType) &&
          T.setRequestHeader("Content-Type", g.contentType),
        T.setRequestHeader(
          "Accept",
          g.dataTypes[0] && g.accepts[g.dataTypes[0]]
            ? g.accepts[g.dataTypes[0]] +
                ("*" !== g.dataTypes[0] ? ", " + Ut + "; q=0.01" : "")
            : g.accepts["*"]
        ),
        g.headers))
          T.setRequestHeader(s, g.headers[s]);
        if (g.beforeSend && (!1 === g.beforeSend.call(v, T, g) || f))
          return T.abort();
        if (
          ((l = "abort"),
          w.add(g.complete),
          T.done(g.success),
          T.fail(g.error),
          (c = Zt(Yt, g, t, T)))
        ) {
          if (((T.readyState = 1), m && y.trigger("ajaxSend", [T, g]), f))
            return T;
          g.async &&
            0 < g.timeout &&
            (h = S.setTimeout(function () {
              T.abort("timeout");
            }, g.timeout));
          try {
            (f = !1), c.send(o, d);
          } catch (e) {
            if (f) throw e;
            d(-1, e);
          }
        } else d(-1, "No Transport");
        function d(e, t, i, n) {
          var s,
            r,
            o,
            a,
            l,
            d = t;
          f ||
            ((f = !0),
            h && S.clearTimeout(h),
            (c = void 0),
            (p = n || ""),
            (T.readyState = 0 < e ? 4 : 0),
            (s = (200 <= e && e < 300) || 304 === e),
            i &&
              (a = (function (e, t, i) {
                for (
                  var n, s, r, o, a = e.contents, l = e.dataTypes;
                  "*" === l[0];

                )
                  l.shift(),
                    void 0 === n &&
                      (n = e.mimeType || t.getResponseHeader("Content-Type"));
                if (n)
                  for (s in a)
                    if (a[s] && a[s].test(n)) {
                      l.unshift(s);
                      break;
                    }
                if (l[0] in i) r = l[0];
                else {
                  for (s in i) {
                    if (!l[0] || e.converters[s + " " + l[0]]) {
                      r = s;
                      break;
                    }
                    o = o || s;
                  }
                  r = r || o;
                }
                if (r) return r !== l[0] && l.unshift(r), i[r];
              })(g, T, i)),
            !s &&
              -1 < E.inArray("script", g.dataTypes) &&
              (g.converters["text script"] = function () {}),
            (a = (function (e, t, i, n) {
              var s,
                r,
                o,
                a,
                l,
                d = {},
                c = e.dataTypes.slice();
              if (c[1])
                for (o in e.converters) d[o.toLowerCase()] = e.converters[o];
              for (r = c.shift(); r; )
                if (
                  (e.responseFields[r] && (i[e.responseFields[r]] = t),
                  !l && n && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
                  (l = r),
                  (r = c.shift()))
                )
                  if ("*" === r) r = l;
                  else if ("*" !== l && l !== r) {
                    if (!(o = d[l + " " + r] || d["* " + r]))
                      for (s in d)
                        if (
                          (a = s.split(" "))[1] === r &&
                          (o = d[l + " " + a[0]] || d["* " + a[0]])
                        ) {
                          !0 === o
                            ? (o = d[s])
                            : !0 !== d[s] && ((r = a[0]), c.unshift(a[1]));
                          break;
                        }
                    if (!0 !== o)
                      if (o && e.throws) t = o(t);
                      else
                        try {
                          t = o(t);
                        } catch (e) {
                          return {
                            state: "parsererror",
                            error: o
                              ? e
                              : "No conversion from " + l + " to " + r,
                          };
                        }
                  }
              return { state: "success", data: t };
            })(g, a, T, s)),
            s
              ? (g.ifModified &&
                  ((l = T.getResponseHeader("Last-Modified")) &&
                    (E.lastModified[u] = l),
                  (l = T.getResponseHeader("etag")) && (E.etag[u] = l)),
                204 === e || "HEAD" === g.type
                  ? (d = "nocontent")
                  : 304 === e
                  ? (d = "notmodified")
                  : ((d = a.state), (r = a.data), (s = !(o = a.error))))
              : ((o = d), (!e && d) || ((d = "error"), e < 0 && (e = 0))),
            (T.status = e),
            (T.statusText = (t || d) + ""),
            s ? b.resolveWith(v, [r, d, T]) : b.rejectWith(v, [T, d, o]),
            T.statusCode(x),
            (x = void 0),
            m && y.trigger(s ? "ajaxSuccess" : "ajaxError", [T, g, s ? r : o]),
            w.fireWith(v, [T, d]),
            m &&
              (y.trigger("ajaxComplete", [T, g]),
              --E.active || E.event.trigger("ajaxStop")));
        }
        return T;
      },
      getJSON: function (e, t, i) {
        return E.get(e, t, i, "json");
      },
      getScript: function (e, t) {
        return E.get(e, void 0, t, "script");
      },
    }),
    E.each(["get", "post"], function (e, s) {
      E[s] = function (e, t, i, n) {
        return (
          b(t) && ((n = n || i), (i = t), (t = void 0)),
          E.ajax(
            E.extend(
              { url: e, type: s, dataType: n, data: t, success: i },
              E.isPlainObject(e) && e
            )
          )
        );
      };
    }),
    E.ajaxPrefilter(function (e) {
      var t;
      for (t in e.headers)
        "content-type" === t.toLowerCase() &&
          (e.contentType = e.headers[t] || "");
    }),
    (E._evalUrl = function (e, t, i) {
      return E.ajax({
        url: e,
        type: "GET",
        dataType: "script",
        cache: !0,
        async: !1,
        global: !1,
        converters: { "text script": function () {} },
        dataFilter: function (e) {
          E.globalEval(e, t, i);
        },
      });
    }),
    E.fn.extend({
      wrapAll: function (e) {
        var t;
        return (
          this[0] &&
            (b(e) && (e = e.call(this[0])),
            (t = E(e, this[0].ownerDocument).eq(0).clone(!0)),
            this[0].parentNode && t.insertBefore(this[0]),
            t
              .map(function () {
                for (var e = this; e.firstElementChild; )
                  e = e.firstElementChild;
                return e;
              })
              .append(this)),
          this
        );
      },
      wrapInner: function (i) {
        return b(i)
          ? this.each(function (e) {
              E(this).wrapInner(i.call(this, e));
            })
          : this.each(function () {
              var e = E(this),
                t = e.contents();
              t.length ? t.wrapAll(i) : e.append(i);
            });
      },
      wrap: function (t) {
        var i = b(t);
        return this.each(function (e) {
          E(this).wrapAll(i ? t.call(this, e) : t);
        });
      },
      unwrap: function (e) {
        return (
          this.parent(e)
            .not("body")
            .each(function () {
              E(this).replaceWith(this.childNodes);
            }),
          this
        );
      },
    }),
    (E.expr.pseudos.hidden = function (e) {
      return !E.expr.pseudos.visible(e);
    }),
    (E.expr.pseudos.visible = function (e) {
      return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
    }),
    (E.ajaxSettings.xhr = function () {
      try {
        return new S.XMLHttpRequest();
      } catch (e) {}
    });
  var Jt = { 0: 200, 1223: 204 },
    ei = E.ajaxSettings.xhr();
  (y.cors = !!ei && "withCredentials" in ei),
    (y.ajax = ei = !!ei),
    E.ajaxTransport(function (s) {
      var r, o;
      if (y.cors || (ei && !s.crossDomain))
        return {
          send: function (e, t) {
            var i,
              n = s.xhr();
            if (
              (n.open(s.type, s.url, s.async, s.username, s.password),
              s.xhrFields)
            )
              for (i in s.xhrFields) n[i] = s.xhrFields[i];
            for (i in (s.mimeType &&
              n.overrideMimeType &&
              n.overrideMimeType(s.mimeType),
            s.crossDomain ||
              e["X-Requested-With"] ||
              (e["X-Requested-With"] = "XMLHttpRequest"),
            e))
              n.setRequestHeader(i, e[i]);
            (r = function (e) {
              return function () {
                r &&
                  ((r =
                    o =
                    n.onload =
                    n.onerror =
                    n.onabort =
                    n.ontimeout =
                    n.onreadystatechange =
                      null),
                  "abort" === e
                    ? n.abort()
                    : "error" === e
                    ? "number" != typeof n.status
                      ? t(0, "error")
                      : t(n.status, n.statusText)
                    : t(
                        Jt[n.status] || n.status,
                        n.statusText,
                        "text" !== (n.responseType || "text") ||
                          "string" != typeof n.responseText
                          ? { binary: n.response }
                          : { text: n.responseText },
                        n.getAllResponseHeaders()
                      ));
              };
            }),
              (n.onload = r()),
              (o = n.onerror = n.ontimeout = r("error")),
              void 0 !== n.onabort
                ? (n.onabort = o)
                : (n.onreadystatechange = function () {
                    4 === n.readyState &&
                      S.setTimeout(function () {
                        r && o();
                      });
                  }),
              (r = r("abort"));
            try {
              n.send((s.hasContent && s.data) || null);
            } catch (e) {
              if (r) throw e;
            }
          },
          abort: function () {
            r && r();
          },
        };
    }),
    E.ajaxPrefilter(function (e) {
      e.crossDomain && (e.contents.script = !1);
    }),
    E.ajaxSetup({
      accepts: {
        script:
          "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
      },
      contents: { script: /\b(?:java|ecma)script\b/ },
      converters: {
        "text script": function (e) {
          return E.globalEval(e), e;
        },
      },
    }),
    E.ajaxPrefilter("script", function (e) {
      void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
    }),
    E.ajaxTransport("script", function (i) {
      var n, s;
      if (i.crossDomain || i.scriptAttrs)
        return {
          send: function (e, t) {
            (n = E("<script>")
              .attr(i.scriptAttrs || {})
              .prop({ charset: i.scriptCharset, src: i.url })
              .on(
                "load error",
                (s = function (e) {
                  n.remove(),
                    (s = null),
                    e && t("error" === e.type ? 404 : 200, e.type);
                })
              )),
              C.head.appendChild(n[0]);
          },
          abort: function () {
            s && s();
          },
        };
    });
  var ti,
    ii = [],
    ni = /(=)\?(?=&|$)|\?\?/;
  E.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function () {
      var e = ii.pop() || E.expando + "_" + Pt.guid++;
      return (this[e] = !0), e;
    },
  }),
    E.ajaxPrefilter("json jsonp", function (e, t, i) {
      var n,
        s,
        r,
        o =
          !1 !== e.jsonp &&
          (ni.test(e.url)
            ? "url"
            : "string" == typeof e.data &&
              0 ===
                (e.contentType || "").indexOf(
                  "application/x-www-form-urlencoded"
                ) &&
              ni.test(e.data) &&
              "data");
      if (o || "jsonp" === e.dataTypes[0])
        return (
          (n = e.jsonpCallback =
            b(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
          o
            ? (e[o] = e[o].replace(ni, "$1" + n))
            : !1 !== e.jsonp &&
              (e.url += (Lt.test(e.url) ? "&" : "?") + e.jsonp + "=" + n),
          (e.converters["script json"] = function () {
            return r || E.error(n + " was not called"), r[0];
          }),
          (e.dataTypes[0] = "json"),
          (s = S[n]),
          (S[n] = function () {
            r = arguments;
          }),
          i.always(function () {
            void 0 === s ? E(S).removeProp(n) : (S[n] = s),
              e[n] && ((e.jsonpCallback = t.jsonpCallback), ii.push(n)),
              r && b(s) && s(r[0]),
              (r = s = void 0);
          }),
          "script"
        );
    }),
    (y.createHTMLDocument =
      (((ti = C.implementation.createHTMLDocument("").body).innerHTML =
        "<form></form><form></form>"),
      2 === ti.childNodes.length)),
    (E.parseHTML = function (e, t, i) {
      return "string" != typeof e
        ? []
        : ("boolean" == typeof t && ((i = t), (t = !1)),
          t ||
            (y.createHTMLDocument
              ? (((n = (t =
                  C.implementation.createHTMLDocument("")).createElement(
                  "base"
                )).href = C.location.href),
                t.head.appendChild(n))
              : (t = C)),
          (r = !i && []),
          (s = A.exec(e))
            ? [t.createElement(s[1])]
            : ((s = be([e], t, r)),
              r && r.length && E(r).remove(),
              E.merge([], s.childNodes)));
      var n, s, r;
    }),
    (E.fn.load = function (e, t, i) {
      var n,
        s,
        r,
        o = this,
        a = e.indexOf(" ");
      return (
        -1 < a && ((n = kt(e.slice(a))), (e = e.slice(0, a))),
        b(t)
          ? ((i = t), (t = void 0))
          : t && "object" == _typeof(t) && (s = "POST"),
        0 < o.length &&
          E.ajax({ url: e, type: s || "GET", dataType: "html", data: t })
            .done(function (e) {
              (r = arguments),
                o.html(n ? E("<div>").append(E.parseHTML(e)).find(n) : e);
            })
            .always(
              i &&
                function (e, t) {
                  o.each(function () {
                    i.apply(this, r || [e.responseText, t, e]);
                  });
                }
            ),
        this
      );
    }),
    (E.expr.pseudos.animated = function (t) {
      return E.grep(E.timers, function (e) {
        return t === e.elem;
      }).length;
    }),
    (E.offset = {
      setOffset: function (e, t, i) {
        var n,
          s,
          r,
          o,
          a,
          l,
          d = E.css(e, "position"),
          c = E(e),
          u = {};
        "static" === d && (e.style.position = "relative"),
          (a = c.offset()),
          (r = E.css(e, "top")),
          (l = E.css(e, "left")),
          (s =
            ("absolute" === d || "fixed" === d) && -1 < (r + l).indexOf("auto")
              ? ((o = (n = c.position()).top), n.left)
              : ((o = parseFloat(r) || 0), parseFloat(l) || 0)),
          b(t) && (t = t.call(e, i, E.extend({}, a))),
          null != t.top && (u.top = t.top - a.top + o),
          null != t.left && (u.left = t.left - a.left + s),
          "using" in t
            ? t.using.call(e, u)
            : ("number" == typeof u.top && (u.top += "px"),
              "number" == typeof u.left && (u.left += "px"),
              c.css(u));
      },
    }),
    E.fn.extend({
      offset: function (t) {
        if (arguments.length)
          return void 0 === t
            ? this
            : this.each(function (e) {
                E.offset.setOffset(this, t, e);
              });
        var e,
          i,
          n = this[0];
        return n
          ? n.getClientRects().length
            ? ((e = n.getBoundingClientRect()),
              (i = n.ownerDocument.defaultView),
              { top: e.top + i.pageYOffset, left: e.left + i.pageXOffset })
            : { top: 0, left: 0 }
          : void 0;
      },
      position: function () {
        if (this[0]) {
          var e,
            t,
            i,
            n = this[0],
            s = { top: 0, left: 0 };
          if ("fixed" === E.css(n, "position")) t = n.getBoundingClientRect();
          else {
            for (
              t = this.offset(),
                i = n.ownerDocument,
                e = n.offsetParent || i.documentElement;
              e &&
              (e === i.body || e === i.documentElement) &&
              "static" === E.css(e, "position");

            )
              e = e.parentNode;
            e &&
              e !== n &&
              1 === e.nodeType &&
              (((s = E(e).offset()).top += E.css(e, "borderTopWidth", !0)),
              (s.left += E.css(e, "borderLeftWidth", !0)));
          }
          return {
            top: t.top - s.top - E.css(n, "marginTop", !0),
            left: t.left - s.left - E.css(n, "marginLeft", !0),
          };
        }
      },
      offsetParent: function () {
        return this.map(function () {
          for (
            var e = this.offsetParent;
            e && "static" === E.css(e, "position");

          )
            e = e.offsetParent;
          return e || ne;
        });
      },
    }),
    E.each(
      { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
      function (t, s) {
        var r = "pageYOffset" === s;
        E.fn[t] = function (e) {
          return F(
            this,
            function (e, t, i) {
              var n;
              if (
                (m(e) ? (n = e) : 9 === e.nodeType && (n = e.defaultView),
                void 0 === i)
              )
                return n ? n[s] : e[t];
              n
                ? n.scrollTo(r ? n.pageXOffset : i, r ? i : n.pageYOffset)
                : (e[t] = i);
            },
            t,
            e,
            arguments.length
          );
        };
      }
    ),
    E.each(["top", "left"], function (e, i) {
      E.cssHooks[i] = Ke(y.pixelPosition, function (e, t) {
        if (t)
          return (t = Ve(e, i)), Xe.test(t) ? E(e).position()[i] + "px" : t;
      });
    }),
    E.each({ Height: "height", Width: "width" }, function (o, a) {
      E.each(
        { padding: "inner" + o, content: a, "": "outer" + o },
        function (n, r) {
          E.fn[r] = function (e, t) {
            var i = arguments.length && (n || "boolean" != typeof e),
              s = n || (!0 === e || !0 === t ? "margin" : "border");
            return F(
              this,
              function (e, t, i) {
                var n;
                return m(e)
                  ? 0 === r.indexOf("outer")
                    ? e["inner" + o]
                    : e.document.documentElement["client" + o]
                  : 9 === e.nodeType
                  ? ((n = e.documentElement),
                    Math.max(
                      e.body["scroll" + o],
                      n["scroll" + o],
                      e.body["offset" + o],
                      n["offset" + o],
                      n["client" + o]
                    ))
                  : void 0 === i
                  ? E.css(e, t, s)
                  : E.style(e, t, i, s);
              },
              a,
              i ? e : void 0,
              i
            );
          };
        }
      );
    }),
    E.each(
      [
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend",
      ],
      function (e, t) {
        E.fn[t] = function (e) {
          return this.on(t, e);
        };
      }
    ),
    E.fn.extend({
      bind: function (e, t, i) {
        return this.on(e, null, t, i);
      },
      unbind: function (e, t) {
        return this.off(e, null, t);
      },
      delegate: function (e, t, i, n) {
        return this.on(t, e, i, n);
      },
      undelegate: function (e, t, i) {
        return 1 === arguments.length
          ? this.off(e, "**")
          : this.off(t, e || "**", i);
      },
      hover: function (e, t) {
        return this.mouseenter(e).mouseleave(t || e);
      },
    }),
    E.each(
      "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
        " "
      ),
      function (e, i) {
        E.fn[i] = function (e, t) {
          return 0 < arguments.length
            ? this.on(i, null, e, t)
            : this.trigger(i);
        };
      }
    );
  var si = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
  (E.proxy = function (e, t) {
    var i, n, s;
    if (("string" == typeof t && ((i = e[t]), (t = e), (e = i)), b(e)))
      return (
        (n = a.call(arguments, 2)),
        ((s = function () {
          return e.apply(t || this, n.concat(a.call(arguments)));
        }).guid = e.guid =
          e.guid || E.guid++),
        s
      );
  }),
    (E.holdReady = function (e) {
      e ? E.readyWait++ : E.ready(!0);
    }),
    (E.isArray = Array.isArray),
    (E.parseJSON = JSON.parse),
    (E.nodeName = $),
    (E.isFunction = b),
    (E.isWindow = m),
    (E.camelCase = X),
    (E.type = x),
    (E.now = Date.now),
    (E.isNumeric = function (e) {
      var t = E.type(e);
      return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
    }),
    (E.trim = function (e) {
      return null == e ? "" : (e + "").replace(si, "");
    }),
    "function" == typeof define &&
      define.amd &&
      define("jquery", [], function () {
        return E;
      });
  var ri = S.jQuery,
    oi = S.$;
  return (
    (E.noConflict = function (e) {
      return S.$ === E && (S.$ = oi), e && S.jQuery === E && (S.jQuery = ri), E;
    }),
    void 0 === e && (S.jQuery = S.$ = E),
    E
  );
}),
  (theme.jQuery = $),
  (function (p) {
    var e,
      t,
      i,
      n,
      s,
      r,
      o,
      a,
      l,
      d,
      c,
      u,
      h,
      f,
      m,
      g,
      v,
      y,
      b,
      w,
      x,
      T,
      S,
      C,
      E,
      k,
      $,
      A,
      z,
      M,
      D,
      _,
      P,
      L,
      O,
      I,
      N,
      H,
      j,
      R,
      q,
      F,
      B,
      W,
      G,
      X,
      Y,
      U,
      V,
      K,
      Z,
      Q,
      J,
      ee,
      te,
      ie,
      ne,
      se,
      re,
      oe,
      ae,
      le,
      de,
      ce,
      ue,
      pe,
      he,
      fe,
      me,
      ge,
      ve,
      ye,
      be,
      we,
      xe,
      Te,
      Se,
      Ce;
    p = jQuery = p;
    function Ee() {
      n(i.lazySizes), i.removeEventListener("lazyunveilread", Ee, !0);
    }
    function ke() {
      r(s.lazySizes), s.removeEventListener("lazyunveilread", ke, !0);
    }
    function $e() {
      a(o.lazySizes), o.removeEventListener("lazyunveilread", $e, !0);
    }
    function Ae() {
      d(l.lazySizes), l.removeEventListener("lazyunveilread", Ae, !0);
    }
    function ze() {
      u(c.lazySizes), c.removeEventListener("lazyunveilread", ze, !0);
    }
    function Me(e, t, i) {
      var n = w.createElement(e);
      return t && (n.id = ae + t), i && (n.style.cssText = i), b(n);
    }
    function De() {
      return x.innerHeight ? x.innerHeight : b(x).height();
    }
    function _e(e, i) {
      i !== Object(i) && (i = {}),
        (this.cache = {}),
        (this.el = e),
        (this.value = function (e) {
          var t;
          return (
            void 0 === this.cache[e] &&
              (void 0 !== (t = b(this.el).attr("data-cbox-" + e))
                ? (this.cache[e] = t)
                : void 0 !== i[e]
                ? (this.cache[e] = i[e])
                : void 0 !== re[e] && (this.cache[e] = re[e])),
            this.cache[e]
          );
        }),
        (this.get = function (e) {
          var t = this.value(e);
          return b.isFunction(t) ? t.call(this.el, this) : t;
        });
    }
    function Pe(e) {
      var t = M.length,
        i = (Y + e) % t;
      return i < 0 ? t + i : i;
    }
    function Le(e, t) {
      return Math.round(
        (/%/.test(e) ? ("x" === t ? D.width() : De()) / 100 : 1) *
          parseInt(e, 10)
      );
    }
    function Oe(e, t) {
      return e.get("photo") || e.get("photoRegex").test(t);
    }
    function Ie(e, t) {
      return e.get("retinaUrl") && 1 < x.devicePixelRatio
        ? t.replace(e.get("photoRegex"), e.get("retinaSuffix"))
        : t;
    }
    function Ne(e) {
      "contains" in S[0] &&
        !S[0].contains(e.target) &&
        e.target !== T[0] &&
        (e.stopPropagation(), S.focus());
    }
    function He(e) {
      He.str !== e && (S.add(T).removeClass(He.str).addClass(e), (He.str = e));
    }
    function je(e) {
      b(w).trigger(e), me.triggerHandler(e);
    }
    function Re(e) {
      var t, i;
      if (!Z) {
        if (
          ((t = b(e).data(oe)),
          (F = new _e(e, t)),
          (i = F.get("rel")),
          (Y = 0),
          i && !1 !== i && "nofollow" !== i
            ? ((M = b("." + le).filter(function () {
                return new _e(this, b.data(this, oe)).get("rel") === i;
              })),
              -1 === (Y = M.index(F.el)) &&
                ((M = M.add(F.el)), (Y = M.length - 1)))
            : (M = b(F.el)),
          !V)
        ) {
          (V = K = !0),
            He(F.get("className")),
            S.css({ visibility: "hidden", display: "block", opacity: "" }),
            (_ = Me(
              ge,
              "LoadedContent",
              "width:0; height:0; overflow:hidden; visibility:hidden"
            )),
            E.css({ width: "", height: "" }).append(_),
            (B = k.height() + z.height() + E.outerHeight(!0) - E.height()),
            (W = $.width() + A.width() + E.outerWidth(!0) - E.width()),
            (G = _.outerHeight(!0)),
            (X = _.outerWidth(!0));
          var n = Le(F.get("initialWidth"), "x"),
            s = Le(F.get("initialHeight"), "y"),
            r = F.get("maxWidth"),
            o = F.get("maxHeight");
          (F.w = Math.max((!1 !== r ? Math.min(n, Le(r, "x")) : n) - X - W, 0)),
            (F.h = Math.max(
              (!1 !== o ? Math.min(s, Le(o, "y")) : s) - G - B,
              0
            )),
            _.css({ width: "", height: F.h }),
            J.position(),
            je(de),
            F.get("onOpen"),
            q.add(O).hide(),
            S.focus(),
            F.get("trapFocus") &&
              w.addEventListener &&
              (w.addEventListener("focus", Ne, !0),
              me.one(he, function () {
                w.removeEventListener("focus", Ne, !0);
              })),
            F.get("returnFocus") &&
              me.one(he, function () {
                b(F.el).focus();
              });
        }
        var a = parseFloat(F.get("opacity"));
        T.css({
          opacity: a == a ? a : "",
          cursor: F.get("overlayClose") ? "pointer" : "",
          visibility: "visible",
        }).show(),
          F.get("closeButton")
            ? R.html(F.get("close")).appendTo(E)
            : R.appendTo("<div/>"),
          (function () {
            var e,
              t,
              i,
              n = J.prep,
              s = ++ve;
            if (
              ((U = !(K = !0)),
              je(fe),
              je(ce),
              F.get("onLoad"),
              (F.h = F.get("height")
                ? Le(F.get("height"), "y") - G - B
                : F.get("innerHeight") && Le(F.get("innerHeight"), "y")),
              (F.w = F.get("width")
                ? Le(F.get("width"), "x") - X - W
                : F.get("innerWidth") && Le(F.get("innerWidth"), "x")),
              (F.mw = F.w),
              (F.mh = F.h),
              F.get("maxWidth") &&
                ((F.mw = Le(F.get("maxWidth"), "x") - X - W),
                (F.mw = F.w && F.w < F.mw ? F.w : F.mw)),
              F.get("maxHeight") &&
                ((F.mh = Le(F.get("maxHeight"), "y") - G - B),
                (F.mh = F.h && F.h < F.mh ? F.h : F.mh)),
              (e = F.get("href")),
              (Q = setTimeout(function () {
                L.show();
              }, 100)),
              F.get("inline"))
            ) {
              var r = b(e).eq(0);
              (i = b("<div>").hide().insertBefore(r)),
                me.one(fe, function () {
                  i.replaceWith(r);
                }),
                n(r);
            } else
              F.get("iframe")
                ? n(" ")
                : F.get("html")
                ? n(F.get("html"))
                : Oe(F, e)
                ? ((e = Ie(F, e)),
                  (U = F.get("createImg")),
                  b(U)
                    .addClass(ae + "Photo")
                    .bind("error." + ae, function () {
                      n(Me(ge, "Error").html(F.get("imgError")));
                    })
                    .one("load", function () {
                      s === ve &&
                        setTimeout(function () {
                          var e;
                          F.get("retinaImage") &&
                            1 < x.devicePixelRatio &&
                            ((U.height = U.height / x.devicePixelRatio),
                            (U.width = U.width / x.devicePixelRatio)),
                            F.get("scalePhotos") &&
                              ((t = function () {
                                (U.height -= U.height * e),
                                  (U.width -= U.width * e);
                              }),
                              F.mw &&
                                U.width > F.mw &&
                                ((e = (U.width - F.mw) / U.width), t()),
                              F.mh &&
                                U.height > F.mh &&
                                ((e = (U.height - F.mh) / U.height), t())),
                            F.h &&
                              (U.style.marginTop =
                                Math.max(F.mh - U.height, 0) / 2 + "px"),
                            M[1] &&
                              (F.get("loop") || M[Y + 1]) &&
                              ((U.style.cursor = "pointer"),
                              b(U).bind("click." + ae, function () {
                                J.next();
                              })),
                            (U.style.width = U.width + "px"),
                            (U.style.height = U.height + "px"),
                            n(U);
                        }, 1);
                    }),
                  (U.src = e))
                : e &&
                  P.load(e, F.get("data"), function (e, t) {
                    s === ve &&
                      n(
                        "error" === t
                          ? Me(ge, "Error").html(F.get("xhrError"))
                          : b(this).contents()
                      );
                  });
          })();
      }
    }
    function qe() {
      S ||
        ((ee = !1),
        (D = b(x)),
        (S = Me(ge)
          .attr({
            id: oe,
            class: !1 === b.support.opacity ? ae + "IE" : "",
            role: "dialog",
            tabindex: "-1",
          })
          .hide()),
        (T = Me(ge, "Overlay").hide()),
        (L = b([Me(ge, "LoadingOverlay")[0], Me(ge, "LoadingGraphic")[0]])),
        (C = Me(ge, "Wrapper")),
        (E = Me(ge, "Content").append(
          (O = Me(ge, "Title")),
          (I = Me(ge, "Current")),
          (j = b(
            '<button type="button" aria-label="' +
              theme.strings.previous +
              '"/>'
          ).attr({ id: ae + "Previous" })),
          (H = b(
            '<button type="button" aria-label="' + theme.strings.next + '"/>'
          ).attr({ id: ae + "Next" })),
          (N = b(
            '<button type="button" aria-label="' +
              theme.strings.slideshow +
              '"/>'
          ).attr({ id: ae + "Slideshow" })),
          L
        )),
        (R = b(
          '<button type="button" aria-label="' + theme.strings.close + '"/>'
        ).attr({ id: ae + "Close" })),
        C.append(
          Me(ge).append(
            Me(ge, "TopLeft"),
            (k = Me(ge, "TopCenter")),
            Me(ge, "TopRight")
          ),
          Me(ge, !1, "clear:left").append(
            ($ = Me(ge, "MiddleLeft")),
            E,
            (A = Me(ge, "MiddleRight"))
          ),
          Me(ge, !1, "clear:left").append(
            Me(ge, "BottomLeft"),
            (z = Me(ge, "BottomCenter")),
            Me(ge, "BottomRight")
          )
        )
          .find("div div")
          .css({ float: "left" }),
        (P = Me(
          ge,
          !1,
          "position:absolute; width:9999px; visibility:hidden; display:none; max-width:none;"
        )),
        (q = H.add(j).add(I).add(N))),
        w.body && !S.parent().length && b(w.body).append(T, S.append(C, P));
    }
    function Fe() {
      clearTimeout(ie);
    }
    function Be() {
      (F.get("loop") || M[Y + 1]) &&
        (Fe(), (ie = setTimeout(J.next, F.get("slideshowSpeed"))));
    }
    function We() {
      N.html(F.get("slideshowStop")).unbind(se).one(se, Ge),
        me.bind(ue, Be).bind(ce, Fe),
        S.removeClass(ne + "off").addClass(ne + "on");
    }
    function Ge() {
      Fe(),
        me.unbind(ue, Be).unbind(ce, Fe),
        N.html(F.get("slideshowStart"))
          .unbind(se)
          .one(se, function () {
            J.next(), We();
          }),
        S.removeClass(ne + "on").addClass(ne + "off");
    }
    function Xe() {
      (te = !1),
        N.hide(),
        Fe(),
        me.unbind(ue, Be).unbind(ce, Fe),
        S.removeClass(ne + "off " + ne + "on");
    }
    !(function (p, h, f) {
      function m(e, t) {
        return _typeof(e) === t;
      }
      function g(e) {
        return "function" != typeof h.createElement
          ? h.createElement(e)
          : w
          ? h.createElementNS.call(h, "http://www.w3.org/2000/svg", e)
          : h.createElement.apply(h, arguments);
      }
      function v(e, t, i, n) {
        var s,
          r,
          o,
          a,
          l,
          d = "modernizr",
          c = g("div"),
          u = ((l = h.body) || ((l = g(w ? "svg" : "body")).fake = !0), l);
        if (parseInt(i, 10))
          for (; i--; )
            ((o = g("div")).id = n ? n[i] : d + (i + 1)), c.appendChild(o);
        return (
          ((s = g("style")).type = "text/css"),
          (s.id = "s" + d),
          (u.fake ? u : c).appendChild(s),
          u.appendChild(c),
          s.styleSheet
            ? (s.styleSheet.cssText = e)
            : s.appendChild(h.createTextNode(e)),
          (c.id = d),
          u.fake &&
            ((u.style.background = ""),
            (u.style.overflow = "hidden"),
            (a = b.style.overflow),
            (b.style.overflow = "hidden"),
            b.appendChild(u)),
          (r = t(c, e)),
          u.fake
            ? (u.parentNode.removeChild(u),
              (b.style.overflow = a),
              b.offsetHeight)
            : c.parentNode.removeChild(c),
          !!r
        );
      }
      function a(e, t) {
        return function () {
          return e.apply(t, arguments);
        };
      }
      function y(e) {
        return e
          .replace(/([A-Z])/g, function (e, t) {
            return "-" + t.toLowerCase();
          })
          .replace(/^ms-/, "-ms-");
      }
      function l(e, t, i, n) {
        function s() {
          o && (delete E.style, delete E.modElem);
        }
        if (((n = !m(n, "undefined") && n), !m(i, "undefined"))) {
          var r = (function (e, t) {
            var i = e.length;
            if ("CSS" in p && "supports" in p.CSS) {
              for (; i--; ) if (p.CSS.supports(y(e[i]), t)) return !0;
              return !1;
            }
            if ("CSSSupportsRule" in p) {
              for (var n = []; i--; ) n.push("(" + y(e[i]) + ":" + t + ")");
              return v(
                "@supports (" +
                  (n = n.join(" or ")) +
                  ") { #modernizr { position: absolute; } }",
                function (e) {
                  return "absolute" == getComputedStyle(e, null).position;
                }
              );
            }
            return f;
          })(e, i);
          if (!m(r, "undefined")) return r;
        }
        for (
          var o, a, l, d, c, u = ["modernizr", "tspan", "samp"];
          !E.style && u.length;

        )
          (o = !0), (E.modElem = g(u.shift())), (E.style = E.modElem.style);
        for (l = e.length, a = 0; a < l; a++)
          if (
            ((d = e[a]),
            (c = E.style[d]),
            ~("" + d).indexOf("-") &&
              (d = d
                .replace(/([a-z])-([a-z])/g, function (e, t, i) {
                  return t + i.toUpperCase();
                })
                .replace(/^-/, "")),
            E.style[d] !== f)
          ) {
            if (n || m(i, "undefined")) return s(), "pfx" != t || d;
            try {
              E.style[d] = i;
            } catch (e) {}
            if (E.style[d] != c) return s(), "pfx" != t || d;
          }
        return s(), !1;
      }
      function n(e, t, i, n, s) {
        var r = e.charAt(0).toUpperCase() + e.slice(1),
          o = (e + " " + T.join(r + " ") + r).split(" ");
        return m(t, "string") || m(t, "undefined")
          ? l(o, t, n, s)
          : (function (e, t, i) {
              var n;
              for (var s in e)
                if (e[s] in t)
                  return !1 === i
                    ? e[s]
                    : m((n = t[e[s]]), "function")
                    ? a(n, i || t)
                    : n;
              return !1;
            })((o = (e + " " + x.join(r + " ") + r).split(" ")), t, i);
      }
      function s(e, t, i) {
        return n(e, f, f, t, i);
      }
      var d = [],
        c = [],
        e = {
          _version: "3.3.1",
          _config: {
            classPrefix: "",
            enableClasses: !0,
            enableJSClass: !0,
            usePrefixes: !0,
          },
          _q: [],
          on: function (e, t) {
            var i = this;
            setTimeout(function () {
              t(i[e]);
            }, 0);
          },
          addTest: function (e, t, i) {
            c.push({ name: e, fn: t, options: i });
          },
          addAsyncTest: function (e) {
            c.push({ name: null, fn: e });
          },
        },
        u = function () {};
      (u.prototype = e),
        (u = new u()).addTest(
          "svg",
          !!h.createElementNS &&
            !!h.createElementNS("http://www.w3.org/2000/svg", "svg")
              .createSVGRect
        );
      var i = e._config.usePrefixes
        ? " -webkit- -moz- -o- -ms- ".split(" ")
        : ["", ""];
      e._prefixes = i;
      var b = h.documentElement,
        w = "svg" === b.nodeName.toLowerCase(),
        t = "Moz O ms Webkit",
        x = e._config.usePrefixes ? t.toLowerCase().split(" ") : [];
      e._domPrefixes = x;
      var r = "CSS" in p && "supports" in p.CSS,
        o = "supportsCSS" in p;
      u.addTest("supports", r || o),
        u.addTest(
          "placeholder",
          "placeholder" in g("input") && "placeholder" in g("textarea")
        );
      var T = e._config.usePrefixes ? t.split(" ") : [];
      e._cssomPrefixes = T;
      var S = (e.testStyles = v);
      u.addTest("touchevents", function () {
        var t;
        if (
          "ontouchstart" in p ||
          (p.DocumentTouch && h instanceof DocumentTouch)
        )
          t = !0;
        else {
          var e = [
            "@media (",
            i.join("touch-enabled),("),
            "heartz",
            ")",
            "{#modernizr{top:9px;position:absolute}}",
          ].join("");
          S(e, function (e) {
            t = 9 === e.offsetTop;
          });
        }
        return t;
      });
      var C = { elem: g("modernizr") };
      u._q.push(function () {
        delete C.elem;
      });
      var E = { style: C.elem.style };
      u._q.unshift(function () {
        delete E.style;
      }),
        (e.testProp = function (e, t, i) {
          return l([e], f, t, i);
        }),
        (e.testAllProps = n),
        (e.testAllProps = s),
        u.addTest("csstransforms", function () {
          return (
            -1 === navigator.userAgent.indexOf("Android 2.") &&
            s("transform", "scale(1)", !0)
          );
        }),
        u.addTest("csstransforms3d", function () {
          var t = !!s("perspective", "1px", !0),
            e = u._config.usePrefixes;
          if (t && (!e || "webkitPerspective" in b.style)) {
            var i;
            u.supports
              ? (i = "@supports (perspective: 1px)")
              : ((i = "@media (transform-3d)"),
                e && (i += ",(-webkit-transform-3d)")),
              S(
                "#modernizr{width:0;height:0}" +
                  (i +=
                    "{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}"),
                function (e) {
                  t = 7 === e.offsetWidth && 18 === e.offsetHeight;
                }
              );
          }
          return t;
        }),
        u.addTest("flexbox", s("flexBasis", "1px", !0)),
        (function () {
          var e, t, i, n, s, r;
          for (var o in c)
            if (c.hasOwnProperty(o)) {
              if (
                ((e = []),
                (t = c[o]).name &&
                  (e.push(t.name.toLowerCase()),
                  t.options && t.options.aliases && t.options.aliases.length))
              )
                for (i = 0; i < t.options.aliases.length; i++)
                  e.push(t.options.aliases[i].toLowerCase());
              for (
                n = m(t.fn, "function") ? t.fn() : t.fn, s = 0;
                s < e.length;
                s++
              )
                1 === (r = e[s].split(".")).length
                  ? (u[r[0]] = n)
                  : (!u[r[0]] ||
                      u[r[0]] instanceof Boolean ||
                      (u[r[0]] = new Boolean(u[r[0]])),
                    (u[r[0]][r[1]] = n)),
                  d.push((n ? "" : "no-") + r.join("-"));
            }
        })(),
        (function (e) {
          var t = b.className,
            i = u._config.classPrefix || "";
          if ((w && (t = t.baseVal), u._config.enableJSClass)) {
            var n = new RegExp("(^|\\s)" + i + "no-js(\\s|$)");
            t = t.replace(n, "$1" + i + "js$2");
          }
          u._config.enableClasses &&
            ((t += " " + i + e.join(" " + i)),
            w ? (b.className.baseVal = t) : (b.className = t));
        })(d),
        delete e.addTest,
        delete e.addAsyncTest;
      for (var k = 0; k < u._q.length; k++) u._q[k]();
      p.Modernizr = u;
    })(window, document),
      (e = window),
      (t = (function (l, N) {
        "use strict";
        if (N.getElementsByClassName) {
          var H,
            j,
            R = N.documentElement,
            d = l.Date,
            s = l.HTMLPictureElement,
            c = "addEventListener",
            q = "getAttribute",
            F = l[c],
            B = l.setTimeout,
            u = l.requestAnimationFrame || B,
            p = l.requestIdleCallback,
            W = /^picture$/i,
            r = ["load", "error", "lazyincluded", "_lazyloaded"],
            n = {},
            G = Array.prototype.forEach,
            X = function e(t, i) {
              return (
                n[i] || (n[i] = new RegExp("(\\s|^)" + i + "(\\s|$)")),
                n[i].test(t[q]("class") || "") && n[i]
              );
            },
            Y = function e(t, i) {
              X(t, i) ||
                t.setAttribute("class", (t[q]("class") || "").trim() + " " + i);
            },
            U = function e(t, i) {
              var n;
              (n = X(t, i)) &&
                t.setAttribute("class", (t[q]("class") || "").replace(n, " "));
            },
            V = function e(t, i, n) {
              var s = n ? c : "removeEventListener";
              n && e(t, i),
                r.forEach(function (e) {
                  t[s](e, i);
                });
            },
            K = function e(t, i, n, s, r) {
              var o = N.createEvent("CustomEvent");
              return (
                n || (n = {}),
                (n.instance = H),
                o.initCustomEvent(i, !s, !r, n),
                t.dispatchEvent(o),
                o
              );
            },
            Z = function e(t, i) {
              var n;
              !s && (n = l.picturefill || j.pf)
                ? n({ reevaluate: !0, elements: [t] })
                : i && i.src && (t.src = i.src);
            },
            Q = function e(t, i) {
              return (getComputedStyle(t, null) || {})[i];
            },
            o = function e(t, i, n) {
              for (
                n = n || t.offsetWidth;
                n < j.minSize && i && !t._lazysizesWidth;

              ) {
                (n = i.offsetWidth), (i = i.parentNode);
              }
              return n;
            },
            J = (function () {
              var n,
                s,
                i = [],
                r = [],
                o = i,
                a = function e() {
                  var t = o;
                  for (o = i.length ? r : i, n = !0, s = !1; t.length; ) {
                    t.shift()();
                  }
                  n = !1;
                },
                e = function e(t, i) {
                  n && !i
                    ? t.apply(this, arguments)
                    : (o.push(t), s || ((s = !0), (N.hidden ? B : u)(a)));
                };
              return (e._lsFlush = a), e;
            })(),
            ee = function e(i, t) {
              return t
                ? function () {
                    J(i);
                  }
                : function () {
                    var e = this,
                      t = arguments;
                    J(function () {
                      i.apply(e, t);
                    });
                  };
            },
            e = function e(t) {
              var i,
                n = 0,
                s = 125,
                r = j.ricTimeout,
                o = function e() {
                  (i = !1), (n = d.now()), t();
                },
                a =
                  p && j.ricTimeout
                    ? function () {
                        p(o, { timeout: r }),
                          r !== j.ricTimeout && (r = j.ricTimeout);
                      }
                    : ee(function () {
                        B(o);
                      }, !0);
              return function (e) {
                var t;
                (e = e === !0) && (r = 33),
                  i ||
                    ((i = !0),
                    (t = s - (d.now() - n)),
                    0 > t && (t = 0),
                    e || (9 > t && p) ? a() : B(a, t));
              };
            },
            te = function e(t) {
              var i,
                n,
                s = 99,
                r = function e() {
                  (i = null), t();
                },
                o = function e() {
                  var t = d.now() - n;
                  s > t ? B(e, s - t) : (p || r)(r);
                };
              return function () {
                (n = d.now()), i || (i = B(o, s));
              };
            };
          !(function () {
            var e,
              t = {
                lazyClass: "lazyload",
                loadedClass: "lazyloaded",
                loadingClass: "lazyloading",
                preloadClass: "lazypreload",
                errorClass: "lazyerror",
                autosizesClass: "lazyautosizes",
                srcAttr: "data-src",
                srcsetAttr: "data-srcset",
                sizesAttr: "data-sizes",
                minSize: 40,
                customMedia: {},
                init: !0,
                expFactor: 1.5,
                hFac: 0.8,
                loadMode: 2,
                loadHidden: !0,
                ricTimeout: 300,
              };
            j = l.lazySizesConfig || l.lazysizesConfig || {};
            for (e in t) {
              e in j || (j[e] = t[e]);
            }
            (l.lazySizesConfig = j),
              B(function () {
                j.init && i();
              });
          })();
          var t = (function () {
              var u,
                p,
                h,
                f,
                i,
                m,
                g,
                v,
                y,
                b,
                w,
                x,
                T,
                S,
                o = /^img$/i,
                C = /^iframe$/i,
                E = "onscroll" in l && !/glebot/.test(navigator.userAgent),
                k = 0,
                $ = 0,
                A = 0,
                z = -1,
                M = function e(t) {
                  A--,
                    t && t.target && V(t.target, e),
                    (!t || 0 > A || !t.target) && (A = 0);
                },
                D = function e(t, i) {
                  var n,
                    s = t,
                    r =
                      "hidden" == Q(N.body, "visibility") ||
                      "hidden" != Q(t, "visibility");
                  for (
                    v -= i, w += i, y -= i, b += i;
                    r && (s = s.offsetParent) && s != N.body && s != R;

                  ) {
                    (r = (Q(s, "opacity") || 1) > 0),
                      r &&
                        "visible" != Q(s, "overflow") &&
                        ((n = s.getBoundingClientRect()),
                        (r =
                          b > n.left &&
                          y < n.right &&
                          w > n.top - 1 &&
                          v < n.bottom + 1));
                  }
                  return r;
                },
                t = function e() {
                  var t,
                    i,
                    n,
                    s,
                    r,
                    o,
                    a,
                    l,
                    d,
                    c = H.elements;
                  if ((f = j.loadMode) && 8 > A && (t = c.length)) {
                    (i = 0),
                      z++,
                      null == T &&
                        ("expand" in j ||
                          (j.expand =
                            R.clientHeight > 500 && R.clientWidth > 500
                              ? 500
                              : 370),
                        (x = j.expand),
                        (T = x * j.expFactor)),
                      T > $ && 1 > A && z > 2 && f > 2 && !N.hidden
                        ? (($ = T), (z = 0))
                        : ($ = f > 1 && z > 1 && 6 > A ? x : k);
                    for (; t > i; i++) {
                      if (c[i] && !c[i]._lazyRace)
                        if (E) {
                          if (
                            (((l = c[i][q]("data-expand")) && (o = 1 * l)) ||
                              (o = $),
                            d !== o &&
                              ((m = innerWidth + o * S),
                              (g = innerHeight + o),
                              (a = -1 * o),
                              (d = o)),
                            (n = c[i].getBoundingClientRect()),
                            (w = n.bottom) >= a &&
                              (v = n.top) <= g &&
                              (b = n.right) >= a * S &&
                              (y = n.left) <= m &&
                              (w || b || y || v) &&
                              (j.loadHidden ||
                                "hidden" != Q(c[i], "visibility")) &&
                              ((p && 3 > A && !l && (3 > f || 4 > z)) ||
                                D(c[i], o)))
                          ) {
                            if ((I(c[i]), (r = !0), A > 9)) break;
                          } else
                            !r &&
                              p &&
                              !s &&
                              4 > A &&
                              4 > z &&
                              f > 2 &&
                              (u[0] || j.preloadAfterLoad) &&
                              (u[0] ||
                                (!l &&
                                  (w ||
                                    b ||
                                    y ||
                                    v ||
                                    "auto" != c[i][q](j.sizesAttr)))) &&
                              (s = u[0] || c[i]);
                        } else I(c[i]);
                    }
                    s && !r && I(s);
                  }
                },
                n = e(t),
                _ = function e(t) {
                  Y(t.target, j.loadedClass),
                    U(t.target, j.loadingClass),
                    V(t.target, P),
                    K(t.target, "lazyloaded");
                },
                s = ee(_),
                P = function e(t) {
                  s({ target: t.target });
                },
                L = function e(t, i) {
                  try {
                    t.contentWindow.location.replace(i);
                  } catch (e) {
                    t.src = i;
                  }
                },
                O = function e(t) {
                  var i,
                    n = t[q](j.srcsetAttr);
                  (i = j.customMedia[t[q]("data-media") || t[q]("media")]) &&
                    t.setAttribute("media", i),
                    n && t.setAttribute("srcset", n);
                },
                a = ee(function (e, t, i, n, s) {
                  var r, o, a, l, d, c;
                  (d = K(e, "lazybeforeunveil", t)).defaultPrevented ||
                    (n &&
                      (i ? Y(e, j.autosizesClass) : e.setAttribute("sizes", n)),
                    (o = e[q](j.srcsetAttr)),
                    (r = e[q](j.srcAttr)),
                    s &&
                      ((a = e.parentNode), (l = a && W.test(a.nodeName || ""))),
                    (c = t.firesLoad || ("src" in e && (o || r || l))),
                    (d = { target: e }),
                    c &&
                      (V(e, M, !0),
                      clearTimeout(h),
                      (h = B(M, 2500)),
                      Y(e, j.loadingClass),
                      V(e, P, !0)),
                    l && G.call(a.getElementsByTagName("source"), O),
                    o
                      ? e.setAttribute("srcset", o)
                      : r && !l && (C.test(e.nodeName) ? L(e, r) : (e.src = r)),
                    s && (o || l) && Z(e, { src: r })),
                    e._lazyRace && delete e._lazyRace,
                    U(e, j.lazyClass),
                    J(function () {
                      (!c || (e.complete && e.naturalWidth > 1)) &&
                        (c ? M(d) : A--, _(d));
                    }, !0);
                }),
                I = function e(t) {
                  var i,
                    n = o.test(t.nodeName),
                    s = n && (t[q](j.sizesAttr) || t[q]("sizes")),
                    r = "auto" == s;
                  ((!r && p) ||
                    !n ||
                    (!t[q]("src") && !t.srcset) ||
                    t.complete ||
                    X(t, j.errorClass) ||
                    !X(t, j.lazyClass)) &&
                    ((i = K(t, "lazyunveilread").detail),
                    r && ie.updateElem(t, !0, t.offsetWidth),
                    (t._lazyRace = !0),
                    A++,
                    a(t, i, r, s, n));
                },
                r = function e() {
                  if (!p) {
                    if (d.now() - i < 999) return void B(e, 999);
                    var t = te(function () {
                      (j.loadMode = 3), n();
                    });
                    (p = !0),
                      (j.loadMode = 3),
                      n(),
                      F(
                        "scroll",
                        function () {
                          3 == j.loadMode && (j.loadMode = 2), t();
                        },
                        !0
                      );
                  }
                };
              return {
                _: function e() {
                  (i = d.now()),
                    (H.elements = N.getElementsByClassName(j.lazyClass)),
                    (u = N.getElementsByClassName(
                      j.lazyClass + " " + j.preloadClass
                    )),
                    (S = j.hFac),
                    F("scroll", n, !0),
                    F("resize", n, !0),
                    l.MutationObserver
                      ? new MutationObserver(n).observe(R, {
                          childList: !0,
                          subtree: !0,
                          attributes: !0,
                        })
                      : (R[c]("DOMNodeInserted", n, !0),
                        R[c]("DOMAttrModified", n, !0),
                        setInterval(n, 999)),
                    F("hashchange", n, !0),
                    [
                      "focus",
                      "mouseover",
                      "click",
                      "load",
                      "transitionend",
                      "animationend",
                      "webkitAnimationEnd",
                    ].forEach(function (e) {
                      N[c](e, n, !0);
                    }),
                    /d$|^c/.test(N.readyState)
                      ? r()
                      : (F("load", r), N[c]("DOMContentLoaded", n), B(r, 2e4)),
                    H.elements.length ? (t(), J._lsFlush()) : n();
                },
                checkElems: n,
                unveil: I,
              };
            })(),
            ie = (function () {
              var n,
                r = ee(function (e, t, i, n) {
                  var s, r, o;
                  if (
                    ((e._lazysizesWidth = n),
                    (n += "px"),
                    e.setAttribute("sizes", n),
                    W.test(t.nodeName || ""))
                  )
                    for (
                      s = t.getElementsByTagName("source"), r = 0, o = s.length;
                      o > r;
                      r++
                    ) {
                      s[r].setAttribute("sizes", n);
                    }
                  i.detail.dataAttr || Z(e, i.detail);
                }),
                s = function e(t, i, n) {
                  var e,
                    s = t.parentNode;
                  s &&
                    ((n = o(t, s, n)),
                    (e = K(t, "lazybeforesizes", { width: n, dataAttr: !!i })),
                    e.defaultPrevented ||
                      ((n = e.detail.width),
                      n && n !== t._lazysizesWidth && r(t, s, e, n)));
                },
                e = function e() {
                  var t,
                    i = n.length;
                  if (i)
                    for (t = 0; i > t; t++) {
                      s(n[t]);
                    }
                },
                t = te(e);
              return {
                _: function e() {
                  (n = N.getElementsByClassName(j.autosizesClass)),
                    F("resize", t);
                },
                checkElems: t,
                updateElem: s,
              };
            })(),
            i = function e() {
              e.i || ((e.i = !0), ie._(), t._());
            };
          return (H = {
            cfg: j,
            autoSizer: ie,
            loader: t,
            init: i,
            uP: Z,
            aC: Y,
            rC: U,
            hC: X,
            fire: K,
            gW: o,
            rAF: J,
          });
        }
      })(e, e.document)),
      (e.lazySizes = t),
      "object" ==
        ("undefined" == typeof module ? "undefined" : _typeof(module)) &&
        module.exports &&
        (module.exports = t),
      (i = window),
      (n = (n = function (u, d, f) {
        "use strict";
        function m(e, t, i) {
          var n,
            s,
            r,
            o = 0,
            a = 0,
            l = i;
          if (e) {
            if ("container" === t.ratio) {
              for (
                o = l.scrollWidth, a = l.scrollHeight;
                !((o && a) || l === d);

              )
                (o = (l = l.parentNode).scrollWidth), (a = l.scrollHeight);
              o && a && (t.ratio = a / o);
            }
            (n = e),
              (s = t),
              ((r = []).srcset = []),
              s.absUrl && (S.setAttribute("href", n), (n = S.href)),
              (n = ((s.prefix || "") + n + (s.postfix || "")).replace(
                h,
                function (e, t) {
                  return c[_typeof(s[t])] ? s[t] : e;
                }
              )),
              s.widths.forEach(function (e) {
                var t = s.widthmap[e] || e,
                  i = {
                    u: n
                      .replace(w, t)
                      .replace(p, s.ratio ? Math.round(e * s.ratio) : ""),
                    w: e,
                  };
                r.push(i), r.srcset.push((i.c = i.u + " " + e + "w"));
              }),
              ((e = r).isPicture = t.isPicture),
              C && "IMG" == i.nodeName.toUpperCase()
                ? i.removeAttribute(y.srcsetAttr)
                : i.setAttribute(y.srcsetAttr, e.srcset.join(", ")),
              Object.defineProperty(i, "_lazyrias", { value: e, writable: !0 });
          }
        }
        function g(e, t) {
          var i = (function (s, e) {
            var t,
              i,
              n,
              r,
              o = u.getComputedStyle(s);
            for (t in ((i = s.parentNode),
            (r = { isPicture: !(!i || !l.test(i.nodeName || "")) }),
            (n = function (e, t) {
              var i = s.getAttribute("data-" + e);
              if (!i) {
                var n = o.getPropertyValue("--ls-" + e);
                n && (i = n.trim());
              }
              if (i) {
                if ("true" == i) i = !0;
                else if ("false" == i) i = !1;
                else if (a.test(i)) i = parseFloat(i);
                else if ("function" == typeof b[e]) i = b[e](s, i);
                else if (x.test(i))
                  try {
                    i = JSON.parse(i);
                  } catch (e) {}
                r[e] = i;
              } else
                e in b && "function" != typeof b[e]
                  ? (r[e] = b[e])
                  : t && "function" == typeof b[e] && (r[e] = b[e](s, i));
            }),
            b))
              n(t);
            return (
              e.replace(h, function (e, t) {
                t in r || n(t, !0);
              }),
              r
            );
          })(e, t);
          return (
            b.modifyOptions.call(e, { target: e, details: i, detail: i }),
            f.fire(e, "lazyriasmodifyoptions", i),
            i
          );
        }
        function v(e) {
          return (
            e.getAttribute(e.getAttribute("data-srcattr") || b.srcAttr) ||
            e.getAttribute(y.srcsetAttr) ||
            e.getAttribute(y.srcAttr) ||
            e.getAttribute("data-pfsrcset") ||
            ""
          );
        }
        var y,
          b,
          c = { string: 1, number: 1 },
          a = /^\-*\+*\d+\.*\d*$/,
          l = /^picture$/i,
          w = /\s*\{\s*width\s*\}\s*/i,
          p = /\s*\{\s*height\s*\}\s*/i,
          h = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
          x = /^\[.*\]|\{.*\}$/,
          T = /^(?:auto|\d+(px)?)$/,
          S = d.createElement("a"),
          e = d.createElement("img"),
          C = "srcset" in e && !("sizes" in e),
          E = !!u.HTMLPictureElement && !C;
        !(function () {
          var e,
            t = {
              prefix: "",
              postfix: "",
              srcAttr: "data-src",
              absUrl: !1,
              modifyOptions: function () {},
              widthmap: {},
              ratio: !1,
            };
          for (e in ((y = (f && f.cfg) || u.lazySizesConfig) ||
            ((y = {}), (u.lazySizesConfig = y)),
          y.supportsType ||
            (y.supportsType = function (e) {
              return !e;
            }),
          y.rias || (y.rias = {}),
          "widths" in (b = y.rias) ||
            ((b.widths = []),
            (function (e) {
              for (var t, i = 0; !t || t < 3e3; )
                30 < (i += 5) && (i += 1), (t = 36 * i), e.push(t);
            })(b.widths)),
          t))
            e in b || (b[e] = t[e]);
        })(),
          addEventListener(
            "lazybeforesizes",
            function (e) {
              var t, i, n, s, r, o, a, l, d, c, u, p, h;
              if (
                e.detail.instance == f &&
                ((t = e.target),
                e.detail.dataAttr &&
                  !e.defaultPrevented &&
                  !b.disabled &&
                  (d =
                    t.getAttribute(y.sizesAttr) || t.getAttribute("sizes")) &&
                  T.test(d))
              ) {
                if (
                  ((n = g(t, (i = v(t)))),
                  (u = w.test(n.prefix) || w.test(n.postfix)),
                  n.isPicture && (s = t.parentNode))
                )
                  for (
                    o = 0, a = (r = s.getElementsByTagName("source")).length;
                    o < a;
                    o++
                  )
                    (u || w.test((l = v(r[o])))) && (m(l, n, r[o]), (p = !0));
                u || w.test(i)
                  ? (m(i, n, t), (p = !0))
                  : p &&
                    (((h = []).srcset = []),
                    (h.isPicture = !0),
                    Object.defineProperty(t, "_lazyrias", {
                      value: h,
                      writable: !0,
                    })),
                  p &&
                    (E
                      ? t.removeAttribute(y.srcAttr)
                      : "auto" != d &&
                        ((c = { width: parseInt(d, 10) }),
                        k({ target: t, detail: c })));
              }
            },
            !0
          );
        var n,
          k =
            ((n = function (e) {
              if (e.detail.instance == f) {
                var t,
                  i = e.target;
                return !C &&
                  (u.respimage || u.picturefill || lazySizesConfig.pf)
                  ? void d.removeEventListener("lazybeforesizes", n)
                  : void (
                      ("_lazyrias" in i || (e.detail.dataAttr && A(i, !0))) &&
                      (t = s(i, e.detail.width)) &&
                      t.u &&
                      i._lazyrias.cur != t.u &&
                      ((i._lazyrias.cur = t.u),
                      (t.cached = !0),
                      f.rAF(function () {
                        i.setAttribute(y.srcAttr, t.u),
                          i.setAttribute("src", t.u);
                      }))
                    );
              }
            }),
            E ? (n = function () {}) : addEventListener("lazybeforesizes", n),
            n);
        function $(e, t) {
          return e.w - t.w;
        }
        function A(e, t) {
          var i;
          return (
            !e._lazyrias &&
              f.pWS &&
              (i = f.pWS(e.getAttribute(y.srcsetAttr || ""))).length &&
              (Object.defineProperty(e, "_lazyrias", {
                value: i,
                writable: !0,
              }),
              t &&
                e.parentNode &&
                (i.isPicture =
                  "PICTURE" == e.parentNode.nodeName.toUpperCase())),
            e._lazyrias
          );
        }
        function s(e, t) {
          var i, n, s, r, o, a, l, d, c;
          if ((o = e._lazyrias).isPicture && u.matchMedia)
            for (
              n = 0,
                i = e.parentNode.getElementsByTagName("source"),
                s = i.length;
              n < s;
              n++
            )
              if (
                A(i[n]) &&
                !i[n].getAttribute("type") &&
                (!(r = i[n].getAttribute("media")) ||
                  (matchMedia(r) || {}).matches)
              ) {
                o = i[n]._lazyrias;
                break;
              }
          return (
            (!o.w || o.w < t) &&
              ((o.w = t),
              (o.d =
                ((l = e),
                (d = u.devicePixelRatio || 1),
                (c = f.getX && f.getX(l)),
                Math.min(c || d, 2.4, d))),
              (a = (function (e) {
                for (var t, i, n = e.length, s = e[n - 1], r = 0; r < n; r++)
                  if (((s = e[r]), (s.d = s.w / e.w), s.d >= e.d)) {
                    !s.cached &&
                      (t = e[r - 1]) &&
                      t.d > e.d - 0.13 * Math.pow(e.d, 2.2) &&
                      ((i = Math.pow(t.d - 0.6, 1.6)),
                      t.cached && (t.d += 0.15 * i),
                      t.d + (s.d - e.d) * i > e.d && (s = t));
                    break;
                  }
                return s;
              })(o.sort($)))),
            a
          );
        }
      }).bind(null, i, i.document)),
      "object" ==
        ("undefined" == typeof module ? "undefined" : _typeof(module)) &&
      module.exports
        ? n(require("lazysizes"))
        : i.lazySizes
        ? Ee()
        : i.addEventListener("lazyunveilread", Ee, !0),
      (function (t, e) {
        "use strict";
        if (t.addEventListener) {
          var l,
            o = /^picture$/i,
            i = e.documentElement,
            s =
              ((g = /(([^,\s].[^\s]+)\s+(\d+)(w|h)(\s+(\d+)(w|h))?)/g),
              function (e) {
                return (m = []), e.replace(g, f), m;
              }),
            d = function (e, t) {
              var i, n, s, r;
              if (
                !e[t] &&
                ((r = e.parentNode || {}),
                (e[t] = h(e, t)),
                (e[t].isImg = !0),
                o.test(r.nodeName || ""))
              )
                for (
                  e[t].picture = !0,
                    n = 0,
                    s = (i = r.getElementsByTagName("source")).length;
                  n < s;
                  n++
                )
                  h(i[n], t).isImg = !1;
              return e[t];
            },
            a = {
              _lazyOptimumx: function (e, t, i) {
                var n, s, r, o, a, l, d;
                for (n = 0; n < e.cands.length; n++)
                  if (
                    (((s = e.cands[n]).d = (s.w || 1) / t), !(e.index >= n))
                  ) {
                    if (
                      !(s.d <= i) &&
                      ((r = e.cands[n - 1]),
                      (o = s.d),
                      (a = i),
                      (d = l = void 0),
                      r &&
                        r.d &&
                        ((d = 0.7 < a ? 0.6 : 0.4),
                        r.d >= a ||
                          ((l = Math.pow(r.d - d, 1.6) || 0.1) < 0.1
                            ? (l = 0.1)
                            : 3 < l && (l = 3),
                          !(r.d + (o - a) * l < a))))
                    )
                      break;
                    e.cSrcset.push(s.c), (e.index = n);
                  }
              },
            },
            c = function (e, t, i, n, s) {
              var r,
                o,
                a,
                l,
                d = e[s];
              if (((d.width = t), d.picture && (o = e.parentNode)))
                for (
                  l = 0, a = (r = o.getElementsByTagName("source")).length;
                  l < a;
                  l++
                )
                  p(r[l], t, i, n, s);
              p(e, t, i, n, s);
            },
            u = function (e) {
              var t =
                e.getAttribute("data-optimumx") ||
                e.getAttribute("data-maxdpr");
              return (
                !t && l.constrainPixelDensity && (t = "auto"),
                (t = t && ("auto" == t ? l.getOptimumX(e) : parseFloat(t, 10)))
              );
            },
            n = function e() {
              t.lazySizes &&
                !t.lazySizes.getOptimumX &&
                ((lazySizes.getX = u),
                (lazySizes.pWS = s),
                i.removeEventListener("lazybeforeunveil", e));
            };
          i.addEventListener("lazybeforeunveil", n),
            setTimeout(n),
            (l = (t.lazySizes && lazySizes.cfg) || t.lazySizesConfig) ||
              ((l = {}), (t.lazySizesConfig = l)),
            "function" != typeof l.getOptimumX &&
              (l.getOptimumX = function () {
                var e = t.devicePixelRatio || 1;
                return (
                  2.6 < e ? (e *= 0.6) : 1.9 < e ? (e *= 0.8) : (e -= 0.01),
                  Math.min(Math.round(100 * e) / 100, 2)
                );
              }),
            t.devicePixelRatio &&
              addEventListener("lazybeforesizes", function (e) {
                var t,
                  i,
                  n,
                  s,
                  r = e.target,
                  o = e.detail,
                  a = o.dataAttr;
                e.defaultPrevented ||
                  !(t = u(r)) ||
                  t >= devicePixelRatio ||
                  (!a ||
                    !r._lazyOptimumx ||
                    o.reloaded ||
                    (l.unloadedClass && lazySizes.hC(r, l.unloadedClass)) ||
                    (r._lazyOptimumx = null),
                  (i = d(r, "_lazyOptimumx")),
                  (n = o.width) &&
                    (i.width || 0) < n &&
                    ((s = a ? lazySizes.cfg.srcsetAttr : "srcset"),
                    lazySizes.rAF(function () {
                      c(r, n, t, s, "_lazyOptimumx");
                    })));
              });
        }
        function p(e, t, i, n, s) {
          var r,
            o = e[s];
          o &&
            ((r = o.index),
            a[s](o, t, i),
            (o.dirty && r == o.index) ||
              (o.cSrcset.join(", "),
              e.setAttribute(n, o.cSrcset.join(", ")),
              (o.dirty = !0)));
        }
        function r(e, t) {
          return e.w - t.w;
        }
        function h(e, t) {
          var i = { srcset: e.getAttribute(lazySizes.cfg.srcsetAttr) || "" },
            n = s(i.srcset);
          return (
            Object.defineProperty(e, t, { value: i, writable: !0 }),
            (i.cands = n),
            (i.index = 0),
            (i.dirty = !1),
            n[0] && n[0].w
              ? (n.sort(r), (i.cSrcset = [n[i.index].c]))
              : ((i.cSrcset = i.srcset ? [i.srcset] : []), (i.cands = [])),
            i
          );
        }
        function f(e, t, i, n, s, r, o, a) {
          m.push({ c: t, u: i, w: +("w" == a ? o : n) });
        }
        var m, g;
      })(window, document),
      (s = window),
      (r = (r = function (e, t, n) {
        "use strict";
        var s, r;
        "srcset" in t.createElement("img") &&
          ((s = /^img$/i),
          (r = function (e) {
            (e.target.style.backgroundSize = ""),
              (e.target.style.backgroundImage = ""),
              e.target.removeEventListener(e.type, r);
          }),
          t.addEventListener(
            "lazybeforeunveil",
            function (e) {
              if (e.detail.instance == n) {
                var t = e.target;
                if (s.test(t.nodeName)) {
                  var i = t.getAttribute("src");
                  i &&
                    ((t.style.backgroundSize = "100% 100%"),
                    (t.style.backgroundImage = "url(" + i + ")"),
                    t.removeAttribute("src"),
                    t.addEventListener("load", r));
                }
              }
            },
            !1
          ));
      }).bind(null, s, s.document)),
      "object" ==
        ("undefined" == typeof module ? "undefined" : _typeof(module)) &&
      module.exports
        ? r(require("lazysizes"))
        : s.lazySizes
        ? ke()
        : s.addEventListener("lazyunveilread", ke, !0),
      (o = window),
      (a = (a = function (a, e, i) {
        "use strict";
        if (a.addEventListener) {
          var l = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
            o = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/,
            d = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,
            c = /^picture$/i,
            u = {
              getParent: function (e, t) {
                var i = e,
                  n = e.parentNode;
                return (
                  (t && "prev" != t) ||
                    !n ||
                    !c.test(n.nodeName || "") ||
                    (n = n.parentNode),
                  "self" != t &&
                    (i =
                      "prev" == t
                        ? e.previousElementSibling
                        : (t &&
                            (n.closest || a.jQuery) &&
                            (n.closest
                              ? n.closest(t)
                              : jQuery(n).closest(t)[0])) ||
                          n),
                  i
                );
              },
              getFit: function (e) {
                var t,
                  i,
                  n = getComputedStyle(e, null) || {},
                  s = n.content || n.fontFamily,
                  r = {
                    fit:
                      e._lazysizesParentFit ||
                      e.getAttribute("data-parent-fit"),
                  };
                return (
                  !r.fit && s && (t = s.match(o)) && (r.fit = t[1]),
                  r.fit
                    ? (!(i =
                        e._lazysizesParentContainer ||
                        e.getAttribute("data-parent-container")) &&
                        s &&
                        (t = s.match(d)) &&
                        (i = t[1]),
                      (r.parent = u.getParent(e, i)))
                    : (r.fit = n.objectFit),
                  r
                );
              },
              getImageRatio: function (e) {
                var t,
                  i,
                  n,
                  s,
                  r = e.parentNode,
                  o =
                    r && c.test(r.nodeName || "")
                      ? r.querySelectorAll("source, img")
                      : [e];
                for (t = 0; t < o.length; t++)
                  if (
                    ((i =
                      (e = o[t]).getAttribute(lazySizesConfig.srcsetAttr) ||
                      e.getAttribute("srcset") ||
                      e.getAttribute("data-pfsrcset") ||
                      e.getAttribute("data-risrcset") ||
                      ""),
                    (n = e._lsMedia || e.getAttribute("media")),
                    (n =
                      lazySizesConfig.customMedia[
                        e.getAttribute("data-media") || n
                      ] || n),
                    i &&
                      (!n || ((a.matchMedia && matchMedia(n)) || {}).matches))
                  ) {
                    !(s = parseFloat(e.getAttribute("data-aspectratio"))) &&
                      i.match(l) &&
                      (s =
                        "w" == RegExp.$2
                          ? RegExp.$1 / RegExp.$3
                          : RegExp.$3 / RegExp.$1);
                    break;
                  }
                return s;
              },
              calculateSize: function (e, t) {
                var i,
                  n,
                  s,
                  r,
                  o = this.getFit(e),
                  a = o.fit,
                  l = o.parent;
                return "width" == a ||
                  (("contain" == a || "cover" == a) &&
                    (s = this.getImageRatio(e)))
                  ? (l ? (t = l.clientWidth) : (l = e),
                    (r = t),
                    "width" == a
                      ? (r = t)
                      : 40 < (n = l.clientHeight) &&
                        (i = t / n) &&
                        (("cover" == a && i < s) ||
                          ("contain" == a && s < i)) &&
                        (r = t * (s / i)),
                    r)
                  : t;
              },
            };
          (i.parentFit = u),
            e.addEventListener("lazybeforesizes", function (e) {
              if (!e.defaultPrevented && e.detail.instance == i) {
                var t = e.target;
                e.detail.width = u.calculateSize(t, e.detail.width);
              }
            });
        }
      }).bind(null, o, o.document)),
      "object" ==
        ("undefined" == typeof module ? "undefined" : _typeof(module)) &&
      module.exports
        ? a(require("lazysizes"))
        : o.lazySizes
        ? $e()
        : o.addEventListener("lazyunveilread", $e, !0),
      (l = window),
      (d = (d = function (u, r, p) {
        "use strict";
        var n,
          o,
          a,
          t,
          s,
          i,
          l,
          h,
          d,
          f,
          m = (p && p.cfg) || u.lazySizesConfig,
          e = r.createElement("img"),
          c = "sizes" in e && "srcset" in e,
          g = /\s+\d+h/g,
          v =
            ((o = /\s+(\d+)(w|h)\s+(\d+)(w|h)/),
            (a = Array.prototype.forEach),
            function (e) {
              function i(e) {
                var t,
                  i,
                  n = e.getAttribute(lazySizesConfig.srcsetAttr);
                n &&
                  (!(i = n.match(o)) ||
                    ((t = "w" == i[2] ? i[1] / i[3] : i[3] / i[1]) &&
                      e.setAttribute("data-aspectratio", t)),
                  e.setAttribute(lazySizesConfig.srcsetAttr, n.replace(g, "")));
              }
              function t(e) {
                var t = e.target.parentNode;
                t &&
                  "PICTURE" == t.nodeName &&
                  a.call(t.getElementsByTagName("source"), i),
                  i(e.target);
              }
              function n() {
                s.currentSrc && r.removeEventListener("lazybeforeunveil", t);
              }
              var s = r.createElement("img");
              e[1] &&
                (r.addEventListener("lazybeforeunveil", t),
                (s.onload = n),
                (s.onerror = n),
                (s.srcset = "data:,a 1w 1h"),
                s.complete && n());
            });
        if (
          (m || ((m = {}), (u.lazySizesConfig = m)),
          m.supportsType ||
            (m.supportsType = function (e) {
              return !e;
            }),
          !u.picturefill && !m.pf)
        ) {
          if (u.HTMLPictureElement && c)
            return (
              r.msElementsFromPoint &&
                v(navigator.userAgent.match(/Edge\/(\d+)/)),
              void (m.pf = function () {})
            );
          (m.pf = function (e) {
            var t, i;
            if (!u.picturefill)
              for (t = 0, i = e.elements.length; t < i; t++) n(e.elements[t]);
          }),
            (h = /^\s*\d+\.*\d*px\s*$/),
            (i = /(([^,\s].[^\s]+)\s+(\d+)w)/g),
            (l = /\s/),
            (f = function (e) {
              return u.matchMedia
                ? (f = function (e) {
                    return !e || (matchMedia(e) || {}).matches;
                  })(e)
                : !e;
            }),
            (T.parse = d =
              function (e) {
                return (
                  (s = []),
                  (e = e.trim()).replace(g, "").replace(i, S),
                  s.length || !e || l.test(e) || s.push({ c: e, u: e, w: 99 }),
                  s
                );
              }),
            (n = T),
            m.loadedClass &&
              m.loadingClass &&
              ((t = []),
              [
                'img[sizes$="px"][srcset].',
                "picture > img:not([srcset]).",
              ].forEach(function (e) {
                t.push(e + m.loadedClass), t.push(e + m.loadingClass);
              }),
              m.pf({ elements: r.querySelectorAll(t.join(", ")) }));
        }
        function y(e, t) {
          return e.w - t.w;
        }
        function b() {
          function e() {
            var e, t;
            for (e = 0, t = i.length; e < t; e++) n(i[e]);
          }
          var t, i;
          b.init ||
            ((b.init = !0),
            addEventListener(
              "resize",
              ((i = r.getElementsByClassName("lazymatchmedia")),
              function () {
                clearTimeout(t), (t = setTimeout(e, 66));
              })
            ));
        }
        function w(e, t) {
          var i,
            n = e.getAttribute("srcset") || e.getAttribute(m.srcsetAttr);
          !n &&
            t &&
            (n = e._lazypolyfill
              ? e._lazypolyfill._set
              : e.getAttribute(m.srcAttr) || e.getAttribute("src")),
            (e._lazypolyfill && e._lazypolyfill._set == n) ||
              ((i = d(n || "")),
              t &&
                e.parentNode &&
                ((i.isPicture =
                  "PICTURE" == e.parentNode.nodeName.toUpperCase()),
                i.isPicture &&
                  u.matchMedia &&
                  (p.aC(e, "lazymatchmedia"), b())),
              (i._set = n),
              Object.defineProperty(e, "_lazypolyfill", {
                value: i,
                writable: !0,
              }));
        }
        function x(e) {
          var t, i, n, s, r, o, a, l, d, c;
          if ((w((s = e), !0), (r = s._lazypolyfill).isPicture))
            for (
              i = 0,
                n = (t = e.parentNode.getElementsByTagName("source")).length;
              i < n;
              i++
            )
              if (
                m.supportsType(t[i].getAttribute("type"), e) &&
                f(t[i].getAttribute("media"))
              ) {
                (s = t[i]), w(s), (r = s._lazypolyfill);
                break;
              }
          return (
            1 < r.length
              ? ((a = s.getAttribute("sizes") || ""),
                (a = (h.test(a) && parseInt(a, 10)) || p.gW(e, e.parentNode)),
                (r.d =
                  ((l = e),
                  (d = u.devicePixelRatio || 1),
                  (c = p.getX && p.getX(l)),
                  Math.min(c || d, 2.5, d))),
                !r.src || !r.w || r.w < a
                  ? ((r.w = a),
                    (o = (function (e) {
                      for (
                        var t, i, n = e.length, s = e[n - 1], r = 0;
                        r < n;
                        r++
                      )
                        if ((((s = e[r]).d = s.w / e.w), s.d >= e.d)) {
                          !s.cached &&
                            (t = e[r - 1]) &&
                            t.d > e.d - 0.13 * Math.pow(e.d, 2.2) &&
                            ((i = Math.pow(t.d - 0.6, 1.6)),
                            t.cached && (t.d += 0.15 * i),
                            t.d + (s.d - e.d) * i > e.d && (s = t));
                          break;
                        }
                      return s;
                    })(r.sort(y))),
                    (r.src = o))
                  : (o = r.src))
              : (o = r[0]),
            o
          );
        }
        function T(e) {
          if (
            !c ||
            !e.parentNode ||
            "PICTURE" == e.parentNode.nodeName.toUpperCase()
          ) {
            var t = x(e);
            t &&
              t.u &&
              e._lazypolyfill.cur != t.u &&
              ((e._lazypolyfill.cur = t.u),
              (t.cached = !0),
              e.setAttribute(m.srcAttr, t.u),
              e.setAttribute("src", t.u));
          }
        }
        function S(e, t, i, n) {
          s.push({ c: t, u: i, w: +n });
        }
      }).bind(null, l, l.document)),
      "object" ==
        ("undefined" == typeof module ? "undefined" : _typeof(module)) &&
      module.exports
        ? d(require("lazysizes"), require("../fix-ios-sizes/fix-ios-sizes"))
        : l.lazySizes
        ? Ae()
        : l.addEventListener("lazyunveilread", Ae, !0),
      (c = window),
      (u = (u = function (e, u, p) {
        "use strict";
        if (e.addEventListener) {
          var h = /\s+/g,
            f = /\s*\|\s+|\s+\|\s*/g,
            m = /^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/,
            s = /\(|\)|'/,
            r = { contain: 1, cover: 1 },
            g = function (e) {
              if (e.target._lazybgset) {
                var t = e.target,
                  i = t._lazybgset,
                  n = t.currentSrc || t.src;
                n &&
                  (i.style.backgroundImage =
                    "url(" + (s.test(n) ? JSON.stringify(n) : n) + ")"),
                  t._lazybgsetLoading &&
                    (p.fire(i, "_lazyloaded", {}, !1, !0),
                    delete t._lazybgsetLoading);
              }
            };
          addEventListener("lazybeforeunveil", function (e) {
            var t, i, n, s, r, o, a, l, d, c;
            !e.defaultPrevented &&
              (t = e.target.getAttribute("data-bgset")) &&
              ((n = e.target),
              ((i = u.createElement("img")).alt = ""),
              (i._lazybgsetLoading = !0),
              (e.detail.firesLoad = !0),
              (s = t),
              (r = n),
              (o = i),
              (a = u.createElement("picture")),
              (l = r.getAttribute(lazySizesConfig.sizesAttr)),
              (d = r.getAttribute("data-ratio")),
              (c = r.getAttribute("data-optimumx")),
              r._lazybgset &&
                r._lazybgset.parentNode == r &&
                r.removeChild(r._lazybgset),
              Object.defineProperty(o, "_lazybgset", {
                value: r,
                writable: !0,
              }),
              Object.defineProperty(r, "_lazybgset", {
                value: a,
                writable: !0,
              }),
              (s = s.replace(h, " ").split(f)),
              (a.style.display = "none"),
              (o.className = lazySizesConfig.lazyClass),
              1 != s.length || l || (l = "auto"),
              s.forEach(function (e) {
                var t = u.createElement("source");
                l && "auto" != l && t.setAttribute("sizes", l),
                  e.match(m) &&
                    (t.setAttribute(lazySizesConfig.srcsetAttr, RegExp.$1),
                    RegExp.$2 &&
                      t.setAttribute(
                        "media",
                        lazySizesConfig.customMedia[RegExp.$2] || RegExp.$2
                      )),
                  a.appendChild(t);
              }),
              l &&
                (o.setAttribute(lazySizesConfig.sizesAttr, l),
                r.removeAttribute(lazySizesConfig.sizesAttr),
                r.removeAttribute("sizes")),
              c && o.setAttribute("data-optimumx", c),
              d && o.setAttribute("data-ratio", d),
              a.appendChild(o),
              r.appendChild(a),
              setTimeout(function () {
                p.loader.unveil(i),
                  p.rAF(function () {
                    p.fire(i, "_lazyloaded", {}, !0, !0),
                      i.complete && g({ target: i });
                  });
              }));
          }),
            u.addEventListener("load", g, !0),
            e.addEventListener(
              "lazybeforesizes",
              function (e) {
                if (
                  e.detail.instance == p &&
                  e.target._lazybgset &&
                  e.detail.dataAttr
                ) {
                  var t = e.target._lazybgset,
                    i =
                      ((n = t),
                      (s = (
                        getComputedStyle(n) || {
                          getPropertyValue: function () {},
                        }
                      ).getPropertyValue("background-size")),
                      !r[s] &&
                        r[n.style.backgroundSize] &&
                        (s = n.style.backgroundSize),
                      s);
                  r[i] &&
                    ((e.target._lazysizesParentFit = i),
                    p.rAF(function () {
                      e.target.setAttribute("data-parent-fit", i),
                        e.target._lazysizesParentFit &&
                          delete e.target._lazysizesParentFit;
                    }));
                }
                var n, s;
              },
              !0
            ),
            u.documentElement.addEventListener("lazybeforesizes", function (e) {
              var t, i;
              !e.defaultPrevented &&
                e.target._lazybgset &&
                e.detail.instance == p &&
                (e.detail.width =
                  ((t = e.target._lazybgset),
                  (i = p.gW(t, t.parentNode)),
                  (!t._lazysizesWidth || i > t._lazysizesWidth) &&
                    (t._lazysizesWidth = i),
                  t._lazysizesWidth));
            });
        }
      }).bind(null, c, c.document)),
      "object" ==
        ("undefined" == typeof module ? "undefined" : _typeof(module)) &&
      module.exports
        ? u(require("lazysizes"))
        : c.lazySizes
        ? ze()
        : c.addEventListener("lazyunveilread", ze, !0),
      document.addEventListener("lazyloaded", function (e) {
        e.target.parentElement.className =
          e.target.parentElement.className.replace("lazyload--placeholder", "");
      }),
      (h = this),
      (f = function () {
        "use strict";
        var f =
            "undefined" == typeof document
              ? {
                  body: {},
                  addEventListener: function () {},
                  removeEventListener: function () {},
                  activeElement: { blur: function () {}, nodeName: "" },
                  querySelector: function () {
                    return null;
                  },
                  querySelectorAll: function () {
                    return [];
                  },
                  getElementById: function () {
                    return null;
                  },
                  createEvent: function () {
                    return { initEvent: function () {} };
                  },
                  createElement: function () {
                    return {
                      children: [],
                      childNodes: [],
                      style: {},
                      setAttribute: function () {},
                      getElementsByTagName: function () {
                        return [];
                      },
                    };
                  },
                  location: { hash: "" },
                }
              : document,
          H =
            "undefined" == typeof window
              ? {
                  document: f,
                  navigator: { userAgent: "" },
                  location: {},
                  history: {},
                  CustomEvent: function () {
                    return this;
                  },
                  addEventListener: function () {},
                  removeEventListener: function () {},
                  getComputedStyle: function () {
                    return {
                      getPropertyValue: function () {
                        return "";
                      },
                    };
                  },
                  Image: function () {},
                  Date: function () {},
                  screen: {},
                  setTimeout: function () {},
                  clearTimeout: function () {},
                }
              : window,
          l = function (e) {
            for (var t = 0; t < e.length; t += 1) this[t] = e[t];
            return (this.length = e.length), this;
          };
        function M(e, t) {
          var i = [],
            n = 0;
          if (e && !t && e instanceof l) return e;
          if (e)
            if ("string" == typeof e) {
              var s,
                r,
                o = e.trim();
              if (0 <= o.indexOf("<") && 0 <= o.indexOf(">")) {
                var a = "div";
                for (
                  0 === o.indexOf("<li") && (a = "ul"),
                    0 === o.indexOf("<tr") && (a = "tbody"),
                    (0 !== o.indexOf("<td") && 0 !== o.indexOf("<th")) ||
                      (a = "tr"),
                    0 === o.indexOf("<tbody") && (a = "table"),
                    0 === o.indexOf("<option") && (a = "select"),
                    (r = f.createElement(a)).innerHTML = o,
                    n = 0;
                  n < r.childNodes.length;
                  n += 1
                )
                  i.push(r.childNodes[n]);
              } else
                for (
                  s =
                    t || "#" !== e[0] || e.match(/[ .<>:~]/)
                      ? (t || f).querySelectorAll(e.trim())
                      : [f.getElementById(e.trim().split("#")[1])],
                    n = 0;
                  n < s.length;
                  n += 1
                )
                  s[n] && i.push(s[n]);
            } else if (e.nodeType || e === H || e === f) i.push(e);
            else if (0 < e.length && e[0].nodeType)
              for (n = 0; n < e.length; n += 1) i.push(e[n]);
          return new l(i);
        }
        function r(e) {
          for (var t = [], i = 0; i < e.length; i += 1)
            -1 === t.indexOf(e[i]) && t.push(e[i]);
          return t;
        }
        (M.fn = l.prototype), (M.Class = l), (M.Dom7 = l);
        var t = {
          addClass: function (e) {
            if (void 0 === e) return this;
            for (var t = e.split(" "), i = 0; i < t.length; i += 1)
              for (var n = 0; n < this.length; n += 1)
                void 0 !== this[n].classList && this[n].classList.add(t[i]);
            return this;
          },
          removeClass: function (e) {
            for (var t = e.split(" "), i = 0; i < t.length; i += 1)
              for (var n = 0; n < this.length; n += 1)
                void 0 !== this[n].classList && this[n].classList.remove(t[i]);
            return this;
          },
          hasClass: function (e) {
            return !!this[0] && this[0].classList.contains(e);
          },
          toggleClass: function (e) {
            for (var t = e.split(" "), i = 0; i < t.length; i += 1)
              for (var n = 0; n < this.length; n += 1)
                void 0 !== this[n].classList && this[n].classList.toggle(t[i]);
            return this;
          },
          attr: function (e, t) {
            var i = arguments;
            if (1 === arguments.length && "string" == typeof e)
              return this[0] ? this[0].getAttribute(e) : void 0;
            for (var n = 0; n < this.length; n += 1)
              if (2 === i.length) this[n].setAttribute(e, t);
              else
                for (var s in e)
                  (this[n][s] = e[s]), this[n].setAttribute(s, e[s]);
            return this;
          },
          removeAttr: function (e) {
            for (var t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
            return this;
          },
          data: function (e, t) {
            var i;
            if (void 0 !== t) {
              for (var n = 0; n < this.length; n += 1)
                (i = this[n]).dom7ElementDataStorage ||
                  (i.dom7ElementDataStorage = {}),
                  (i.dom7ElementDataStorage[e] = t);
              return this;
            }
            if ((i = this[0]))
              return i.dom7ElementDataStorage && e in i.dom7ElementDataStorage
                ? i.dom7ElementDataStorage[e]
                : i.getAttribute("data-" + e) || void 0;
          },
          transform: function (e) {
            for (var t = 0; t < this.length; t += 1) {
              var i = this[t].style;
              (i.webkitTransform = e), (i.transform = e);
            }
            return this;
          },
          transition: function (e) {
            "string" != typeof e && (e += "ms");
            for (var t = 0; t < this.length; t += 1) {
              var i = this[t].style;
              (i.webkitTransitionDuration = e), (i.transitionDuration = e);
            }
            return this;
          },
          on: function () {
            for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
            var i = e[0],
              r = e[1],
              o = e[2],
              n = e[3];
            function s(e) {
              var t = e.target;
              if (t) {
                var i = e.target.dom7EventData || [];
                if ((i.indexOf(e) < 0 && i.unshift(e), M(t).is(r)))
                  o.apply(t, i);
                else
                  for (var n = M(t).parents(), s = 0; s < n.length; s += 1)
                    M(n[s]).is(r) && o.apply(n[s], i);
              }
            }
            function a(e) {
              var t = (e && e.target && e.target.dom7EventData) || [];
              t.indexOf(e) < 0 && t.unshift(e), o.apply(this, t);
            }
            "function" == typeof e[1] &&
              ((i = e[0]), (o = e[1]), (n = e[2]), (r = void 0)),
              (n = n || !1);
            for (var l, d = i.split(" "), c = 0; c < this.length; c += 1) {
              var u = this[c];
              if (r)
                for (l = 0; l < d.length; l += 1) {
                  var p = d[l];
                  u.dom7LiveListeners || (u.dom7LiveListeners = {}),
                    u.dom7LiveListeners[p] || (u.dom7LiveListeners[p] = []),
                    u.dom7LiveListeners[p].push({
                      listener: o,
                      proxyListener: s,
                    }),
                    u.addEventListener(p, s, n);
                }
              else
                for (l = 0; l < d.length; l += 1) {
                  var h = d[l];
                  u.dom7Listeners || (u.dom7Listeners = {}),
                    u.dom7Listeners[h] || (u.dom7Listeners[h] = []),
                    u.dom7Listeners[h].push({ listener: o, proxyListener: a }),
                    u.addEventListener(h, a, n);
                }
            }
            return this;
          },
          off: function () {
            for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
            var i = e[0],
              n = e[1],
              s = e[2],
              r = e[3];
            "function" == typeof e[1] &&
              ((i = e[0]), (s = e[1]), (r = e[2]), (n = void 0)),
              (r = r || !1);
            for (var o = i.split(" "), a = 0; a < o.length; a += 1)
              for (var l = o[a], d = 0; d < this.length; d += 1) {
                var c = this[d],
                  u = void 0;
                if (
                  (!n && c.dom7Listeners
                    ? (u = c.dom7Listeners[l])
                    : n && c.dom7LiveListeners && (u = c.dom7LiveListeners[l]),
                  u && u.length)
                )
                  for (var p = u.length - 1; 0 <= p; --p) {
                    var h = u[p];
                    ((!s || h.listener !== s) && s) ||
                      (c.removeEventListener(l, h.proxyListener, r),
                      u.splice(p, 1));
                  }
              }
            return this;
          },
          trigger: function () {
            for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
            for (var i = e[0].split(" "), n = e[1], s = 0; s < i.length; s += 1)
              for (var r = i[s], o = 0; o < this.length; o += 1) {
                var a = this[o],
                  l = void 0;
                try {
                  l = new H.CustomEvent(r, {
                    detail: n,
                    bubbles: !0,
                    cancelable: !0,
                  });
                } catch (e) {
                  (l = f.createEvent("Event")).initEvent(r, !0, !0),
                    (l.detail = n);
                }
                (a.dom7EventData = e.filter(function (e, t) {
                  return 0 < t;
                })),
                  a.dispatchEvent(l),
                  (a.dom7EventData = []),
                  delete a.dom7EventData;
              }
            return this;
          },
          transitionEnd: function (t) {
            var i,
              n = ["webkitTransitionEnd", "transitionend"],
              s = this;
            function r(e) {
              if (e.target === this)
                for (t.call(this, e), i = 0; i < n.length; i += 1)
                  s.off(n[i], r);
            }
            if (t) for (i = 0; i < n.length; i += 1) s.on(n[i], r);
            return this;
          },
          outerWidth: function (e) {
            if (0 < this.length) {
              if (e) {
                var t = this.styles();
                return (
                  this[0].offsetWidth +
                  parseFloat(t.getPropertyValue("margin-right")) +
                  parseFloat(t.getPropertyValue("margin-left"))
                );
              }
              return this[0].offsetWidth;
            }
            return null;
          },
          outerHeight: function (e) {
            if (0 < this.length) {
              if (e) {
                var t = this.styles();
                return (
                  this[0].offsetHeight +
                  parseFloat(t.getPropertyValue("margin-top")) +
                  parseFloat(t.getPropertyValue("margin-bottom"))
                );
              }
              return this[0].offsetHeight;
            }
            return null;
          },
          offset: function () {
            if (0 < this.length) {
              var e = this[0],
                t = e.getBoundingClientRect(),
                i = f.body,
                n = e.clientTop || i.clientTop || 0,
                s = e.clientLeft || i.clientLeft || 0,
                r = e === H ? H.scrollY : e.scrollTop,
                o = e === H ? H.scrollX : e.scrollLeft;
              return { top: t.top + r - n, left: t.left + o - s };
            }
            return null;
          },
          css: function (e, t) {
            var i;
            if (1 === arguments.length) {
              if ("string" != typeof e) {
                for (i = 0; i < this.length; i += 1)
                  for (var n in e) this[i].style[n] = e[n];
                return this;
              }
              if (this[0])
                return H.getComputedStyle(this[0], null).getPropertyValue(e);
            }
            if (2 !== arguments.length || "string" != typeof e) return this;
            for (i = 0; i < this.length; i += 1) this[i].style[e] = t;
            return this;
          },
          each: function (e) {
            if (!e) return this;
            for (var t = 0; t < this.length; t += 1)
              if (!1 === e.call(this[t], t, this[t])) return this;
            return this;
          },
          html: function (e) {
            if (void 0 === e) return this[0] ? this[0].innerHTML : void 0;
            for (var t = 0; t < this.length; t += 1) this[t].innerHTML = e;
            return this;
          },
          text: function (e) {
            if (void 0 === e)
              return this[0] ? this[0].textContent.trim() : null;
            for (var t = 0; t < this.length; t += 1) this[t].textContent = e;
            return this;
          },
          is: function (e) {
            var t,
              i,
              n = this[0];
            if (!n || void 0 === e) return !1;
            if ("string" == typeof e) {
              if (n.matches) return n.matches(e);
              if (n.webkitMatchesSelector) return n.webkitMatchesSelector(e);
              if (n.msMatchesSelector) return n.msMatchesSelector(e);
              for (t = M(e), i = 0; i < t.length; i += 1)
                if (t[i] === n) return !0;
              return !1;
            }
            if (e === f) return n === f;
            if (e === H) return n === H;
            if (e.nodeType || e instanceof l) {
              for (t = e.nodeType ? [e] : e, i = 0; i < t.length; i += 1)
                if (t[i] === n) return !0;
              return !1;
            }
            return !1;
          },
          index: function () {
            var e,
              t = this[0];
            if (t) {
              for (e = 0; null !== (t = t.previousSibling); )
                1 === t.nodeType && (e += 1);
              return e;
            }
          },
          eq: function (e) {
            if (void 0 === e) return this;
            var t,
              i = this.length;
            return new l(
              i - 1 < e
                ? []
                : e < 0
                ? (t = i + e) < 0
                  ? []
                  : [this[t]]
                : [this[e]]
            );
          },
          append: function () {
            for (var e, t = [], i = arguments.length; i--; )
              t[i] = arguments[i];
            for (var n = 0; n < t.length; n += 1) {
              e = t[n];
              for (var s = 0; s < this.length; s += 1)
                if ("string" == typeof e) {
                  var r = f.createElement("div");
                  for (r.innerHTML = e; r.firstChild; )
                    this[s].appendChild(r.firstChild);
                } else if (e instanceof l)
                  for (var o = 0; o < e.length; o += 1)
                    this[s].appendChild(e[o]);
                else this[s].appendChild(e);
            }
            return this;
          },
          prepend: function (e) {
            var t, i;
            for (t = 0; t < this.length; t += 1)
              if ("string" == typeof e) {
                var n = f.createElement("div");
                for (n.innerHTML = e, i = n.childNodes.length - 1; 0 <= i; --i)
                  this[t].insertBefore(n.childNodes[i], this[t].childNodes[0]);
              } else if (e instanceof l)
                for (i = 0; i < e.length; i += 1)
                  this[t].insertBefore(e[i], this[t].childNodes[0]);
              else this[t].insertBefore(e, this[t].childNodes[0]);
            return this;
          },
          next: function (e) {
            return 0 < this.length
              ? e
                ? this[0].nextElementSibling &&
                  M(this[0].nextElementSibling).is(e)
                  ? new l([this[0].nextElementSibling])
                  : new l([])
                : this[0].nextElementSibling
                ? new l([this[0].nextElementSibling])
                : new l([])
              : new l([]);
          },
          nextAll: function (e) {
            var t = [],
              i = this[0];
            if (!i) return new l([]);
            for (; i.nextElementSibling; ) {
              var n = i.nextElementSibling;
              (e && !M(n).is(e)) || t.push(n), (i = n);
            }
            return new l(t);
          },
          prev: function (e) {
            if (0 < this.length) {
              var t = this[0];
              return e
                ? t.previousElementSibling && M(t.previousElementSibling).is(e)
                  ? new l([t.previousElementSibling])
                  : new l([])
                : t.previousElementSibling
                ? new l([t.previousElementSibling])
                : new l([]);
            }
            return new l([]);
          },
          prevAll: function (e) {
            var t = [],
              i = this[0];
            if (!i) return new l([]);
            for (; i.previousElementSibling; ) {
              var n = i.previousElementSibling;
              (e && !M(n).is(e)) || t.push(n), (i = n);
            }
            return new l(t);
          },
          parent: function (e) {
            for (var t = [], i = 0; i < this.length; i += 1)
              null === this[i].parentNode ||
                (e && !M(this[i].parentNode).is(e)) ||
                t.push(this[i].parentNode);
            return M(r(t));
          },
          parents: function (e) {
            for (var t = [], i = 0; i < this.length; i += 1)
              for (var n = this[i].parentNode; n; )
                (e && !M(n).is(e)) || t.push(n), (n = n.parentNode);
            return M(r(t));
          },
          closest: function (e) {
            var t = this;
            return void 0 === e
              ? new l([])
              : (t.is(e) || (t = t.parents(e).eq(0)), t);
          },
          find: function (e) {
            for (var t = [], i = 0; i < this.length; i += 1)
              for (
                var n = this[i].querySelectorAll(e), s = 0;
                s < n.length;
                s += 1
              )
                t.push(n[s]);
            return new l(t);
          },
          children: function (e) {
            for (var t = [], i = 0; i < this.length; i += 1)
              for (var n = this[i].childNodes, s = 0; s < n.length; s += 1)
                e
                  ? 1 === n[s].nodeType && M(n[s]).is(e) && t.push(n[s])
                  : 1 === n[s].nodeType && t.push(n[s]);
            return new l(r(t));
          },
          remove: function () {
            for (var e = 0; e < this.length; e += 1)
              this[e].parentNode && this[e].parentNode.removeChild(this[e]);
            return this;
          },
          add: function () {
            for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
            var i, n;
            for (i = 0; i < e.length; i += 1) {
              var s = M(e[i]);
              for (n = 0; n < s.length; n += 1)
                (this[this.length] = s[n]), (this.length += 1);
            }
            return this;
          },
          styles: function () {
            return this[0] ? H.getComputedStyle(this[0], null) : {};
          },
        };
        Object.keys(t).forEach(function (e) {
          M.fn[e] = t[e];
        });
        function e(e) {
          void 0 === e && (e = {});
          var t = this;
          (t.params = e),
            (t.eventsListeners = {}),
            t.params &&
              t.params.on &&
              Object.keys(t.params.on).forEach(function (e) {
                t.on(e, t.params.on[e]);
              });
        }
        var i,
          n,
          s,
          j = {
            deleteProps: function (e) {
              var t = e;
              Object.keys(t).forEach(function (e) {
                try {
                  t[e] = null;
                } catch (e) {}
                try {
                  delete t[e];
                } catch (e) {}
              });
            },
            nextTick: function (e, t) {
              return void 0 === t && (t = 0), setTimeout(e, t);
            },
            now: function () {
              return Date.now();
            },
            getTranslate: function (e, t) {
              var i, n, s;
              void 0 === t && (t = "x");
              var r = H.getComputedStyle(e, null);
              return (
                H.WebKitCSSMatrix
                  ? (6 <
                      (n = r.transform || r.webkitTransform).split(",")
                        .length &&
                      (n = n
                        .split(", ")
                        .map(function (e) {
                          return e.replace(",", ".");
                        })
                        .join(", ")),
                    (s = new H.WebKitCSSMatrix("none" === n ? "" : n)))
                  : (i = (s =
                      r.MozTransform ||
                      r.OTransform ||
                      r.MsTransform ||
                      r.msTransform ||
                      r.transform ||
                      r
                        .getPropertyValue("transform")
                        .replace("translate(", "matrix(1, 0, 0, 1,"))
                      .toString()
                      .split(",")),
                "x" === t &&
                  (n = H.WebKitCSSMatrix
                    ? s.m41
                    : 16 === i.length
                    ? parseFloat(i[12])
                    : parseFloat(i[4])),
                "y" === t &&
                  (n = H.WebKitCSSMatrix
                    ? s.m42
                    : 16 === i.length
                    ? parseFloat(i[13])
                    : parseFloat(i[5])),
                n || 0
              );
            },
            parseUrlQuery: function (e) {
              var t,
                i,
                n,
                s,
                r = {},
                o = e || H.location.href;
              if ("string" == typeof o && o.length)
                for (
                  s = (i = (o =
                    -1 < o.indexOf("?") ? o.replace(/\S*\?/, "") : "")
                    .split("&")
                    .filter(function (e) {
                      return "" !== e;
                    })).length,
                    t = 0;
                  t < s;
                  t += 1
                )
                  (n = i[t].replace(/#\S+/g, "").split("=")),
                    (r[decodeURIComponent(n[0])] =
                      void 0 === n[1]
                        ? void 0
                        : decodeURIComponent(n[1]) || "");
              return r;
            },
            isObject: function (e) {
              return (
                "object" == _typeof(e) &&
                null !== e &&
                e.constructor &&
                e.constructor === Object
              );
            },
            extend: function () {
              for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
              for (var i = Object(e[0]), n = 1; n < e.length; n += 1) {
                var s = e[n];
                if (null != s)
                  for (
                    var r = Object.keys(Object(s)), o = 0, a = r.length;
                    o < a;
                    o += 1
                  ) {
                    var l = r[o],
                      d = Object.getOwnPropertyDescriptor(s, l);
                    void 0 !== d &&
                      d.enumerable &&
                      (j.isObject(i[l]) && j.isObject(s[l])
                        ? j.extend(i[l], s[l])
                        : !j.isObject(i[l]) && j.isObject(s[l])
                        ? ((i[l] = {}), j.extend(i[l], s[l]))
                        : (i[l] = s[l]));
                  }
              }
              return i;
            },
          },
          R =
            ((s = f.createElement("div")),
            {
              touch:
                (H.Modernizr && !0 === H.Modernizr.touch) ||
                !!(
                  "ontouchstart" in H ||
                  (H.DocumentTouch && f instanceof H.DocumentTouch)
                ),
              pointerEvents: !(!H.navigator.pointerEnabled && !H.PointerEvent),
              prefixedPointerEvents: !!H.navigator.msPointerEnabled,
              transition:
                "transition" in (n = s.style) ||
                "webkitTransition" in n ||
                "MozTransition" in n,
              transforms3d:
                (H.Modernizr && !0 === H.Modernizr.csstransforms3d) ||
                "webkitPerspective" in (i = s.style) ||
                "MozPerspective" in i ||
                "OPerspective" in i ||
                "MsPerspective" in i ||
                "perspective" in i,
              flexbox: (function () {
                for (
                  var e = s.style,
                    t =
                      "alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient".split(
                        " "
                      ),
                    i = 0;
                  i < t.length;
                  i += 1
                )
                  if (t[i] in e) return !0;
                return !1;
              })(),
              observer:
                "MutationObserver" in H || "WebkitMutationObserver" in H,
              passiveListener: (function () {
                var e = !1;
                try {
                  var t = Object.defineProperty({}, "passive", {
                    get: function () {
                      e = !0;
                    },
                  });
                  H.addEventListener("testPassiveListener", null, t);
                } catch (e) {}
                return e;
              })(),
              gestures: "ongesturestart" in H,
            }),
          o = { components: { configurable: !0 } };
        (e.prototype.on = function (e, t, i) {
          var n = this;
          if ("function" != typeof t) return n;
          var s = i ? "unshift" : "push";
          return (
            e.split(" ").forEach(function (e) {
              n.eventsListeners[e] || (n.eventsListeners[e] = []),
                n.eventsListeners[e][s](t);
            }),
            n
          );
        }),
          (e.prototype.once = function (n, s, e) {
            var r = this;
            return "function" != typeof s
              ? r
              : r.on(
                  n,
                  function e() {
                    for (var t = [], i = arguments.length; i--; )
                      t[i] = arguments[i];
                    s.apply(r, t), r.off(n, e);
                  },
                  e
                );
          }),
          (e.prototype.off = function (e, n) {
            var s = this;
            return (
              s.eventsListeners &&
                e.split(" ").forEach(function (i) {
                  void 0 === n
                    ? (s.eventsListeners[i] = [])
                    : s.eventsListeners[i].forEach(function (e, t) {
                        e === n && s.eventsListeners[i].splice(t, 1);
                      });
                }),
              s
            );
          }),
          (e.prototype.emit = function () {
            for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
            var i,
              n,
              s,
              r = this;
            return (
              r.eventsListeners &&
                ((s =
                  "string" == typeof e[0] || Array.isArray(e[0])
                    ? ((i = e[0]), (n = e.slice(1, e.length)), r)
                    : ((i = e[0].events), (n = e[0].data), e[0].context || r)),
                (Array.isArray(i) ? i : i.split(" ")).forEach(function (e) {
                  if (r.eventsListeners && r.eventsListeners[e]) {
                    var t = [];
                    r.eventsListeners[e].forEach(function (e) {
                      t.push(e);
                    }),
                      t.forEach(function (e) {
                        e.apply(s, n);
                      });
                  }
                })),
              r
            );
          }),
          (e.prototype.useModulesParams = function (i) {
            var n = this;
            n.modules &&
              Object.keys(n.modules).forEach(function (e) {
                var t = n.modules[e];
                t.params && j.extend(i, t.params);
              });
          }),
          (e.prototype.useModules = function (n) {
            void 0 === n && (n = {});
            var s = this;
            s.modules &&
              Object.keys(s.modules).forEach(function (e) {
                var i = s.modules[e],
                  t = n[e] || {};
                i.instance &&
                  Object.keys(i.instance).forEach(function (e) {
                    var t = i.instance[e];
                    s[e] = "function" == typeof t ? t.bind(s) : t;
                  }),
                  i.on &&
                    s.on &&
                    Object.keys(i.on).forEach(function (e) {
                      s.on(e, i.on[e]);
                    }),
                  i.create && i.create.bind(s)(t);
              });
          }),
          (o.components.set = function (e) {
            this.use && this.use(e);
          }),
          (e.installModule = function (t) {
            for (var e = [], i = arguments.length - 1; 0 < i--; )
              e[i] = arguments[i + 1];
            var n = this;
            n.prototype.modules || (n.prototype.modules = {});
            var s =
              t.name || Object.keys(n.prototype.modules).length + "_" + j.now();
            return (
              (n.prototype.modules[s] = t).proto &&
                Object.keys(t.proto).forEach(function (e) {
                  n.prototype[e] = t.proto[e];
                }),
              t.static &&
                Object.keys(t.static).forEach(function (e) {
                  n[e] = t.static[e];
                }),
              t.install && t.install.apply(n, e),
              n
            );
          }),
          (e.use = function (e) {
            for (var t = [], i = arguments.length - 1; 0 < i--; )
              t[i] = arguments[i + 1];
            var n = this;
            return Array.isArray(e)
              ? (e.forEach(function (e) {
                  return n.installModule(e);
                }),
                n)
              : n.installModule.apply(n, [e].concat(t));
          }),
          Object.defineProperties(e, o);
        var a = {
            updateSize: function () {
              var e,
                t,
                i = this.$el;
              (e =
                void 0 !== this.params.width
                  ? this.params.width
                  : i[0].clientWidth),
                (t =
                  void 0 !== this.params.height
                    ? this.params.height
                    : i[0].clientHeight),
                (0 === e && this.isHorizontal()) ||
                  (0 === t && this.isVertical()) ||
                  ((e =
                    e -
                    parseInt(i.css("padding-left"), 10) -
                    parseInt(i.css("padding-right"), 10)),
                  (t =
                    t -
                    parseInt(i.css("padding-top"), 10) -
                    parseInt(i.css("padding-bottom"), 10)),
                  j.extend(this, {
                    width: e,
                    height: t,
                    size: this.isHorizontal() ? e : t,
                  }));
            },
            updateSlides: function () {
              var e = this.params,
                t = this.$wrapperEl,
                i = this.size,
                n = this.rtlTranslate,
                s = this.wrongRTL,
                r = this.virtual && e.virtual.enabled,
                o = r ? this.virtual.slides.length : this.slides.length,
                a = t.children("." + this.params.slideClass),
                l = r ? this.virtual.slides.length : a.length,
                d = [],
                c = [],
                u = [],
                p = e.slidesOffsetBefore;
              "function" == typeof p && (p = e.slidesOffsetBefore.call(this));
              var h = e.slidesOffsetAfter;
              "function" == typeof h && (h = e.slidesOffsetAfter.call(this));
              var f = this.snapGrid.length,
                m = this.snapGrid.length,
                g = e.spaceBetween,
                v = -p,
                y = 0,
                b = 0;
              if (void 0 !== i) {
                var w, x;
                "string" == typeof g &&
                  0 <= g.indexOf("%") &&
                  (g = (parseFloat(g.replace("%", "")) / 100) * i),
                  (this.virtualSize = -g),
                  n
                    ? a.css({ marginLeft: "", marginTop: "" })
                    : a.css({ marginRight: "", marginBottom: "" }),
                  1 < e.slidesPerColumn &&
                    ((w =
                      Math.floor(l / e.slidesPerColumn) ===
                      l / this.params.slidesPerColumn
                        ? l
                        : Math.ceil(l / e.slidesPerColumn) * e.slidesPerColumn),
                    "auto" !== e.slidesPerView &&
                      "row" === e.slidesPerColumnFill &&
                      (w = Math.max(w, e.slidesPerView * e.slidesPerColumn)));
                for (
                  var T,
                    S = e.slidesPerColumn,
                    C = w / S,
                    E = C - (e.slidesPerColumn * C - l),
                    k = 0;
                  k < l;
                  k += 1
                ) {
                  x = 0;
                  var $ = a.eq(k);
                  if (1 < e.slidesPerColumn) {
                    var A = void 0,
                      z = void 0,
                      M = void 0;
                    "column" === e.slidesPerColumnFill
                      ? ((M = k - (z = Math.floor(k / S)) * S),
                        (E < z || (z === E && M === S - 1)) &&
                          (M += 1) >= S &&
                          ((M = 0), (z += 1)),
                        (A = z + (M * w) / S),
                        $.css({
                          "-webkit-box-ordinal-group": A,
                          "-moz-box-ordinal-group": A,
                          "-ms-flex-order": A,
                          "-webkit-order": A,
                          order: A,
                        }))
                      : (z = k - (M = Math.floor(k / C)) * C),
                      $.css(
                        "margin-" + (this.isHorizontal() ? "top" : "left"),
                        0 !== M && e.spaceBetween && e.spaceBetween + "px"
                      )
                        .attr("data-swiper-column", z)
                        .attr("data-swiper-row", M);
                  }
                  if ("none" !== $.css("display")) {
                    if ("auto" === e.slidesPerView) {
                      var D = H.getComputedStyle($[0], null),
                        _ = $[0].style.transform,
                        P = $[0].style.webkitTransform;
                      _ && ($[0].style.transform = "none"),
                        P && ($[0].style.webkitTransform = "none"),
                        (x = this.isHorizontal()
                          ? $[0].getBoundingClientRect().width +
                            parseFloat(D.getPropertyValue("margin-left")) +
                            parseFloat(D.getPropertyValue("margin-right"))
                          : $[0].getBoundingClientRect().height +
                            parseFloat(D.getPropertyValue("margin-top")) +
                            parseFloat(D.getPropertyValue("margin-bottom"))),
                        _ && ($[0].style.transform = _),
                        P && ($[0].style.webkitTransform = P),
                        e.roundLengths && (x = Math.floor(x));
                    } else
                      (x = (i - (e.slidesPerView - 1) * g) / e.slidesPerView),
                        e.roundLengths && (x = Math.floor(x)),
                        a[k] &&
                          (this.isHorizontal()
                            ? (a[k].style.width = x + "px")
                            : (a[k].style.height = x + "px"));
                    a[k] && (a[k].swiperSlideSize = x),
                      u.push(x),
                      e.centeredSlides
                        ? ((v = v + x / 2 + y / 2 + g),
                          0 === y && 0 !== k && (v = v - i / 2 - g),
                          0 === k && (v = v - i / 2 - g),
                          Math.abs(v) < 0.001 && (v = 0),
                          e.roundLengths && (v = Math.floor(v)),
                          b % e.slidesPerGroup == 0 && d.push(v),
                          c.push(v))
                        : (e.roundLengths && (v = Math.floor(v)),
                          b % e.slidesPerGroup == 0 && d.push(v),
                          c.push(v),
                          (v = v + x + g)),
                      (this.virtualSize += x + g),
                      (y = x),
                      (b += 1);
                  }
                }
                if (
                  ((this.virtualSize = Math.max(this.virtualSize, i) + h),
                  n &&
                    s &&
                    ("slide" === e.effect || "coverflow" === e.effect) &&
                    t.css({ width: this.virtualSize + e.spaceBetween + "px" }),
                  (R.flexbox && !e.setWrapperSize) ||
                    (this.isHorizontal()
                      ? t.css({
                          width: this.virtualSize + e.spaceBetween + "px",
                        })
                      : t.css({
                          height: this.virtualSize + e.spaceBetween + "px",
                        })),
                  1 < e.slidesPerColumn &&
                    ((this.virtualSize = (x + e.spaceBetween) * w),
                    (this.virtualSize =
                      Math.ceil(this.virtualSize / e.slidesPerColumn) -
                      e.spaceBetween),
                    this.isHorizontal()
                      ? t.css({
                          width: this.virtualSize + e.spaceBetween + "px",
                        })
                      : t.css({
                          height: this.virtualSize + e.spaceBetween + "px",
                        }),
                    e.centeredSlides))
                ) {
                  T = [];
                  for (var L = 0; L < d.length; L += 1) {
                    var O = d[L];
                    e.roundLengths && (O = Math.floor(O)),
                      d[L] < this.virtualSize + d[0] && T.push(O);
                  }
                  d = T;
                }
                if (!e.centeredSlides) {
                  T = [];
                  for (var I = 0; I < d.length; I += 1) {
                    var N = d[I];
                    e.roundLengths && (N = Math.floor(N)),
                      d[I] <= this.virtualSize - i && T.push(N);
                  }
                  (d = T),
                    1 <
                      Math.floor(this.virtualSize - i) -
                        Math.floor(d[d.length - 1]) &&
                      d.push(this.virtualSize - i);
                }
                0 === d.length && (d = [0]),
                  0 !== e.spaceBetween &&
                    (this.isHorizontal()
                      ? n
                        ? a.css({ marginLeft: g + "px" })
                        : a.css({ marginRight: g + "px" })
                      : a.css({ marginBottom: g + "px" })),
                  j.extend(this, {
                    slides: a,
                    snapGrid: d,
                    slidesGrid: c,
                    slidesSizesGrid: u,
                  }),
                  l !== o && this.emit("slidesLengthChange"),
                  d.length !== f &&
                    (this.params.watchOverflow && this.checkOverflow(),
                    this.emit("snapGridLengthChange")),
                  c.length !== m && this.emit("slidesGridLengthChange"),
                  (e.watchSlidesProgress || e.watchSlidesVisibility) &&
                    this.updateSlidesOffset();
              }
            },
            updateAutoHeight: function (e) {
              var t,
                i = [],
                n = 0;
              if (
                ("number" == typeof e
                  ? this.setTransition(e)
                  : !0 === e && this.setTransition(this.params.speed),
                "auto" !== this.params.slidesPerView &&
                  1 < this.params.slidesPerView)
              )
                for (t = 0; t < Math.ceil(this.params.slidesPerView); t += 1) {
                  var s = this.activeIndex + t;
                  if (s > this.slides.length) break;
                  i.push(this.slides.eq(s)[0]);
                }
              else i.push(this.slides.eq(this.activeIndex)[0]);
              for (t = 0; t < i.length; t += 1)
                if (void 0 !== i[t]) {
                  var r = i[t].offsetHeight;
                  n = n < r ? r : n;
                }
              n && this.$wrapperEl.css("height", n + "px");
            },
            updateSlidesOffset: function () {
              for (var e = this.slides, t = 0; t < e.length; t += 1)
                e[t].swiperSlideOffset = this.isHorizontal()
                  ? e[t].offsetLeft
                  : e[t].offsetTop;
            },
            updateSlidesProgress: function (e) {
              void 0 === e && (e = (this && this.translate) || 0);
              var t = this.params,
                i = this.slides,
                n = this.rtlTranslate;
              if (0 !== i.length) {
                void 0 === i[0].swiperSlideOffset && this.updateSlidesOffset();
                var s = -e;
                n && (s = e), i.removeClass(t.slideVisibleClass);
                for (var r = 0; r < i.length; r += 1) {
                  var o = i[r],
                    a =
                      (s +
                        (t.centeredSlides ? this.minTranslate() : 0) -
                        o.swiperSlideOffset) /
                      (o.swiperSlideSize + t.spaceBetween);
                  if (t.watchSlidesVisibility) {
                    var l = -(s - o.swiperSlideOffset),
                      d = l + this.slidesSizesGrid[r];
                    ((0 <= l && l < this.size) ||
                      (0 < d && d <= this.size) ||
                      (l <= 0 && d >= this.size)) &&
                      i.eq(r).addClass(t.slideVisibleClass);
                  }
                  o.progress = n ? -a : a;
                }
              }
            },
            updateProgress: function (e) {
              void 0 === e && (e = (this && this.translate) || 0);
              var t = this.params,
                i = this.maxTranslate() - this.minTranslate(),
                n = this.progress,
                s = this.isBeginning,
                r = this.isEnd,
                o = s,
                a = r;
              (r =
                0 == i
                  ? (s = !(n = 0))
                  : ((s = (n = (e - this.minTranslate()) / i) <= 0), 1 <= n)),
                j.extend(this, { progress: n, isBeginning: s, isEnd: r }),
                (t.watchSlidesProgress || t.watchSlidesVisibility) &&
                  this.updateSlidesProgress(e),
                s && !o && this.emit("reachBeginning toEdge"),
                r && !a && this.emit("reachEnd toEdge"),
                ((o && !s) || (a && !r)) && this.emit("fromEdge"),
                this.emit("progress", n);
            },
            updateSlidesClasses: function () {
              var e,
                t = this.slides,
                i = this.params,
                n = this.$wrapperEl,
                s = this.activeIndex,
                r = this.realIndex,
                o = this.virtual && i.virtual.enabled;
              t.removeClass(
                i.slideActiveClass +
                  " " +
                  i.slideNextClass +
                  " " +
                  i.slidePrevClass +
                  " " +
                  i.slideDuplicateActiveClass +
                  " " +
                  i.slideDuplicateNextClass +
                  " " +
                  i.slideDuplicatePrevClass
              ),
                (e = o
                  ? this.$wrapperEl.find(
                      "." +
                        i.slideClass +
                        '[data-swiper-slide-index="' +
                        s +
                        '"]'
                    )
                  : t.eq(s)).addClass(i.slideActiveClass),
                i.loop &&
                  (e.hasClass(i.slideDuplicateClass)
                    ? n
                        .children(
                          "." +
                            i.slideClass +
                            ":not(." +
                            i.slideDuplicateClass +
                            ')[data-swiper-slide-index="' +
                            r +
                            '"]'
                        )
                        .addClass(i.slideDuplicateActiveClass)
                    : n
                        .children(
                          "." +
                            i.slideClass +
                            "." +
                            i.slideDuplicateClass +
                            '[data-swiper-slide-index="' +
                            r +
                            '"]'
                        )
                        .addClass(i.slideDuplicateActiveClass));
              var a = e
                .nextAll("." + i.slideClass)
                .eq(0)
                .addClass(i.slideNextClass);
              i.loop &&
                0 === a.length &&
                (a = t.eq(0)).addClass(i.slideNextClass);
              var l = e
                .prevAll("." + i.slideClass)
                .eq(0)
                .addClass(i.slidePrevClass);
              i.loop &&
                0 === l.length &&
                (l = t.eq(-1)).addClass(i.slidePrevClass),
                i.loop &&
                  (a.hasClass(i.slideDuplicateClass)
                    ? n
                        .children(
                          "." +
                            i.slideClass +
                            ":not(." +
                            i.slideDuplicateClass +
                            ')[data-swiper-slide-index="' +
                            a.attr("data-swiper-slide-index") +
                            '"]'
                        )
                        .addClass(i.slideDuplicateNextClass)
                    : n
                        .children(
                          "." +
                            i.slideClass +
                            "." +
                            i.slideDuplicateClass +
                            '[data-swiper-slide-index="' +
                            a.attr("data-swiper-slide-index") +
                            '"]'
                        )
                        .addClass(i.slideDuplicateNextClass),
                  l.hasClass(i.slideDuplicateClass)
                    ? n
                        .children(
                          "." +
                            i.slideClass +
                            ":not(." +
                            i.slideDuplicateClass +
                            ')[data-swiper-slide-index="' +
                            l.attr("data-swiper-slide-index") +
                            '"]'
                        )
                        .addClass(i.slideDuplicatePrevClass)
                    : n
                        .children(
                          "." +
                            i.slideClass +
                            "." +
                            i.slideDuplicateClass +
                            '[data-swiper-slide-index="' +
                            l.attr("data-swiper-slide-index") +
                            '"]'
                        )
                        .addClass(i.slideDuplicatePrevClass));
            },
            updateActiveIndex: function (e) {
              var t,
                i = this.rtlTranslate ? this.translate : -this.translate,
                n = this.slidesGrid,
                s = this.snapGrid,
                r = this.params,
                o = this.activeIndex,
                a = this.realIndex,
                l = this.snapIndex,
                d = e;
              if (void 0 === d) {
                for (var c = 0; c < n.length; c += 1)
                  void 0 !== n[c + 1]
                    ? i >= n[c] && i < n[c + 1] - (n[c + 1] - n[c]) / 2
                      ? (d = c)
                      : i >= n[c] && i < n[c + 1] && (d = c + 1)
                    : i >= n[c] && (d = c);
                r.normalizeSlideIndex && (d < 0 || void 0 === d) && (d = 0);
              }
              if (
                ((t =
                  0 <= s.indexOf(i)
                    ? s.indexOf(i)
                    : Math.floor(d / r.slidesPerGroup)) >= s.length &&
                  (t = s.length - 1),
                d !== o)
              ) {
                var u = parseInt(
                  this.slides.eq(d).attr("data-swiper-slide-index") || d,
                  10
                );
                j.extend(this, {
                  snapIndex: t,
                  realIndex: u,
                  previousIndex: o,
                  activeIndex: d,
                }),
                  this.emit("activeIndexChange"),
                  this.emit("snapIndexChange"),
                  a !== u && this.emit("realIndexChange"),
                  this.emit("slideChange");
              } else
                t !== l && ((this.snapIndex = t), this.emit("snapIndexChange"));
            },
            updateClickedSlide: function (e) {
              var t = this.params,
                i = M(e.target).closest("." + t.slideClass)[0],
                n = !1;
              if (i)
                for (var s = 0; s < this.slides.length; s += 1)
                  this.slides[s] === i && (n = !0);
              if (!i || !n)
                return (
                  (this.clickedSlide = void 0),
                  void (this.clickedIndex = void 0)
                );
              (this.clickedSlide = i),
                this.virtual && this.params.virtual.enabled
                  ? (this.clickedIndex = parseInt(
                      M(i).attr("data-swiper-slide-index"),
                      10
                    ))
                  : (this.clickedIndex = M(i).index()),
                t.slideToClickedSlide &&
                  void 0 !== this.clickedIndex &&
                  this.clickedIndex !== this.activeIndex &&
                  this.slideToClickedSlide();
            },
          },
          d = {
            getTranslate: function (e) {
              void 0 === e && (e = this.isHorizontal() ? "x" : "y");
              var t = this.params,
                i = this.rtlTranslate,
                n = this.translate,
                s = this.$wrapperEl;
              if (t.virtualTranslate) return i ? -n : n;
              var r = j.getTranslate(s[0], e);
              return i && (r = -r), r || 0;
            },
            setTranslate: function (e, t) {
              var i = this.rtlTranslate,
                n = this.params,
                s = this.$wrapperEl,
                r = this.progress,
                o = 0,
                a = 0;
              this.isHorizontal() ? (o = i ? -e : e) : (a = e),
                n.roundLengths && ((o = Math.floor(o)), (a = Math.floor(a))),
                n.virtualTranslate ||
                  (R.transforms3d
                    ? s.transform("translate3d(" + o + "px, " + a + "px, 0px)")
                    : s.transform("translate(" + o + "px, " + a + "px)")),
                (this.previousTranslate = this.translate),
                (this.translate = this.isHorizontal() ? o : a);
              var l = this.maxTranslate() - this.minTranslate();
              (0 == l ? 0 : (e - this.minTranslate()) / l) !== r &&
                this.updateProgress(e),
                this.emit("setTranslate", this.translate, t);
            },
            minTranslate: function () {
              return -this.snapGrid[0];
            },
            maxTranslate: function () {
              return -this.snapGrid[this.snapGrid.length - 1];
            },
          },
          c = {
            slideTo: function (e, t, i, n) {
              void 0 === e && (e = 0),
                void 0 === t && (t = this.params.speed),
                void 0 === i && (i = !0);
              var s = this,
                r = e;
              r < 0 && (r = 0);
              var o = s.params,
                a = s.snapGrid,
                l = s.slidesGrid,
                d = s.previousIndex,
                c = s.activeIndex,
                u = s.rtlTranslate;
              if (s.animating && o.preventIntercationOnTransition) return !1;
              var p = Math.floor(r / o.slidesPerGroup);
              p >= a.length && (p = a.length - 1),
                (c || o.initialSlide || 0) === (d || 0) &&
                  i &&
                  s.emit("beforeSlideChangeStart");
              var h,
                f = -a[p];
              if ((s.updateProgress(f), o.normalizeSlideIndex))
                for (var m = 0; m < l.length; m += 1)
                  -Math.floor(100 * f) >= Math.floor(100 * l[m]) && (r = m);
              if (s.initialized && r !== c) {
                if (
                  !s.allowSlideNext &&
                  f < s.translate &&
                  f < s.minTranslate()
                )
                  return !1;
                if (
                  !s.allowSlidePrev &&
                  f > s.translate &&
                  f > s.maxTranslate() &&
                  (c || 0) !== r
                )
                  return !1;
              }
              return (
                (h = c < r ? "next" : r < c ? "prev" : "reset"),
                (u && -f === s.translate) || (!u && f === s.translate)
                  ? (s.updateActiveIndex(r),
                    o.autoHeight && s.updateAutoHeight(),
                    s.updateSlidesClasses(),
                    "slide" !== o.effect && s.setTranslate(f),
                    "reset" != h &&
                      (s.transitionStart(i, h), s.transitionEnd(i, h)),
                    !1)
                  : (0 !== t && R.transition
                      ? (s.setTransition(t),
                        s.setTranslate(f),
                        s.updateActiveIndex(r),
                        s.updateSlidesClasses(),
                        s.emit("beforeTransitionStart", t, n),
                        s.transitionStart(i, h),
                        s.animating ||
                          ((s.animating = !0),
                          s.onSlideToWrapperTransitionEnd ||
                            (s.onSlideToWrapperTransitionEnd = function (e) {
                              s &&
                                !s.destroyed &&
                                e.target === this &&
                                (s.$wrapperEl[0].removeEventListener(
                                  "transitionend",
                                  s.onSlideToWrapperTransitionEnd
                                ),
                                s.$wrapperEl[0].removeEventListener(
                                  "webkitTransitionEnd",
                                  s.onSlideToWrapperTransitionEnd
                                ),
                                s.transitionEnd(i, h));
                            }),
                          s.$wrapperEl[0].addEventListener(
                            "transitionend",
                            s.onSlideToWrapperTransitionEnd
                          ),
                          s.$wrapperEl[0].addEventListener(
                            "webkitTransitionEnd",
                            s.onSlideToWrapperTransitionEnd
                          )))
                      : (s.setTransition(0),
                        s.setTranslate(f),
                        s.updateActiveIndex(r),
                        s.updateSlidesClasses(),
                        s.emit("beforeTransitionStart", t, n),
                        s.transitionStart(i, h),
                        s.transitionEnd(i, h)),
                    !0)
              );
            },
            slideToLoop: function (e, t, i, n) {
              void 0 === e && (e = 0),
                void 0 === t && (t = this.params.speed),
                void 0 === i && (i = !0);
              var s = e;
              return (
                this.params.loop && (s += this.loopedSlides),
                this.slideTo(s, t, i, n)
              );
            },
            slideNext: function (e, t, i) {
              void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
              var n = this.params,
                s = this.animating;
              return n.loop
                ? !s &&
                    (this.loopFix(),
                    (this._clientLeft = this.$wrapperEl[0].clientLeft),
                    this.slideTo(this.activeIndex + n.slidesPerGroup, e, t, i))
                : this.slideTo(this.activeIndex + n.slidesPerGroup, e, t, i);
            },
            slidePrev: function (e, t, i) {
              void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
              var n = this.params,
                s = this.animating,
                r = this.snapGrid,
                o = this.slidesGrid,
                a = this.rtlTranslate;
              if (n.loop) {
                if (s) return !1;
                this.loopFix(),
                  (this._clientLeft = this.$wrapperEl[0].clientLeft);
              }
              function l(e) {
                return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
              }
              var d,
                c = l(a ? this.translate : -this.translate),
                u = r.map(function (e) {
                  return l(e);
                }),
                p =
                  (o.map(function (e) {
                    return l(e);
                  }),
                  r[u.indexOf(c)],
                  r[u.indexOf(c) - 1]);
              return (
                void 0 !== p &&
                  (d = o.indexOf(p)) < 0 &&
                  (d = this.activeIndex - 1),
                this.slideTo(d, e, t, i)
              );
            },
            slideReset: function (e, t, i) {
              return (
                void 0 === e && (e = this.params.speed),
                void 0 === t && (t = !0),
                this.slideTo(this.activeIndex, e, t, i)
              );
            },
            slideToClosest: function (e, t, i) {
              void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
              var n = this.activeIndex,
                s = Math.floor(n / this.params.slidesPerGroup);
              if (s < this.snapGrid.length - 1) {
                var r = this.rtlTranslate ? this.translate : -this.translate,
                  o = this.snapGrid[s];
                r - o > (this.snapGrid[s + 1] - o) / 2 &&
                  (n = this.params.slidesPerGroup);
              }
              return this.slideTo(n, e, t, i);
            },
            slideToClickedSlide: function () {
              var e,
                t = this,
                i = t.params,
                n = t.$wrapperEl,
                s =
                  "auto" === i.slidesPerView
                    ? t.slidesPerViewDynamic()
                    : i.slidesPerView,
                r = t.clickedIndex;
              if (i.loop) {
                if (t.animating) return;
                (e = parseInt(
                  M(t.clickedSlide).attr("data-swiper-slide-index"),
                  10
                )),
                  i.centeredSlides
                    ? r < t.loopedSlides - s / 2 ||
                      r > t.slides.length - t.loopedSlides + s / 2
                      ? (t.loopFix(),
                        (r = n
                          .children(
                            "." +
                              i.slideClass +
                              '[data-swiper-slide-index="' +
                              e +
                              '"]:not(.' +
                              i.slideDuplicateClass +
                              ")"
                          )
                          .eq(0)
                          .index()),
                        j.nextTick(function () {
                          t.slideTo(r);
                        }))
                      : t.slideTo(r)
                    : r > t.slides.length - s
                    ? (t.loopFix(),
                      (r = n
                        .children(
                          "." +
                            i.slideClass +
                            '[data-swiper-slide-index="' +
                            e +
                            '"]:not(.' +
                            i.slideDuplicateClass +
                            ")"
                        )
                        .eq(0)
                        .index()),
                      j.nextTick(function () {
                        t.slideTo(r);
                      }))
                    : t.slideTo(r);
              } else t.slideTo(r);
            },
          },
          u = {
            loopCreate: function () {
              var n = this,
                e = n.params,
                t = n.$wrapperEl;
              t.children(
                "." + e.slideClass + "." + e.slideDuplicateClass
              ).remove();
              var s = t.children("." + e.slideClass);
              if (e.loopFillGroupWithBlank) {
                var i = e.slidesPerGroup - (s.length % e.slidesPerGroup);
                if (i !== e.slidesPerGroup) {
                  for (var r = 0; r < i; r += 1) {
                    var o = M(f.createElement("div")).addClass(
                      e.slideClass + " " + e.slideBlankClass
                    );
                    t.append(o);
                  }
                  s = t.children("." + e.slideClass);
                }
              }
              "auto" !== e.slidesPerView ||
                e.loopedSlides ||
                (e.loopedSlides = s.length),
                (n.loopedSlides = parseInt(
                  e.loopedSlides || e.slidesPerView,
                  10
                )),
                (n.loopedSlides += e.loopAdditionalSlides),
                n.loopedSlides > s.length && (n.loopedSlides = s.length);
              var a = [],
                l = [];
              s.each(function (e, t) {
                var i = M(t);
                e < n.loopedSlides && l.push(t),
                  e < s.length && e >= s.length - n.loopedSlides && a.push(t),
                  i.attr("data-swiper-slide-index", e);
              });
              for (var d = 0; d < l.length; d += 1)
                t.append(M(l[d].cloneNode(!0)).addClass(e.slideDuplicateClass));
              for (var c = a.length - 1; 0 <= c; --c)
                t.prepend(
                  M(a[c].cloneNode(!0)).addClass(e.slideDuplicateClass)
                );
            },
            loopFix: function () {
              var e,
                t = this.params,
                i = this.activeIndex,
                n = this.slides,
                s = this.loopedSlides,
                r = this.allowSlidePrev,
                o = this.allowSlideNext,
                a = this.snapGrid,
                l = this.rtlTranslate;
              (this.allowSlidePrev = !0), (this.allowSlideNext = !0);
              var d = -a[i] - this.getTranslate();
              i < s
                ? ((e = n.length - 3 * s + i),
                  (e += s),
                  this.slideTo(e, 0, !1, !0) &&
                    0 != d &&
                    this.setTranslate(
                      (l ? -this.translate : this.translate) - d
                    ))
                : (("auto" === t.slidesPerView && 2 * s <= i) ||
                    i >= n.length - s) &&
                  ((e = -n.length + i + s),
                  (e += s),
                  this.slideTo(e, 0, !1, !0) &&
                    0 != d &&
                    this.setTranslate(
                      (l ? -this.translate : this.translate) - d
                    )),
                (this.allowSlidePrev = r),
                (this.allowSlideNext = o);
            },
            loopDestroy: function () {
              var e = this.$wrapperEl,
                t = this.params,
                i = this.slides;
              e
                .children("." + t.slideClass + "." + t.slideDuplicateClass)
                .remove(),
                i.removeAttr("data-swiper-slide-index");
            },
          },
          p = {
            setGrabCursor: function (e) {
              if (
                !(
                  R.touch ||
                  !this.params.simulateTouch ||
                  (this.params.watchOverflow && this.isLocked)
                )
              ) {
                var t = this.el;
                (t.style.cursor = "move"),
                  (t.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab"),
                  (t.style.cursor = e ? "-moz-grabbin" : "-moz-grab"),
                  (t.style.cursor = e ? "grabbing" : "grab");
              }
            },
            unsetGrabCursor: function () {
              R.touch ||
                (this.params.watchOverflow && this.isLocked) ||
                (this.el.style.cursor = "");
            },
          },
          h = {
            appendSlide: function (e) {
              var t = this.$wrapperEl,
                i = this.params;
              if (
                (i.loop && this.loopDestroy(),
                "object" == _typeof(e) && "length" in e)
              )
                for (var n = 0; n < e.length; n += 1) e[n] && t.append(e[n]);
              else t.append(e);
              i.loop && this.loopCreate(),
                (i.observer && R.observer) || this.update();
            },
            prependSlide: function (e) {
              var t = this.params,
                i = this.$wrapperEl,
                n = this.activeIndex;
              t.loop && this.loopDestroy();
              var s = n + 1;
              if ("object" == _typeof(e) && "length" in e) {
                for (var r = 0; r < e.length; r += 1) e[r] && i.prepend(e[r]);
                s = n + e.length;
              } else i.prepend(e);
              t.loop && this.loopCreate(),
                (t.observer && R.observer) || this.update(),
                this.slideTo(s, 0, !1);
            },
            addSlide: function (e, t) {
              var i = this.$wrapperEl,
                n = this.params,
                s = this.activeIndex;
              n.loop &&
                ((s -= this.loopedSlides),
                this.loopDestroy(),
                (this.slides = i.children("." + n.slideClass)));
              var r = this.slides.length;
              if (e <= 0) this.prependSlide(t);
              else if (r <= e) this.appendSlide(t);
              else {
                for (
                  var o = e < s ? s + 1 : s, a = [], l = r - 1;
                  e <= l;
                  --l
                ) {
                  var d = this.slides.eq(l);
                  d.remove(), a.unshift(d);
                }
                if ("object" == _typeof(t) && "length" in t) {
                  for (var c = 0; c < t.length; c += 1) t[c] && i.append(t[c]);
                  o = e < s ? s + t.length : s;
                } else i.append(t);
                for (var u = 0; u < a.length; u += 1) i.append(a[u]);
                n.loop && this.loopCreate(),
                  (n.observer && R.observer) || this.update(),
                  n.loop
                    ? this.slideTo(o + this.loopedSlides, 0, !1)
                    : this.slideTo(o, 0, !1);
              }
            },
            removeSlide: function (e) {
              var t = this.params,
                i = this.$wrapperEl,
                n = this.activeIndex;
              t.loop &&
                ((n -= this.loopedSlides),
                this.loopDestroy(),
                (this.slides = i.children("." + t.slideClass)));
              var s,
                r = n;
              if ("object" == _typeof(e) && "length" in e) {
                for (var o = 0; o < e.length; o += 1)
                  (s = e[o]),
                    this.slides[s] && this.slides.eq(s).remove(),
                    s < r && --r;
                r = Math.max(r, 0);
              } else
                (s = e),
                  this.slides[s] && this.slides.eq(s).remove(),
                  s < r && --r,
                  (r = Math.max(r, 0));
              t.loop && this.loopCreate(),
                (t.observer && R.observer) || this.update(),
                t.loop
                  ? this.slideTo(r + this.loopedSlides, 0, !1)
                  : this.slideTo(r, 0, !1);
            },
            removeAllSlides: function () {
              for (var e = [], t = 0; t < this.slides.length; t += 1) e.push(t);
              this.removeSlide(e);
            },
          },
          m = (function () {
            var e = H.navigator.userAgent,
              t = {
                ios: !1,
                android: !1,
                androidChrome: !1,
                desktop: !1,
                windows: !1,
                iphone: !1,
                ipod: !1,
                ipad: !1,
                cordova: H.cordova || H.phonegap,
                phonegap: H.cordova || H.phonegap,
              },
              i = e.match(/(Windows Phone);?[\s\/]+([\d.]+)?/),
              n = e.match(/(Android);?[\s\/]+([\d.]+)?/),
              s = e.match(/(iPad).*OS\s([\d_]+)/),
              r = e.match(/(iPod)(.*OS\s([\d_]+))?/),
              o = !s && e.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
            if (
              (i &&
                ((t.os = "windows"), (t.osVersion = i[2]), (t.windows = !0)),
              n &&
                !i &&
                ((t.os = "android"),
                (t.osVersion = n[2]),
                (t.android = !0),
                (t.androidChrome = 0 <= e.toLowerCase().indexOf("chrome"))),
              (s || o || r) && ((t.os = "ios"), (t.ios = !0)),
              o &&
                !r &&
                ((t.osVersion = o[2].replace(/_/g, ".")), (t.iphone = !0)),
              s && ((t.osVersion = s[2].replace(/_/g, ".")), (t.ipad = !0)),
              r &&
                ((t.osVersion = r[3] ? r[3].replace(/_/g, ".") : null),
                (t.iphone = !0)),
              t.ios &&
                t.osVersion &&
                0 <= e.indexOf("Version/") &&
                "10" === t.osVersion.split(".")[0] &&
                (t.osVersion = e
                  .toLowerCase()
                  .split("version/")[1]
                  .split(" ")[0]),
              (t.desktop = !(t.os || t.android || t.webView)),
              (t.webView =
                (o || s || r) && e.match(/.*AppleWebKit(?!.*Safari)/i)),
              t.os && "ios" === t.os)
            ) {
              var a = t.osVersion.split("."),
                l = f.querySelector('meta[name="viewport"]');
              t.minimalUi =
                !t.webView &&
                (r || o) &&
                (7 == +a[0] ? 1 <= +a[1] : 7 < +a[0]) &&
                l &&
                0 <= l.getAttribute("content").indexOf("minimal-ui");
            }
            return (t.pixelRatio = H.devicePixelRatio || 1), t;
          })();
        function g() {
          var e = this.params,
            t = this.el;
          if (!t || 0 !== t.offsetWidth) {
            e.breakpoints && this.setBreakpoint();
            var i = this.allowSlideNext,
              n = this.allowSlidePrev,
              s = this.snapGrid;
            if (
              ((this.allowSlideNext = !0),
              (this.allowSlidePrev = !0),
              this.updateSize(),
              this.updateSlides(),
              e.freeMode)
            ) {
              var r = Math.min(
                Math.max(this.translate, this.maxTranslate()),
                this.minTranslate()
              );
              this.setTranslate(r),
                this.updateActiveIndex(),
                this.updateSlidesClasses(),
                e.autoHeight && this.updateAutoHeight();
            } else
              this.updateSlidesClasses(),
                ("auto" === e.slidesPerView || 1 < e.slidesPerView) &&
                this.isEnd &&
                !this.params.centeredSlides
                  ? this.slideTo(this.slides.length - 1, 0, !1, !0)
                  : this.slideTo(this.activeIndex, 0, !1, !0);
            (this.allowSlidePrev = n),
              (this.allowSlideNext = i),
              this.params.watchOverflow &&
                s !== this.snapGrid &&
                this.checkOverflow();
          }
        }
        var v,
          y = {
            attachEvents: function () {
              var e = this.params,
                t = this.touchEvents,
                i = this.el,
                n = this.wrapperEl;
              (this.onTouchStart = function (e) {
                var t = this.touchEventsData,
                  i = this.params,
                  n = this.touches;
                if (!this.animating || !i.preventIntercationOnTransition) {
                  var s = e;
                  if (
                    (s.originalEvent && (s = s.originalEvent),
                    (t.isTouchEvent = "touchstart" === s.type),
                    (t.isTouchEvent || !("which" in s) || 3 !== s.which) &&
                      (!t.isTouched || !t.isMoved))
                  )
                    if (
                      i.noSwiping &&
                      M(s.target).closest(
                        i.noSwipingSelector
                          ? i.noSwipingSelector
                          : "." + i.noSwipingClass
                      )[0]
                    )
                      this.allowClick = !0;
                    else if (
                      !i.swipeHandler ||
                      M(s).closest(i.swipeHandler)[0]
                    ) {
                      (n.currentX =
                        "touchstart" === s.type
                          ? s.targetTouches[0].pageX
                          : s.pageX),
                        (n.currentY =
                          "touchstart" === s.type
                            ? s.targetTouches[0].pageY
                            : s.pageY);
                      var r = n.currentX,
                        o = n.currentY;
                      if (
                        !m.ios ||
                        m.cordova ||
                        !i.iOSEdgeSwipeDetection ||
                        !(
                          r <= i.iOSEdgeSwipeThreshold ||
                          r >= H.screen.width - i.iOSEdgeSwipeThreshold
                        )
                      ) {
                        if (
                          (j.extend(t, {
                            isTouched: !0,
                            isMoved: !1,
                            allowTouchCallbacks: !0,
                            isScrolling: void 0,
                            startMoving: void 0,
                          }),
                          (n.startX = r),
                          (n.startY = o),
                          (t.touchStartTime = j.now()),
                          (this.allowClick = !0),
                          this.updateSize(),
                          (this.swipeDirection = void 0),
                          0 < i.threshold && (t.allowThresholdMove = !1),
                          "touchstart" !== s.type)
                        ) {
                          var a = !0;
                          M(s.target).is(t.formElements) && (a = !1),
                            f.activeElement &&
                              M(f.activeElement).is(t.formElements) &&
                              f.activeElement !== s.target &&
                              f.activeElement.blur(),
                            a && this.allowTouchMove && s.preventDefault();
                        }
                        this.emit("touchStart", s);
                      }
                    }
                }
              }.bind(this)),
                (this.onTouchMove = function (e) {
                  var t = this.touchEventsData,
                    i = this.params,
                    n = this.touches,
                    s = this.rtlTranslate,
                    r = e;
                  if ((r.originalEvent && (r = r.originalEvent), t.isTouched)) {
                    if (!t.isTouchEvent || "mousemove" !== r.type) {
                      var o =
                          "touchmove" === r.type
                            ? r.targetTouches[0].pageX
                            : r.pageX,
                        a =
                          "touchmove" === r.type
                            ? r.targetTouches[0].pageY
                            : r.pageY;
                      if (r.preventedByNestedSwiper)
                        return (n.startX = o), void (n.startY = a);
                      if (!this.allowTouchMove)
                        return (
                          (this.allowClick = !1),
                          void (
                            t.isTouched &&
                            (j.extend(n, {
                              startX: o,
                              startY: a,
                              currentX: o,
                              currentY: a,
                            }),
                            (t.touchStartTime = j.now()))
                          )
                        );
                      if (t.isTouchEvent && i.touchReleaseOnEdges && !i.loop)
                        if (this.isVertical()) {
                          if (
                            (a < n.startY &&
                              this.translate <= this.maxTranslate()) ||
                            (a > n.startY &&
                              this.translate >= this.minTranslate())
                          )
                            return (t.isTouched = !1), void (t.isMoved = !1);
                        } else if (
                          (o < n.startX &&
                            this.translate <= this.maxTranslate()) ||
                          (o > n.startX &&
                            this.translate >= this.minTranslate())
                        )
                          return;
                      if (
                        t.isTouchEvent &&
                        f.activeElement &&
                        r.target === f.activeElement &&
                        M(r.target).is(t.formElements)
                      )
                        return (t.isMoved = !0), void (this.allowClick = !1);
                      if (
                        (t.allowTouchCallbacks && this.emit("touchMove", r),
                        !(r.targetTouches && 1 < r.targetTouches.length))
                      ) {
                        (n.currentX = o), (n.currentY = a);
                        var l,
                          d = n.currentX - n.startX,
                          c = n.currentY - n.startY;
                        if (
                          (void 0 === t.isScrolling &&
                            ((this.isHorizontal() && n.currentY === n.startY) ||
                            (this.isVertical() && n.currentX === n.startX)
                              ? (t.isScrolling = !1)
                              : 25 <= d * d + c * c &&
                                ((l =
                                  (180 * Math.atan2(Math.abs(c), Math.abs(d))) /
                                  Math.PI),
                                (t.isScrolling = this.isHorizontal()
                                  ? l > i.touchAngle
                                  : 90 - l > i.touchAngle))),
                          t.isScrolling && this.emit("touchMoveOpposite", r),
                          "undefined" == typeof startMoving &&
                            ((n.currentX === n.startX &&
                              n.currentY === n.startY) ||
                              (t.startMoving = !0)),
                          t.isScrolling)
                        )
                          t.isTouched = !1;
                        else if (t.startMoving) {
                          (this.allowClick = !1),
                            r.preventDefault(),
                            i.touchMoveStopPropagation &&
                              !i.nested &&
                              r.stopPropagation(),
                            t.isMoved ||
                              (i.loop && this.loopFix(),
                              (t.startTranslate = this.getTranslate()),
                              this.setTransition(0),
                              this.animating &&
                                this.$wrapperEl.trigger(
                                  "webkitTransitionEnd transitionend"
                                ),
                              (t.allowMomentumBounce = !1),
                              !i.grabCursor ||
                                (!0 !== this.allowSlideNext &&
                                  !0 !== this.allowSlidePrev) ||
                                this.setGrabCursor(!0),
                              this.emit("sliderFirstMove", r)),
                            this.emit("sliderMove", r),
                            (t.isMoved = !0);
                          var u = this.isHorizontal() ? d : c;
                          (n.diff = u),
                            (u *= i.touchRatio),
                            s && (u = -u),
                            (this.swipeDirection = 0 < u ? "prev" : "next"),
                            (t.currentTranslate = u + t.startTranslate);
                          var p = !0,
                            h = i.resistanceRatio;
                          if (
                            (i.touchReleaseOnEdges && (h = 0),
                            0 < u && t.currentTranslate > this.minTranslate()
                              ? ((p = !1),
                                i.resistance &&
                                  (t.currentTranslate =
                                    this.minTranslate() -
                                    1 +
                                    Math.pow(
                                      -this.minTranslate() +
                                        t.startTranslate +
                                        u,
                                      h
                                    )))
                              : u < 0 &&
                                t.currentTranslate < this.maxTranslate() &&
                                ((p = !1),
                                i.resistance &&
                                  (t.currentTranslate =
                                    this.maxTranslate() +
                                    1 -
                                    Math.pow(
                                      this.maxTranslate() -
                                        t.startTranslate -
                                        u,
                                      h
                                    ))),
                            p && (r.preventedByNestedSwiper = !0),
                            !this.allowSlideNext &&
                              "next" === this.swipeDirection &&
                              t.currentTranslate < t.startTranslate &&
                              (t.currentTranslate = t.startTranslate),
                            !this.allowSlidePrev &&
                              "prev" === this.swipeDirection &&
                              t.currentTranslate > t.startTranslate &&
                              (t.currentTranslate = t.startTranslate),
                            0 < i.threshold)
                          ) {
                            if (
                              !(
                                Math.abs(u) > i.threshold ||
                                t.allowThresholdMove
                              )
                            )
                              return void (t.currentTranslate =
                                t.startTranslate);
                            if (!t.allowThresholdMove)
                              return (
                                (t.allowThresholdMove = !0),
                                (n.startX = n.currentX),
                                (n.startY = n.currentY),
                                (t.currentTranslate = t.startTranslate),
                                void (n.diff = this.isHorizontal()
                                  ? n.currentX - n.startX
                                  : n.currentY - n.startY)
                              );
                          }
                          i.followFinger &&
                            ((i.freeMode ||
                              i.watchSlidesProgress ||
                              i.watchSlidesVisibility) &&
                              (this.updateActiveIndex(),
                              this.updateSlidesClasses()),
                            i.freeMode &&
                              (0 === t.velocities.length &&
                                t.velocities.push({
                                  position:
                                    n[
                                      this.isHorizontal() ? "startX" : "startY"
                                    ],
                                  time: t.touchStartTime,
                                }),
                              t.velocities.push({
                                position:
                                  n[
                                    this.isHorizontal()
                                      ? "currentX"
                                      : "currentY"
                                  ],
                                time: j.now(),
                              })),
                            this.updateProgress(t.currentTranslate),
                            this.setTranslate(t.currentTranslate));
                        }
                      }
                    }
                  } else
                    t.startMoving &&
                      t.isScrolling &&
                      this.emit("touchMoveOpposite", r);
                }.bind(this)),
                (this.onTouchEnd = function (e) {
                  var t = this,
                    i = t.touchEventsData,
                    n = t.params,
                    s = t.touches,
                    r = t.rtlTranslate,
                    o = t.$wrapperEl,
                    a = t.slidesGrid,
                    l = t.snapGrid,
                    d = e;
                  if (
                    (d.originalEvent && (d = d.originalEvent),
                    i.allowTouchCallbacks && t.emit("touchEnd", d),
                    (i.allowTouchCallbacks = !1),
                    !i.isTouched)
                  )
                    return (
                      i.isMoved && n.grabCursor && t.setGrabCursor(!1),
                      (i.isMoved = !1),
                      void (i.startMoving = !1)
                    );
                  n.grabCursor &&
                    i.isMoved &&
                    i.isTouched &&
                    (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
                    t.setGrabCursor(!1);
                  var c,
                    u = j.now(),
                    p = u - i.touchStartTime;
                  if (
                    (t.allowClick &&
                      (t.updateClickedSlide(d),
                      t.emit("tap", d),
                      p < 300 &&
                        300 < u - i.lastClickTime &&
                        (i.clickTimeout && clearTimeout(i.clickTimeout),
                        (i.clickTimeout = j.nextTick(function () {
                          t && !t.destroyed && t.emit("click", d);
                        }, 300))),
                      p < 300 &&
                        u - i.lastClickTime < 300 &&
                        (i.clickTimeout && clearTimeout(i.clickTimeout),
                        t.emit("doubleTap", d))),
                    (i.lastClickTime = j.now()),
                    j.nextTick(function () {
                      t.destroyed || (t.allowClick = !0);
                    }),
                    !i.isTouched ||
                      !i.isMoved ||
                      !t.swipeDirection ||
                      0 === s.diff ||
                      i.currentTranslate === i.startTranslate)
                  )
                    return (
                      (i.isTouched = !1),
                      (i.isMoved = !1),
                      void (i.startMoving = !1)
                    );
                  if (
                    ((i.isTouched = !1),
                    (i.isMoved = !1),
                    (i.startMoving = !1),
                    (c = n.followFinger
                      ? r
                        ? t.translate
                        : -t.translate
                      : -i.currentTranslate),
                    n.freeMode)
                  ) {
                    if (c < -t.minTranslate())
                      return void t.slideTo(t.activeIndex);
                    if (c > -t.maxTranslate())
                      return void (t.slides.length < l.length
                        ? t.slideTo(l.length - 1)
                        : t.slideTo(t.slides.length - 1));
                    if (n.freeModeMomentum) {
                      if (1 < i.velocities.length) {
                        var h = i.velocities.pop(),
                          f = i.velocities.pop(),
                          m = h.position - f.position,
                          g = h.time - f.time;
                        (t.velocity = m / g),
                          (t.velocity /= 2),
                          Math.abs(t.velocity) < n.freeModeMinimumVelocity &&
                            (t.velocity = 0),
                          (150 < g || 300 < j.now() - h.time) &&
                            (t.velocity = 0);
                      } else t.velocity = 0;
                      (t.velocity *= n.freeModeMomentumVelocityRatio),
                        (i.velocities.length = 0);
                      var v = 1e3 * n.freeModeMomentumRatio,
                        y = t.velocity * v,
                        b = t.translate + y;
                      r && (b = -b);
                      var w,
                        x,
                        T = !1,
                        S =
                          20 *
                          Math.abs(t.velocity) *
                          n.freeModeMomentumBounceRatio;
                      if (b < t.maxTranslate())
                        n.freeModeMomentumBounce
                          ? (b + t.maxTranslate() < -S &&
                              (b = t.maxTranslate() - S),
                            (w = t.maxTranslate()),
                            (T = !0),
                            (i.allowMomentumBounce = !0))
                          : (b = t.maxTranslate()),
                          n.loop && n.centeredSlides && (x = !0);
                      else if (b > t.minTranslate())
                        n.freeModeMomentumBounce
                          ? (b - t.minTranslate() > S &&
                              (b = t.minTranslate() + S),
                            (w = t.minTranslate()),
                            (T = !0),
                            (i.allowMomentumBounce = !0))
                          : (b = t.minTranslate()),
                          n.loop && n.centeredSlides && (x = !0);
                      else if (n.freeModeSticky) {
                        for (var C, E = 0; E < l.length; E += 1)
                          if (l[E] > -b) {
                            C = E;
                            break;
                          }
                        b = -(Math.abs(l[C] - b) < Math.abs(l[C - 1] - b) ||
                        "next" === t.swipeDirection
                          ? l[C]
                          : l[C - 1]);
                      }
                      if (
                        (x &&
                          t.once("transitionEnd", function () {
                            t.loopFix();
                          }),
                        0 !== t.velocity)
                      )
                        v = r
                          ? Math.abs((-b - t.translate) / t.velocity)
                          : Math.abs((b - t.translate) / t.velocity);
                      else if (n.freeModeSticky) return void t.slideToClosest();
                      n.freeModeMomentumBounce && T
                        ? (t.updateProgress(w),
                          t.setTransition(v),
                          t.setTranslate(b),
                          t.transitionStart(!0, t.swipeDirection),
                          (t.animating = !0),
                          o.transitionEnd(function () {
                            t &&
                              !t.destroyed &&
                              i.allowMomentumBounce &&
                              (t.emit("momentumBounce"),
                              t.setTransition(n.speed),
                              t.setTranslate(w),
                              o.transitionEnd(function () {
                                t && !t.destroyed && t.transitionEnd();
                              }));
                          }))
                        : t.velocity
                        ? (t.updateProgress(b),
                          t.setTransition(v),
                          t.setTranslate(b),
                          t.transitionStart(!0, t.swipeDirection),
                          t.animating ||
                            ((t.animating = !0),
                            o.transitionEnd(function () {
                              t && !t.destroyed && t.transitionEnd();
                            })))
                        : t.updateProgress(b),
                        t.updateActiveIndex(),
                        t.updateSlidesClasses();
                    } else if (n.freeModeSticky) return void t.slideToClosest();
                    (!n.freeModeMomentum || p >= n.longSwipesMs) &&
                      (t.updateProgress(),
                      t.updateActiveIndex(),
                      t.updateSlidesClasses());
                  } else {
                    for (
                      var k = 0, $ = t.slidesSizesGrid[0], A = 0;
                      A < a.length;
                      A += n.slidesPerGroup
                    )
                      void 0 !== a[A + n.slidesPerGroup]
                        ? c >= a[A] &&
                          c < a[A + n.slidesPerGroup] &&
                          ($ = a[(k = A) + n.slidesPerGroup] - a[A])
                        : c >= a[A] &&
                          ((k = A), ($ = a[a.length - 1] - a[a.length - 2]));
                    var z = (c - a[k]) / $;
                    if (p > n.longSwipesMs) {
                      if (!n.longSwipes) return void t.slideTo(t.activeIndex);
                      "next" === t.swipeDirection &&
                        (z >= n.longSwipesRatio
                          ? t.slideTo(k + n.slidesPerGroup)
                          : t.slideTo(k)),
                        "prev" === t.swipeDirection &&
                          (z > 1 - n.longSwipesRatio
                            ? t.slideTo(k + n.slidesPerGroup)
                            : t.slideTo(k));
                    } else {
                      if (!n.shortSwipes) return void t.slideTo(t.activeIndex);
                      "next" === t.swipeDirection &&
                        t.slideTo(k + n.slidesPerGroup),
                        "prev" === t.swipeDirection && t.slideTo(k);
                    }
                  }
                }.bind(this)),
                (this.onClick = function (e) {
                  this.allowClick ||
                    (this.params.preventClicks && e.preventDefault(),
                    this.params.preventClicksPropagation &&
                      this.animating &&
                      (e.stopPropagation(), e.stopImmediatePropagation()));
                }.bind(this));
              var s = "container" === e.touchEventsTarget ? i : n,
                r = !!e.nested;
              if (R.touch || (!R.pointerEvents && !R.prefixedPointerEvents)) {
                if (R.touch) {
                  var o = !(
                    "touchstart" !== t.start ||
                    !R.passiveListener ||
                    !e.passiveListeners
                  ) && { passive: !0, capture: !1 };
                  s.addEventListener(t.start, this.onTouchStart, o),
                    s.addEventListener(
                      t.move,
                      this.onTouchMove,
                      R.passiveListener ? { passive: !1, capture: r } : r
                    ),
                    s.addEventListener(t.end, this.onTouchEnd, o);
                }
                ((e.simulateTouch && !m.ios && !m.android) ||
                  (e.simulateTouch && !R.touch && m.ios)) &&
                  (s.addEventListener("mousedown", this.onTouchStart, !1),
                  f.addEventListener("mousemove", this.onTouchMove, r),
                  f.addEventListener("mouseup", this.onTouchEnd, !1));
              } else
                s.addEventListener(t.start, this.onTouchStart, !1),
                  f.addEventListener(t.move, this.onTouchMove, r),
                  f.addEventListener(t.end, this.onTouchEnd, !1);
              (e.preventClicks || e.preventClicksPropagation) &&
                s.addEventListener("click", this.onClick, !0),
                this.on(
                  m.ios || m.android
                    ? "resize orientationchange observerUpdate"
                    : "resize observerUpdate",
                  g,
                  !0
                );
            },
            detachEvents: function () {
              var e = this.params,
                t = this.touchEvents,
                i = this.el,
                n = this.wrapperEl,
                s = "container" === e.touchEventsTarget ? i : n,
                r = !!e.nested;
              if (R.touch || (!R.pointerEvents && !R.prefixedPointerEvents)) {
                if (R.touch) {
                  var o = !(
                    "onTouchStart" !== t.start ||
                    !R.passiveListener ||
                    !e.passiveListeners
                  ) && { passive: !0, capture: !1 };
                  s.removeEventListener(t.start, this.onTouchStart, o),
                    s.removeEventListener(t.move, this.onTouchMove, r),
                    s.removeEventListener(t.end, this.onTouchEnd, o);
                }
                ((e.simulateTouch && !m.ios && !m.android) ||
                  (e.simulateTouch && !R.touch && m.ios)) &&
                  (s.removeEventListener("mousedown", this.onTouchStart, !1),
                  f.removeEventListener("mousemove", this.onTouchMove, r),
                  f.removeEventListener("mouseup", this.onTouchEnd, !1));
              } else
                s.removeEventListener(t.start, this.onTouchStart, !1),
                  f.removeEventListener(t.move, this.onTouchMove, r),
                  f.removeEventListener(t.end, this.onTouchEnd, !1);
              (e.preventClicks || e.preventClicksPropagation) &&
                s.removeEventListener("click", this.onClick, !0),
                this.off(
                  m.ios || m.android
                    ? "resize orientationchange observerUpdate"
                    : "resize observerUpdate",
                  g
                );
            },
          },
          b = {
            setBreakpoint: function () {
              var e = this.activeIndex,
                t = this.initialized,
                i = this.loopedSlides;
              void 0 === i && (i = 0);
              var n = this.params,
                s = n.breakpoints;
              if (s && (!s || 0 !== Object.keys(s).length)) {
                var r = this.getBreakpoint(s);
                if (r && this.currentBreakpoint !== r) {
                  var o = r in s ? s[r] : this.originalParams,
                    a = n.loop && o.slidesPerView !== n.slidesPerView;
                  j.extend(this.params, o),
                    j.extend(this, {
                      allowTouchMove: this.params.allowTouchMove,
                      allowSlideNext: this.params.allowSlideNext,
                      allowSlidePrev: this.params.allowSlidePrev,
                    }),
                    (this.currentBreakpoint = r),
                    a &&
                      t &&
                      (this.loopDestroy(),
                      this.loopCreate(),
                      this.updateSlides(),
                      this.slideTo(e - i + this.loopedSlides, 0, !1)),
                    this.emit("breakpoint", o);
                }
              }
            },
            getBreakpoint: function (e) {
              if (e) {
                var t = !1,
                  i = [];
                Object.keys(e).forEach(function (e) {
                  i.push(e);
                }),
                  i.sort(function (e, t) {
                    return parseInt(e, 10) - parseInt(t, 10);
                  });
                for (var n = 0; n < i.length; n += 1) {
                  var s = i[n];
                  s >= H.innerWidth && !t && (t = s);
                }
                return t || "max";
              }
            },
          },
          D = {
            isIE:
              !!H.navigator.userAgent.match(/Trident/g) ||
              !!H.navigator.userAgent.match(/MSIE/g),
            isSafari:
              0 <=
                (v = H.navigator.userAgent.toLowerCase()).indexOf("safari") &&
              v.indexOf("chrome") < 0 &&
              v.indexOf("android") < 0,
            isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
              H.navigator.userAgent
            ),
          },
          w = {
            init: !0,
            direction: "horizontal",
            touchEventsTarget: "container",
            initialSlide: 0,
            speed: 300,
            preventIntercationOnTransition: !1,
            iOSEdgeSwipeDetection: !1,
            iOSEdgeSwipeThreshold: 20,
            freeMode: !1,
            freeModeMomentum: !0,
            freeModeMomentumRatio: 1,
            freeModeMomentumBounce: !0,
            freeModeMomentumBounceRatio: 1,
            freeModeMomentumVelocityRatio: 1,
            freeModeSticky: !1,
            freeModeMinimumVelocity: 0.02,
            autoHeight: !1,
            setWrapperSize: !1,
            virtualTranslate: !1,
            effect: "slide",
            breakpoints: void 0,
            spaceBetween: 0,
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerColumnFill: "column",
            slidesPerGroup: 1,
            centeredSlides: !1,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            normalizeSlideIndex: !0,
            watchOverflow: !1,
            roundLengths: !1,
            touchRatio: 1,
            touchAngle: 45,
            simulateTouch: !0,
            shortSwipes: !0,
            longSwipes: !0,
            longSwipesRatio: 0.5,
            longSwipesMs: 300,
            followFinger: !0,
            allowTouchMove: !0,
            threshold: 0,
            touchMoveStopPropagation: !0,
            touchReleaseOnEdges: !1,
            uniqueNavElements: !0,
            resistance: !0,
            resistanceRatio: 0.85,
            watchSlidesProgress: !1,
            watchSlidesVisibility: !1,
            grabCursor: !1,
            preventClicks: !0,
            preventClicksPropagation: !0,
            slideToClickedSlide: !1,
            preloadImages: !0,
            updateOnImagesReady: !0,
            loop: !1,
            loopAdditionalSlides: 0,
            loopedSlides: null,
            loopFillGroupWithBlank: !1,
            allowSlidePrev: !0,
            allowSlideNext: !0,
            swipeHandler: null,
            noSwiping: !0,
            noSwipingClass: "swiper-no-swiping",
            noSwipingSelector: null,
            passiveListeners: !0,
            containerModifierClass: "swiper-container-",
            slideClass: "swiper-slide",
            slideBlankClass: "swiper-slide-invisible-blank",
            slideActiveClass: "swiper-slide-active",
            slideDuplicateActiveClass: "swiper-slide-duplicate-active",
            slideVisibleClass: "swiper-slide-visible",
            slideDuplicateClass: "swiper-slide-duplicate",
            slideNextClass: "swiper-slide-next",
            slideDuplicateNextClass: "swiper-slide-duplicate-next",
            slidePrevClass: "swiper-slide-prev",
            slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
            wrapperClass: "swiper-wrapper",
            runCallbacksOnInit: !0,
          },
          x = {
            update: a,
            translate: d,
            transition: {
              setTransition: function (e, t) {
                this.$wrapperEl.transition(e), this.emit("setTransition", e, t);
              },
              transitionStart: function (e, t) {
                void 0 === e && (e = !0);
                var i = this.activeIndex,
                  n = this.params,
                  s = this.previousIndex;
                n.autoHeight && this.updateAutoHeight();
                var r = t;
                if (
                  ((r = r || (s < i ? "next" : i < s ? "prev" : "reset")),
                  this.emit("transitionStart"),
                  e && i !== s)
                ) {
                  if ("reset" === r)
                    return void this.emit("slideResetTransitionStart");
                  this.emit("slideChangeTransitionStart"),
                    "next" === r
                      ? this.emit("slideNextTransitionStart")
                      : this.emit("slidePrevTransitionStart");
                }
              },
              transitionEnd: function (e, t) {
                void 0 === e && (e = !0);
                var i = this.activeIndex,
                  n = this.previousIndex;
                (this.animating = !1), this.setTransition(0);
                var s = t;
                if (
                  ((s = s || (n < i ? "next" : i < n ? "prev" : "reset")),
                  this.emit("transitionEnd"),
                  e && i !== n)
                ) {
                  if ("reset" === s)
                    return void this.emit("slideResetTransitionEnd");
                  this.emit("slideChangeTransitionEnd"),
                    "next" === s
                      ? this.emit("slideNextTransitionEnd")
                      : this.emit("slidePrevTransitionEnd");
                }
              },
            },
            slide: c,
            loop: u,
            grabCursor: p,
            manipulation: h,
            events: y,
            breakpoints: b,
            checkOverflow: {
              checkOverflow: function () {
                var e = this.isLocked;
                (this.isLocked = 1 === this.snapGrid.length),
                  (this.allowSlideNext = !this.isLocked),
                  (this.allowSlidePrev = !this.isLocked),
                  e !== this.isLocked &&
                    this.emit(this.isLocked ? "lock" : "unlock"),
                  e &&
                    e !== this.isLocked &&
                    ((this.isEnd = !1), this.navigation.update());
              },
            },
            classes: {
              addClasses: function () {
                var t = this.classNames,
                  i = this.params,
                  e = this.rtl,
                  n = this.$el,
                  s = [];
                s.push(i.direction),
                  i.freeMode && s.push("free-mode"),
                  R.flexbox || s.push("no-flexbox"),
                  i.autoHeight && s.push("autoheight"),
                  e && s.push("rtl"),
                  1 < i.slidesPerColumn && s.push("multirow"),
                  m.android && s.push("android"),
                  m.ios && s.push("ios"),
                  D.isIE &&
                    (R.pointerEvents || R.prefixedPointerEvents) &&
                    s.push("wp8-" + i.direction),
                  s.forEach(function (e) {
                    t.push(i.containerModifierClass + e);
                  }),
                  n.addClass(t.join(" "));
              },
              removeClasses: function () {
                var e = this.$el,
                  t = this.classNames;
                e.removeClass(t.join(" "));
              },
            },
            images: {
              loadImage: function (e, t, i, n, s, r) {
                var o;
                function a() {
                  r && r();
                }
                (!e.complete || !s) && t
                  ? (((o = new H.Image()).onload = a),
                    (o.onerror = a),
                    n && (o.sizes = n),
                    i && (o.srcset = i),
                    t && (o.src = t))
                  : a();
              },
              preloadImages: function () {
                var e = this;
                function t() {
                  null != e &&
                    e &&
                    !e.destroyed &&
                    (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1),
                    e.imagesLoaded === e.imagesToLoad.length &&
                      (e.params.updateOnImagesReady && e.update(),
                      e.emit("imagesReady")));
                }
                e.imagesToLoad = e.$el.find("img");
                for (var i = 0; i < e.imagesToLoad.length; i += 1) {
                  var n = e.imagesToLoad[i];
                  e.loadImage(
                    n,
                    n.currentSrc || n.getAttribute("src"),
                    n.srcset || n.getAttribute("srcset"),
                    n.sizes || n.getAttribute("sizes"),
                    !0,
                    t
                  );
                }
              },
            },
          },
          T = {},
          S = (function (u) {
            function p() {
              for (var e, s, t = [], i = arguments.length; i--; )
                t[i] = arguments[i];
              (s =
                (s =
                  1 === t.length &&
                  t[0].constructor &&
                  t[0].constructor === Object
                    ? t[0]
                    : ((e = t[0]), t[1])) || {}),
                (s = j.extend({}, s)),
                e && !s.el && (s.el = e),
                u.call(this, s),
                Object.keys(x).forEach(function (t) {
                  Object.keys(x[t]).forEach(function (e) {
                    p.prototype[e] || (p.prototype[e] = x[t][e]);
                  });
                });
              var r = this;
              void 0 === r.modules && (r.modules = {}),
                Object.keys(r.modules).forEach(function (e) {
                  var t = r.modules[e];
                  if (t.params) {
                    var i = Object.keys(t.params)[0],
                      n = t.params[i];
                    if ("object" != _typeof(n)) return;
                    if (!(i in s && "enabled" in n)) return;
                    !0 === s[i] && (s[i] = { enabled: !0 }),
                      "object" != _typeof(s[i]) ||
                        "enabled" in s[i] ||
                        (s[i].enabled = !0),
                      s[i] || (s[i] = { enabled: !1 });
                  }
                });
              var n = j.extend({}, w);
              r.useModulesParams(n),
                (r.params = j.extend({}, n, T, s)),
                (r.originalParams = j.extend({}, r.params)),
                (r.passedParams = j.extend({}, s));
              var o = (r.$ = M)(r.params.el);
              if ((e = o[0])) {
                if (1 < o.length) {
                  var a = [];
                  return (
                    o.each(function (e, t) {
                      var i = j.extend({}, s, { el: t });
                      a.push(new p(i));
                    }),
                    a
                  );
                }
                (e.swiper = r), o.data("swiper", r);
                var l,
                  d,
                  c = o.children("." + r.params.wrapperClass);
                return (
                  j.extend(r, {
                    $el: o,
                    el: e,
                    $wrapperEl: c,
                    wrapperEl: c[0],
                    classNames: [],
                    slides: M(),
                    slidesGrid: [],
                    snapGrid: [],
                    slidesSizesGrid: [],
                    isHorizontal: function () {
                      return "horizontal" === r.params.direction;
                    },
                    isVertical: function () {
                      return "vertical" === r.params.direction;
                    },
                    rtl:
                      "rtl" === e.dir.toLowerCase() ||
                      "rtl" === o.css("direction"),
                    rtlTranslate:
                      "horizontal" === r.params.direction &&
                      ("rtl" === e.dir.toLowerCase() ||
                        "rtl" === o.css("direction")),
                    wrongRTL: "-webkit-box" === c.css("display"),
                    activeIndex: 0,
                    realIndex: 0,
                    isBeginning: !0,
                    isEnd: !1,
                    translate: 0,
                    previousTranslate: 0,
                    progress: 0,
                    velocity: 0,
                    animating: !1,
                    allowSlideNext: r.params.allowSlideNext,
                    allowSlidePrev: r.params.allowSlidePrev,
                    touchEvents:
                      ((l = ["touchstart", "touchmove", "touchend"]),
                      (d = ["mousedown", "mousemove", "mouseup"]),
                      R.pointerEvents
                        ? (d = ["pointerdown", "pointermove", "pointerup"])
                        : R.prefixedPointerEvents &&
                          (d = [
                            "MSPointerDown",
                            "MSPointerMove",
                            "MSPointerUp",
                          ]),
                      (r.touchEventsTouch = {
                        start: l[0],
                        move: l[1],
                        end: l[2],
                      }),
                      (r.touchEventsDesktop = {
                        start: d[0],
                        move: d[1],
                        end: d[2],
                      }),
                      R.touch || !r.params.simulateTouch
                        ? r.touchEventsTouch
                        : r.touchEventsDesktop),
                    touchEventsData: {
                      isTouched: void 0,
                      isMoved: void 0,
                      allowTouchCallbacks: void 0,
                      touchStartTime: void 0,
                      isScrolling: void 0,
                      currentTranslate: void 0,
                      startTranslate: void 0,
                      allowThresholdMove: void 0,
                      formElements:
                        "input, select, option, textarea, button, video",
                      lastClickTime: j.now(),
                      clickTimeout: void 0,
                      velocities: [],
                      allowMomentumBounce: void 0,
                      isTouchEvent: void 0,
                      startMoving: void 0,
                    },
                    allowClick: !0,
                    allowTouchMove: r.params.allowTouchMove,
                    touches: {
                      startX: 0,
                      startY: 0,
                      currentX: 0,
                      currentY: 0,
                      diff: 0,
                    },
                    imagesToLoad: [],
                    imagesLoaded: 0,
                  }),
                  r.useModules(),
                  r.params.init && r.init(),
                  r
                );
              }
            }
            u && (p.__proto__ = u);
            var e = {
              extendedDefaults: { configurable: !0 },
              defaults: { configurable: !0 },
              Class: { configurable: !0 },
              $: { configurable: !0 },
            };
            return (
              (((p.prototype = Object.create(u && u.prototype)).constructor =
                p).prototype.slidesPerViewDynamic = function () {
                var e = this.params,
                  t = this.slides,
                  i = this.slidesGrid,
                  n = this.size,
                  s = this.activeIndex,
                  r = 1;
                if (e.centeredSlides) {
                  for (
                    var o, a = t[s].swiperSlideSize, l = s + 1;
                    l < t.length;
                    l += 1
                  )
                    t[l] &&
                      !o &&
                      ((r += 1), (a += t[l].swiperSlideSize) > n && (o = !0));
                  for (var d = s - 1; 0 <= d; --d)
                    t[d] &&
                      !o &&
                      ((r += 1), (a += t[d].swiperSlideSize) > n && (o = !0));
                } else
                  for (var c = s + 1; c < t.length; c += 1)
                    i[c] - i[s] < n && (r += 1);
                return r;
              }),
              (p.prototype.update = function () {
                var i = this;
                if (i && !i.destroyed) {
                  var e = i.snapGrid,
                    t = i.params;
                  t.breakpoints && i.setBreakpoint(),
                    i.updateSize(),
                    i.updateSlides(),
                    i.updateProgress(),
                    i.updateSlidesClasses(),
                    i.params.freeMode
                      ? (n(), i.params.autoHeight && i.updateAutoHeight())
                      : (("auto" === i.params.slidesPerView ||
                          1 < i.params.slidesPerView) &&
                        i.isEnd &&
                        !i.params.centeredSlides
                          ? i.slideTo(i.slides.length - 1, 0, !1, !0)
                          : i.slideTo(i.activeIndex, 0, !1, !0)) || n(),
                    t.watchOverflow && e !== i.snapGrid && i.checkOverflow(),
                    i.emit("update");
                }
                function n() {
                  var e = i.rtlTranslate ? -1 * i.translate : i.translate,
                    t = Math.min(
                      Math.max(e, i.maxTranslate()),
                      i.minTranslate()
                    );
                  i.setTranslate(t),
                    i.updateActiveIndex(),
                    i.updateSlidesClasses();
                }
              }),
              (p.prototype.init = function () {
                this.initialized ||
                  (this.emit("beforeInit"),
                  this.params.breakpoints && this.setBreakpoint(),
                  this.addClasses(),
                  this.params.loop && this.loopCreate(),
                  this.updateSize(),
                  this.updateSlides(),
                  this.params.watchOverflow && this.checkOverflow(),
                  this.params.grabCursor && this.setGrabCursor(),
                  this.params.preloadImages && this.preloadImages(),
                  this.params.loop
                    ? this.slideTo(
                        this.params.initialSlide + this.loopedSlides,
                        0,
                        this.params.runCallbacksOnInit
                      )
                    : this.slideTo(
                        this.params.initialSlide,
                        0,
                        this.params.runCallbacksOnInit
                      ),
                  this.attachEvents(),
                  (this.initialized = !0),
                  this.emit("init"));
              }),
              (p.prototype.destroy = function (e, t) {
                void 0 === e && (e = !0), void 0 === t && (t = !0);
                var i = this,
                  n = i.params,
                  s = i.$el,
                  r = i.$wrapperEl,
                  o = i.slides;
                return (
                  void 0 === i.params ||
                    i.destroyed ||
                    (i.emit("beforeDestroy"),
                    (i.initialized = !1),
                    i.detachEvents(),
                    n.loop && i.loopDestroy(),
                    t &&
                      (i.removeClasses(),
                      s.removeAttr("style"),
                      r.removeAttr("style"),
                      o &&
                        o.length &&
                        o
                          .removeClass(
                            [
                              n.slideVisibleClass,
                              n.slideActiveClass,
                              n.slideNextClass,
                              n.slidePrevClass,
                            ].join(" ")
                          )
                          .removeAttr("style")
                          .removeAttr("data-swiper-slide-index")
                          .removeAttr("data-swiper-column")
                          .removeAttr("data-swiper-row")),
                    i.emit("destroy"),
                    Object.keys(i.eventsListeners).forEach(function (e) {
                      i.off(e);
                    }),
                    !1 !== e &&
                      ((i.$el[0].swiper = null),
                      i.$el.data("swiper", null),
                      j.deleteProps(i)),
                    (i.destroyed = !0)),
                  null
                );
              }),
              (p.extendDefaults = function (e) {
                j.extend(T, e);
              }),
              (e.extendedDefaults.get = function () {
                return T;
              }),
              (e.defaults.get = function () {
                return w;
              }),
              (e.Class.get = function () {
                return u;
              }),
              (e.$.get = function () {
                return M;
              }),
              Object.defineProperties(p, e),
              p
            );
          })(e),
          C = { name: "device", proto: { device: m }, static: { device: m } },
          E = {
            name: "support",
            proto: { support: R },
            static: { support: R },
          },
          k = {
            name: "browser",
            proto: { browser: D },
            static: { browser: D },
          },
          $ = {
            name: "resize",
            create: function () {
              var e = this;
              j.extend(e, {
                resize: {
                  resizeHandler: function () {
                    e &&
                      !e.destroyed &&
                      e.initialized &&
                      (e.emit("beforeResize"), e.emit("resize"));
                  },
                  orientationChangeHandler: function () {
                    e &&
                      !e.destroyed &&
                      e.initialized &&
                      e.emit("orientationchange");
                  },
                },
              });
            },
            on: {
              init: function () {
                H.addEventListener("resize", this.resize.resizeHandler),
                  H.addEventListener(
                    "orientationchange",
                    this.resize.orientationChangeHandler
                  );
              },
              destroy: function () {
                H.removeEventListener("resize", this.resize.resizeHandler),
                  H.removeEventListener(
                    "orientationchange",
                    this.resize.orientationChangeHandler
                  );
              },
            },
          },
          A = {
            func: H.MutationObserver || H.WebkitMutationObserver,
            attach: function (e, t) {
              void 0 === t && (t = {});
              var i = this,
                n = new A.func(function (e) {
                  e.forEach(function (e) {
                    i.emit("observerUpdate", e);
                  });
                });
              n.observe(e, {
                attributes: void 0 === t.attributes || t.attributes,
                childList: void 0 === t.childList || t.childList,
                characterData: void 0 === t.characterData || t.characterData,
              }),
                i.observer.observers.push(n);
            },
            init: function () {
              if (R.observer && this.params.observer) {
                if (this.params.observeParents)
                  for (var e = this.$el.parents(), t = 0; t < e.length; t += 1)
                    this.observer.attach(e[t]);
                this.observer.attach(this.$el[0], { childList: !1 }),
                  this.observer.attach(this.$wrapperEl[0], { attributes: !1 });
              }
            },
            destroy: function () {
              this.observer.observers.forEach(function (e) {
                e.disconnect();
              }),
                (this.observer.observers = []);
            },
          },
          z = {
            name: "observer",
            params: { observer: !1, observeParents: !1 },
            create: function () {
              j.extend(this, {
                observer: {
                  init: A.init.bind(this),
                  attach: A.attach.bind(this),
                  destroy: A.destroy.bind(this),
                  observers: [],
                },
              });
            },
            on: {
              init: function () {
                this.observer.init();
              },
              destroy: function () {
                this.observer.destroy();
              },
            },
          },
          _ = {
            update: function (e) {
              var t = this,
                i = t.params,
                n = i.slidesPerView,
                s = i.slidesPerGroup,
                r = i.centeredSlides,
                o = t.virtual,
                a = o.from,
                l = o.to,
                d = o.slides,
                c = o.slidesGrid,
                u = o.renderSlide,
                p = o.offset;
              t.updateActiveIndex();
              var h,
                f,
                m,
                g = t.activeIndex || 0;
              (h = t.rtlTranslate
                ? "right"
                : t.isHorizontal()
                ? "left"
                : "top"),
                (m = r
                  ? ((f = Math.floor(n / 2) + s), Math.floor(n / 2) + s)
                  : ((f = n + (s - 1)), s));
              var v = Math.max((g || 0) - m, 0),
                y = Math.min((g || 0) + f, d.length - 1),
                b = (t.slidesGrid[v] || 0) - (t.slidesGrid[0] || 0);
              function w() {
                t.updateSlides(),
                  t.updateProgress(),
                  t.updateSlidesClasses(),
                  t.lazy && t.params.lazy.enabled && t.lazy.load();
              }
              if (
                (j.extend(t.virtual, {
                  from: v,
                  to: y,
                  offset: b,
                  slidesGrid: t.slidesGrid,
                }),
                a === v && l === y && !e)
              )
                return (
                  t.slidesGrid !== c && b !== p && t.slides.css(h, b + "px"),
                  void t.updateProgress()
                );
              if (t.params.virtual.renderExternal)
                return (
                  t.params.virtual.renderExternal.call(t, {
                    offset: b,
                    from: v,
                    to: y,
                    slides: (function () {
                      for (var e = [], t = v; t <= y; t += 1) e.push(d[t]);
                      return e;
                    })(),
                  }),
                  void w()
                );
              var x = [],
                T = [];
              if (e) t.$wrapperEl.find("." + t.params.slideClass).remove();
              else
                for (var S = a; S <= l; S += 1)
                  (S < v || y < S) &&
                    t.$wrapperEl
                      .find(
                        "." +
                          t.params.slideClass +
                          '[data-swiper-slide-index="' +
                          S +
                          '"]'
                      )
                      .remove();
              for (var C = 0; C < d.length; C += 1)
                v <= C &&
                  C <= y &&
                  (void 0 === l || e
                    ? T.push(C)
                    : (l < C && T.push(C), C < a && x.push(C)));
              T.forEach(function (e) {
                t.$wrapperEl.append(u(d[e], e));
              }),
                x
                  .sort(function (e, t) {
                    return e < t;
                  })
                  .forEach(function (e) {
                    t.$wrapperEl.prepend(u(d[e], e));
                  }),
                t.$wrapperEl.children(".swiper-slide").css(h, b + "px"),
                w();
            },
            renderSlide: function (e, t) {
              var i = this.params.virtual;
              if (i.cache && this.virtual.cache[t])
                return this.virtual.cache[t];
              var n = i.renderSlide
                ? M(i.renderSlide.call(this, e, t))
                : M(
                    '<div class="' +
                      this.params.slideClass +
                      '" data-swiper-slide-index="' +
                      t +
                      '">' +
                      e +
                      "</div>"
                  );
              return (
                n.attr("data-swiper-slide-index") ||
                  n.attr("data-swiper-slide-index", t),
                i.cache && (this.virtual.cache[t] = n),
                n
              );
            },
            appendSlide: function (e) {
              this.virtual.slides.push(e), this.virtual.update(!0);
            },
            prependSlide: function (e) {
              if ((this.virtual.slides.unshift(e), this.params.virtual.cache)) {
                var t = this.virtual.cache,
                  i = {};
                Object.keys(t).forEach(function (e) {
                  i[e + 1] = t[e];
                }),
                  (this.virtual.cache = i);
              }
              this.virtual.update(!0), this.slideNext(0);
            },
          },
          P = {
            name: "virtual",
            params: {
              virtual: {
                enabled: !1,
                slides: [],
                cache: !0,
                renderSlide: null,
                renderExternal: null,
              },
            },
            create: function () {
              j.extend(this, {
                virtual: {
                  update: _.update.bind(this),
                  appendSlide: _.appendSlide.bind(this),
                  prependSlide: _.prependSlide.bind(this),
                  renderSlide: _.renderSlide.bind(this),
                  slides: this.params.virtual.slides,
                  cache: {},
                },
              });
            },
            on: {
              beforeInit: function () {
                if (this.params.virtual.enabled) {
                  this.classNames.push(
                    this.params.containerModifierClass + "virtual"
                  );
                  var e = { watchSlidesProgress: !0 };
                  j.extend(this.params, e),
                    j.extend(this.originalParams, e),
                    this.virtual.update();
                }
              },
              setTranslate: function () {
                this.params.virtual.enabled && this.virtual.update();
              },
            },
          },
          L = {
            handle: function (e) {
              var t = this.rtlTranslate,
                i = e;
              i.originalEvent && (i = i.originalEvent);
              var n = i.keyCode || i.charCode;
              if (
                !this.allowSlideNext &&
                ((this.isHorizontal() && 39 === n) ||
                  (this.isVertical() && 40 === n))
              )
                return !1;
              if (
                !this.allowSlidePrev &&
                ((this.isHorizontal() && 37 === n) ||
                  (this.isVertical() && 38 === n))
              )
                return !1;
              if (
                !(
                  i.shiftKey ||
                  i.altKey ||
                  i.ctrlKey ||
                  i.metaKey ||
                  (f.activeElement &&
                    f.activeElement.nodeName &&
                    ("input" === f.activeElement.nodeName.toLowerCase() ||
                      "textarea" === f.activeElement.nodeName.toLowerCase()))
                )
              ) {
                if (
                  this.params.keyboard.onlyInViewport &&
                  (37 === n || 39 === n || 38 === n || 40 === n)
                ) {
                  var s = !1;
                  if (
                    0 < this.$el.parents("." + this.params.slideClass).length &&
                    0 ===
                      this.$el.parents("." + this.params.slideActiveClass)
                        .length
                  )
                    return;
                  var r = H.innerWidth,
                    o = H.innerHeight,
                    a = this.$el.offset();
                  t && (a.left -= this.$el[0].scrollLeft);
                  for (
                    var l = [
                        [a.left, a.top],
                        [a.left + this.width, a.top],
                        [a.left, a.top + this.height],
                        [a.left + this.width, a.top + this.height],
                      ],
                      d = 0;
                    d < l.length;
                    d += 1
                  ) {
                    var c = l[d];
                    0 <= c[0] &&
                      c[0] <= r &&
                      0 <= c[1] &&
                      c[1] <= o &&
                      (s = !0);
                  }
                  if (!s) return;
                }
                this.isHorizontal()
                  ? ((37 !== n && 39 !== n) ||
                      (i.preventDefault
                        ? i.preventDefault()
                        : (i.returnValue = !1)),
                    ((39 === n && !t) || (37 === n && t)) && this.slideNext(),
                    ((37 === n && !t) || (39 === n && t)) && this.slidePrev())
                  : ((38 !== n && 40 !== n) ||
                      (i.preventDefault
                        ? i.preventDefault()
                        : (i.returnValue = !1)),
                    40 === n && this.slideNext(),
                    38 === n && this.slidePrev()),
                  this.emit("keyPress", n);
              }
            },
            enable: function () {
              this.keyboard.enabled ||
                (M(f).on("keydown", this.keyboard.handle),
                (this.keyboard.enabled = !0));
            },
            disable: function () {
              this.keyboard.enabled &&
                (M(f).off("keydown", this.keyboard.handle),
                (this.keyboard.enabled = !1));
            },
          },
          O = {
            name: "keyboard",
            params: { keyboard: { enabled: !1, onlyInViewport: !0 } },
            create: function () {
              j.extend(this, {
                keyboard: {
                  enabled: !1,
                  enable: L.enable.bind(this),
                  disable: L.disable.bind(this),
                  handle: L.handle.bind(this),
                },
              });
            },
            on: {
              init: function () {
                this.params.keyboard.enabled && this.keyboard.enable();
              },
              destroy: function () {
                this.keyboard.enabled && this.keyboard.disable();
              },
            },
          },
          I = {
            lastScrollTime: j.now(),
            event:
              -1 < H.navigator.userAgent.indexOf("firefox")
                ? "DOMMouseScroll"
                : (function () {
                    var e = "onwheel" in f;
                    if (!e) {
                      var t = f.createElement("div");
                      t.setAttribute("onwheel", "return;"),
                        (e = "function" == typeof t.onwheel);
                    }
                    return (
                      !e &&
                        f.implementation &&
                        f.implementation.hasFeature &&
                        !0 !== f.implementation.hasFeature("", "") &&
                        (e = f.implementation.hasFeature(
                          "Events.wheel",
                          "3.0"
                        )),
                      e
                    );
                  })()
                ? "wheel"
                : "mousewheel",
            normalize: function (e) {
              var t = 0,
                i = 0,
                n = 0,
                s = 0;
              return (
                "detail" in e && (i = e.detail),
                "wheelDelta" in e && (i = -e.wheelDelta / 120),
                "wheelDeltaY" in e && (i = -e.wheelDeltaY / 120),
                "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120),
                "axis" in e &&
                  e.axis === e.HORIZONTAL_AXIS &&
                  ((t = i), (i = 0)),
                (n = 10 * t),
                (s = 10 * i),
                "deltaY" in e && (s = e.deltaY),
                "deltaX" in e && (n = e.deltaX),
                (n || s) &&
                  e.deltaMode &&
                  (1 === e.deltaMode
                    ? ((n *= 40), (s *= 40))
                    : ((n *= 800), (s *= 800))),
                n && !t && (t = n < 1 ? -1 : 1),
                s && !i && (i = s < 1 ? -1 : 1),
                { spinX: t, spinY: i, pixelX: n, pixelY: s }
              );
            },
            handleMouseEnter: function () {
              this.mouseEntered = !0;
            },
            handleMouseLeave: function () {
              this.mouseEntered = !1;
            },
            handle: function (e) {
              var t = e,
                i = this,
                n = i.params.mousewheel;
              if (!i.mouseEntered && !n.releaseOnEdges) return !0;
              t.originalEvent && (t = t.originalEvent);
              var s = 0,
                r = i.rtlTranslate ? -1 : 1,
                o = I.normalize(t);
              if (n.forceToAxis)
                if (i.isHorizontal()) {
                  if (!(Math.abs(o.pixelX) > Math.abs(o.pixelY))) return !0;
                  s = o.pixelX * r;
                } else {
                  if (!(Math.abs(o.pixelY) > Math.abs(o.pixelX))) return !0;
                  s = o.pixelY;
                }
              else
                s =
                  Math.abs(o.pixelX) > Math.abs(o.pixelY)
                    ? -o.pixelX * r
                    : -o.pixelY;
              if (0 === s) return !0;
              if ((n.invert && (s = -s), i.params.freeMode)) {
                i.params.loop && i.loopFix();
                var a = i.getTranslate() + s * n.sensitivity,
                  l = i.isBeginning,
                  d = i.isEnd;
                if (
                  (a >= i.minTranslate() && (a = i.minTranslate()),
                  a <= i.maxTranslate() && (a = i.maxTranslate()),
                  i.setTransition(0),
                  i.setTranslate(a),
                  i.updateProgress(),
                  i.updateActiveIndex(),
                  i.updateSlidesClasses(),
                  ((!l && i.isBeginning) || (!d && i.isEnd)) &&
                    i.updateSlidesClasses(),
                  i.params.freeModeSticky &&
                    (clearTimeout(i.mousewheel.timeout),
                    (i.mousewheel.timeout = j.nextTick(function () {
                      i.slideToClosest();
                    }, 300))),
                  i.emit("scroll", t),
                  i.params.autoplay &&
                    i.params.autoplayDisableOnInteraction &&
                    i.autoplay.stop(),
                  a === i.minTranslate() || a === i.maxTranslate())
                )
                  return !0;
              } else {
                if (60 < j.now() - i.mousewheel.lastScrollTime)
                  if (s < 0)
                    if ((i.isEnd && !i.params.loop) || i.animating) {
                      if (n.releaseOnEdges) return !0;
                    } else i.slideNext(), i.emit("scroll", t);
                  else if ((i.isBeginning && !i.params.loop) || i.animating) {
                    if (n.releaseOnEdges) return !0;
                  } else i.slidePrev(), i.emit("scroll", t);
                i.mousewheel.lastScrollTime = new H.Date().getTime();
              }
              return (
                t.preventDefault ? t.preventDefault() : (t.returnValue = !1), !1
              );
            },
            enable: function () {
              if (!I.event) return !1;
              if (this.mousewheel.enabled) return !1;
              var e = this.$el;
              return (
                "container" !== this.params.mousewheel.eventsTarged &&
                  (e = M(this.params.mousewheel.eventsTarged)),
                e.on("mouseenter", this.mousewheel.handleMouseEnter),
                e.on("mouseleave", this.mousewheel.handleMouseLeave),
                e.on(I.event, this.mousewheel.handle),
                (this.mousewheel.enabled = !0)
              );
            },
            disable: function () {
              if (!I.event) return !1;
              if (!this.mousewheel.enabled) return !1;
              var e = this.$el;
              return (
                "container" !== this.params.mousewheel.eventsTarged &&
                  (e = M(this.params.mousewheel.eventsTarged)),
                e.off(I.event, this.mousewheel.handle),
                !(this.mousewheel.enabled = !1)
              );
            },
          },
          N = {
            update: function () {
              var e = this.params.navigation;
              if (!this.params.loop) {
                var t = this.navigation,
                  i = t.$nextEl,
                  n = t.$prevEl;
                n &&
                  0 < n.length &&
                  (this.isBeginning
                    ? n.addClass(e.disabledClass)
                    : n.removeClass(e.disabledClass),
                  n[
                    this.params.watchOverflow && this.isLocked
                      ? "addClass"
                      : "removeClass"
                  ](e.lockClass)),
                  i &&
                    0 < i.length &&
                    (this.isEnd
                      ? i.addClass(e.disabledClass)
                      : i.removeClass(e.disabledClass),
                    i[
                      this.params.watchOverflow && this.isLocked
                        ? "addClass"
                        : "removeClass"
                    ](e.lockClass));
              }
            },
            init: function () {
              var e,
                t,
                i = this,
                n = i.params.navigation;
              (n.nextEl || n.prevEl) &&
                (n.nextEl &&
                  ((e = M(n.nextEl)),
                  i.params.uniqueNavElements &&
                    "string" == typeof n.nextEl &&
                    1 < e.length &&
                    1 === i.$el.find(n.nextEl).length &&
                    (e = i.$el.find(n.nextEl))),
                n.prevEl &&
                  ((t = M(n.prevEl)),
                  i.params.uniqueNavElements &&
                    "string" == typeof n.prevEl &&
                    1 < t.length &&
                    1 === i.$el.find(n.prevEl).length &&
                    (t = i.$el.find(n.prevEl))),
                e &&
                  0 < e.length &&
                  e.on("click", function (e) {
                    e.preventDefault(),
                      (i.isEnd && !i.params.loop) || i.slideNext();
                  }),
                t &&
                  0 < t.length &&
                  t.on("click", function (e) {
                    e.preventDefault(),
                      (i.isBeginning && !i.params.loop) || i.slidePrev();
                  }),
                j.extend(i.navigation, {
                  $nextEl: e,
                  nextEl: e && e[0],
                  $prevEl: t,
                  prevEl: t && t[0],
                }));
            },
            destroy: function () {
              var e = this.navigation,
                t = e.$nextEl,
                i = e.$prevEl;
              t &&
                t.length &&
                (t.off("click"),
                t.removeClass(this.params.navigation.disabledClass)),
                i &&
                  i.length &&
                  (i.off("click"),
                  i.removeClass(this.params.navigation.disabledClass));
            },
          },
          q = {
            update: function () {
              var e = this.rtl,
                s = this.params.pagination;
              if (
                s.el &&
                this.pagination.el &&
                this.pagination.$el &&
                0 !== this.pagination.$el.length
              ) {
                var r,
                  t =
                    this.virtual && this.params.virtual.enabled
                      ? this.virtual.slides.length
                      : this.slides.length,
                  i = this.pagination.$el,
                  n = this.params.loop
                    ? Math.ceil(
                        (t - 2 * this.loopedSlides) / this.params.slidesPerGroup
                      )
                    : this.snapGrid.length;
                if (
                  (this.params.loop
                    ? ((r = Math.ceil(
                        (this.activeIndex - this.loopedSlides) /
                          this.params.slidesPerGroup
                      )) >
                        t - 1 - 2 * this.loopedSlides &&
                        (r -= t - 2 * this.loopedSlides),
                      n - 1 < r && (r -= n),
                      r < 0 &&
                        "bullets" !== this.params.paginationType &&
                        (r = n + r))
                    : (r =
                        void 0 !== this.snapIndex
                          ? this.snapIndex
                          : this.activeIndex || 0),
                  "bullets" === s.type &&
                    this.pagination.bullets &&
                    0 < this.pagination.bullets.length)
                ) {
                  var o,
                    a,
                    l,
                    d = this.pagination.bullets;
                  if (
                    (s.dynamicBullets &&
                      ((this.pagination.bulletSize = d
                        .eq(0)
                        [this.isHorizontal() ? "outerWidth" : "outerHeight"](
                          !0
                        )),
                      i.css(
                        this.isHorizontal() ? "width" : "height",
                        this.pagination.bulletSize *
                          (s.dynamicMainBullets + 4) +
                          "px"
                      ),
                      1 < s.dynamicMainBullets &&
                        void 0 !== this.previousIndex &&
                        ((this.pagination.dynamicBulletIndex +=
                          r - this.previousIndex),
                        this.pagination.dynamicBulletIndex >
                        s.dynamicMainBullets - 1
                          ? (this.pagination.dynamicBulletIndex =
                              s.dynamicMainBullets - 1)
                          : this.pagination.dynamicBulletIndex < 0 &&
                            (this.pagination.dynamicBulletIndex = 0)),
                      (o = r - this.pagination.dynamicBulletIndex),
                      (l =
                        ((a =
                          o + (Math.min(d.length, s.dynamicMainBullets) - 1)) +
                          o) /
                        2)),
                    d.removeClass(
                      s.bulletActiveClass +
                        " " +
                        s.bulletActiveClass +
                        "-next " +
                        s.bulletActiveClass +
                        "-next-next " +
                        s.bulletActiveClass +
                        "-prev " +
                        s.bulletActiveClass +
                        "-prev-prev " +
                        s.bulletActiveClass +
                        "-main"
                    ),
                    1 < i.length)
                  )
                    d.each(function (e, t) {
                      var i = M(t),
                        n = i.index();
                      n === r && i.addClass(s.bulletActiveClass),
                        s.dynamicBullets &&
                          (o <= n &&
                            n <= a &&
                            i.addClass(s.bulletActiveClass + "-main"),
                          n === o &&
                            i
                              .prev()
                              .addClass(s.bulletActiveClass + "-prev")
                              .prev()
                              .addClass(s.bulletActiveClass + "-prev-prev"),
                          n === a &&
                            i
                              .next()
                              .addClass(s.bulletActiveClass + "-next")
                              .next()
                              .addClass(s.bulletActiveClass + "-next-next"));
                    });
                  else if (
                    (d.eq(r).addClass(s.bulletActiveClass), s.dynamicBullets)
                  ) {
                    for (var c = d.eq(o), u = d.eq(a), p = o; p <= a; p += 1)
                      d.eq(p).addClass(s.bulletActiveClass + "-main");
                    c
                      .prev()
                      .addClass(s.bulletActiveClass + "-prev")
                      .prev()
                      .addClass(s.bulletActiveClass + "-prev-prev"),
                      u
                        .next()
                        .addClass(s.bulletActiveClass + "-next")
                        .next()
                        .addClass(s.bulletActiveClass + "-next-next");
                  }
                  if (s.dynamicBullets) {
                    var h = Math.min(d.length, s.dynamicMainBullets + 4),
                      f =
                        (this.pagination.bulletSize * h -
                          this.pagination.bulletSize) /
                          2 -
                        l * this.pagination.bulletSize,
                      m = e ? "right" : "left";
                    d.css(this.isHorizontal() ? m : "top", f + "px");
                  }
                }
                if (
                  ("fraction" === s.type &&
                    (i
                      .find("." + s.currentClass)
                      .text(s.formatFractionCurrent(r + 1)),
                    i.find("." + s.totalClass).text(s.formatFractionTotal(n))),
                  "progressbar" === s.type)
                ) {
                  var g;
                  g = s.progressbarOpposite
                    ? this.isHorizontal()
                      ? "vertical"
                      : "horizontal"
                    : this.isHorizontal()
                    ? "horizontal"
                    : "vertical";
                  var v = (r + 1) / n,
                    y = 1,
                    b = 1;
                  "horizontal" == g ? (y = v) : (b = v),
                    i
                      .find("." + s.progressbarFillClass)
                      .transform(
                        "translate3d(0,0,0) scaleX(" + y + ") scaleY(" + b + ")"
                      )
                      .transition(this.params.speed);
                }
                "custom" === s.type && s.renderCustom
                  ? (i.html(s.renderCustom(this, r + 1, n)),
                    this.emit("paginationRender", this, i[0]))
                  : this.emit("paginationUpdate", this, i[0]),
                  i[
                    this.params.watchOverflow && this.isLocked
                      ? "addClass"
                      : "removeClass"
                  ](s.lockClass);
              }
            },
            render: function () {
              var e = this.params.pagination;
              if (
                e.el &&
                this.pagination.el &&
                this.pagination.$el &&
                0 !== this.pagination.$el.length
              ) {
                var t =
                    this.virtual && this.params.virtual.enabled
                      ? this.virtual.slides.length
                      : this.slides.length,
                  i = this.pagination.$el,
                  n = "";
                if ("bullets" === e.type) {
                  for (
                    var s = this.params.loop
                        ? Math.ceil(
                            (t - 2 * this.loopedSlides) /
                              this.params.slidesPerGroup
                          )
                        : this.snapGrid.length,
                      r = 0;
                    r < s;
                    r += 1
                  )
                    e.renderBullet
                      ? (n += e.renderBullet.call(this, r, e.bulletClass))
                      : (n +=
                          "<" +
                          e.bulletElement +
                          ' class="' +
                          e.bulletClass +
                          '"></' +
                          e.bulletElement +
                          ">");
                  i.html(n),
                    (this.pagination.bullets = i.find("." + e.bulletClass));
                }
                "fraction" === e.type &&
                  ((n = e.renderFraction
                    ? e.renderFraction.call(this, e.currentClass, e.totalClass)
                    : '<span class="' +
                      e.currentClass +
                      '"></span> / <span class="' +
                      e.totalClass +
                      '"></span>'),
                  i.html(n)),
                  "progressbar" === e.type &&
                    ((n = e.renderProgressbar
                      ? e.renderProgressbar.call(this, e.progressbarFillClass)
                      : '<span class="' + e.progressbarFillClass + '"></span>'),
                    i.html(n)),
                  "custom" !== e.type &&
                    this.emit("paginationRender", this.pagination.$el[0]);
              }
            },
            init: function () {
              var i = this,
                e = i.params.pagination;
              if (e.el) {
                var t = M(e.el);
                0 !== t.length &&
                  (i.params.uniqueNavElements &&
                    "string" == typeof e.el &&
                    1 < t.length &&
                    1 === i.$el.find(e.el).length &&
                    (t = i.$el.find(e.el)),
                  "bullets" === e.type &&
                    e.clickable &&
                    t.addClass(e.clickableClass),
                  t.addClass(e.modifierClass + e.type),
                  "bullets" === e.type &&
                    e.dynamicBullets &&
                    (t.addClass("" + e.modifierClass + e.type + "-dynamic"),
                    (i.pagination.dynamicBulletIndex = 0),
                    e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)),
                  "progressbar" === e.type &&
                    e.progressbarOpposite &&
                    t.addClass(e.progressbarOppositeClass),
                  e.clickable &&
                    t.on("click", "." + e.bulletClass, function (e) {
                      e.preventDefault();
                      var t = M(this).index() * i.params.slidesPerGroup;
                      i.params.loop && (t += i.loopedSlides), i.slideTo(t);
                    }),
                  j.extend(i.pagination, { $el: t, el: t[0] }));
              }
            },
            destroy: function () {
              var e = this.params.pagination;
              if (
                e.el &&
                this.pagination.el &&
                this.pagination.$el &&
                0 !== this.pagination.$el.length
              ) {
                var t = this.pagination.$el;
                t.removeClass(e.hiddenClass),
                  t.removeClass(e.modifierClass + e.type),
                  this.pagination.bullets &&
                    this.pagination.bullets.removeClass(e.bulletActiveClass),
                  e.clickable && t.off("click", "." + e.bulletClass);
              }
            },
          },
          F = {
            setTranslate: function () {
              if (this.params.scrollbar.el && this.scrollbar.el) {
                var e = this.scrollbar,
                  t = this.rtlTranslate,
                  i = this.progress,
                  n = e.dragSize,
                  s = e.trackSize,
                  r = e.$dragEl,
                  o = e.$el,
                  a = this.params.scrollbar,
                  l = n,
                  d = (s - n) * i;
                t
                  ? 0 < (d = -d)
                    ? ((l = n - d), (d = 0))
                    : s < -d + n && (l = s + d)
                  : d < 0
                  ? ((l = n + d), (d = 0))
                  : s < d + n && (l = s - d),
                  this.isHorizontal()
                    ? (R.transforms3d
                        ? r.transform("translate3d(" + d + "px, 0, 0)")
                        : r.transform("translateX(" + d + "px)"),
                      (r[0].style.width = l + "px"))
                    : (R.transforms3d
                        ? r.transform("translate3d(0px, " + d + "px, 0)")
                        : r.transform("translateY(" + d + "px)"),
                      (r[0].style.height = l + "px")),
                  a.hide &&
                    (clearTimeout(this.scrollbar.timeout),
                    (o[0].style.opacity = 1),
                    (this.scrollbar.timeout = setTimeout(function () {
                      (o[0].style.opacity = 0), o.transition(400);
                    }, 1e3)));
              }
            },
            setTransition: function (e) {
              this.params.scrollbar.el &&
                this.scrollbar.el &&
                this.scrollbar.$dragEl.transition(e);
            },
            updateSize: function () {
              if (this.params.scrollbar.el && this.scrollbar.el) {
                var e = this.scrollbar,
                  t = e.$dragEl,
                  i = e.$el;
                (t[0].style.width = ""), (t[0].style.height = "");
                var n,
                  s = this.isHorizontal()
                    ? i[0].offsetWidth
                    : i[0].offsetHeight,
                  r = this.size / this.virtualSize,
                  o = r * (s / this.size);
                (n =
                  "auto" === this.params.scrollbar.dragSize
                    ? s * r
                    : parseInt(this.params.scrollbar.dragSize, 10)),
                  this.isHorizontal()
                    ? (t[0].style.width = n + "px")
                    : (t[0].style.height = n + "px"),
                  (i[0].style.display = 1 <= r ? "none" : ""),
                  this.params.scrollbarHide && (i[0].style.opacity = 0),
                  j.extend(e, {
                    trackSize: s,
                    divider: r,
                    moveDivider: o,
                    dragSize: n,
                  }),
                  e.$el[
                    this.params.watchOverflow && this.isLocked
                      ? "addClass"
                      : "removeClass"
                  ](this.params.scrollbar.lockClass);
              }
            },
            setDragPosition: function (e) {
              var t,
                i = this.scrollbar,
                n = this.rtlTranslate,
                s = i.$el,
                r = i.dragSize,
                o = i.trackSize;
              (t =
                ((this.isHorizontal()
                  ? "touchstart" === e.type || "touchmove" === e.type
                    ? e.targetTouches[0].pageX
                    : e.pageX || e.clientX
                  : "touchstart" === e.type || "touchmove" === e.type
                  ? e.targetTouches[0].pageY
                  : e.pageY || e.clientY) -
                  s.offset()[this.isHorizontal() ? "left" : "top"] -
                  r / 2) /
                (o - r)),
                (t = Math.max(Math.min(t, 1), 0)),
                n && (t = 1 - t);
              var a =
                this.minTranslate() +
                (this.maxTranslate() - this.minTranslate()) * t;
              this.updateProgress(a),
                this.setTranslate(a),
                this.updateActiveIndex(),
                this.updateSlidesClasses();
            },
            onDragStart: function (e) {
              var t = this.params.scrollbar,
                i = this.scrollbar,
                n = this.$wrapperEl,
                s = i.$el,
                r = i.$dragEl;
              (this.scrollbar.isTouched = !0),
                e.preventDefault(),
                e.stopPropagation(),
                n.transition(100),
                r.transition(100),
                i.setDragPosition(e),
                clearTimeout(this.scrollbar.dragTimeout),
                s.transition(0),
                t.hide && s.css("opacity", 1),
                this.emit("scrollbarDragStart", e);
            },
            onDragMove: function (e) {
              var t = this.scrollbar,
                i = this.$wrapperEl,
                n = t.$el,
                s = t.$dragEl;
              this.scrollbar.isTouched &&
                (e.preventDefault ? e.preventDefault() : (e.returnValue = !1),
                t.setDragPosition(e),
                i.transition(0),
                n.transition(0),
                s.transition(0),
                this.emit("scrollbarDragMove", e));
            },
            onDragEnd: function (e) {
              var t = this.params.scrollbar,
                i = this.scrollbar.$el;
              this.scrollbar.isTouched &&
                ((this.scrollbar.isTouched = !1),
                t.hide &&
                  (clearTimeout(this.scrollbar.dragTimeout),
                  (this.scrollbar.dragTimeout = j.nextTick(function () {
                    i.css("opacity", 0), i.transition(400);
                  }, 1e3))),
                this.emit("scrollbarDragEnd", e),
                t.snapOnRelease && this.slideToClosest());
            },
            enableDraggable: function () {
              if (this.params.scrollbar.el) {
                var e = this.scrollbar,
                  t = this.touchEvents,
                  i = this.touchEventsDesktop,
                  n = this.params,
                  s = e.$el[0],
                  r = !(!R.passiveListener || !n.passiveListener) && {
                    passive: !1,
                    capture: !1,
                  },
                  o = !(!R.passiveListener || !n.passiveListener) && {
                    passive: !0,
                    capture: !1,
                  };
                R.touch || (!R.pointerEvents && !R.prefixedPointerEvents)
                  ? (R.touch &&
                      (s.addEventListener(
                        t.start,
                        this.scrollbar.onDragStart,
                        r
                      ),
                      s.addEventListener(t.move, this.scrollbar.onDragMove, r),
                      s.addEventListener(t.end, this.scrollbar.onDragEnd, o)),
                    ((n.simulateTouch && !m.ios && !m.android) ||
                      (n.simulateTouch && !R.touch && m.ios)) &&
                      (s.addEventListener(
                        "mousedown",
                        this.scrollbar.onDragStart,
                        r
                      ),
                      f.addEventListener(
                        "mousemove",
                        this.scrollbar.onDragMove,
                        r
                      ),
                      f.addEventListener(
                        "mouseup",
                        this.scrollbar.onDragEnd,
                        o
                      )))
                  : (s.addEventListener(i.start, this.scrollbar.onDragStart, r),
                    f.addEventListener(i.move, this.scrollbar.onDragMove, r),
                    f.addEventListener(i.end, this.scrollbar.onDragEnd, o));
              }
            },
            disableDraggable: function () {
              if (this.params.scrollbar.el) {
                var e = this.scrollbar,
                  t = this.touchEvents,
                  i = this.touchEventsDesktop,
                  n = this.params,
                  s = e.$el[0],
                  r = !(!R.passiveListener || !n.passiveListener) && {
                    passive: !1,
                    capture: !1,
                  },
                  o = !(!R.passiveListener || !n.passiveListener) && {
                    passive: !0,
                    capture: !1,
                  };
                R.touch || (!R.pointerEvents && !R.prefixedPointerEvents)
                  ? (R.touch &&
                      (s.removeEventListener(
                        t.start,
                        this.scrollbar.onDragStart,
                        r
                      ),
                      s.removeEventListener(
                        t.move,
                        this.scrollbar.onDragMove,
                        r
                      ),
                      s.removeEventListener(
                        t.end,
                        this.scrollbar.onDragEnd,
                        o
                      )),
                    ((n.simulateTouch && !m.ios && !m.android) ||
                      (n.simulateTouch && !R.touch && m.ios)) &&
                      (s.removeEventListener(
                        "mousedown",
                        this.scrollbar.onDragStart,
                        r
                      ),
                      f.removeEventListener(
                        "mousemove",
                        this.scrollbar.onDragMove,
                        r
                      ),
                      f.removeEventListener(
                        "mouseup",
                        this.scrollbar.onDragEnd,
                        o
                      )))
                  : (s.removeEventListener(
                      i.start,
                      this.scrollbar.onDragStart,
                      r
                    ),
                    f.removeEventListener(i.move, this.scrollbar.onDragMove, r),
                    f.removeEventListener(i.end, this.scrollbar.onDragEnd, o));
              }
            },
            init: function () {
              if (this.params.scrollbar.el) {
                var e = this.scrollbar,
                  t = this.$el,
                  i = this.params.scrollbar,
                  n = M(i.el);
                this.params.uniqueNavElements &&
                  "string" == typeof i.el &&
                  1 < n.length &&
                  1 === t.find(i.el).length &&
                  (n = t.find(i.el));
                var s = n.find("." + this.params.scrollbar.dragClass);
                0 === s.length &&
                  ((s = M(
                    '<div class="' +
                      this.params.scrollbar.dragClass +
                      '"></div>'
                  )),
                  n.append(s)),
                  j.extend(e, { $el: n, el: n[0], $dragEl: s, dragEl: s[0] }),
                  i.draggable && e.enableDraggable();
              }
            },
            destroy: function () {
              this.scrollbar.disableDraggable();
            },
          },
          B = {
            setTransform: function (e, t) {
              var i = this.rtl,
                n = M(e),
                s = i ? -1 : 1,
                r = n.attr("data-swiper-parallax") || "0",
                o = n.attr("data-swiper-parallax-x"),
                a = n.attr("data-swiper-parallax-y"),
                l = n.attr("data-swiper-parallax-scale"),
                d = n.attr("data-swiper-parallax-opacity");
              if (
                (o || a
                  ? ((o = o || "0"), (a = a || "0"))
                  : this.isHorizontal()
                  ? ((o = r), (a = "0"))
                  : ((a = r), (o = "0")),
                (o =
                  0 <= o.indexOf("%")
                    ? parseInt(o, 10) * t * s + "%"
                    : o * t * s + "px"),
                (a =
                  0 <= a.indexOf("%")
                    ? parseInt(a, 10) * t + "%"
                    : a * t + "px"),
                null != d)
              ) {
                var c = d - (d - 1) * (1 - Math.abs(t));
                n[0].style.opacity = c;
              }
              if (null == l)
                n.transform("translate3d(" + o + ", " + a + ", 0px)");
              else {
                var u = l - (l - 1) * (1 - Math.abs(t));
                n.transform(
                  "translate3d(" + o + ", " + a + ", 0px) scale(" + u + ")"
                );
              }
            },
            setTranslate: function () {
              var n = this,
                e = n.$el,
                t = n.slides,
                s = n.progress,
                r = n.snapGrid;
              e
                .children(
                  "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]"
                )
                .each(function (e, t) {
                  n.parallax.setTransform(t, s);
                }),
                t.each(function (e, t) {
                  var i = t.progress;
                  1 < n.params.slidesPerGroup &&
                    "auto" !== n.params.slidesPerView &&
                    (i += Math.ceil(e / 2) - s * (r.length - 1)),
                    (i = Math.min(Math.max(i, -1), 1)),
                    M(t)
                      .find(
                        "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]"
                      )
                      .each(function (e, t) {
                        n.parallax.setTransform(t, i);
                      });
                });
            },
            setTransition: function (s) {
              void 0 === s && (s = this.params.speed),
                this.$el
                  .find(
                    "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]"
                  )
                  .each(function (e, t) {
                    var i = M(t),
                      n =
                        parseInt(i.attr("data-swiper-parallax-duration"), 10) ||
                        s;
                    0 === s && (n = 0), i.transition(n);
                  });
            },
          },
          W = {
            getDistanceBetweenTouches: function (e) {
              if (e.targetTouches.length < 2) return 1;
              var t = e.targetTouches[0].pageX,
                i = e.targetTouches[0].pageY,
                n = e.targetTouches[1].pageX,
                s = e.targetTouches[1].pageY;
              return Math.sqrt(Math.pow(n - t, 2) + Math.pow(s - i, 2));
            },
            onGestureStart: function (e) {
              var t = this.params.zoom,
                i = this.zoom,
                n = i.gesture;
              if (
                ((i.fakeGestureTouched = !1),
                (i.fakeGestureMoved = !1),
                !R.gestures)
              ) {
                if (
                  "touchstart" !== e.type ||
                  ("touchstart" === e.type && e.targetTouches.length < 2)
                )
                  return;
                (i.fakeGestureTouched = !0),
                  (n.scaleStart = W.getDistanceBetweenTouches(e));
              }
              (n.$slideEl && n.$slideEl.length) ||
              ((n.$slideEl = M(e.target).closest(".swiper-slide")),
              0 === n.$slideEl.length &&
                (n.$slideEl = this.slides.eq(this.activeIndex)),
              (n.$imageEl = n.$slideEl.find("img, svg, canvas")),
              (n.$imageWrapEl = n.$imageEl.parent("." + t.containerClass)),
              (n.maxRatio =
                n.$imageWrapEl.attr("data-swiper-zoom") || t.maxRatio),
              0 !== n.$imageWrapEl.length)
                ? (n.$imageEl.transition(0), (this.zoom.isScaling = !0))
                : (n.$imageEl = void 0);
            },
            onGestureChange: function (e) {
              var t = this.params.zoom,
                i = this.zoom,
                n = i.gesture;
              if (!R.gestures) {
                if (
                  "touchmove" !== e.type ||
                  ("touchmove" === e.type && e.targetTouches.length < 2)
                )
                  return;
                (i.fakeGestureMoved = !0),
                  (n.scaleMove = W.getDistanceBetweenTouches(e));
              }
              n.$imageEl &&
                0 !== n.$imageEl.length &&
                (R.gestures
                  ? (this.zoom.scale = e.scale * i.currentScale)
                  : (i.scale = (n.scaleMove / n.scaleStart) * i.currentScale),
                i.scale > n.maxRatio &&
                  (i.scale =
                    n.maxRatio - 1 + Math.pow(i.scale - n.maxRatio + 1, 0.5)),
                i.scale < t.minRatio &&
                  (i.scale =
                    t.minRatio + 1 - Math.pow(t.minRatio - i.scale + 1, 0.5)),
                n.$imageEl.transform(
                  "translate3d(0,0,0) scale(" + i.scale + ")"
                ));
            },
            onGestureEnd: function (e) {
              var t = this.params.zoom,
                i = this.zoom,
                n = i.gesture;
              if (!R.gestures) {
                if (!i.fakeGestureTouched || !i.fakeGestureMoved) return;
                if (
                  "touchend" !== e.type ||
                  ("touchend" === e.type &&
                    e.changedTouches.length < 2 &&
                    !m.android)
                )
                  return;
                (i.fakeGestureTouched = !1), (i.fakeGestureMoved = !1);
              }
              n.$imageEl &&
                0 !== n.$imageEl.length &&
                ((i.scale = Math.max(
                  Math.min(i.scale, n.maxRatio),
                  t.minRatio
                )),
                n.$imageEl
                  .transition(this.params.speed)
                  .transform("translate3d(0,0,0) scale(" + i.scale + ")"),
                (i.currentScale = i.scale),
                (i.isScaling = !1),
                1 === i.scale && (n.$slideEl = void 0));
            },
            onTouchStart: function (e) {
              var t = this.zoom,
                i = t.gesture,
                n = t.image;
              i.$imageEl &&
                0 !== i.$imageEl.length &&
                (n.isTouched ||
                  (m.android && e.preventDefault(),
                  (n.isTouched = !0),
                  (n.touchesStart.x =
                    "touchstart" === e.type
                      ? e.targetTouches[0].pageX
                      : e.pageX),
                  (n.touchesStart.y =
                    "touchstart" === e.type
                      ? e.targetTouches[0].pageY
                      : e.pageY)));
            },
            onTouchMove: function (e) {
              var t = this.zoom,
                i = t.gesture,
                n = t.image,
                s = t.velocity;
              if (
                i.$imageEl &&
                0 !== i.$imageEl.length &&
                ((this.allowClick = !1), n.isTouched && i.$slideEl)
              ) {
                n.isMoved ||
                  ((n.width = i.$imageEl[0].offsetWidth),
                  (n.height = i.$imageEl[0].offsetHeight),
                  (n.startX = j.getTranslate(i.$imageWrapEl[0], "x") || 0),
                  (n.startY = j.getTranslate(i.$imageWrapEl[0], "y") || 0),
                  (i.slideWidth = i.$slideEl[0].offsetWidth),
                  (i.slideHeight = i.$slideEl[0].offsetHeight),
                  i.$imageWrapEl.transition(0),
                  this.rtl && ((n.startX = -n.startX), (n.startY = -n.startY)));
                var r = n.width * t.scale,
                  o = n.height * t.scale;
                if (!(r < i.slideWidth && o < i.slideHeight)) {
                  if (
                    ((n.minX = Math.min(i.slideWidth / 2 - r / 2, 0)),
                    (n.maxX = -n.minX),
                    (n.minY = Math.min(i.slideHeight / 2 - o / 2, 0)),
                    (n.maxY = -n.minY),
                    (n.touchesCurrent.x =
                      "touchmove" === e.type
                        ? e.targetTouches[0].pageX
                        : e.pageX),
                    (n.touchesCurrent.y =
                      "touchmove" === e.type
                        ? e.targetTouches[0].pageY
                        : e.pageY),
                    !n.isMoved && !t.isScaling)
                  ) {
                    if (
                      this.isHorizontal() &&
                      ((Math.floor(n.minX) === Math.floor(n.startX) &&
                        n.touchesCurrent.x < n.touchesStart.x) ||
                        (Math.floor(n.maxX) === Math.floor(n.startX) &&
                          n.touchesCurrent.x > n.touchesStart.x))
                    )
                      return void (n.isTouched = !1);
                    if (
                      !this.isHorizontal() &&
                      ((Math.floor(n.minY) === Math.floor(n.startY) &&
                        n.touchesCurrent.y < n.touchesStart.y) ||
                        (Math.floor(n.maxY) === Math.floor(n.startY) &&
                          n.touchesCurrent.y > n.touchesStart.y))
                    )
                      return void (n.isTouched = !1);
                  }
                  e.preventDefault(),
                    e.stopPropagation(),
                    (n.isMoved = !0),
                    (n.currentX =
                      n.touchesCurrent.x - n.touchesStart.x + n.startX),
                    (n.currentY =
                      n.touchesCurrent.y - n.touchesStart.y + n.startY),
                    n.currentX < n.minX &&
                      (n.currentX =
                        n.minX + 1 - Math.pow(n.minX - n.currentX + 1, 0.8)),
                    n.currentX > n.maxX &&
                      (n.currentX =
                        n.maxX - 1 + Math.pow(n.currentX - n.maxX + 1, 0.8)),
                    n.currentY < n.minY &&
                      (n.currentY =
                        n.minY + 1 - Math.pow(n.minY - n.currentY + 1, 0.8)),
                    n.currentY > n.maxY &&
                      (n.currentY =
                        n.maxY - 1 + Math.pow(n.currentY - n.maxY + 1, 0.8)),
                    s.prevPositionX || (s.prevPositionX = n.touchesCurrent.x),
                    s.prevPositionY || (s.prevPositionY = n.touchesCurrent.y),
                    s.prevTime || (s.prevTime = Date.now()),
                    (s.x =
                      (n.touchesCurrent.x - s.prevPositionX) /
                      (Date.now() - s.prevTime) /
                      2),
                    (s.y =
                      (n.touchesCurrent.y - s.prevPositionY) /
                      (Date.now() - s.prevTime) /
                      2),
                    Math.abs(n.touchesCurrent.x - s.prevPositionX) < 2 &&
                      (s.x = 0),
                    Math.abs(n.touchesCurrent.y - s.prevPositionY) < 2 &&
                      (s.y = 0),
                    (s.prevPositionX = n.touchesCurrent.x),
                    (s.prevPositionY = n.touchesCurrent.y),
                    (s.prevTime = Date.now()),
                    i.$imageWrapEl.transform(
                      "translate3d(" +
                        n.currentX +
                        "px, " +
                        n.currentY +
                        "px,0)"
                    );
                }
              }
            },
            onTouchEnd: function () {
              var e = this.zoom,
                t = e.gesture,
                i = e.image,
                n = e.velocity;
              if (t.$imageEl && 0 !== t.$imageEl.length) {
                if (!i.isTouched || !i.isMoved)
                  return (i.isTouched = !1), void (i.isMoved = !1);
                (i.isTouched = !1), (i.isMoved = !1);
                var s = 300,
                  r = 300,
                  o = n.x * s,
                  a = i.currentX + o,
                  l = n.y * r,
                  d = i.currentY + l;
                0 !== n.x && (s = Math.abs((a - i.currentX) / n.x)),
                  0 !== n.y && (r = Math.abs((d - i.currentY) / n.y));
                var c = Math.max(s, r);
                (i.currentX = a), (i.currentY = d);
                var u = i.width * e.scale,
                  p = i.height * e.scale;
                (i.minX = Math.min(t.slideWidth / 2 - u / 2, 0)),
                  (i.maxX = -i.minX),
                  (i.minY = Math.min(t.slideHeight / 2 - p / 2, 0)),
                  (i.maxY = -i.minY),
                  (i.currentX = Math.max(Math.min(i.currentX, i.maxX), i.minX)),
                  (i.currentY = Math.max(Math.min(i.currentY, i.maxY), i.minY)),
                  t.$imageWrapEl
                    .transition(c)
                    .transform(
                      "translate3d(" +
                        i.currentX +
                        "px, " +
                        i.currentY +
                        "px,0)"
                    );
              }
            },
            onTransitionEnd: function () {
              var e = this.zoom,
                t = e.gesture;
              t.$slideEl &&
                this.previousIndex !== this.activeIndex &&
                (t.$imageEl.transform("translate3d(0,0,0) scale(1)"),
                t.$imageWrapEl.transform("translate3d(0,0,0)"),
                (t.$slideEl = void 0),
                (t.$imageEl = void 0),
                (t.$imageWrapEl = void 0),
                (e.scale = 1),
                (e.currentScale = 1));
            },
            toggle: function (e) {
              var t = this.zoom;
              t.scale && 1 !== t.scale ? t.out() : t.in(e);
            },
            in: function (e) {
              var t,
                i,
                n,
                s,
                r,
                o,
                a,
                l,
                d,
                c,
                u,
                p,
                h,
                f,
                m,
                g,
                v = this.zoom,
                y = this.params.zoom,
                b = v.gesture,
                w = v.image;
              b.$slideEl ||
                ((b.$slideEl = this.clickedSlide
                  ? M(this.clickedSlide)
                  : this.slides.eq(this.activeIndex)),
                (b.$imageEl = b.$slideEl.find("img, svg, canvas")),
                (b.$imageWrapEl = b.$imageEl.parent("." + y.containerClass))),
                b.$imageEl &&
                  0 !== b.$imageEl.length &&
                  (b.$slideEl.addClass("" + y.zoomedSlideClass),
                  (i =
                    void 0 === w.touchesStart.x && e
                      ? ((t =
                          "touchend" === e.type
                            ? e.changedTouches[0].pageX
                            : e.pageX),
                        "touchend" === e.type
                          ? e.changedTouches[0].pageY
                          : e.pageY)
                      : ((t = w.touchesStart.x), w.touchesStart.y)),
                  (v.scale =
                    b.$imageWrapEl.attr("data-swiper-zoom") || y.maxRatio),
                  (v.currentScale =
                    b.$imageWrapEl.attr("data-swiper-zoom") || y.maxRatio),
                  e
                    ? ((m = b.$slideEl[0].offsetWidth),
                      (g = b.$slideEl[0].offsetHeight),
                      (n = b.$slideEl.offset().left + m / 2 - t),
                      (s = b.$slideEl.offset().top + g / 2 - i),
                      (a = b.$imageEl[0].offsetWidth),
                      (l = b.$imageEl[0].offsetHeight),
                      (d = a * v.scale),
                      (c = l * v.scale),
                      (h = -(u = Math.min(m / 2 - d / 2, 0))),
                      (f = -(p = Math.min(g / 2 - c / 2, 0))),
                      (r = n * v.scale) < u && (r = u),
                      h < r && (r = h),
                      (o = s * v.scale) < p && (o = p),
                      f < o && (o = f))
                    : (o = r = 0),
                  b.$imageWrapEl
                    .transition(300)
                    .transform("translate3d(" + r + "px, " + o + "px,0)"),
                  b.$imageEl
                    .transition(300)
                    .transform("translate3d(0,0,0) scale(" + v.scale + ")"));
            },
            out: function () {
              var e = this.zoom,
                t = this.params.zoom,
                i = e.gesture;
              i.$slideEl ||
                ((i.$slideEl = this.clickedSlide
                  ? M(this.clickedSlide)
                  : this.slides.eq(this.activeIndex)),
                (i.$imageEl = i.$slideEl.find("img, svg, canvas")),
                (i.$imageWrapEl = i.$imageEl.parent("." + t.containerClass))),
                i.$imageEl &&
                  0 !== i.$imageEl.length &&
                  ((e.scale = 1),
                  (e.currentScale = 1),
                  i.$imageWrapEl
                    .transition(300)
                    .transform("translate3d(0,0,0)"),
                  i.$imageEl
                    .transition(300)
                    .transform("translate3d(0,0,0) scale(1)"),
                  i.$slideEl.removeClass("" + t.zoomedSlideClass),
                  (i.$slideEl = void 0));
            },
            enable: function () {
              var e = this.zoom;
              if (!e.enabled) {
                e.enabled = !0;
                var t = !(
                  "touchstart" !== this.touchEvents.start ||
                  !R.passiveListener ||
                  !this.params.passiveListeners
                ) && { passive: !0, capture: !1 };
                R.gestures
                  ? (this.$wrapperEl.on(
                      "gesturestart",
                      ".swiper-slide",
                      e.onGestureStart,
                      t
                    ),
                    this.$wrapperEl.on(
                      "gesturechange",
                      ".swiper-slide",
                      e.onGestureChange,
                      t
                    ),
                    this.$wrapperEl.on(
                      "gestureend",
                      ".swiper-slide",
                      e.onGestureEnd,
                      t
                    ))
                  : "touchstart" === this.touchEvents.start &&
                    (this.$wrapperEl.on(
                      this.touchEvents.start,
                      ".swiper-slide",
                      e.onGestureStart,
                      t
                    ),
                    this.$wrapperEl.on(
                      this.touchEvents.move,
                      ".swiper-slide",
                      e.onGestureChange,
                      t
                    ),
                    this.$wrapperEl.on(
                      this.touchEvents.end,
                      ".swiper-slide",
                      e.onGestureEnd,
                      t
                    )),
                  this.$wrapperEl.on(
                    this.touchEvents.move,
                    "." + this.params.zoom.containerClass,
                    e.onTouchMove
                  );
              }
            },
            disable: function () {
              var e = this.zoom;
              if (e.enabled) {
                this.zoom.enabled = !1;
                var t = !(
                  "touchstart" !== this.touchEvents.start ||
                  !R.passiveListener ||
                  !this.params.passiveListeners
                ) && { passive: !0, capture: !1 };
                R.gestures
                  ? (this.$wrapperEl.off(
                      "gesturestart",
                      ".swiper-slide",
                      e.onGestureStart,
                      t
                    ),
                    this.$wrapperEl.off(
                      "gesturechange",
                      ".swiper-slide",
                      e.onGestureChange,
                      t
                    ),
                    this.$wrapperEl.off(
                      "gestureend",
                      ".swiper-slide",
                      e.onGestureEnd,
                      t
                    ))
                  : "touchstart" === this.touchEvents.start &&
                    (this.$wrapperEl.off(
                      this.touchEvents.start,
                      ".swiper-slide",
                      e.onGestureStart,
                      t
                    ),
                    this.$wrapperEl.off(
                      this.touchEvents.move,
                      ".swiper-slide",
                      e.onGestureChange,
                      t
                    ),
                    this.$wrapperEl.off(
                      this.touchEvents.end,
                      ".swiper-slide",
                      e.onGestureEnd,
                      t
                    )),
                  this.$wrapperEl.off(
                    this.touchEvents.move,
                    "." + this.params.zoom.containerClass,
                    e.onTouchMove
                  );
              }
            },
          },
          G = {
            loadInSlide: function (e, l) {
              void 0 === l && (l = !0);
              var d = this,
                c = d.params.lazy;
              if (void 0 !== e && 0 !== d.slides.length) {
                var u =
                    d.virtual && d.params.virtual.enabled
                      ? d.$wrapperEl.children(
                          "." +
                            d.params.slideClass +
                            '[data-swiper-slide-index="' +
                            e +
                            '"]'
                        )
                      : d.slides.eq(e),
                  t = u.find(
                    "." +
                      c.elementClass +
                      ":not(." +
                      c.loadedClass +
                      "):not(." +
                      c.loadingClass +
                      ")"
                  );
                !u.hasClass(c.elementClass) ||
                  u.hasClass(c.loadedClass) ||
                  u.hasClass(c.loadingClass) ||
                  (t = t.add(u[0])),
                  0 !== t.length &&
                    t.each(function (e, t) {
                      var n = M(t);
                      n.addClass(c.loadingClass);
                      var s = n.attr("data-background"),
                        r = n.attr("data-src"),
                        o = n.attr("data-srcset"),
                        a = n.attr("data-sizes");
                      d.loadImage(n[0], r || s, o, a, !1, function () {
                        if (
                          null != d &&
                          d &&
                          (!d || d.params) &&
                          !d.destroyed
                        ) {
                          if (
                            (s
                              ? (n.css("background-image", 'url("' + s + '")'),
                                n.removeAttr("data-background"))
                              : (o &&
                                  (n.attr("srcset", o),
                                  n.removeAttr("data-srcset")),
                                a &&
                                  (n.attr("sizes", a),
                                  n.removeAttr("data-sizes")),
                                r &&
                                  (n.attr("src", r), n.removeAttr("data-src"))),
                            n
                              .addClass(c.loadedClass)
                              .removeClass(c.loadingClass),
                            u.find("." + c.preloaderClass).remove(),
                            d.params.loop && l)
                          ) {
                            var e = u.attr("data-swiper-slide-index");
                            if (u.hasClass(d.params.slideDuplicateClass)) {
                              var t = d.$wrapperEl.children(
                                '[data-swiper-slide-index="' +
                                  e +
                                  '"]:not(.' +
                                  d.params.slideDuplicateClass +
                                  ")"
                              );
                              d.lazy.loadInSlide(t.index(), !1);
                            } else {
                              var i = d.$wrapperEl.children(
                                "." +
                                  d.params.slideDuplicateClass +
                                  '[data-swiper-slide-index="' +
                                  e +
                                  '"]'
                              );
                              d.lazy.loadInSlide(i.index(), !1);
                            }
                          }
                          d.emit("lazyImageReady", u[0], n[0]);
                        }
                      }),
                        d.emit("lazyImageLoad", u[0], n[0]);
                    });
              }
            },
            load: function () {
              var n = this,
                t = n.$wrapperEl,
                i = n.params,
                s = n.slides,
                e = n.activeIndex,
                r = n.virtual && i.virtual.enabled,
                o = i.lazy,
                a = i.slidesPerView;
              function l(e) {
                if (r) {
                  if (
                    t.children(
                      "." +
                        i.slideClass +
                        '[data-swiper-slide-index="' +
                        e +
                        '"]'
                    ).length
                  )
                    return 1;
                } else if (s[e]) return 1;
              }
              function d(e) {
                return r ? M(e).attr("data-swiper-slide-index") : M(e).index();
              }
              if (
                ("auto" === a && (a = 0),
                n.lazy.initialImageLoaded || (n.lazy.initialImageLoaded = !0),
                n.params.watchSlidesVisibility)
              )
                t.children("." + i.slideVisibleClass).each(function (e, t) {
                  var i = r
                    ? M(t).attr("data-swiper-slide-index")
                    : M(t).index();
                  n.lazy.loadInSlide(i);
                });
              else if (1 < a)
                for (var c = e; c < e + a; c += 1)
                  l(c) && n.lazy.loadInSlide(c);
              else n.lazy.loadInSlide(e);
              if (o.loadPrevNext)
                if (
                  1 < a ||
                  (o.loadPrevNextAmount && 1 < o.loadPrevNextAmount)
                ) {
                  for (
                    var u = o.loadPrevNextAmount,
                      p = a,
                      h = Math.min(e + p + Math.max(u, p), s.length),
                      f = Math.max(e - Math.max(p, u), 0),
                      m = e + a;
                    m < h;
                    m += 1
                  )
                    l(m) && n.lazy.loadInSlide(m);
                  for (var g = f; g < e; g += 1) l(g) && n.lazy.loadInSlide(g);
                } else {
                  var v = t.children("." + i.slideNextClass);
                  0 < v.length && n.lazy.loadInSlide(d(v));
                  var y = t.children("." + i.slidePrevClass);
                  0 < y.length && n.lazy.loadInSlide(d(y));
                }
            },
          },
          X = {
            LinearSpline: function (e, t) {
              var i, n, s, r, o;
              return (
                (this.x = e),
                (this.y = t),
                (this.lastIndex = e.length - 1),
                (this.interpolate = function (e) {
                  return e
                    ? ((o = (function (e, t) {
                        for (n = -1, i = e.length; 1 < i - n; )
                          e[(s = (i + n) >> 1)] <= t ? (n = s) : (i = s);
                        return i;
                      })(this.x, e)),
                      (r = o - 1),
                      ((e - this.x[r]) * (this.y[o] - this.y[r])) /
                        (this.x[o] - this.x[r]) +
                        this.y[r])
                    : 0;
                }),
                this
              );
            },
            getInterpolateFunction: function (e) {
              this.controller.spline ||
                (this.controller.spline = this.params.loop
                  ? new X.LinearSpline(this.slidesGrid, e.slidesGrid)
                  : new X.LinearSpline(this.snapGrid, e.snapGrid));
            },
            setTranslate: function (e, t) {
              var i,
                n,
                s = this,
                r = s.controller.control;
              function o(e) {
                var t = s.rtlTranslate ? -s.translate : s.translate;
                "slide" === s.params.controller.by &&
                  (s.controller.getInterpolateFunction(e),
                  (n = -s.controller.spline.interpolate(-t))),
                  (n && "container" !== s.params.controller.by) ||
                    ((i =
                      (e.maxTranslate() - e.minTranslate()) /
                      (s.maxTranslate() - s.minTranslate())),
                    (n = (t - s.minTranslate()) * i + e.minTranslate())),
                  s.params.controller.inverse && (n = e.maxTranslate() - n),
                  e.updateProgress(n),
                  e.setTranslate(n, s),
                  e.updateActiveIndex(),
                  e.updateSlidesClasses();
              }
              if (Array.isArray(r))
                for (var a = 0; a < r.length; a += 1)
                  r[a] !== t && r[a] instanceof S && o(r[a]);
              else r instanceof S && t !== r && o(r);
            },
            setTransition: function (t, e) {
              var i,
                n = this,
                s = n.controller.control;
              function r(e) {
                e.setTransition(t, n),
                  0 !== t &&
                    (e.transitionStart(),
                    e.$wrapperEl.transitionEnd(function () {
                      s &&
                        (e.params.loop &&
                          "slide" === n.params.controller.by &&
                          e.loopFix(),
                        e.transitionEnd());
                    }));
              }
              if (Array.isArray(s))
                for (i = 0; i < s.length; i += 1)
                  s[i] !== e && s[i] instanceof S && r(s[i]);
              else s instanceof S && e !== s && r(s);
            },
          },
          Y = {
            makeElFocusable: function (e) {
              return e.attr("tabIndex", "0"), e;
            },
            addElRole: function (e, t) {
              return e.attr("role", t), e;
            },
            addElLabel: function (e, t) {
              return e.attr("aria-label", t), e;
            },
            disableEl: function (e) {
              return e.attr("aria-disabled", !0), e;
            },
            enableEl: function (e) {
              return e.attr("aria-disabled", !1), e;
            },
            onEnterKey: function (e) {
              var t = this.params.a11y;
              if (13 === e.keyCode) {
                var i = M(e.target);
                this.navigation &&
                  this.navigation.$nextEl &&
                  i.is(this.navigation.$nextEl) &&
                  ((this.isEnd && !this.params.loop) || this.slideNext(),
                  this.isEnd
                    ? this.a11y.notify(t.lastSlideMessage)
                    : this.a11y.notify(t.nextSlideMessage)),
                  this.navigation &&
                    this.navigation.$prevEl &&
                    i.is(this.navigation.$prevEl) &&
                    ((this.isBeginning && !this.params.loop) ||
                      this.slidePrev(),
                    this.isBeginning
                      ? this.a11y.notify(t.firstSlideMessage)
                      : this.a11y.notify(t.prevSlideMessage)),
                  this.pagination &&
                    i.is("." + this.params.pagination.bulletClass) &&
                    i[0].click();
              }
            },
            notify: function (e) {
              var t = this.a11y.liveRegion;
              0 !== t.length && (t.html(""), t.html(e));
            },
            updateNavigation: function () {
              if (!this.params.loop) {
                var e = this.navigation,
                  t = e.$nextEl,
                  i = e.$prevEl;
                i &&
                  0 < i.length &&
                  (this.isBeginning
                    ? this.a11y.disableEl(i)
                    : this.a11y.enableEl(i)),
                  t &&
                    0 < t.length &&
                    (this.isEnd
                      ? this.a11y.disableEl(t)
                      : this.a11y.enableEl(t));
              }
            },
            updatePagination: function () {
              var n = this,
                s = n.params.a11y;
              n.pagination &&
                n.params.pagination.clickable &&
                n.pagination.bullets &&
                n.pagination.bullets.length &&
                n.pagination.bullets.each(function (e, t) {
                  var i = M(t);
                  n.a11y.makeElFocusable(i),
                    n.a11y.addElRole(i, "button"),
                    n.a11y.addElLabel(
                      i,
                      s.paginationBulletMessage.replace(
                        /{{index}}/,
                        i.index() + 1
                      )
                    );
                });
            },
            init: function () {
              this.$el.append(this.a11y.liveRegion);
              var e,
                t,
                i = this.params.a11y;
              this.navigation &&
                this.navigation.$nextEl &&
                (e = this.navigation.$nextEl),
                this.navigation &&
                  this.navigation.$prevEl &&
                  (t = this.navigation.$prevEl),
                e &&
                  (this.a11y.makeElFocusable(e),
                  this.a11y.addElRole(e, "button"),
                  this.a11y.addElLabel(e, i.nextSlideMessage),
                  e.on("keydown", this.a11y.onEnterKey)),
                t &&
                  (this.a11y.makeElFocusable(t),
                  this.a11y.addElRole(t, "button"),
                  this.a11y.addElLabel(t, i.prevSlideMessage),
                  t.on("keydown", this.a11y.onEnterKey)),
                this.pagination &&
                  this.params.pagination.clickable &&
                  this.pagination.bullets &&
                  this.pagination.bullets.length &&
                  this.pagination.$el.on(
                    "keydown",
                    "." + this.params.pagination.bulletClass,
                    this.a11y.onEnterKey
                  );
            },
            destroy: function () {
              var e, t;
              this.a11y.liveRegion &&
                0 < this.a11y.liveRegion.length &&
                this.a11y.liveRegion.remove(),
                this.navigation &&
                  this.navigation.$nextEl &&
                  (e = this.navigation.$nextEl),
                this.navigation &&
                  this.navigation.$prevEl &&
                  (t = this.navigation.$prevEl),
                e && e.off("keydown", this.a11y.onEnterKey),
                t && t.off("keydown", this.a11y.onEnterKey),
                this.pagination &&
                  this.params.pagination.clickable &&
                  this.pagination.bullets &&
                  this.pagination.bullets.length &&
                  this.pagination.$el.off(
                    "keydown",
                    "." + this.params.pagination.bulletClass,
                    this.a11y.onEnterKey
                  );
            },
          },
          U = {
            init: function () {
              if (this.params.history) {
                if (!H.history || !H.history.pushState)
                  return (
                    (this.params.history.enabled = !1),
                    void (this.params.hashNavigation.enabled = !0)
                  );
                var e = this.history;
                (e.initialized = !0),
                  (e.paths = U.getPathValues()),
                  (e.paths.key || e.paths.value) &&
                    (e.scrollToSlide(
                      0,
                      e.paths.value,
                      this.params.runCallbacksOnInit
                    ),
                    this.params.history.replaceState ||
                      H.addEventListener(
                        "popstate",
                        this.history.setHistoryPopState
                      ));
              }
            },
            destroy: function () {
              this.params.history.replaceState ||
                H.removeEventListener(
                  "popstate",
                  this.history.setHistoryPopState
                );
            },
            setHistoryPopState: function () {
              (this.history.paths = U.getPathValues()),
                this.history.scrollToSlide(
                  this.params.speed,
                  this.history.paths.value,
                  !1
                );
            },
            getPathValues: function () {
              var e = H.location.pathname
                  .slice(1)
                  .split("/")
                  .filter(function (e) {
                    return "" !== e;
                  }),
                t = e.length;
              return { key: e[t - 2], value: e[t - 1] };
            },
            setHistory: function (e, t) {
              if (this.history.initialized && this.params.history.enabled) {
                var i = this.slides.eq(t),
                  n = U.slugify(i.attr("data-history"));
                H.location.pathname.includes(e) || (n = e + "/" + n);
                var s = H.history.state;
                (s && s.value === n) ||
                  (this.params.history.replaceState
                    ? H.history.replaceState({ value: n }, null, n)
                    : H.history.pushState({ value: n }, null, n));
              }
            },
            slugify: function (e) {
              return e
                .toString()
                .toLowerCase()
                .replace(/\s+/g, "-")
                .replace(/[^\w-]+/g, "")
                .replace(/--+/g, "-")
                .replace(/^-+/, "")
                .replace(/-+$/, "");
            },
            scrollToSlide: function (e, t, i) {
              if (t)
                for (var n = 0, s = this.slides.length; n < s; n += 1) {
                  var r = this.slides.eq(n);
                  if (
                    U.slugify(r.attr("data-history")) === t &&
                    !r.hasClass(this.params.slideDuplicateClass)
                  ) {
                    var o = r.index();
                    this.slideTo(o, e, i);
                  }
                }
              else this.slideTo(0, e, i);
            },
          },
          V = {
            onHashCange: function () {
              var e = f.location.hash.replace("#", "");
              e !== this.slides.eq(this.activeIndex).attr("data-hash") &&
                this.slideTo(
                  this.$wrapperEl
                    .children(
                      "." + this.params.slideClass + '[data-hash="' + e + '"]'
                    )
                    .index()
                );
            },
            setHash: function () {
              if (
                this.hashNavigation.initialized &&
                this.params.hashNavigation.enabled
              )
                if (
                  this.params.hashNavigation.replaceState &&
                  H.history &&
                  H.history.replaceState
                )
                  H.history.replaceState(
                    null,
                    null,
                    "#" + this.slides.eq(this.activeIndex).attr("data-hash") ||
                      ""
                  );
                else {
                  var e = this.slides.eq(this.activeIndex),
                    t = e.attr("data-hash") || e.attr("data-history");
                  f.location.hash = t || "";
                }
            },
            init: function () {
              if (
                !(
                  !this.params.hashNavigation.enabled ||
                  (this.params.history && this.params.history.enabled)
                )
              ) {
                this.hashNavigation.initialized = !0;
                var e = f.location.hash.replace("#", "");
                if (e)
                  for (var t = 0, i = this.slides.length; t < i; t += 1) {
                    var n = this.slides.eq(t);
                    if (
                      (n.attr("data-hash") || n.attr("data-history")) === e &&
                      !n.hasClass(this.params.slideDuplicateClass)
                    ) {
                      var s = n.index();
                      this.slideTo(s, 0, this.params.runCallbacksOnInit, !0);
                    }
                  }
                this.params.hashNavigation.watchState &&
                  M(H).on("hashchange", this.hashNavigation.onHashCange);
              }
            },
            destroy: function () {
              this.params.hashNavigation.watchState &&
                M(H).off("hashchange", this.hashNavigation.onHashCange);
            },
          },
          K = {
            run: function () {
              var e = this,
                t = e.slides.eq(e.activeIndex),
                i = e.params.autoplay.delay;
              t.attr("data-swiper-autoplay") &&
                (i = t.attr("data-swiper-autoplay") || e.params.autoplay.delay),
                (e.autoplay.timeout = j.nextTick(function () {
                  e.params.autoplay.reverseDirection
                    ? e.params.loop
                      ? (e.loopFix(),
                        e.slidePrev(e.params.speed, !0, !0),
                        e.emit("autoplay"))
                      : e.isBeginning
                      ? e.params.autoplay.stopOnLastSlide
                        ? e.autoplay.stop()
                        : (e.slideTo(
                            e.slides.length - 1,
                            e.params.speed,
                            !0,
                            !0
                          ),
                          e.emit("autoplay"))
                      : (e.slidePrev(e.params.speed, !0, !0),
                        e.emit("autoplay"))
                    : e.params.loop
                    ? (e.loopFix(),
                      e.slideNext(e.params.speed, !0, !0),
                      e.emit("autoplay"))
                    : e.isEnd
                    ? e.params.autoplay.stopOnLastSlide
                      ? e.autoplay.stop()
                      : (e.slideTo(0, e.params.speed, !0, !0),
                        e.emit("autoplay"))
                    : (e.slideNext(e.params.speed, !0, !0), e.emit("autoplay"));
                }, i));
            },
            start: function () {
              return (
                void 0 === this.autoplay.timeout &&
                !this.autoplay.running &&
                ((this.autoplay.running = !0),
                this.emit("autoplayStart"),
                this.autoplay.run(),
                !0)
              );
            },
            stop: function () {
              return (
                !!this.autoplay.running &&
                void 0 !== this.autoplay.timeout &&
                (this.autoplay.timeout &&
                  (clearTimeout(this.autoplay.timeout),
                  (this.autoplay.timeout = void 0)),
                (this.autoplay.running = !1),
                this.emit("autoplayStop"),
                !0)
              );
            },
            pause: function (e) {
              this.autoplay.running &&
                (this.autoplay.paused ||
                  (this.autoplay.timeout && clearTimeout(this.autoplay.timeout),
                  (this.autoplay.paused = !0),
                  0 !== e && this.params.autoplay.waitForTransition
                    ? (this.$wrapperEl[0].addEventListener(
                        "transitionend",
                        this.autoplay.onTransitionEnd
                      ),
                      this.$wrapperEl[0].addEventListener(
                        "webkitTransitionEnd",
                        this.autoplay.onTransitionEnd
                      ))
                    : ((this.autoplay.paused = !1), this.autoplay.run())));
            },
          },
          Z = {
            setTranslate: function () {
              for (var e = this.slides, t = 0; t < e.length; t += 1) {
                var i = this.slides.eq(t),
                  n = -i[0].swiperSlideOffset;
                this.params.virtualTranslate || (n -= this.translate);
                var s = 0;
                this.isHorizontal() || ((s = n), (n = 0));
                var r = this.params.fadeEffect.crossFade
                  ? Math.max(1 - Math.abs(i[0].progress), 0)
                  : 1 + Math.min(Math.max(i[0].progress, -1), 0);
                i.css({ opacity: r }).transform(
                  "translate3d(" + n + "px, " + s + "px, 0px)"
                );
              }
            },
            setTransition: function (e) {
              var i = this,
                t = i.slides,
                n = i.$wrapperEl;
              if ((t.transition(e), i.params.virtualTranslate && 0 !== e)) {
                var s = !1;
                t.transitionEnd(function () {
                  if (!s && i && !i.destroyed) {
                    (s = !0), (i.animating = !1);
                    for (
                      var e = ["webkitTransitionEnd", "transitionend"], t = 0;
                      t < e.length;
                      t += 1
                    )
                      n.trigger(e[t]);
                  }
                });
              }
            },
          },
          Q = {
            setTranslate: function () {
              var e,
                t = this.$el,
                i = this.$wrapperEl,
                n = this.slides,
                s = this.width,
                r = this.height,
                o = this.rtlTranslate,
                a = this.size,
                l = this.params.cubeEffect,
                d = this.isHorizontal(),
                c = this.virtual && this.params.virtual.enabled,
                u = 0;
              l.shadow &&
                (d
                  ? (0 === (e = i.find(".swiper-cube-shadow")).length &&
                      ((e = M('<div class="swiper-cube-shadow"></div>')),
                      i.append(e)),
                    e.css({ height: s + "px" }))
                  : 0 === (e = t.find(".swiper-cube-shadow")).length &&
                    ((e = M('<div class="swiper-cube-shadow"></div>')),
                    t.append(e)));
              for (var p = 0; p < n.length; p += 1) {
                var h = n.eq(p),
                  f = p;
                c && (f = parseInt(h.attr("data-swiper-slide-index"), 10));
                var m = 90 * f,
                  g = Math.floor(m / 360);
                o && ((m = -m), (g = Math.floor(-m / 360)));
                var v = Math.max(Math.min(h[0].progress, 1), -1),
                  y = 0,
                  b = 0,
                  w = 0;
                f % 4 == 0
                  ? ((y = 4 * -g * a), (w = 0))
                  : (f - 1) % 4 == 0
                  ? ((y = 0), (w = 4 * -g * a))
                  : (f - 2) % 4 == 0
                  ? ((y = a + 4 * g * a), (w = a))
                  : (f - 3) % 4 == 0 && ((y = -a), (w = 3 * a + 4 * a * g)),
                  o && (y = -y),
                  d || ((b = y), (y = 0));
                var x =
                  "rotateX(" +
                  (d ? 0 : -m) +
                  "deg) rotateY(" +
                  (d ? m : 0) +
                  "deg) translate3d(" +
                  y +
                  "px, " +
                  b +
                  "px, " +
                  w +
                  "px)";
                if (
                  (v <= 1 &&
                    -1 < v &&
                    ((u = 90 * f + 90 * v), o && (u = 90 * -f - 90 * v)),
                  h.transform(x),
                  l.slideShadows)
                ) {
                  var T = d
                      ? h.find(".swiper-slide-shadow-left")
                      : h.find(".swiper-slide-shadow-top"),
                    S = d
                      ? h.find(".swiper-slide-shadow-right")
                      : h.find(".swiper-slide-shadow-bottom");
                  0 === T.length &&
                    ((T = M(
                      '<div class="swiper-slide-shadow-' +
                        (d ? "left" : "top") +
                        '"></div>'
                    )),
                    h.append(T)),
                    0 === S.length &&
                      ((S = M(
                        '<div class="swiper-slide-shadow-' +
                          (d ? "right" : "bottom") +
                          '"></div>'
                      )),
                      h.append(S)),
                    T.length && (T[0].style.opacity = Math.max(-v, 0)),
                    S.length && (S[0].style.opacity = Math.max(v, 0));
                }
              }
              if (
                (i.css({
                  "-webkit-transform-origin": "50% 50% -" + a / 2 + "px",
                  "-moz-transform-origin": "50% 50% -" + a / 2 + "px",
                  "-ms-transform-origin": "50% 50% -" + a / 2 + "px",
                  "transform-origin": "50% 50% -" + a / 2 + "px",
                }),
                l.shadow)
              )
                if (d)
                  e.transform(
                    "translate3d(0px, " +
                      (s / 2 + l.shadowOffset) +
                      "px, " +
                      -s / 2 +
                      "px) rotateX(90deg) rotateZ(0deg) scale(" +
                      l.shadowScale +
                      ")"
                  );
                else {
                  var C = Math.abs(u) - 90 * Math.floor(Math.abs(u) / 90),
                    E =
                      1.5 -
                      (Math.sin((2 * C * Math.PI) / 360) / 2 +
                        Math.cos((2 * C * Math.PI) / 360) / 2),
                    k = l.shadowScale,
                    $ = l.shadowScale / E,
                    A = l.shadowOffset;
                  e.transform(
                    "scale3d(" +
                      k +
                      ", 1, " +
                      $ +
                      ") translate3d(0px, " +
                      (r / 2 + A) +
                      "px, " +
                      -r / 2 / $ +
                      "px) rotateX(-90deg)"
                  );
                }
              var z = D.isSafari || D.isUiWebView ? -a / 2 : 0;
              i.transform(
                "translate3d(0px,0," +
                  z +
                  "px) rotateX(" +
                  (this.isHorizontal() ? 0 : u) +
                  "deg) rotateY(" +
                  (this.isHorizontal() ? -u : 0) +
                  "deg)"
              );
            },
            setTransition: function (e) {
              var t = this.$el;
              this.slides
                .transition(e)
                .find(
                  ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                )
                .transition(e),
                this.params.cubeEffect.shadow &&
                  !this.isHorizontal() &&
                  t.find(".swiper-cube-shadow").transition(e);
            },
          },
          J = {
            setTranslate: function () {
              for (
                var e = this.slides, t = this.rtlTranslate, i = 0;
                i < e.length;
                i += 1
              ) {
                var n = e.eq(i),
                  s = n[0].progress;
                this.params.flipEffect.limitRotation &&
                  (s = Math.max(Math.min(n[0].progress, 1), -1));
                var r = -180 * s,
                  o = 0,
                  a = -n[0].swiperSlideOffset,
                  l = 0;
                if (
                  (this.isHorizontal()
                    ? t && (r = -r)
                    : ((l = a), (o = -r), (r = a = 0)),
                  (n[0].style.zIndex = -Math.abs(Math.round(s)) + e.length),
                  this.params.flipEffect.slideShadows)
                ) {
                  var d = this.isHorizontal()
                      ? n.find(".swiper-slide-shadow-left")
                      : n.find(".swiper-slide-shadow-top"),
                    c = this.isHorizontal()
                      ? n.find(".swiper-slide-shadow-right")
                      : n.find(".swiper-slide-shadow-bottom");
                  0 === d.length &&
                    ((d = M(
                      '<div class="swiper-slide-shadow-' +
                        (this.isHorizontal() ? "left" : "top") +
                        '"></div>'
                    )),
                    n.append(d)),
                    0 === c.length &&
                      ((c = M(
                        '<div class="swiper-slide-shadow-' +
                          (this.isHorizontal() ? "right" : "bottom") +
                          '"></div>'
                      )),
                      n.append(c)),
                    d.length && (d[0].style.opacity = Math.max(-s, 0)),
                    c.length && (c[0].style.opacity = Math.max(s, 0));
                }
                n.transform(
                  "translate3d(" +
                    a +
                    "px, " +
                    l +
                    "px, 0px) rotateX(" +
                    o +
                    "deg) rotateY(" +
                    r +
                    "deg)"
                );
              }
            },
            setTransition: function (e) {
              var i = this,
                t = i.slides,
                n = i.activeIndex,
                s = i.$wrapperEl;
              if (
                (t
                  .transition(e)
                  .find(
                    ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                  )
                  .transition(e),
                i.params.virtualTranslate && 0 !== e)
              ) {
                var r = !1;
                t.eq(n).transitionEnd(function () {
                  if (!r && i && !i.destroyed) {
                    (r = !0), (i.animating = !1);
                    for (
                      var e = ["webkitTransitionEnd", "transitionend"], t = 0;
                      t < e.length;
                      t += 1
                    )
                      s.trigger(e[t]);
                  }
                });
              }
            },
          },
          ee = {
            setTranslate: function () {
              for (
                var e = this.width,
                  t = this.height,
                  i = this.slides,
                  n = this.$wrapperEl,
                  s = this.slidesSizesGrid,
                  r = this.params.coverflowEffect,
                  o = this.isHorizontal(),
                  a = this.translate,
                  l = o ? e / 2 - a : t / 2 - a,
                  d = o ? r.rotate : -r.rotate,
                  c = r.depth,
                  u = 0,
                  p = i.length;
                u < p;
                u += 1
              ) {
                var h = i.eq(u),
                  f = s[u],
                  m = ((l - h[0].swiperSlideOffset - f / 2) / f) * r.modifier,
                  g = o ? d * m : 0,
                  v = o ? 0 : d * m,
                  y = -c * Math.abs(m),
                  b = o ? 0 : r.stretch * m,
                  w = o ? r.stretch * m : 0;
                Math.abs(w) < 0.001 && (w = 0),
                  Math.abs(b) < 0.001 && (b = 0),
                  Math.abs(y) < 0.001 && (y = 0),
                  Math.abs(g) < 0.001 && (g = 0),
                  Math.abs(v) < 0.001 && (v = 0);
                var x =
                  "translate3d(" +
                  w +
                  "px," +
                  b +
                  "px," +
                  y +
                  "px)  rotateX(" +
                  v +
                  "deg) rotateY(" +
                  g +
                  "deg)";
                if (
                  (h.transform(x),
                  (h[0].style.zIndex = 1 - Math.abs(Math.round(m))),
                  r.slideShadows)
                ) {
                  var T = o
                      ? h.find(".swiper-slide-shadow-left")
                      : h.find(".swiper-slide-shadow-top"),
                    S = o
                      ? h.find(".swiper-slide-shadow-right")
                      : h.find(".swiper-slide-shadow-bottom");
                  0 === T.length &&
                    ((T = M(
                      '<div class="swiper-slide-shadow-' +
                        (o ? "left" : "top") +
                        '"></div>'
                    )),
                    h.append(T)),
                    0 === S.length &&
                      ((S = M(
                        '<div class="swiper-slide-shadow-' +
                          (o ? "right" : "bottom") +
                          '"></div>'
                      )),
                      h.append(S)),
                    T.length && (T[0].style.opacity = 0 < m ? m : 0),
                    S.length && (S[0].style.opacity = 0 < -m ? -m : 0);
                }
              }
              (R.pointerEvents || R.prefixedPointerEvents) &&
                (n[0].style.perspectiveOrigin = l + "px 50%");
            },
            setTransition: function (e) {
              this.slides
                .transition(e)
                .find(
                  ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                )
                .transition(e);
            },
          },
          te = [
            C,
            E,
            k,
            $,
            z,
            P,
            O,
            {
              name: "mousewheel",
              params: {
                mousewheel: {
                  enabled: !1,
                  releaseOnEdges: !1,
                  invert: !1,
                  forceToAxis: !1,
                  sensitivity: 1,
                  eventsTarged: "container",
                },
              },
              create: function () {
                j.extend(this, {
                  mousewheel: {
                    enabled: !1,
                    enable: I.enable.bind(this),
                    disable: I.disable.bind(this),
                    handle: I.handle.bind(this),
                    handleMouseEnter: I.handleMouseEnter.bind(this),
                    handleMouseLeave: I.handleMouseLeave.bind(this),
                    lastScrollTime: j.now(),
                  },
                });
              },
              on: {
                init: function () {
                  this.params.mousewheel.enabled && this.mousewheel.enable();
                },
                destroy: function () {
                  this.mousewheel.enabled && this.mousewheel.disable();
                },
              },
            },
            {
              name: "navigation",
              params: {
                navigation: {
                  nextEl: null,
                  prevEl: null,
                  hideOnClick: !1,
                  disabledClass: "swiper-button-disabled",
                  hiddenClass: "swiper-button-hidden",
                  lockClass: "swiper-button-lock",
                },
              },
              create: function () {
                j.extend(this, {
                  navigation: {
                    init: N.init.bind(this),
                    update: N.update.bind(this),
                    destroy: N.destroy.bind(this),
                  },
                });
              },
              on: {
                init: function () {
                  this.navigation.init(), this.navigation.update();
                },
                toEdge: function () {
                  this.navigation.update();
                },
                fromEdge: function () {
                  this.navigation.update();
                },
                destroy: function () {
                  this.navigation.destroy();
                },
                click: function (e) {
                  var t = this.navigation,
                    i = t.$nextEl,
                    n = t.$prevEl;
                  !this.params.navigation.hideOnClick ||
                    M(e.target).is(n) ||
                    M(e.target).is(i) ||
                    (i && i.toggleClass(this.params.navigation.hiddenClass),
                    n && n.toggleClass(this.params.navigation.hiddenClass));
                },
              },
            },
            {
              name: "pagination",
              params: {
                pagination: {
                  el: null,
                  bulletElement: "span",
                  clickable: !1,
                  hideOnClick: !1,
                  renderBullet: null,
                  renderProgressbar: null,
                  renderFraction: null,
                  renderCustom: null,
                  progressbarOpposite: !1,
                  type: "bullets",
                  dynamicBullets: !1,
                  dynamicMainBullets: 1,
                  formatFractionCurrent: function (e) {
                    return e;
                  },
                  formatFractionTotal: function (e) {
                    return e;
                  },
                  bulletClass: "swiper-pagination-bullet",
                  bulletActiveClass: "swiper-pagination-bullet-active",
                  modifierClass: "swiper-pagination-",
                  currentClass: "swiper-pagination-current",
                  totalClass: "swiper-pagination-total",
                  hiddenClass: "swiper-pagination-hidden",
                  progressbarFillClass: "swiper-pagination-progressbar-fill",
                  progressbarOppositeClass:
                    "swiper-pagination-progressbar-opposite",
                  clickableClass: "swiper-pagination-clickable",
                  lockClass: "swiper-pagination-lock",
                },
              },
              create: function () {
                j.extend(this, {
                  pagination: {
                    init: q.init.bind(this),
                    render: q.render.bind(this),
                    update: q.update.bind(this),
                    destroy: q.destroy.bind(this),
                    dynamicBulletIndex: 0,
                  },
                });
              },
              on: {
                init: function () {
                  this.pagination.init(),
                    this.pagination.render(),
                    this.pagination.update();
                },
                activeIndexChange: function () {
                  (!this.params.loop && void 0 !== this.snapIndex) ||
                    this.pagination.update();
                },
                snapIndexChange: function () {
                  this.params.loop || this.pagination.update();
                },
                slidesLengthChange: function () {
                  this.params.loop &&
                    (this.pagination.render(), this.pagination.update());
                },
                snapGridLengthChange: function () {
                  this.params.loop ||
                    (this.pagination.render(), this.pagination.update());
                },
                destroy: function () {
                  this.pagination.destroy();
                },
                click: function (e) {
                  this.params.pagination.el &&
                    this.params.pagination.hideOnClick &&
                    0 < this.pagination.$el.length &&
                    !M(e.target).hasClass(this.params.pagination.bulletClass) &&
                    this.pagination.$el.toggleClass(
                      this.params.pagination.hiddenClass
                    );
                },
              },
            },
            {
              name: "scrollbar",
              params: {
                scrollbar: {
                  el: null,
                  dragSize: "auto",
                  hide: !1,
                  draggable: !1,
                  snapOnRelease: !0,
                  lockClass: "swiper-scrollbar-lock",
                  dragClass: "swiper-scrollbar-drag",
                },
              },
              create: function () {
                j.extend(this, {
                  scrollbar: {
                    init: F.init.bind(this),
                    destroy: F.destroy.bind(this),
                    updateSize: F.updateSize.bind(this),
                    setTranslate: F.setTranslate.bind(this),
                    setTransition: F.setTransition.bind(this),
                    enableDraggable: F.enableDraggable.bind(this),
                    disableDraggable: F.disableDraggable.bind(this),
                    setDragPosition: F.setDragPosition.bind(this),
                    onDragStart: F.onDragStart.bind(this),
                    onDragMove: F.onDragMove.bind(this),
                    onDragEnd: F.onDragEnd.bind(this),
                    isTouched: !1,
                    timeout: null,
                    dragTimeout: null,
                  },
                });
              },
              on: {
                init: function () {
                  this.scrollbar.init(),
                    this.scrollbar.updateSize(),
                    this.scrollbar.setTranslate();
                },
                update: function () {
                  this.scrollbar.updateSize();
                },
                resize: function () {
                  this.scrollbar.updateSize();
                },
                observerUpdate: function () {
                  this.scrollbar.updateSize();
                },
                setTranslate: function () {
                  this.scrollbar.setTranslate();
                },
                setTransition: function (e) {
                  this.scrollbar.setTransition(e);
                },
                destroy: function () {
                  this.scrollbar.destroy();
                },
              },
            },
            {
              name: "parallax",
              params: { parallax: { enabled: !1 } },
              create: function () {
                j.extend(this, {
                  parallax: {
                    setTransform: B.setTransform.bind(this),
                    setTranslate: B.setTranslate.bind(this),
                    setTransition: B.setTransition.bind(this),
                  },
                });
              },
              on: {
                beforeInit: function () {
                  this.params.parallax.enabled &&
                    (this.params.watchSlidesProgress = !0);
                },
                init: function () {
                  this.params.parallax && this.parallax.setTranslate();
                },
                setTranslate: function () {
                  this.params.parallax && this.parallax.setTranslate();
                },
                setTransition: function (e) {
                  this.params.parallax && this.parallax.setTransition(e);
                },
              },
            },
            {
              name: "zoom",
              params: {
                zoom: {
                  enabled: !1,
                  maxRatio: 3,
                  minRatio: 1,
                  toggle: !0,
                  containerClass: "swiper-zoom-container",
                  zoomedSlideClass: "swiper-slide-zoomed",
                },
              },
              create: function () {
                var t = this,
                  i = {
                    enabled: !1,
                    scale: 1,
                    currentScale: 1,
                    isScaling: !1,
                    gesture: {
                      $slideEl: void 0,
                      slideWidth: void 0,
                      slideHeight: void 0,
                      $imageEl: void 0,
                      $imageWrapEl: void 0,
                      maxRatio: 3,
                    },
                    image: {
                      isTouched: void 0,
                      isMoved: void 0,
                      currentX: void 0,
                      currentY: void 0,
                      minX: void 0,
                      minY: void 0,
                      maxX: void 0,
                      maxY: void 0,
                      width: void 0,
                      height: void 0,
                      startX: void 0,
                      startY: void 0,
                      touchesStart: {},
                      touchesCurrent: {},
                    },
                    velocity: {
                      x: void 0,
                      y: void 0,
                      prevPositionX: void 0,
                      prevPositionY: void 0,
                      prevTime: void 0,
                    },
                  };
                "onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out"
                  .split(" ")
                  .forEach(function (e) {
                    i[e] = W[e].bind(t);
                  }),
                  j.extend(t, { zoom: i });
              },
              on: {
                init: function () {
                  this.params.zoom.enabled && this.zoom.enable();
                },
                destroy: function () {
                  this.zoom.disable();
                },
                touchStart: function (e) {
                  this.zoom.enabled && this.zoom.onTouchStart(e);
                },
                touchEnd: function (e) {
                  this.zoom.enabled && this.zoom.onTouchEnd(e);
                },
                doubleTap: function (e) {
                  this.params.zoom.enabled &&
                    this.zoom.enabled &&
                    this.params.zoom.toggle &&
                    this.zoom.toggle(e);
                },
                transitionEnd: function () {
                  this.zoom.enabled &&
                    this.params.zoom.enabled &&
                    this.zoom.onTransitionEnd();
                },
              },
            },
            {
              name: "lazy",
              params: {
                lazy: {
                  enabled: !1,
                  loadPrevNext: !1,
                  loadPrevNextAmount: 1,
                  loadOnTransitionStart: !1,
                  elementClass: "swiper-lazy",
                  loadingClass: "swiper-lazy-loading",
                  loadedClass: "swiper-lazy-loaded",
                  preloaderClass: "swiper-lazy-preloader",
                },
              },
              create: function () {
                j.extend(this, {
                  lazy: {
                    initialImageLoaded: !1,
                    load: G.load.bind(this),
                    loadInSlide: G.loadInSlide.bind(this),
                  },
                });
              },
              on: {
                beforeInit: function () {
                  this.params.lazy.enabled &&
                    this.params.preloadImages &&
                    (this.params.preloadImages = !1);
                },
                init: function () {
                  this.params.lazy.enabled &&
                    !this.params.loop &&
                    0 === this.params.initialSlide &&
                    this.lazy.load();
                },
                scroll: function () {
                  this.params.freeMode &&
                    !this.params.freeModeSticky &&
                    this.lazy.load();
                },
                resize: function () {
                  this.params.lazy.enabled && this.lazy.load();
                },
                scrollbarDragMove: function () {
                  this.params.lazy.enabled && this.lazy.load();
                },
                transitionStart: function () {
                  this.params.lazy.enabled &&
                    (this.params.lazy.loadOnTransitionStart ||
                      (!this.params.lazy.loadOnTransitionStart &&
                        !this.lazy.initialImageLoaded)) &&
                    this.lazy.load();
                },
                transitionEnd: function () {
                  this.params.lazy.enabled &&
                    !this.params.lazy.loadOnTransitionStart &&
                    this.lazy.load();
                },
              },
            },
            {
              name: "controller",
              params: {
                controller: { control: void 0, inverse: !1, by: "slide" },
              },
              create: function () {
                j.extend(this, {
                  controller: {
                    control: this.params.controller.control,
                    getInterpolateFunction: X.getInterpolateFunction.bind(this),
                    setTranslate: X.setTranslate.bind(this),
                    setTransition: X.setTransition.bind(this),
                  },
                });
              },
              on: {
                update: function () {
                  this.controller.control &&
                    this.controller.spline &&
                    ((this.controller.spline = void 0),
                    delete this.controller.spline);
                },
                resize: function () {
                  this.controller.control &&
                    this.controller.spline &&
                    ((this.controller.spline = void 0),
                    delete this.controller.spline);
                },
                observerUpdate: function () {
                  this.controller.control &&
                    this.controller.spline &&
                    ((this.controller.spline = void 0),
                    delete this.controller.spline);
                },
                setTranslate: function (e, t) {
                  this.controller.control && this.controller.setTranslate(e, t);
                },
                setTransition: function (e, t) {
                  this.controller.control &&
                    this.controller.setTransition(e, t);
                },
              },
            },
            {
              name: "a11y",
              params: {
                a11y: {
                  enabled: !0,
                  notificationClass: "swiper-notification",
                  prevSlideMessage: "Previous slide",
                  nextSlideMessage: "Next slide",
                  firstSlideMessage: "This is the first slide",
                  lastSlideMessage: "This is the last slide",
                  paginationBulletMessage: "Go to slide {{index}}",
                },
              },
              create: function () {
                var t = this;
                j.extend(t, {
                  a11y: {
                    liveRegion: M(
                      '<span class="' +
                        t.params.a11y.notificationClass +
                        '" aria-live="assertive" aria-atomic="true"></span>'
                    ),
                  },
                }),
                  Object.keys(Y).forEach(function (e) {
                    t.a11y[e] = Y[e].bind(t);
                  });
              },
              on: {
                init: function () {
                  this.params.a11y.enabled &&
                    (this.a11y.init(), this.a11y.updateNavigation());
                },
                toEdge: function () {
                  this.params.a11y.enabled && this.a11y.updateNavigation();
                },
                fromEdge: function () {
                  this.params.a11y.enabled && this.a11y.updateNavigation();
                },
                paginationUpdate: function () {
                  this.params.a11y.enabled && this.a11y.updatePagination();
                },
                destroy: function () {
                  this.params.a11y.enabled && this.a11y.destroy();
                },
              },
            },
            {
              name: "history",
              params: {
                history: { enabled: !1, replaceState: !1, key: "slides" },
              },
              create: function () {
                j.extend(this, {
                  history: {
                    init: U.init.bind(this),
                    setHistory: U.setHistory.bind(this),
                    setHistoryPopState: U.setHistoryPopState.bind(this),
                    scrollToSlide: U.scrollToSlide.bind(this),
                    destroy: U.destroy.bind(this),
                  },
                });
              },
              on: {
                init: function () {
                  this.params.history.enabled && this.history.init();
                },
                destroy: function () {
                  this.params.history.enabled && this.history.destroy();
                },
                transitionEnd: function () {
                  this.history.initialized &&
                    this.history.setHistory(
                      this.params.history.key,
                      this.activeIndex
                    );
                },
              },
            },
            {
              name: "hash-navigation",
              params: {
                hashNavigation: {
                  enabled: !1,
                  replaceState: !1,
                  watchState: !1,
                },
              },
              create: function () {
                j.extend(this, {
                  hashNavigation: {
                    initialized: !1,
                    init: V.init.bind(this),
                    destroy: V.destroy.bind(this),
                    setHash: V.setHash.bind(this),
                    onHashCange: V.onHashCange.bind(this),
                  },
                });
              },
              on: {
                init: function () {
                  this.params.hashNavigation.enabled &&
                    this.hashNavigation.init();
                },
                destroy: function () {
                  this.params.hashNavigation.enabled &&
                    this.hashNavigation.destroy();
                },
                transitionEnd: function () {
                  this.hashNavigation.initialized &&
                    this.hashNavigation.setHash();
                },
              },
            },
            {
              name: "autoplay",
              params: {
                autoplay: {
                  enabled: !1,
                  delay: 3e3,
                  waitForTransition: !0,
                  disableOnInteraction: !0,
                  stopOnLastSlide: !1,
                  reverseDirection: !1,
                },
              },
              create: function () {
                var t = this;
                j.extend(t, {
                  autoplay: {
                    running: !1,
                    paused: !1,
                    run: K.run.bind(t),
                    start: K.start.bind(t),
                    stop: K.stop.bind(t),
                    pause: K.pause.bind(t),
                    onTransitionEnd: function (e) {
                      t &&
                        !t.destroyed &&
                        t.$wrapperEl &&
                        e.target === this &&
                        (t.$wrapperEl[0].removeEventListener(
                          "transitionend",
                          t.autoplay.onTransitionEnd
                        ),
                        t.$wrapperEl[0].removeEventListener(
                          "webkitTransitionEnd",
                          t.autoplay.onTransitionEnd
                        ),
                        (t.autoplay.paused = !1),
                        t.autoplay.running
                          ? t.autoplay.run()
                          : t.autoplay.stop());
                    },
                  },
                });
              },
              on: {
                init: function () {
                  this.params.autoplay.enabled && this.autoplay.start();
                },
                beforeTransitionStart: function (e, t) {
                  this.autoplay.running &&
                    (t || !this.params.autoplay.disableOnInteraction
                      ? this.autoplay.pause(e)
                      : this.autoplay.stop());
                },
                sliderFirstMove: function () {
                  this.autoplay.running &&
                    (this.params.autoplay.disableOnInteraction
                      ? this.autoplay.stop()
                      : this.autoplay.pause());
                },
                destroy: function () {
                  this.autoplay.running && this.autoplay.stop();
                },
              },
            },
            {
              name: "effect-fade",
              params: { fadeEffect: { crossFade: !1 } },
              create: function () {
                j.extend(this, {
                  fadeEffect: {
                    setTranslate: Z.setTranslate.bind(this),
                    setTransition: Z.setTransition.bind(this),
                  },
                });
              },
              on: {
                beforeInit: function () {
                  if ("fade" === this.params.effect) {
                    this.classNames.push(
                      this.params.containerModifierClass + "fade"
                    );
                    var e = {
                      slidesPerView: 1,
                      slidesPerColumn: 1,
                      slidesPerGroup: 1,
                      watchSlidesProgress: !0,
                      spaceBetween: 0,
                      virtualTranslate: !0,
                    };
                    j.extend(this.params, e), j.extend(this.originalParams, e);
                  }
                },
                setTranslate: function () {
                  "fade" === this.params.effect &&
                    this.fadeEffect.setTranslate();
                },
                setTransition: function (e) {
                  "fade" === this.params.effect &&
                    this.fadeEffect.setTransition(e);
                },
              },
            },
            {
              name: "effect-cube",
              params: {
                cubeEffect: {
                  slideShadows: !0,
                  shadow: !0,
                  shadowOffset: 20,
                  shadowScale: 0.94,
                },
              },
              create: function () {
                j.extend(this, {
                  cubeEffect: {
                    setTranslate: Q.setTranslate.bind(this),
                    setTransition: Q.setTransition.bind(this),
                  },
                });
              },
              on: {
                beforeInit: function () {
                  if ("cube" === this.params.effect) {
                    this.classNames.push(
                      this.params.containerModifierClass + "cube"
                    ),
                      this.classNames.push(
                        this.params.containerModifierClass + "3d"
                      );
                    var e = {
                      slidesPerView: 1,
                      slidesPerColumn: 1,
                      slidesPerGroup: 1,
                      watchSlidesProgress: !0,
                      resistanceRatio: 0,
                      spaceBetween: 0,
                      centeredSlides: !1,
                      virtualTranslate: !0,
                    };
                    j.extend(this.params, e), j.extend(this.originalParams, e);
                  }
                },
                setTranslate: function () {
                  "cube" === this.params.effect &&
                    this.cubeEffect.setTranslate();
                },
                setTransition: function (e) {
                  "cube" === this.params.effect &&
                    this.cubeEffect.setTransition(e);
                },
              },
            },
            {
              name: "effect-flip",
              params: { flipEffect: { slideShadows: !0, limitRotation: !0 } },
              create: function () {
                j.extend(this, {
                  flipEffect: {
                    setTranslate: J.setTranslate.bind(this),
                    setTransition: J.setTransition.bind(this),
                  },
                });
              },
              on: {
                beforeInit: function () {
                  if ("flip" === this.params.effect) {
                    this.classNames.push(
                      this.params.containerModifierClass + "flip"
                    ),
                      this.classNames.push(
                        this.params.containerModifierClass + "3d"
                      );
                    var e = {
                      slidesPerView: 1,
                      slidesPerColumn: 1,
                      slidesPerGroup: 1,
                      watchSlidesProgress: !0,
                      spaceBetween: 0,
                      virtualTranslate: !0,
                    };
                    j.extend(this.params, e), j.extend(this.originalParams, e);
                  }
                },
                setTranslate: function () {
                  "flip" === this.params.effect &&
                    this.flipEffect.setTranslate();
                },
                setTransition: function (e) {
                  "flip" === this.params.effect &&
                    this.flipEffect.setTransition(e);
                },
              },
            },
            {
              name: "effect-coverflow",
              params: {
                coverflowEffect: {
                  rotate: 50,
                  stretch: 0,
                  depth: 100,
                  modifier: 1,
                  slideShadows: !0,
                },
              },
              create: function () {
                j.extend(this, {
                  coverflowEffect: {
                    setTranslate: ee.setTranslate.bind(this),
                    setTransition: ee.setTransition.bind(this),
                  },
                });
              },
              on: {
                beforeInit: function () {
                  "coverflow" === this.params.effect &&
                    (this.classNames.push(
                      this.params.containerModifierClass + "coverflow"
                    ),
                    this.classNames.push(
                      this.params.containerModifierClass + "3d"
                    ),
                    (this.params.watchSlidesProgress = !0),
                    (this.originalParams.watchSlidesProgress = !0));
                },
                setTranslate: function () {
                  "coverflow" === this.params.effect &&
                    this.coverflowEffect.setTranslate();
                },
                setTransition: function (e) {
                  "coverflow" === this.params.effect &&
                    this.coverflowEffect.setTransition(e);
                },
              },
            },
          ];
        return (
          void 0 === S.use &&
            ((S.use = S.Class.use), (S.installModule = S.Class.installModule)),
          S.use(te),
          S
        );
      }),
      "object" ==
        ("undefined" == typeof exports ? "undefined" : _typeof(exports)) &&
      "undefined" != typeof module
        ? (module.exports = f())
        : (h.Swiper = f()),
      (m = this),
      (g = function () {
        "use strict";
        return function (h, n, e, t) {
          var f = {
            features: null,
            bind: function (e, t, i, n) {
              var s = (n ? "remove" : "add") + "EventListener";
              t = t.split(" ");
              for (var r = 0; r < t.length; r++) t[r] && e[s](t[r], i, !1);
            },
            isArray: function (e) {
              return e instanceof Array;
            },
            createEl: function (e, t) {
              var i = document.createElement(t || "div");
              return e && (i.className = e), i;
            },
            getScrollY: function () {
              var e = window.pageYOffset;
              return void 0 !== e ? e : document.documentElement.scrollTop;
            },
            unbind: function (e, t, i) {
              f.bind(e, t, i, !0);
            },
            removeClass: function (e, t) {
              var i = new RegExp("(\\s|^)" + t + "(\\s|$)");
              e.className = e.className
                .replace(i, " ")
                .replace(/^\s\s*/, "")
                .replace(/\s\s*$/, "");
            },
            addClass: function (e, t) {
              f.hasClass(e, t) || (e.className += (e.className ? " " : "") + t);
            },
            hasClass: function (e, t) {
              return (
                e.className &&
                new RegExp("(^|\\s)" + t + "(\\s|$)").test(e.className)
              );
            },
            getChildByClass: function (e, t) {
              for (var i = e.firstChild; i; ) {
                if (f.hasClass(i, t)) return i;
                i = i.nextSibling;
              }
            },
            arraySearch: function (e, t, i) {
              for (var n = e.length; n--; ) if (e[n][i] === t) return n;
              return -1;
            },
            extend: function (e, t, i) {
              for (var n in t)
                if (t.hasOwnProperty(n)) {
                  if (i && e.hasOwnProperty(n)) continue;
                  e[n] = t[n];
                }
            },
            easing: {
              sine: {
                out: function (e) {
                  return Math.sin(e * (Math.PI / 2));
                },
                inOut: function (e) {
                  return -(Math.cos(Math.PI * e) - 1) / 2;
                },
              },
              cubic: {
                out: function (e) {
                  return --e * e * e + 1;
                },
              },
            },
            detectFeatures: function () {
              if (f.features) return f.features;
              var e = f.createEl().style,
                t = "",
                i = {};
              if (
                ((i.oldIE = document.all && !document.addEventListener),
                (i.touch = "ontouchstart" in window),
                window.requestAnimationFrame &&
                  ((i.raf = window.requestAnimationFrame),
                  (i.caf = window.cancelAnimationFrame)),
                (i.pointerEvent =
                  navigator.pointerEnabled || navigator.msPointerEnabled),
                !i.pointerEvent)
              ) {
                var n = navigator.userAgent;
                if (/iP(hone|od)/.test(navigator.platform)) {
                  var s = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                  s &&
                    0 < s.length &&
                    1 <= (s = parseInt(s[1], 10)) &&
                    s < 8 &&
                    (i.isOldIOSPhone = !0);
                }
                var r = n.match(/Android\s([0-9\.]*)/),
                  o = r ? r[1] : 0;
                1 <= (o = parseFloat(o)) &&
                  (o < 4.4 && (i.isOldAndroid = !0), (i.androidVersion = o)),
                  (i.isMobileOpera = /opera mini|opera mobi/i.test(n));
              }
              for (
                var a,
                  l,
                  d = ["transform", "perspective", "animationName"],
                  c = ["", "webkit", "Moz", "ms", "O"],
                  u = 0;
                u < 4;
                u++
              ) {
                t = c[u];
                for (var p = 0; p < 3; p++)
                  (a = d[p]),
                    (l = t + (t ? a.charAt(0).toUpperCase() + a.slice(1) : a)),
                    !i[a] && l in e && (i[a] = l);
                t &&
                  !i.raf &&
                  ((t = t.toLowerCase()),
                  (i.raf = window[t + "RequestAnimationFrame"]),
                  i.raf &&
                    (i.caf =
                      window[t + "CancelAnimationFrame"] ||
                      window[t + "CancelRequestAnimationFrame"]));
              }
              if (!i.raf) {
                var h = 0;
                (i.raf = function (e) {
                  var t = new Date().getTime(),
                    i = Math.max(0, 16 - (t - h)),
                    n = window.setTimeout(function () {
                      e(t + i);
                    }, i);
                  return (h = t + i), n;
                }),
                  (i.caf = function (e) {
                    clearTimeout(e);
                  });
              }
              return (
                (i.svg =
                  !!document.createElementNS &&
                  !!document.createElementNS(
                    "http://www.w3.org/2000/svg",
                    "svg"
                  ).createSVGRect),
                (f.features = i)
              );
            },
          };
          f.detectFeatures(),
            f.features.oldIE &&
              (f.bind = function (e, t, i, n) {
                t = t.split(" ");
                for (
                  var s,
                    r = (n ? "detach" : "attach") + "Event",
                    o = function () {
                      i.handleEvent.call(i);
                    },
                    a = 0;
                  a < t.length;
                  a++
                )
                  if ((s = t[a]))
                    if ("object" == _typeof(i) && i.handleEvent) {
                      if (n) {
                        if (!i["oldIE" + s]) return !1;
                      } else i["oldIE" + s] = o;
                      e[r]("on" + s, i["oldIE" + s]);
                    } else e[r]("on" + s, i);
              });
          var m = this,
            g = {
              allowPanToNext: !0,
              spacing: 0.12,
              bgOpacity: 1,
              mouseUsed: !1,
              loop: !0,
              pinchToClose: !0,
              closeOnScroll: !0,
              closeOnVerticalDrag: !0,
              verticalDragRange: 0.75,
              hideAnimationDuration: 333,
              showAnimationDuration: 333,
              showHideOpacity: !1,
              focus: !0,
              escKey: !0,
              arrowKeys: !0,
              mainScrollEndFriction: 0.35,
              panEndFriction: 0.35,
              isClickableElement: function (e) {
                return "A" === e.tagName;
              },
              getDoubleTapZoom: function (e, t) {
                return e || t.initialZoomLevel < 0.7 ? 1 : 1.33;
              },
              maxSpreadZoom: 1.33,
              modal: !0,
              scaleMode: "fit",
            };
          f.extend(g, t);
          function i() {
            return { x: 0, y: 0 };
          }
          function s(e, t) {
            f.extend(m, t.publicMethods), Qe.push(e);
          }
          function l(e) {
            var t = Gt();
            return t - 1 < e ? e - t : e < 0 ? t + e : e;
          }
          function r(e, t) {
            return tt[e] || (tt[e] = []), tt[e].push(t);
          }
          function v(e) {
            var t = tt[e];
            if (t) {
              var i = Array.prototype.slice.call(arguments);
              i.shift();
              for (var n = 0; n < t.length; n++) t[n].apply(m, i);
            }
          }
          function c() {
            return new Date().getTime();
          }
          function y(e) {
            (Re = e), (m.bg.style.opacity = e * g.bgOpacity);
          }
          function o(e, t, i, n, s) {
            (!et || (s && s !== m.currItem)) &&
              (n /= s ? s.fitRatio : m.currItem.fitRatio),
              (e[le] = Q + t + "px, " + i + "px" + J + " scale(" + n + ")");
          }
          function u(e, t) {
            if (!g.loop && t) {
              var i = W + (Ve.x * Ye - e) / Ve.x,
                n = Math.round(e - xt.x);
              ((i < 0 && 0 < n) || (i >= Gt() - 1 && n < 0)) &&
                (e = xt.x + n * g.mainScrollEndFriction);
            }
            (xt.x = e), st(e, G);
          }
          function p(e, t) {
            var i = Tt[e] - Ue[e];
            return We[e] + Be[e] + i - (t / Z) * i;
          }
          function b(e, t) {
            (e.x = t.x), (e.y = t.y), t.id && (e.id = t.id);
          }
          function w(e) {
            (e.x = Math.round(e.x)), (e.y = Math.round(e.y));
          }
          function a() {
            rt &&
              (f.unbind(document, "mousemove", a),
              f.addClass(h, "pswp--has_mouse"),
              (g.mouseUsed = !0),
              v("mouseUsed")),
              (rt = setTimeout(function () {
                rt = null;
              }, 100));
          }
          function x(e, t) {
            var i = Kt(m.currItem, Xe, e);
            return t && (Le = i), i;
          }
          function T(e) {
            return (e = e || m.currItem).initialZoomLevel;
          }
          function S(e) {
            return 0 < (e = e || m.currItem).w ? g.maxSpreadZoom : 1;
          }
          function C(e, t, i, n) {
            return n === m.currItem.initialZoomLevel
              ? ((i[e] = m.currItem.initialPosition[e]), !0)
              : ((i[e] = p(e, n)),
                i[e] > t.min[e]
                  ? ((i[e] = t.min[e]), !0)
                  : i[e] < t.max[e] && ((i[e] = t.max[e]), !0));
          }
          function d(e) {
            var t = "";
            g.escKey && 27 === e.keyCode
              ? (t = "close")
              : g.arrowKeys &&
                (37 === e.keyCode
                  ? (t = "prev")
                  : 39 === e.keyCode && (t = "next")),
              t &&
                (e.ctrlKey ||
                  e.altKey ||
                  e.shiftKey ||
                  e.metaKey ||
                  (e.preventDefault ? e.preventDefault() : (e.returnValue = !1),
                  m[t]()));
          }
          function E(e) {
            e &&
              (Ae || $e || Ie || Se) &&
              (e.preventDefault(), e.stopPropagation());
          }
          function k() {
            m.setScrollOffset(0, f.getScrollY());
          }
          function $(e) {
            ot[e] && (ot[e].raf && pe(ot[e].raf), at--, delete ot[e]);
          }
          function A(e) {
            ot[e] && $(e), ot[e] || (at++, (ot[e] = {}));
          }
          function z() {
            for (var e in ot) ot.hasOwnProperty(e) && $(e);
          }
          function M(t, i, n, s, r, o, a) {
            var l,
              d = c();
            A(t),
              (function e() {
                if (ot[t]) {
                  if (((l = c() - d), s <= l))
                    return $(t), o(n), void (a && a());
                  o((n - i) * r(l / s) + i), (ot[t].raf = ue(e));
                }
              })();
          }
          function D(e, t) {
            return (
              (vt.x = Math.abs(e.x - t.x)),
              (vt.y = Math.abs(e.y - t.y)),
              Math.sqrt(vt.x * vt.x + vt.y * vt.y)
            );
          }
          function _(e, t) {
            return (
              (Et.prevent = !(function e(t, i) {
                return (
                  !(!t || t === document) &&
                  !(
                    t.getAttribute("class") &&
                    -1 < t.getAttribute("class").indexOf("pswp__scroll-wrap")
                  ) &&
                  (i(t) ? t : e(t.parentNode, i))
                );
              })(e.target, g.isClickableElement)),
              v("preventDragEvent", e, t, Et),
              Et.prevent
            );
          }
          function P(e, t) {
            return (t.x = e.pageX), (t.y = e.pageY), (t.id = e.identifier), t;
          }
          function L(e, t, i) {
            (i.x = 0.5 * (e.x + t.x)), (i.y = 0.5 * (e.y + t.y));
          }
          function O() {
            var e = Ge.y - m.currItem.initialPosition.y;
            return 1 - Math.abs(e / (Xe.y / 2));
          }
          function I(e) {
            for (; 0 < At.length; ) At.pop();
            return (
              de
                ? ((Fe = 0),
                  ft.forEach(function (e) {
                    0 === Fe ? (At[0] = e) : 1 === Fe && (At[1] = e), Fe++;
                  }))
                : -1 < e.type.indexOf("touch")
                ? e.touches &&
                  0 < e.touches.length &&
                  ((At[0] = P(e.touches[0], kt)),
                  1 < e.touches.length && (At[1] = P(e.touches[1], $t)))
                : ((kt.x = e.pageX),
                  (kt.y = e.pageY),
                  (kt.id = ""),
                  (At[0] = kt)),
              At
            );
          }
          function N(e, t) {
            var i,
              n,
              s,
              r,
              o = Ge[e] + t[e],
              a = 0 < t[e],
              l = xt.x + t.x,
              d = xt.x - mt.x;
            return (
              (i = o > Le.min[e] || o < Le.max[e] ? g.panEndFriction : 1),
              (o = Ge[e] + t[e] * i),
              (!g.allowPanToNext && K !== m.currItem.initialZoomLevel) ||
              (Oe
                ? "h" !== Ne ||
                  "x" !== e ||
                  $e ||
                  (a
                    ? (o > Le.min[e] &&
                        ((i = g.panEndFriction),
                        Le.min[e],
                        (n = Le.min[e] - We[e])),
                      (n <= 0 || d < 0) && 1 < Gt()
                        ? ((r = l), d < 0 && l > mt.x && (r = mt.x))
                        : Le.min.x !== Le.max.x && (s = o))
                    : (o < Le.max[e] &&
                        ((i = g.panEndFriction),
                        Le.max[e],
                        (n = We[e] - Le.max[e])),
                      (n <= 0 || 0 < d) && 1 < Gt()
                        ? ((r = l), 0 < d && l < mt.x && (r = mt.x))
                        : Le.min.x !== Le.max.x && (s = o)))
                : (r = l),
              "x" !== e)
                ? void (
                    Ie ||
                    Me ||
                    (K > m.currItem.fitRatio && (Ge[e] += t[e] * i))
                  )
                : (void 0 !== r && (u(r, !0), (Me = r !== mt.x)),
                  Le.min.x !== Le.max.x &&
                    (void 0 !== s ? (Ge.x = s) : Me || (Ge.x += t.x * i)),
                  void 0 !== r)
            );
          }
          function H(e) {
            if (!("mousedown" === e.type && 0 < e.button)) {
              if (Bt) return void e.preventDefault();
              if (!Ce || "mousedown" !== e.type) {
                if ((_(e, !0) && e.preventDefault(), v("pointerDown"), de)) {
                  var t = f.arraySearch(ft, e.pointerId, "id");
                  t < 0 && (t = ft.length),
                    (ft[t] = { x: e.pageX, y: e.pageY, id: e.pointerId });
                }
                var i = I(e),
                  n = i.length;
                (De = null),
                  z(),
                  (Ee && 1 !== n) ||
                    ((Ee = He = !0),
                    f.bind(window, Y, m),
                    (Te = qe = je = Se = Me = Ae = ke = $e = !1),
                    (Ne = null),
                    v("firstTouchStart", i),
                    b(We, Ge),
                    (Be.x = Be.y = 0),
                    b(pt, i[0]),
                    b(ht, pt),
                    (mt.x = Ve.x * Ye),
                    (gt = [{ x: pt.x, y: pt.y }]),
                    (we = be = c()),
                    x(K, !0),
                    Ct(),
                    (function e() {
                      Ee && ((ze = ue(e)), zt());
                    })()),
                  !_e &&
                    1 < n &&
                    !Ie &&
                    !Me &&
                    ((Z = K),
                    (_e = ke = !($e = !1)),
                    (Be.y = Be.x = 0),
                    b(We, Ge),
                    b(dt, i[0]),
                    b(ct, i[1]),
                    L(dt, ct, St),
                    (Tt.x = Math.abs(St.x) - Ge.x),
                    (Tt.y = Math.abs(St.y) - Ge.y),
                    (Pe = D(dt, ct)));
              }
            }
          }
          function j(e) {
            if ((e.preventDefault(), de)) {
              var t = f.arraySearch(ft, e.pointerId, "id");
              if (-1 < t) {
                var i = ft[t];
                (i.x = e.pageX), (i.y = e.pageY);
              }
            }
            if (Ee) {
              var n = I(e);
              if (Ne || Ae || _e) De = n;
              else if (xt.x !== Ve.x * Ye) Ne = "h";
              else {
                var s = Math.abs(n[0].x - pt.x) - Math.abs(n[0].y - pt.y);
                10 <= Math.abs(s) && ((Ne = 0 < s ? "h" : "v"), (De = n));
              }
            }
          }
          function R(e) {
            if (ve.isOldAndroid) {
              if (Ce && "mouseup" === e.type) return;
              -1 < e.type.indexOf("touch") &&
                (clearTimeout(Ce),
                (Ce = setTimeout(function () {
                  Ce = 0;
                }, 600)));
            }
            var t;
            if ((v("pointerUp"), _(e, !1) && e.preventDefault(), de)) {
              var i = f.arraySearch(ft, e.pointerId, "id");
              if (-1 < i)
                if (((t = ft.splice(i, 1)[0]), navigator.pointerEnabled))
                  t.type = e.pointerType || "mouse";
                else {
                  (t.type = { 4: "mouse", 2: "touch", 3: "pen" }[
                    e.pointerType
                  ]),
                    t.type || (t.type = e.pointerType || "mouse");
                }
            }
            var n,
              s = I(e),
              r = s.length;
            if (("mouseup" === e.type && (r = 0), 2 === r)) return !(De = null);
            1 === r && b(ht, s[0]),
              0 !== r ||
                Ne ||
                Ie ||
                (t ||
                  ("mouseup" === e.type
                    ? (t = { x: e.pageX, y: e.pageY, type: "mouse" })
                    : e.changedTouches &&
                      e.changedTouches[0] &&
                      (t = {
                        x: e.changedTouches[0].pageX,
                        y: e.changedTouches[0].pageY,
                        type: "touch",
                      })),
                v("touchRelease", e, t));
            var o = -1;
            if (
              (0 === r &&
                ((Ee = !1),
                f.unbind(window, Y, m),
                Ct(),
                _e ? (o = 0) : -1 !== wt && (o = c() - wt)),
              (wt = 1 === r ? c() : -1),
              (n = -1 !== o && o < 150 ? "zoom" : "swipe"),
              _e &&
                r < 2 &&
                ((_e = !1),
                1 === r && (n = "zoomPointerUp"),
                v("zoomGestureEnded")),
              (De = null),
              Ae || $e || Ie || Se)
            )
              if ((z(), (xe = xe || Mt()).calculateSwipeSpeed("x"), Se)) {
                if (O() < g.verticalDragRange) m.close();
                else {
                  var a = Ge.y,
                    l = Re;
                  M(
                    "verticalDrag",
                    0,
                    1,
                    300,
                    f.easing.cubic.out,
                    function (e) {
                      (Ge.y = (m.currItem.initialPosition.y - a) * e + a),
                        y((1 - l) * e + l),
                        it();
                    }
                  ),
                    v("onVerticalDrag", 1);
                }
              } else {
                if ((Me || Ie) && 0 === r) {
                  if (_t(n, xe)) return;
                  n = "zoomPointerUp";
                }
                if (!Ie)
                  return "swipe" !== n
                    ? void Lt()
                    : void (!Me && K > m.currItem.fitRatio && Dt(xe));
              }
          }
          var q,
            F,
            B,
            W,
            G,
            X,
            Y,
            U,
            V,
            K,
            Z,
            Q,
            J,
            ee,
            te,
            ie,
            ne,
            se,
            re,
            oe,
            ae,
            le,
            de,
            ce,
            ue,
            pe,
            he,
            fe,
            me,
            ge,
            ve,
            ye,
            be,
            we,
            xe,
            Te,
            Se,
            Ce,
            Ee,
            ke,
            $e,
            Ae,
            ze,
            Me,
            De,
            _e,
            Pe,
            Le,
            Oe,
            Ie,
            Ne,
            He,
            je,
            Re,
            qe,
            Fe,
            Be = i(),
            We = i(),
            Ge = i(),
            Xe = {},
            Ye = 0,
            Ue = {},
            Ve = i(),
            Ke = 0,
            Ze = !0,
            Qe = [],
            Je = {},
            et = !1,
            tt = {},
            it = function (e) {
              Oe &&
                (e &&
                  (K > m.currItem.fitRatio
                    ? et || (Zt(m.currItem, !1, !0), (et = !0))
                    : et && (Zt(m.currItem), (et = !1))),
                o(Oe, Ge.x, Ge.y, K));
            },
            nt = function (e) {
              e.container &&
                o(
                  e.container.style,
                  e.initialPosition.x,
                  e.initialPosition.y,
                  e.initialZoomLevel,
                  e
                );
            },
            st = function (e, t) {
              t[le] = Q + e + "px, 0px" + J;
            },
            rt = null,
            ot = {},
            at = 0,
            lt = {
              shout: v,
              listen: r,
              viewportSize: Xe,
              options: g,
              isMainScrollAnimating: function () {
                return Ie;
              },
              getZoomLevel: function () {
                return K;
              },
              getCurrentIndex: function () {
                return W;
              },
              isDragging: function () {
                return Ee;
              },
              isZooming: function () {
                return _e;
              },
              setScrollOffset: function (e, t) {
                (Ue.x = e), (ge = Ue.y = t), v("updateScrollOffset", Ue);
              },
              applyZoomPan: function (e, t, i, n) {
                (Ge.x = t), (Ge.y = i), (K = e), it(n);
              },
              init: function () {
                if (!q && !F) {
                  var e;
                  (m.framework = f),
                    (m.template = h),
                    (m.bg = f.getChildByClass(h, "pswp__bg")),
                    (he = h.className),
                    (q = !0),
                    (ve = f.detectFeatures()),
                    (ue = ve.raf),
                    (pe = ve.caf),
                    (le = ve.transform),
                    (me = ve.oldIE),
                    (m.scrollWrap = f.getChildByClass(h, "pswp__scroll-wrap")),
                    (m.container = f.getChildByClass(
                      m.scrollWrap,
                      "pswp__container"
                    )),
                    (G = m.container.style),
                    (m.itemHolders = ie =
                      [
                        { el: m.container.children[0], wrap: 0, index: -1 },
                        { el: m.container.children[1], wrap: 0, index: -1 },
                        { el: m.container.children[2], wrap: 0, index: -1 },
                      ]),
                    (ie[0].el.style.display = ie[2].el.style.display = "none"),
                    (function () {
                      if (le) {
                        var e = ve.perspective && !ce;
                        return (
                          (Q = "translate" + (e ? "3d(" : "(")),
                          (J = ve.perspective ? ", 0px)" : ")")
                        );
                      }
                      (le = "left"),
                        f.addClass(h, "pswp--ie"),
                        (st = function (e, t) {
                          t.left = e + "px";
                        }),
                        (nt = function (e) {
                          var t = 1 < e.fitRatio ? 1 : e.fitRatio,
                            i = e.container.style,
                            n = t * e.w,
                            s = t * e.h;
                          (i.width = n + "px"),
                            (i.height = s + "px"),
                            (i.left = e.initialPosition.x + "px"),
                            (i.top = e.initialPosition.y + "px");
                        }),
                        (it = function () {
                          if (Oe) {
                            var e = Oe,
                              t = m.currItem,
                              i = 1 < t.fitRatio ? 1 : t.fitRatio,
                              n = i * t.w,
                              s = i * t.h;
                            (e.width = n + "px"),
                              (e.height = s + "px"),
                              (e.left = Ge.x + "px"),
                              (e.top = Ge.y + "px");
                          }
                        });
                    })(),
                    (V = {
                      resize: m.updateSize,
                      orientationchange: function () {
                        clearTimeout(ye),
                          (ye = setTimeout(function () {
                            Xe.x !== m.scrollWrap.clientWidth && m.updateSize();
                          }, 500));
                      },
                      scroll: k,
                      keydown: d,
                      click: E,
                    });
                  var t =
                    ve.isOldIOSPhone || ve.isOldAndroid || ve.isMobileOpera;
                  for (
                    (ve.animationName && ve.transform && !t) ||
                      (g.showAnimationDuration = g.hideAnimationDuration = 0),
                      e = 0;
                    e < Qe.length;
                    e++
                  )
                    m["init" + Qe[e]]();
                  if (n) (m.ui = new n(m, f)).init();
                  v("firstUpdate"),
                    (W = W || g.index || 0),
                    (isNaN(W) || W < 0 || W >= Gt()) && (W = 0),
                    (m.currItem = Wt(W)),
                    (ve.isOldIOSPhone || ve.isOldAndroid) && (Ze = !1),
                    h.setAttribute("aria-hidden", "false"),
                    g.modal &&
                      (Ze
                        ? (h.style.position = "fixed")
                        : ((h.style.position = "absolute"),
                          (h.style.top = f.getScrollY() + "px"))),
                    void 0 === ge &&
                      (v("initialLayout"), (ge = fe = f.getScrollY()));
                  var i = "pswp--open ";
                  for (
                    g.mainClass && (i += g.mainClass + " "),
                      g.showHideOpacity && (i += "pswp--animate_opacity "),
                      i += ce ? "pswp--touch" : "pswp--notouch",
                      i += ve.animationName ? " pswp--css_animation" : "",
                      i += ve.svg ? " pswp--svg" : "",
                      f.addClass(h, i),
                      m.updateSize(),
                      X = -1,
                      Ke = null,
                      e = 0;
                    e < 3;
                    e++
                  )
                    st((e + X) * Ve.x, ie[e].el.style);
                  me || f.bind(m.scrollWrap, U, m),
                    r("initialZoomInEnd", function () {
                      m.setContent(ie[0], W - 1),
                        m.setContent(ie[2], W + 1),
                        (ie[0].el.style.display = ie[2].el.style.display =
                          "block"),
                        g.focus && h.focus(),
                        f.bind(document, "keydown", m),
                        ve.transform && f.bind(m.scrollWrap, "click", m),
                        g.mouseUsed || f.bind(document, "mousemove", a),
                        f.bind(window, "resize scroll orientationchange", m),
                        v("bindEvents");
                    }),
                    m.setContent(ie[1], W),
                    m.updateCurrItem(),
                    v("afterInit"),
                    Ze ||
                      (ee = setInterval(function () {
                        at ||
                          Ee ||
                          _e ||
                          K !== m.currItem.initialZoomLevel ||
                          m.updateSize();
                      }, 1e3)),
                    f.addClass(h, "pswp--visible");
                }
              },
              close: function () {
                q &&
                  ((F = !(q = !1)),
                  v("close"),
                  f.unbind(window, "resize scroll orientationchange", m),
                  f.unbind(window, "scroll", V.scroll),
                  f.unbind(document, "keydown", m),
                  f.unbind(document, "mousemove", a),
                  ve.transform && f.unbind(m.scrollWrap, "click", m),
                  Ee && f.unbind(window, Y, m),
                  clearTimeout(ye),
                  v("unbindEvents"),
                  Xt(m.currItem, null, !0, m.destroy));
              },
              destroy: function () {
                v("destroy"),
                  Rt && clearTimeout(Rt),
                  h.setAttribute("aria-hidden", "true"),
                  (h.className = he),
                  ee && clearInterval(ee),
                  f.unbind(m.scrollWrap, U, m),
                  f.unbind(window, "scroll", m),
                  Ct(),
                  z(),
                  (tt = null);
              },
              panTo: function (e, t, i) {
                i ||
                  (e > Le.min.x
                    ? (e = Le.min.x)
                    : e < Le.max.x && (e = Le.max.x),
                  t > Le.min.y
                    ? (t = Le.min.y)
                    : t < Le.max.y && (t = Le.max.y)),
                  (Ge.x = e),
                  (Ge.y = t),
                  it();
              },
              handleEvent: function (e) {
                (e = e || window.event), V[e.type] && V[e.type](e);
              },
              goTo: function (e) {
                var t = (e = l(e)) - W;
                (Ke = t),
                  (W = e),
                  (m.currItem = Wt(W)),
                  (Ye -= t),
                  u(Ve.x * Ye),
                  z(),
                  (Ie = !1),
                  m.updateCurrItem();
              },
              next: function () {
                m.goTo(W + 1);
              },
              prev: function () {
                m.goTo(W - 1);
              },
              updateCurrZoomItem: function (e) {
                if ((e && v("beforeChange", 0), ie[1].el.children.length)) {
                  var t = ie[1].el.children[0];
                  Oe = f.hasClass(t, "pswp__zoom-wrap") ? t.style : null;
                } else Oe = null;
                (Le = m.currItem.bounds),
                  (Z = K = m.currItem.initialZoomLevel),
                  (Ge.x = Le.center.x),
                  (Ge.y = Le.center.y),
                  e && v("afterChange");
              },
              invalidateCurrItems: function () {
                te = !0;
                for (var e = 0; e < 3; e++)
                  ie[e].item && (ie[e].item.needsUpdate = !0);
              },
              updateCurrItem: function (e) {
                if (0 !== Ke) {
                  var t,
                    i = Math.abs(Ke);
                  if (!(e && i < 2)) {
                    (m.currItem = Wt(W)),
                      (et = !1),
                      v("beforeChange", Ke),
                      3 <= i && ((X += Ke + (0 < Ke ? -3 : 3)), (i = 3));
                    for (var n = 0; n < i; n++)
                      0 < Ke
                        ? ((t = ie.shift()),
                          (ie[2] = t),
                          st((++X + 2) * Ve.x, t.el.style),
                          m.setContent(t, W - i + n + 1 + 1))
                        : ((t = ie.pop()),
                          ie.unshift(t),
                          st(--X * Ve.x, t.el.style),
                          m.setContent(t, W + i - n - 1 - 1));
                    if (Oe && 1 === Math.abs(Ke)) {
                      var s = Wt(ne);
                      s.initialZoomLevel !== K && (Kt(s, Xe), Zt(s), nt(s));
                    }
                    (Ke = 0),
                      m.updateCurrZoomItem(),
                      (ne = W),
                      v("afterChange");
                  }
                }
              },
              updateSize: function (e) {
                if (!Ze && g.modal) {
                  var t = f.getScrollY();
                  if (
                    (ge !== t && ((h.style.top = t + "px"), (ge = t)),
                    !e &&
                      Je.x === window.innerWidth &&
                      Je.y === window.innerHeight)
                  )
                    return;
                  (Je.x = window.innerWidth),
                    (Je.y = window.innerHeight),
                    (h.style.height = Je.y + "px");
                }
                if (
                  ((Xe.x = m.scrollWrap.clientWidth),
                  (Xe.y = m.scrollWrap.clientHeight),
                  k(),
                  (Ve.x = Xe.x + Math.round(Xe.x * g.spacing)),
                  (Ve.y = Xe.y),
                  u(Ve.x * Ye),
                  v("beforeResize"),
                  void 0 !== X)
                ) {
                  for (var i, n, s, r = 0; r < 3; r++)
                    (i = ie[r]),
                      st((r + X) * Ve.x, i.el.style),
                      (s = W + r - 1),
                      g.loop && 2 < Gt() && (s = l(s)),
                      (n = Wt(s)) && (te || n.needsUpdate || !n.bounds)
                        ? (m.cleanSlide(n),
                          m.setContent(i, s),
                          1 === r &&
                            ((m.currItem = n), m.updateCurrZoomItem(!0)),
                          (n.needsUpdate = !1))
                        : -1 === i.index && 0 <= s && m.setContent(i, s),
                      n && n.container && (Kt(n, Xe), Zt(n), nt(n));
                  te = !1;
                }
                (Z = K = m.currItem.initialZoomLevel),
                  (Le = m.currItem.bounds) &&
                    ((Ge.x = Le.center.x), (Ge.y = Le.center.y), it(!0)),
                  v("resize");
              },
              zoomTo: function (t, e, i, n, s) {
                e &&
                  ((Z = K),
                  (Tt.x = Math.abs(e.x) - Ge.x),
                  (Tt.y = Math.abs(e.y) - Ge.y),
                  b(We, Ge));
                var r = x(t, !1),
                  o = {};
                C("x", r, o, t), C("y", r, o, t);
                var a = K,
                  l = Ge.x,
                  d = Ge.y;
                w(o);
                function c(e) {
                  1 === e
                    ? ((K = t), (Ge.x = o.x), (Ge.y = o.y))
                    : ((K = (t - a) * e + a),
                      (Ge.x = (o.x - l) * e + l),
                      (Ge.y = (o.y - d) * e + d)),
                    s && s(e),
                    it(1 === e);
                }
                i
                  ? M("customZoomTo", 0, 1, i, n || f.easing.sine.inOut, c)
                  : c(1);
              },
            },
            dt = {},
            ct = {},
            ut = {},
            pt = {},
            ht = {},
            ft = [],
            mt = {},
            gt = [],
            vt = {},
            yt = 0,
            bt = i(),
            wt = 0,
            xt = i(),
            Tt = i(),
            St = i(),
            Ct = function () {
              ze && (pe(ze), (ze = null));
            },
            Et = {},
            kt = {},
            $t = {},
            At = [],
            zt = function () {
              if (De) {
                var e = De.length;
                if (0 !== e)
                  if (
                    (b(dt, De[0]),
                    (ut.x = dt.x - pt.x),
                    (ut.y = dt.y - pt.y),
                    _e && 1 < e)
                  ) {
                    if (
                      ((pt.x = dt.x),
                      (pt.y = dt.y),
                      !ut.x &&
                        !ut.y &&
                        ((l = De[1]), (d = ct), l.x === d.x && l.y === d.y))
                    )
                      return;
                    b(ct, De[1]), $e || (($e = !0), v("zoomGestureStarted"));
                    var t = D(dt, ct),
                      i = Pt(t);
                    i >
                      m.currItem.initialZoomLevel +
                        m.currItem.initialZoomLevel / 15 && (qe = !0);
                    var n = 1,
                      s = T(),
                      r = S();
                    if (i < s)
                      if (
                        g.pinchToClose &&
                        !qe &&
                        Z <= m.currItem.initialZoomLevel
                      ) {
                        var o = 1 - (s - i) / (s / 1.2);
                        y(o), v("onPinchClose", o), (je = !0);
                      } else
                        1 < (n = (s - i) / s) && (n = 1), (i = s - n * (s / 3));
                    else
                      r < i &&
                        (1 < (n = (i - r) / (6 * s)) && (n = 1),
                        (i = r + n * s));
                    n < 0 && (n = 0),
                      L(dt, ct, bt),
                      (Be.x += bt.x - St.x),
                      (Be.y += bt.y - St.y),
                      b(St, bt),
                      (Ge.x = p("x", i)),
                      (Ge.y = p("y", i)),
                      (Te = K < i),
                      (K = i),
                      it();
                  } else {
                    if (!Ne) return;
                    if (
                      (He &&
                        ((He = !1),
                        10 <= Math.abs(ut.x) && (ut.x -= De[0].x - ht.x),
                        10 <= Math.abs(ut.y) && (ut.y -= De[0].y - ht.y)),
                      (pt.x = dt.x),
                      (pt.y = dt.y),
                      0 === ut.x && 0 === ut.y)
                    )
                      return;
                    if (
                      "v" === Ne &&
                      g.closeOnVerticalDrag &&
                      "fit" === g.scaleMode &&
                      K === m.currItem.initialZoomLevel
                    ) {
                      (Be.y += ut.y), (Ge.y += ut.y);
                      var a = O();
                      return (Se = !0), v("onVerticalDrag", a), y(a), void it();
                    }
                    (function (e, t, i) {
                      if (50 < e - we) {
                        var n = 2 < gt.length ? gt.shift() : {};
                        (n.x = t), (n.y = i), gt.push(n), (we = e);
                      }
                    })(c(), dt.x, dt.y),
                      (Ae = !0),
                      (Le = m.currItem.bounds),
                      N("x", ut) || (N("y", ut), w(Ge), it());
                  }
              }
              var l, d;
            },
            Mt = function () {
              var t,
                i,
                n = {
                  lastFlickOffset: {},
                  lastFlickDist: {},
                  lastFlickSpeed: {},
                  slowDownRatio: {},
                  slowDownRatioReverse: {},
                  speedDecelerationRatio: {},
                  speedDecelerationRatioAbs: {},
                  distanceOffset: {},
                  backAnimDestination: {},
                  backAnimStarted: {},
                  calculateSwipeSpeed: function (e) {
                    (i =
                      1 < gt.length
                        ? ((t = c() - we + 50), gt[gt.length - 2][e])
                        : ((t = c() - be), ht[e])),
                      (n.lastFlickOffset[e] = pt[e] - i),
                      (n.lastFlickDist[e] = Math.abs(n.lastFlickOffset[e])),
                      20 < n.lastFlickDist[e]
                        ? (n.lastFlickSpeed[e] = n.lastFlickOffset[e] / t)
                        : (n.lastFlickSpeed[e] = 0),
                      Math.abs(n.lastFlickSpeed[e]) < 0.1 &&
                        (n.lastFlickSpeed[e] = 0),
                      (n.slowDownRatio[e] = 0.95),
                      (n.slowDownRatioReverse[e] = 1 - n.slowDownRatio[e]),
                      (n.speedDecelerationRatio[e] = 1);
                  },
                  calculateOverBoundsAnimOffset: function (t, e) {
                    n.backAnimStarted[t] ||
                      (Ge[t] > Le.min[t]
                        ? (n.backAnimDestination[t] = Le.min[t])
                        : Ge[t] < Le.max[t] &&
                          (n.backAnimDestination[t] = Le.max[t]),
                      void 0 !== n.backAnimDestination[t] &&
                        ((n.slowDownRatio[t] = 0.7),
                        (n.slowDownRatioReverse[t] = 1 - n.slowDownRatio[t]),
                        n.speedDecelerationRatioAbs[t] < 0.05 &&
                          ((n.lastFlickSpeed[t] = 0),
                          (n.backAnimStarted[t] = !0),
                          M(
                            "bounceZoomPan" + t,
                            Ge[t],
                            n.backAnimDestination[t],
                            e || 300,
                            f.easing.sine.out,
                            function (e) {
                              (Ge[t] = e), it();
                            }
                          ))));
                  },
                  calculateAnimOffset: function (e) {
                    n.backAnimStarted[e] ||
                      ((n.speedDecelerationRatio[e] =
                        n.speedDecelerationRatio[e] *
                        (n.slowDownRatio[e] +
                          n.slowDownRatioReverse[e] -
                          (n.slowDownRatioReverse[e] * n.timeDiff) / 10)),
                      (n.speedDecelerationRatioAbs[e] = Math.abs(
                        n.lastFlickSpeed[e] * n.speedDecelerationRatio[e]
                      )),
                      (n.distanceOffset[e] =
                        n.lastFlickSpeed[e] *
                        n.speedDecelerationRatio[e] *
                        n.timeDiff),
                      (Ge[e] += n.distanceOffset[e]));
                  },
                  panAnimLoop: function () {
                    if (
                      ot.zoomPan &&
                      ((ot.zoomPan.raf = ue(n.panAnimLoop)),
                      (n.now = c()),
                      (n.timeDiff = n.now - n.lastNow),
                      (n.lastNow = n.now),
                      n.calculateAnimOffset("x"),
                      n.calculateAnimOffset("y"),
                      it(),
                      n.calculateOverBoundsAnimOffset("x"),
                      n.calculateOverBoundsAnimOffset("y"),
                      n.speedDecelerationRatioAbs.x < 0.05 &&
                        n.speedDecelerationRatioAbs.y < 0.05)
                    )
                      return (
                        (Ge.x = Math.round(Ge.x)),
                        (Ge.y = Math.round(Ge.y)),
                        it(),
                        void $("zoomPan")
                      );
                  },
                };
              return n;
            },
            Dt = function (e) {
              return (
                e.calculateSwipeSpeed("y"),
                (Le = m.currItem.bounds),
                (e.backAnimDestination = {}),
                (e.backAnimStarted = {}),
                Math.abs(e.lastFlickSpeed.x) <= 0.05 &&
                Math.abs(e.lastFlickSpeed.y) <= 0.05
                  ? ((e.speedDecelerationRatioAbs.x =
                      e.speedDecelerationRatioAbs.y =
                        0),
                    e.calculateOverBoundsAnimOffset("x"),
                    e.calculateOverBoundsAnimOffset("y"),
                    !0)
                  : (A("zoomPan"), (e.lastNow = c()), void e.panAnimLoop())
              );
            },
            _t = function (e, t) {
              var i, n, s;
              if ((Ie || (yt = W), "swipe" === e)) {
                var r = pt.x - ht.x,
                  o = t.lastFlickDist.x < 10;
                30 < r && (o || 20 < t.lastFlickOffset.x)
                  ? (n = -1)
                  : r < -30 && (o || t.lastFlickOffset.x < -20) && (n = 1);
              }
              n &&
                ((W += n) < 0
                  ? ((W = g.loop ? Gt() - 1 : 0), (s = !0))
                  : W >= Gt() && ((W = g.loop ? 0 : Gt() - 1), (s = !0)),
                (s && !g.loop) || ((Ke += n), (Ye -= n), (i = !0)));
              var a,
                l = Ve.x * Ye,
                d = Math.abs(l - xt.x);
              return (
                (a =
                  i || l > xt.x == 0 < t.lastFlickSpeed.x
                    ? ((a =
                        0 < Math.abs(t.lastFlickSpeed.x)
                          ? d / Math.abs(t.lastFlickSpeed.x)
                          : 333),
                      (a = Math.min(a, 400)),
                      Math.max(a, 250))
                    : 333),
                yt === W && (i = !1),
                (Ie = !0),
                v("mainScrollAnimStart"),
                M("mainScroll", xt.x, l, a, f.easing.cubic.out, u, function () {
                  z(),
                    (Ie = !1),
                    (yt = -1),
                    (!i && yt === W) || m.updateCurrItem(),
                    v("mainScrollAnimComplete");
                }),
                i && m.updateCurrItem(!0),
                i
              );
            },
            Pt = function (e) {
              return (1 / Pe) * e * Z;
            },
            Lt = function () {
              var e = K,
                t = T(),
                i = S();
              K < t ? (e = t) : i < K && (e = i);
              var n,
                s = Re;
              return (
                je && !Te && !qe && K < t
                  ? m.close()
                  : (je &&
                      (n = function (e) {
                        y((1 - s) * e + s);
                      }),
                    m.zoomTo(e, 0, 200, f.easing.cubic.out, n)),
                !0
              );
            };
          s("Gestures", {
            publicMethods: {
              initGestures: function () {
                function e(e, t, i, n, s) {
                  (se = e + t),
                    (re = e + i),
                    (oe = e + n),
                    (ae = s ? e + s : "");
                }
                (de = ve.pointerEvent) && ve.touch && (ve.touch = !1),
                  de
                    ? navigator.pointerEnabled
                      ? e("pointer", "down", "move", "up", "cancel")
                      : e("MSPointer", "Down", "Move", "Up", "Cancel")
                    : ve.touch
                    ? (e("touch", "start", "move", "end", "cancel"), (ce = !0))
                    : e("mouse", "down", "move", "up"),
                  (Y = re + " " + oe + " " + ae),
                  (U = se),
                  de &&
                    !ce &&
                    (ce =
                      1 < navigator.maxTouchPoints ||
                      1 < navigator.msMaxTouchPoints),
                  (m.likelyTouchDevice = ce),
                  (V[se] = H),
                  (V[re] = j),
                  (V[oe] = R),
                  ae && (V[ae] = V[oe]),
                  ve.touch &&
                    ((U += " mousedown"),
                    (Y += " mousemove mouseup"),
                    (V.mousedown = V[se]),
                    (V.mousemove = V[re]),
                    (V.mouseup = V[oe])),
                  ce || (g.allowPanToNext = !1);
              },
            },
          });
          function Ot() {
            return {
              center: { x: 0, y: 0 },
              max: { x: 0, y: 0 },
              min: { x: 0, y: 0 },
            };
          }
          function It(e, t, i, n, s, r) {
            t.loadError ||
              (n &&
                ((t.imageAppended = !0),
                Zt(t, n, t === m.currItem && et),
                i.appendChild(n),
                r &&
                  setTimeout(function () {
                    t &&
                      t.loaded &&
                      t.placeholder &&
                      ((t.placeholder.style.display = "none"),
                      (t.placeholder = null));
                  }, 500)));
          }
          function Nt(e) {
            function t() {
              (e.loading = !1),
                (e.loaded = !0),
                e.loadComplete ? e.loadComplete(e) : (e.img = null),
                (i.onload = i.onerror = null),
                (i = null);
            }
            (e.loading = !0), (e.loaded = !1);
            var i = (e.img = f.createEl("pswp__img", "img"));
            return (
              (i.onload = t),
              (i.onerror = function () {
                (e.loadError = !0), t();
              }),
              (i.src = e.src),
              i
            );
          }
          function Ht(e, t) {
            return (
              e.src &&
              e.loadError &&
              e.container &&
              (t && (e.container.innerHTML = ""),
              (e.container.innerHTML = g.errorMsg.replace("%url%", e.src)),
              1)
            );
          }
          function jt() {
            if (Ut.length) {
              for (var e, t = 0; t < Ut.length; t++)
                (e = Ut[t]).holder.index === e.index &&
                  It(e.index, e.item, e.baseDiv, e.img, 0, e.clearPlaceholder);
              Ut = [];
            }
          }
          var Rt,
            qt,
            Ft,
            Bt,
            Wt,
            Gt,
            Xt = function (o, e, a, t) {
              var l;
              Rt && clearTimeout(Rt),
                (Ft = Bt = !0),
                o.initialLayout
                  ? ((l = o.initialLayout), (o.initialLayout = null))
                  : (l = g.getThumbBoundsFn && g.getThumbBoundsFn(W));
              function d() {
                $("initialZoom"),
                  a
                    ? (m.template.removeAttribute("style"),
                      m.bg.removeAttribute("style"))
                    : (y(1),
                      e && (e.style.display = "block"),
                      f.addClass(h, "pswp--animated-in"),
                      v("initialZoom" + (a ? "OutEnd" : "InEnd"))),
                  t && t(),
                  (Bt = !1);
              }
              var c = a ? g.hideAnimationDuration : g.showAnimationDuration;
              if (!c || !l || void 0 === l.x)
                return (
                  v("initialZoom" + (a ? "Out" : "In")),
                  (K = o.initialZoomLevel),
                  b(Ge, o.initialPosition),
                  it(),
                  (h.style.opacity = a ? 0 : 1),
                  y(1),
                  void (c
                    ? setTimeout(function () {
                        d();
                      }, c)
                    : d())
                );
              var u, p;
              (u = B),
                (p =
                  !m.currItem.src || m.currItem.loadError || g.showHideOpacity),
                o.miniImg &&
                  (o.miniImg.style.webkitBackfaceVisibility = "hidden"),
                a ||
                  ((K = l.w / o.w),
                  (Ge.x = l.x),
                  (Ge.y = l.y - fe),
                  (m[p ? "template" : "bg"].style.opacity = 0.001),
                  it()),
                A("initialZoom"),
                a && !u && f.removeClass(h, "pswp--animated-in"),
                p &&
                  (a
                    ? f[(u ? "remove" : "add") + "Class"](
                        h,
                        "pswp--animate_opacity"
                      )
                    : setTimeout(function () {
                        f.addClass(h, "pswp--animate_opacity");
                      }, 30)),
                (Rt = setTimeout(
                  function () {
                    if ((v("initialZoom" + (a ? "Out" : "In")), a)) {
                      var t = l.w / o.w,
                        i = Ge.x,
                        n = Ge.y,
                        s = K,
                        r = Re,
                        e = function (e) {
                          1 === e
                            ? ((K = t), (Ge.x = l.x), (Ge.y = l.y - ge))
                            : ((K = (t - s) * e + s),
                              (Ge.x = (l.x - i) * e + i),
                              (Ge.y = (l.y - ge - n) * e + n)),
                            it(),
                            p ? (h.style.opacity = 1 - e) : y(r - e * r);
                        };
                      u
                        ? M("initialZoom", 0, 1, c, f.easing.cubic.out, e, d)
                        : (e(1), (Rt = setTimeout(d, c + 20)));
                    } else
                      (K = o.initialZoomLevel),
                        b(Ge, o.initialPosition),
                        it(),
                        y(1),
                        p ? (h.style.opacity = 1) : y(1),
                        (Rt = setTimeout(d, c + 20));
                  },
                  a ? 25 : 90
                ));
            },
            Yt = {},
            Ut = [],
            Vt = {
              index: 0,
              errorMsg:
                '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
              forceProgressiveLoading: !1,
              preload: [1, 1],
              getNumItemsFn: function () {
                return qt.length;
              },
            },
            Kt = function (e, t, i) {
              if (!e.src || e.loadError)
                return (
                  (e.w = e.h = 0),
                  (e.initialZoomLevel = e.fitRatio = 1),
                  (e.bounds = Ot()),
                  (e.initialPosition = e.bounds.center),
                  e.bounds
                );
              var n,
                s,
                r,
                o,
                a = !i;
              if (
                (a &&
                  (e.vGap || (e.vGap = { top: 0, bottom: 0 }),
                  v("parseVerticalMargin", e)),
                (Yt.x = t.x),
                (Yt.y = t.y - e.vGap.top - e.vGap.bottom),
                a)
              ) {
                var l = Yt.x / e.w,
                  d = Yt.y / e.h;
                e.fitRatio = l < d ? l : d;
                var c = g.scaleMode;
                "orig" === c ? (i = 1) : "fit" === c && (i = e.fitRatio),
                  1 < i && (i = 1),
                  (e.initialZoomLevel = i),
                  e.bounds || (e.bounds = Ot());
              }
              return i
                ? ((s = (n = e).w * i),
                  (r = e.h * i),
                  ((o = n.bounds).center.x = Math.round((Yt.x - s) / 2)),
                  (o.center.y = Math.round((Yt.y - r) / 2) + n.vGap.top),
                  (o.max.x = s > Yt.x ? Math.round(Yt.x - s) : o.center.x),
                  (o.max.y =
                    r > Yt.y ? Math.round(Yt.y - r) + n.vGap.top : o.center.y),
                  (o.min.x = s > Yt.x ? 0 : o.center.x),
                  (o.min.y = r > Yt.y ? n.vGap.top : o.center.y),
                  a &&
                    i === e.initialZoomLevel &&
                    (e.initialPosition = e.bounds.center),
                  e.bounds)
                : void 0;
            },
            Zt = function (e, t, i) {
              if (e.src) {
                t = t || e.container.lastChild;
                var n = i ? e.w : Math.round(e.w * e.fitRatio),
                  s = i ? e.h : Math.round(e.h * e.fitRatio);
                e.placeholder &&
                  !e.loaded &&
                  ((e.placeholder.style.width = n + "px"),
                  (e.placeholder.style.height = s + "px")),
                  (t.style.width = n + "px"),
                  (t.style.height = s + "px");
              }
            };
          s("Controller", {
            publicMethods: {
              lazyLoadItem: function (e) {
                e = l(e);
                var t = Wt(e);
                t &&
                  ((!t.loaded && !t.loading) || te) &&
                  (v("gettingData", e, t), t.src && Nt(t));
              },
              initController: function () {
                f.extend(g, Vt, !0),
                  (m.items = qt = e),
                  (Wt = m.getItemAt),
                  (Gt = g.getNumItemsFn),
                  g.loop,
                  Gt() < 3 && (g.loop = !1),
                  r("beforeChange", function (e) {
                    var t,
                      i = g.preload,
                      n = null === e || 0 <= e,
                      s = Math.min(i[0], Gt()),
                      r = Math.min(i[1], Gt());
                    for (t = 1; t <= (n ? r : s); t++) m.lazyLoadItem(W + t);
                    for (t = 1; t <= (n ? s : r); t++) m.lazyLoadItem(W - t);
                  }),
                  r("initialLayout", function () {
                    m.currItem.initialLayout =
                      g.getThumbBoundsFn && g.getThumbBoundsFn(W);
                  }),
                  r("mainScrollAnimComplete", jt),
                  r("initialZoomInEnd", jt),
                  r("destroy", function () {
                    for (var e, t = 0; t < qt.length; t++)
                      (e = qt[t]).container && (e.container = null),
                        e.placeholder && (e.placeholder = null),
                        e.img && (e.img = null),
                        e.preloader && (e.preloader = null),
                        e.loadError && (e.loaded = e.loadError = !1);
                    Ut = null;
                  });
              },
              getItemAt: function (e) {
                return 0 <= e && void 0 !== qt[e] && qt[e];
              },
              allowProgressiveImg: function () {
                return (
                  g.forceProgressiveLoading ||
                  !ce ||
                  g.mouseUsed ||
                  1200 < screen.width
                );
              },
              setContent: function (t, i) {
                g.loop && (i = l(i));
                var e = m.getItemAt(t.index);
                e && (e.container = null);
                var n,
                  s = m.getItemAt(i);
                if (s) {
                  v("gettingData", i, s), (t.index = i);
                  var r = ((t.item = s).container =
                    f.createEl("pswp__zoom-wrap"));
                  if (
                    (!s.src &&
                      s.html &&
                      (s.html.tagName
                        ? r.appendChild(s.html)
                        : (r.innerHTML = s.html)),
                    Ht(s),
                    Kt(s, Xe),
                    !s.src || s.loadError || s.loaded)
                  )
                    s.src &&
                      !s.loadError &&
                      (((n = f.createEl("pswp__img", "img")).style.opacity = 1),
                      (n.src = s.src),
                      Zt(s, n),
                      It(0, s, r, n));
                  else {
                    if (
                      ((s.loadComplete = function (e) {
                        if (q) {
                          if (t && t.index === i) {
                            if (Ht(e, !0))
                              return (
                                (e.loadComplete = e.img = null),
                                Kt(e, Xe),
                                nt(e),
                                void (t.index === W && m.updateCurrZoomItem())
                              );
                            e.imageAppended
                              ? !Bt &&
                                e.placeholder &&
                                ((e.placeholder.style.display = "none"),
                                (e.placeholder = null))
                              : ve.transform && (Ie || Bt)
                              ? Ut.push({
                                  item: e,
                                  baseDiv: r,
                                  img: e.img,
                                  index: i,
                                  holder: t,
                                  clearPlaceholder: !0,
                                })
                              : It(0, e, r, e.img, 0, !0);
                          }
                          (e.loadComplete = null),
                            (e.img = null),
                            v("imageLoadComplete", i, e);
                        }
                      }),
                      f.features.transform)
                    ) {
                      var o = "pswp__img pswp__img--placeholder";
                      o += s.msrc ? "" : " pswp__img--placeholder--blank";
                      var a = f.createEl(o, s.msrc ? "img" : "");
                      s.msrc && (a.src = s.msrc),
                        Zt(s, a),
                        r.appendChild(a),
                        (s.placeholder = a);
                    }
                    s.loading || Nt(s),
                      m.allowProgressiveImg() &&
                        (!Ft && ve.transform
                          ? Ut.push({
                              item: s,
                              baseDiv: r,
                              img: s.img,
                              index: i,
                              holder: t,
                            })
                          : It(0, s, r, s.img, 0, !0));
                  }
                  Ft || i !== W ? nt(s) : ((Oe = r.style), Xt(s, n || s.img)),
                    (t.el.innerHTML = ""),
                    t.el.appendChild(r);
                } else t.el.innerHTML = "";
              },
              cleanSlide: function (e) {
                e.img && (e.img.onload = e.img.onerror = null),
                  (e.loaded = e.loading = e.img = e.imageAppended = !1);
              },
            },
          });
          function Qt(e, t, i) {
            var n = document.createEvent("CustomEvent"),
              s = {
                origEvent: e,
                target: e.target,
                releasePoint: t,
                pointerType: i || "touch",
              };
            n.initCustomEvent("pswpTap", !0, !0, s), e.target.dispatchEvent(n);
          }
          var Jt,
            ei,
            ti = {};
          s("Tap", {
            publicMethods: {
              initTap: function () {
                r("firstTouchStart", m.onTapStart),
                  r("touchRelease", m.onTapRelease),
                  r("destroy", function () {
                    (ti = {}), (Jt = null);
                  });
              },
              onTapStart: function (e) {
                1 < e.length && (clearTimeout(Jt), (Jt = null));
              },
              onTapRelease: function (e, t) {
                if (t && !Ae && !ke && !at) {
                  var i = t;
                  if (
                    Jt &&
                    (clearTimeout(Jt),
                    (Jt = null),
                    (n = i),
                    (s = ti),
                    Math.abs(n.x - s.x) < 25 && Math.abs(n.y - s.y) < 25)
                  )
                    return void v("doubleTap", i);
                  if ("mouse" === t.type) return void Qt(e, t, "mouse");
                  if (
                    "BUTTON" === e.target.tagName.toUpperCase() ||
                    f.hasClass(e.target, "pswp__single-tap")
                  )
                    return void Qt(e, t);
                  b(ti, i),
                    (Jt = setTimeout(function () {
                      Qt(e, t), (Jt = null);
                    }, 300));
                }
                var n, s;
              },
            },
          }),
            s("DesktopZoom", {
              publicMethods: {
                initDesktopZoom: function () {
                  me ||
                    (ce
                      ? r("mouseUsed", function () {
                          m.setupDesktopZoom();
                        })
                      : m.setupDesktopZoom(!0));
                },
                setupDesktopZoom: function (e) {
                  ei = {};
                  var t = "wheel mousewheel DOMMouseScroll";
                  r("bindEvents", function () {
                    f.bind(h, t, m.handleMouseWheel);
                  }),
                    r("unbindEvents", function () {
                      ei && f.unbind(h, t, m.handleMouseWheel);
                    }),
                    (m.mouseZoomedIn = !1);
                  function i() {
                    m.mouseZoomedIn &&
                      (f.removeClass(h, "pswp--zoomed-in"),
                      (m.mouseZoomedIn = !1)),
                      K < 1
                        ? f.addClass(h, "pswp--zoom-allowed")
                        : f.removeClass(h, "pswp--zoom-allowed"),
                      s();
                  }
                  var n,
                    s = function () {
                      n && (f.removeClass(h, "pswp--dragging"), (n = !1));
                    };
                  r("resize", i),
                    r("afterChange", i),
                    r("pointerDown", function () {
                      m.mouseZoomedIn &&
                        ((n = !0), f.addClass(h, "pswp--dragging"));
                    }),
                    r("pointerUp", s),
                    e || i();
                },
                handleMouseWheel: function (e) {
                  if (K <= m.currItem.fitRatio)
                    return (
                      g.modal &&
                        (!g.closeOnScroll || at || Ee
                          ? e.preventDefault()
                          : le &&
                            2 < Math.abs(e.deltaY) &&
                            ((B = !0), m.close())),
                      !0
                    );
                  if ((e.stopPropagation(), (ei.x = 0), "deltaX" in e))
                    1 === e.deltaMode
                      ? ((ei.x = 18 * e.deltaX), (ei.y = 18 * e.deltaY))
                      : ((ei.x = e.deltaX), (ei.y = e.deltaY));
                  else if ("wheelDelta" in e)
                    e.wheelDeltaX && (ei.x = -0.16 * e.wheelDeltaX),
                      e.wheelDeltaY
                        ? (ei.y = -0.16 * e.wheelDeltaY)
                        : (ei.y = -0.16 * e.wheelDelta);
                  else {
                    if (!("detail" in e)) return;
                    ei.y = e.detail;
                  }
                  x(K, !0);
                  var t = Ge.x - ei.x,
                    i = Ge.y - ei.y;
                  (g.modal ||
                    (t <= Le.min.x &&
                      t >= Le.max.x &&
                      i <= Le.min.y &&
                      i >= Le.max.y)) &&
                    e.preventDefault(),
                    m.panTo(t, i);
                },
                toggleDesktopZoom: function (e) {
                  e = e || { x: Xe.x / 2 + Ue.x, y: Xe.y / 2 + Ue.y };
                  var t = g.getDoubleTapZoom(!0, m.currItem),
                    i = K === t;
                  (m.mouseZoomedIn = !i),
                    m.zoomTo(i ? m.currItem.initialZoomLevel : t, e, 333),
                    f[(i ? "remove" : "add") + "Class"](h, "pswp--zoomed-in");
                },
              },
            });
          function ii() {
            return gi.hash.substring(1);
          }
          function ni() {
            oi && clearTimeout(oi), li && clearTimeout(li);
          }
          function si() {
            var e = ii(),
              t = {};
            if (e.length < 5) return t;
            var i,
              n = e.split("&");
            for (i = 0; i < n.length; i++)
              if (n[i]) {
                var s = n[i].split("=");
                s.length < 2 || (t[s[0]] = s[1]);
              }
            if (g.galleryPIDs) {
              var r = t.pid;
              for (i = t.pid = 0; i < qt.length; i++)
                if (qt[i].pid === r) {
                  t.pid = i;
                  break;
                }
            } else t.pid = parseInt(t.pid, 10) - 1;
            return t.pid < 0 && (t.pid = 0), t;
          }
          function ri() {
            if ((li && clearTimeout(li), at || Ee)) li = setTimeout(ri, 500);
            else {
              di ? clearTimeout(ai) : (di = !0);
              var e = W + 1,
                t = Wt(W);
              t.hasOwnProperty("pid") && (e = t.pid);
              var i = pi + "&gid=" + g.galleryUID + "&pid=" + e;
              hi || (-1 === gi.hash.indexOf(i) && (mi = !0));
              var n = gi.href.split("#")[0] + "#" + i;
              vi
                ? "#" + i !== window.location.hash &&
                  history[hi ? "replaceState" : "pushState"](
                    "",
                    document.title,
                    n
                  )
                : hi
                ? gi.replace(n)
                : (gi.hash = i),
                (hi = !0),
                (ai = setTimeout(function () {
                  di = !1;
                }, 60));
            }
          }
          var oi,
            ai,
            li,
            di,
            ci,
            ui,
            pi,
            hi,
            fi,
            mi,
            gi,
            vi,
            yi = { history: !0, galleryUID: 1 };
          s("History", {
            publicMethods: {
              initHistory: function () {
                if ((f.extend(g, yi, !0), g.history)) {
                  (gi = window.location),
                    (hi = fi = mi = !1),
                    (pi = ii()),
                    (vi = "pushState" in history),
                    -1 < pi.indexOf("gid=") &&
                      (pi = (pi = pi.split("&gid=")[0]).split("?gid=")[0]),
                    r("afterChange", m.updateURL),
                    r("unbindEvents", function () {
                      f.unbind(window, "hashchange", m.onHashChange);
                    });
                  var e = function () {
                    (ui = !0),
                      fi ||
                        (mi
                          ? history.back()
                          : pi
                          ? (gi.hash = pi)
                          : vi
                          ? history.pushState(
                              "",
                              document.title,
                              gi.pathname + gi.search
                            )
                          : (gi.hash = "")),
                      ni();
                  };
                  r("unbindEvents", function () {
                    B && e();
                  }),
                    r("destroy", function () {
                      ui || e();
                    }),
                    r("firstUpdate", function () {
                      W = si().pid;
                    });
                  var t = pi.indexOf("pid=");
                  -1 < t &&
                    "&" === (pi = pi.substring(0, t)).slice(-1) &&
                    (pi = pi.slice(0, -1)),
                    setTimeout(function () {
                      q && f.bind(window, "hashchange", m.onHashChange);
                    }, 40);
                }
              },
              onHashChange: function () {
                return ii() === pi
                  ? ((fi = !0), void m.close())
                  : void (di || ((ci = !0), m.goTo(si().pid), (ci = !1)));
              },
              updateURL: function () {
                ni(), ci || (hi ? (oi = setTimeout(ri, 800)) : ri());
              },
            },
          }),
            f.extend(m, lt);
        };
      }),
      "object" ==
      ("undefined" == typeof exports ? "undefined" : _typeof(exports))
        ? (module.exports = g())
        : (m.PhotoSwipe = g()),
      (v = this),
      (y = function () {
        "use strict";
        return function (s, a) {
          function e(e) {
            if ($) return !0;
            (e = e || window.event), k.timeToIdle && k.mouseUsed && !w && N();
            for (
              var t,
                i,
                n = (e.target || e.srcElement).getAttribute("class") || "",
                s = 0;
              s < j.length;
              s++
            )
              (t = j[s]).onTap &&
                -1 < n.indexOf("pswp__" + t.name) &&
                (t.onTap(), (i = !0));
            if (i) {
              e.stopPropagation && e.stopPropagation(), ($ = !0);
              var r = a.features.isOldAndroid ? 600 : 30;
              setTimeout(function () {
                $ = !1;
              }, r);
            }
          }
          function i(e, t, i) {
            a[(i ? "add" : "remove") + "Class"](e, "pswp__" + t);
          }
          function n() {
            var e = 1 === k.getNumItemsFn();
            e !== E && (i(h, "ui--one-slide", e), (E = e));
          }
          function t() {
            i(y, "share-modal--hidden", P);
          }
          function r() {
            return (
              (P = !P)
                ? (a.removeClass(y, "pswp__share-modal--fade-in"),
                  setTimeout(function () {
                    P && t();
                  }, 300))
                : (t(),
                  setTimeout(function () {
                    P || a.addClass(y, "pswp__share-modal--fade-in");
                  }, 30)),
              P || O(),
              0
            );
          }
          function o(e) {
            var t = (e = e || window.event).target || e.srcElement;
            return (
              s.shout("shareLinkClick", e, t),
              !(
                !t.href ||
                (!t.hasAttribute("download") &&
                  (window.open(
                    t.href,
                    "pswp_share",
                    "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" +
                      (window.screen ? Math.round(screen.width / 2 - 275) : 100)
                  ),
                  P || r(),
                  1))
              )
            );
          }
          function l(e) {
            for (var t = 0; t < k.closeElClasses.length; t++)
              if (a.hasClass(e, "pswp__" + k.closeElClasses[t])) return !0;
          }
          function d(e) {
            var t = (e = e || window.event).relatedTarget || e.toElement;
            (t && "HTML" !== t.nodeName) ||
              (clearTimeout(z),
              (z = setTimeout(function () {
                M.setIdle(!0);
              }, k.timeToIdleOutside)));
          }
          function c(e) {
            var t = e.vGap;
            if (
              !s.likelyTouchDevice ||
              k.mouseUsed ||
              screen.width > k.fitControlsWidth
            ) {
              var i = k.barsSize;
              if (k.captionEl && "auto" === i.bottom)
                if (
                  (m ||
                    ((m = a.createEl(
                      "pswp__caption pswp__caption--fake"
                    )).appendChild(a.createEl("pswp__caption__center")),
                    h.insertBefore(m, f),
                    a.addClass(h, "pswp__ui--fit")),
                  k.addCaptionHTMLFn(e, m, !0))
                ) {
                  var n = m.clientHeight;
                  t.bottom = parseInt(n, 10) || 44;
                } else t.bottom = i.top;
              else t.bottom = "auto" === i.bottom ? 0 : i.bottom;
              t.top = i.top;
            } else t.top = t.bottom = 0;
          }
          function u() {
            function e(e) {
              if (e)
                for (var t = e.length, i = 0; i < t; i++) {
                  (s = e[i]), (r = s.className);
                  for (var n = 0; n < j.length; n++)
                    (o = j[n]),
                      -1 < r.indexOf("pswp__" + o.name) &&
                        (k[o.option]
                          ? (a.removeClass(s, "pswp__element--disabled"),
                            o.onInit && o.onInit(s))
                          : a.addClass(s, "pswp__element--disabled"));
                }
            }
            var s, r, o;
            e(h.children);
            var t = a.getChildByClass(h, "pswp__top-bar");
            t && e(t.children);
          }
          var p,
            h,
            f,
            m,
            g,
            v,
            y,
            b,
            w,
            x,
            T,
            S,
            C,
            E,
            k,
            $,
            A,
            z,
            M = this,
            D = !1,
            _ = !0,
            P = !0,
            L = {
              barsSize: { top: 44, bottom: "auto" },
              closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"],
              timeToIdle: 4e3,
              timeToIdleOutside: 1e3,
              loadingIndicatorDelay: 1e3,
              addCaptionHTMLFn: function (e, t) {
                return e.title
                  ? ((t.children[0].innerHTML = e.title), !0)
                  : ((t.children[0].innerHTML = ""), !1);
              },
              closeEl: !0,
              captionEl: !0,
              fullscreenEl: !0,
              zoomEl: !0,
              shareEl: !0,
              counterEl: !0,
              arrowEl: !0,
              preloaderEl: !0,
              tapToClose: !1,
              tapToToggleControls: !0,
              clickToCloseNonZoomable: !0,
              shareButtons: [
                {
                  id: "facebook",
                  label: "Share on Facebook",
                  url: "https://www.facebook.com/sharer/sharer.php?u={{url}}",
                },
                {
                  id: "twitter",
                  label: "Tweet",
                  url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}",
                },
                {
                  id: "pinterest",
                  label: "Pin it",
                  url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}",
                },
                {
                  id: "download",
                  label: "Download image",
                  url: "{{raw_image_url}}",
                  download: !0,
                },
              ],
              getImageURLForShare: function () {
                return s.currItem.src || "";
              },
              getPageURLForShare: function () {
                return window.location.href;
              },
              getTextForShare: function () {
                return s.currItem.title || "";
              },
              indexIndicatorSep: " / ",
              fitControlsWidth: 1200,
            },
            O = function () {
              for (
                var e, t, i, n, s = "", r = 0;
                r < k.shareButtons.length;
                r++
              )
                (e = k.shareButtons[r]),
                  (t = k.getImageURLForShare(e)),
                  (i = k.getPageURLForShare(e)),
                  (n = k.getTextForShare(e)),
                  (s +=
                    '<a href="' +
                    e.url
                      .replace("{{url}}", encodeURIComponent(i))
                      .replace("{{image_url}}", encodeURIComponent(t))
                      .replace("{{raw_image_url}}", t)
                      .replace("{{text}}", encodeURIComponent(n)) +
                    '" target="_blank" class="pswp__share--' +
                    e.id +
                    '"' +
                    (e.download ? "download" : "") +
                    ">" +
                    e.label +
                    "</a>"),
                  k.parseShareButtonOut && (s = k.parseShareButtonOut(e, s));
              (y.children[0].innerHTML = s), (y.children[0].onclick = o);
            },
            I = 0,
            N = function () {
              clearTimeout(z), (I = 0), w && M.setIdle(!1);
            },
            H = function (e) {
              S !== e && (i(T, "preloader--active", !e), (S = e));
            },
            j = [
              {
                name: "caption",
                option: "captionEl",
                onInit: function (e) {
                  f = e;
                },
              },
              {
                name: "share-modal",
                option: "shareEl",
                onInit: function (e) {
                  y = e;
                },
                onTap: function () {
                  r();
                },
              },
              {
                name: "button--share",
                option: "shareEl",
                onInit: function (e) {
                  v = e;
                },
                onTap: function () {
                  r();
                },
              },
              {
                name: "button--zoom",
                option: "zoomEl",
                onTap: s.toggleDesktopZoom,
              },
              {
                name: "counter",
                option: "counterEl",
                onInit: function (e) {
                  g = e;
                },
              },
              { name: "button--close", option: "closeEl", onTap: s.close },
              { name: "button--arrow--left", option: "arrowEl", onTap: s.prev },
              {
                name: "button--arrow--right",
                option: "arrowEl",
                onTap: s.next,
              },
              {
                name: "button--fs",
                option: "fullscreenEl",
                onTap: function () {
                  p.isFullscreen() ? p.exit() : p.enter();
                },
              },
              {
                name: "preloader",
                option: "preloaderEl",
                onInit: function (e) {
                  T = e;
                },
              },
            ];
          (M.init = function () {
            var t;
            a.extend(s.options, L, !0),
              (k = s.options),
              (h = a.getChildByClass(s.scrollWrap, "pswp__ui")),
              (x = s.listen)("onVerticalDrag", function (e) {
                _ && e < 0.95
                  ? M.hideControls()
                  : !_ && 0.95 <= e && M.showControls();
              }),
              x("onPinchClose", function (e) {
                _ && e < 0.9
                  ? (M.hideControls(), (t = !0))
                  : t && !_ && 0.9 < e && M.showControls();
              }),
              x("zoomGestureEnded", function () {
                (t = !1) && !_ && M.showControls();
              }),
              x("beforeChange", M.update),
              x("doubleTap", function (e) {
                var t = s.currItem.initialZoomLevel;
                s.getZoomLevel() !== t
                  ? s.zoomTo(t, e, 333)
                  : s.zoomTo(k.getDoubleTapZoom(!1, s.currItem), e, 333);
              }),
              x("preventDragEvent", function (e, t, i) {
                var n = e.target || e.srcElement;
                n &&
                  n.getAttribute("class") &&
                  -1 < e.type.indexOf("mouse") &&
                  (0 < n.getAttribute("class").indexOf("__caption") ||
                    /(SMALL|STRONG|EM)/i.test(n.tagName)) &&
                  (i.prevent = !1);
              }),
              x("bindEvents", function () {
                a.bind(h, "pswpTap click", e),
                  a.bind(s.scrollWrap, "pswpTap", M.onGlobalTap),
                  s.likelyTouchDevice ||
                    a.bind(s.scrollWrap, "mouseover", M.onMouseOver);
              }),
              x("unbindEvents", function () {
                P || r(),
                  A && clearInterval(A),
                  a.unbind(document, "mouseout", d),
                  a.unbind(document, "mousemove", N),
                  a.unbind(h, "pswpTap click", e),
                  a.unbind(s.scrollWrap, "pswpTap", M.onGlobalTap),
                  a.unbind(s.scrollWrap, "mouseover", M.onMouseOver),
                  p &&
                    (a.unbind(document, p.eventK, M.updateFullscreen),
                    p.isFullscreen() &&
                      ((k.hideAnimationDuration = 0), p.exit()),
                    (p = null));
              }),
              x("destroy", function () {
                k.captionEl &&
                  (m && h.removeChild(m),
                  a.removeClass(f, "pswp__caption--empty")),
                  y && (y.children[0].onclick = null),
                  a.removeClass(h, "pswp__ui--over-close"),
                  a.addClass(h, "pswp__ui--hidden"),
                  M.setIdle(!1);
              }),
              k.showAnimationDuration || a.removeClass(h, "pswp__ui--hidden"),
              x("initialZoomIn", function () {
                k.showAnimationDuration && a.removeClass(h, "pswp__ui--hidden");
              }),
              x("initialZoomOut", function () {
                a.addClass(h, "pswp__ui--hidden");
              }),
              x("parseVerticalMargin", c),
              u(),
              k.shareEl && v && y && (P = !0),
              n(),
              k.timeToIdle &&
                x("mouseUsed", function () {
                  a.bind(document, "mousemove", N),
                    a.bind(document, "mouseout", d),
                    (A = setInterval(function () {
                      2 === ++I && M.setIdle(!0);
                    }, k.timeToIdle / 2));
                }),
              k.fullscreenEl &&
                !a.features.isOldAndroid &&
                ((p = p || M.getFullscreenAPI())
                  ? (a.bind(document, p.eventK, M.updateFullscreen),
                    M.updateFullscreen(),
                    a.addClass(s.template, "pswp--supports-fs"))
                  : a.removeClass(s.template, "pswp--supports-fs")),
              k.preloaderEl &&
                (H(!0),
                x("beforeChange", function () {
                  clearTimeout(C),
                    (C = setTimeout(function () {
                      s.currItem && s.currItem.loading
                        ? (s.allowProgressiveImg() &&
                            (!s.currItem.img || s.currItem.img.naturalWidth)) ||
                          H(!1)
                        : H(!0);
                    }, k.loadingIndicatorDelay));
                }),
                x("imageLoadComplete", function (e, t) {
                  s.currItem === t && H(!0);
                }));
          }),
            (M.setIdle = function (e) {
              i(h, "ui--idle", (w = e));
            }),
            (M.update = function () {
              (D =
                !(!_ || !s.currItem) &&
                (M.updateIndexIndicator(),
                k.captionEl &&
                  (k.addCaptionHTMLFn(s.currItem, f),
                  i(f, "caption--empty", !s.currItem.title)),
                !0)),
                P || r(),
                n();
            }),
            (M.updateFullscreen = function (e) {
              e &&
                setTimeout(function () {
                  s.setScrollOffset(0, a.getScrollY());
                }, 50),
                a[(p.isFullscreen() ? "add" : "remove") + "Class"](
                  s.template,
                  "pswp--fs"
                );
            }),
            (M.updateIndexIndicator = function () {
              k.counterEl &&
                (g.innerHTML =
                  s.getCurrentIndex() +
                  1 +
                  k.indexIndicatorSep +
                  k.getNumItemsFn());
            }),
            (M.onGlobalTap = function (e) {
              var t = (e = e || window.event).target || e.srcElement;
              if (!$)
                if (e.detail && "mouse" === e.detail.pointerType) {
                  if (l(t)) return void s.close();
                  a.hasClass(t, "pswp__img") &&
                    (1 === s.getZoomLevel() &&
                    s.getZoomLevel() <= s.currItem.fitRatio
                      ? k.clickToCloseNonZoomable && s.close()
                      : s.toggleDesktopZoom(e.detail.releasePoint));
                } else if (
                  (k.tapToToggleControls &&
                    (_ ? M.hideControls() : M.showControls()),
                  k.tapToClose && (a.hasClass(t, "pswp__img") || l(t)))
                )
                  return void s.close();
            }),
            (M.onMouseOver = function (e) {
              var t = (e = e || window.event).target || e.srcElement;
              i(h, "ui--over-close", l(t));
            }),
            (M.hideControls = function () {
              a.addClass(h, "pswp__ui--hidden"), (_ = !1);
            }),
            (M.showControls = function () {
              (_ = !0), D || M.update(), a.removeClass(h, "pswp__ui--hidden");
            }),
            (M.supportsFullscreen = function () {
              var e = document;
              return !!(
                e.exitFullscreen ||
                e.mozCancelFullScreen ||
                e.webkitExitFullscreen ||
                e.msExitFullscreen
              );
            }),
            (M.getFullscreenAPI = function () {
              var e,
                t = document.documentElement,
                i = "fullscreenchange";
              return (
                t.requestFullscreen
                  ? (e = {
                      enterK: "requestFullscreen",
                      exitK: "exitFullscreen",
                      elementK: "fullscreenElement",
                      eventK: i,
                    })
                  : t.mozRequestFullScreen
                  ? (e = {
                      enterK: "mozRequestFullScreen",
                      exitK: "mozCancelFullScreen",
                      elementK: "mozFullScreenElement",
                      eventK: "moz" + i,
                    })
                  : t.webkitRequestFullscreen
                  ? (e = {
                      enterK: "webkitRequestFullscreen",
                      exitK: "webkitExitFullscreen",
                      elementK: "webkitFullscreenElement",
                      eventK: "webkit" + i,
                    })
                  : t.msRequestFullscreen &&
                    (e = {
                      enterK: "msRequestFullscreen",
                      exitK: "msExitFullscreen",
                      elementK: "msFullscreenElement",
                      eventK: "MSFullscreenChange",
                    }),
                e &&
                  ((e.enter = function () {
                    return (
                      (b = k.closeOnScroll),
                      (k.closeOnScroll = !1),
                      "webkitRequestFullscreen" !== this.enterK
                        ? s.template[this.enterK]()
                        : void s.template[this.enterK](
                            Element.ALLOW_KEYBOARD_INPUT
                          )
                    );
                  }),
                  (e.exit = function () {
                    return (k.closeOnScroll = b), document[this.exitK]();
                  }),
                  (e.isFullscreen = function () {
                    return document[this.elementK];
                  })),
                e
              );
            });
        };
      }),
      "object" ==
      ("undefined" == typeof exports ? "undefined" : _typeof(exports))
        ? (module.exports = y())
        : (v.PhotoSwipeUI_Default = y()),
      (function (e) {
        "use strict";
        "undefined" != typeof exports
          ? (module.exports = e(require("jquery")))
          : e(jQuery);
      })(function (d) {
        "use strict";
        var s,
          r = window.Slick || {};
        (s = 0),
          ((r = function (e, t) {
            var i,
              n = this;
            (n.defaults = {
              accessibility: !0,
              adaptiveHeight: !1,
              appendArrows: d(e),
              appendDots: d(e),
              arrows: !0,
              asNavFor: null,
              prevArrow:
                '<button type="button" data-role="none" class="slick-prev" aria-label="' +
                theme.strings.previous +
                '" tabindex="0" role="button">' +
                theme.strings.previous +
                "</button>",
              nextArrow:
                '<button type="button" data-role="none" class="slick-next" aria-label="' +
                theme.strings.next +
                '" tabindex="0" role="button">' +
                theme.strings.next +
                "</button>",
              autoplay: !1,
              autoplaySpeed: 3e3,
              centerMode: !1,
              centerPadding: "50px",
              cssEase: "ease",
              customPaging: function (e, t) {
                return d(
                  '<button type="button" data-role="none" role="button" tabindex="0" />'
                ).text(t + 1);
              },
              dots: !1,
              dotsClass: "slick-dots",
              draggable: !0,
              easing: "linear",
              edgeFriction: 0.35,
              fade: !1,
              focusOnSelect: !1,
              infinite: !0,
              initialSlide: 0,
              lazyLoad: "ondemand",
              mobileFirst: !1,
              pauseOnHover: !0,
              pauseOnFocus: !0,
              pauseOnDotsHover: !1,
              respondTo: "window",
              responsive: null,
              rows: 1,
              rtl: !1,
              slide: "",
              slidesPerRow: 1,
              slidesToShow: 1,
              slidesToScroll: 1,
              speed: 500,
              swipe: !0,
              swipeToSlide: !1,
              touchMove: !0,
              touchThreshold: 5,
              useCSS: !0,
              useTransform: !0,
              variableWidth: !1,
              vertical: !1,
              verticalSwiping: !1,
              waitForAnimate: !0,
              zIndex: 1e3,
            }),
              (n.initials = {
                animating: !1,
                dragging: !1,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: !1,
                slideOffset: 0,
                swipeLeft: null,
                $list: null,
                touchObject: {},
                transformsEnabled: !1,
                unslicked: !1,
              }),
              d.extend(n, n.initials),
              (n.activeBreakpoint = null),
              (n.animType = null),
              (n.animProp = null),
              (n.breakpoints = []),
              (n.breakpointSettings = []),
              (n.cssTransitions = !1),
              (n.focussed = !1),
              (n.interrupted = !1),
              (n.hidden = "hidden"),
              (n.paused = !0),
              (n.positionProp = null),
              (n.respondTo = null),
              (n.rowCount = 1),
              (n.shouldClick = !0),
              (n.$slider = d(e)),
              (n.$slidesCache = null),
              (n.transformType = null),
              (n.transitionType = null),
              (n.visibilityChange = "visibilitychange"),
              (n.windowWidth = 0),
              (n.windowTimer = null),
              (i = d(e).data("slick") || {}),
              (n.options = d.extend({}, n.defaults, t, i)),
              (n.currentSlide = n.options.initialSlide),
              (n.originalSettings = n.options),
              void 0 !== document.mozHidden
                ? ((n.hidden = "mozHidden"),
                  (n.visibilityChange = "mozvisibilitychange"))
                : void 0 !== document.webkitHidden &&
                  ((n.hidden = "webkitHidden"),
                  (n.visibilityChange = "webkitvisibilitychange")),
              (n.autoPlay = d.proxy(n.autoPlay, n)),
              (n.autoPlayClear = d.proxy(n.autoPlayClear, n)),
              (n.autoPlayIterator = d.proxy(n.autoPlayIterator, n)),
              (n.changeSlide = d.proxy(n.changeSlide, n)),
              (n.clickHandler = d.proxy(n.clickHandler, n)),
              (n.selectHandler = d.proxy(n.selectHandler, n)),
              (n.setPosition = d.proxy(n.setPosition, n)),
              (n.swipeHandler = d.proxy(n.swipeHandler, n)),
              (n.dragHandler = d.proxy(n.dragHandler, n)),
              (n.keyHandler = d.proxy(n.keyHandler, n)),
              (n.instanceUid = s++),
              (n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
              n.registerBreakpoints(),
              n.init(!0);
          }).prototype.activateADA = function () {
            this.$slideTrack
              .find(".slick-active")
              .attr({ "aria-hidden": "false" })
              .find("a, input, button, select")
              .attr({ tabindex: "0" });
          }),
          (r.prototype.addSlide = r.prototype.slickAdd =
            function (e, t, i) {
              var n = this;
              if ("boolean" == typeof t) (i = t), (t = null);
              else if (t < 0 || t >= n.slideCount) return !1;
              n.unload(),
                "number" == typeof t
                  ? 0 === t && 0 === n.$slides.length
                    ? d(e).appendTo(n.$slideTrack)
                    : i
                    ? d(e).insertBefore(n.$slides.eq(t))
                    : d(e).insertAfter(n.$slides.eq(t))
                  : !0 === i
                  ? d(e).prependTo(n.$slideTrack)
                  : d(e).appendTo(n.$slideTrack),
                (n.$slides = n.$slideTrack.children(this.options.slide)),
                n.$slideTrack.children(this.options.slide).detach(),
                n.$slideTrack.append(n.$slides),
                n.$slides.each(function (e, t) {
                  d(t).attr("data-slick-index", e);
                }),
                (n.$slidesCache = n.$slides),
                n.reinit();
            }),
          (r.prototype.animateHeight = function () {
            if (
              1 === this.options.slidesToShow &&
              !0 === this.options.adaptiveHeight &&
              !1 === this.options.vertical
            ) {
              var e = this.$slides.eq(this.currentSlide).outerHeight(!0);
              this.$list.animate({ height: e }, this.options.speed);
            }
          }),
          (r.prototype.animateSlide = function (e, t) {
            var i = {},
              n = this;
            n.animateHeight(),
              !0 === n.options.rtl && !1 === n.options.vertical && (e = -e),
              !1 === n.transformsEnabled
                ? !1 === n.options.vertical
                  ? n.$slideTrack.animate(
                      { left: e },
                      n.options.speed,
                      n.options.easing,
                      t
                    )
                  : n.$slideTrack.animate(
                      { top: e },
                      n.options.speed,
                      n.options.easing,
                      t
                    )
                : !1 === n.cssTransitions
                ? (!0 === n.options.rtl && (n.currentLeft = -n.currentLeft),
                  d({ animStart: n.currentLeft }).animate(
                    { animStart: e },
                    {
                      duration: n.options.speed,
                      easing: n.options.easing,
                      step: function (e) {
                        (e = Math.ceil(e)),
                          !1 === n.options.vertical
                            ? (i[n.animType] = "translate(" + e + "px, 0px)")
                            : (i[n.animType] = "translate(0px," + e + "px)"),
                          n.$slideTrack.css(i);
                      },
                      complete: function () {
                        t && t.call();
                      },
                    }
                  ))
                : (n.applyTransition(),
                  (e = Math.ceil(e)),
                  !1 === n.options.vertical
                    ? (i[n.animType] = "translate3d(" + e + "px, 0px, 0px)")
                    : (i[n.animType] = "translate3d(0px," + e + "px, 0px)"),
                  n.$slideTrack.css(i),
                  t &&
                    setTimeout(function () {
                      n.disableTransition(), t.call();
                    }, n.options.speed));
          }),
          (r.prototype.getNavTarget = function () {
            var e = this.options.asNavFor;
            return e && null !== e && (e = d(e).not(this.$slider)), e;
          }),
          (r.prototype.asNavFor = function (t) {
            var e = this.getNavTarget();
            null !== e &&
              "object" == _typeof(e) &&
              e.each(function () {
                var e = d(this).slick("getSlick");
                e.unslicked || e.slideHandler(t, !0);
              });
          }),
          (r.prototype.applyTransition = function (e) {
            var t = this,
              i = {};
            !1 === t.options.fade
              ? (i[t.transitionType] =
                  t.transformType +
                  " " +
                  t.options.speed +
                  "ms " +
                  t.options.cssEase)
              : (i[t.transitionType] =
                  "opacity " + t.options.speed + "ms " + t.options.cssEase),
              !1 === t.options.fade
                ? t.$slideTrack.css(i)
                : t.$slides.eq(e).css(i);
          }),
          (r.prototype.autoPlay = function () {
            this.autoPlayClear(),
              this.slideCount > this.options.slidesToShow &&
                (this.autoPlayTimer = setInterval(
                  this.autoPlayIterator,
                  this.options.autoplaySpeed
                ));
          }),
          (r.prototype.autoPlayClear = function () {
            this.autoPlayTimer && clearInterval(this.autoPlayTimer);
          }),
          (r.prototype.autoPlayIterator = function () {
            var e = this,
              t = e.currentSlide + e.options.slidesToScroll;
            e.paused ||
              e.interrupted ||
              e.focussed ||
              (!1 === e.options.infinite &&
                (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1
                  ? (e.direction = 0)
                  : 0 === e.direction &&
                    ((t = e.currentSlide - e.options.slidesToScroll),
                    e.currentSlide - 1 == 0 && (e.direction = 1))),
              e.slideHandler(t));
          }),
          (r.prototype.buildArrows = function () {
            var e = this;
            !0 === e.options.arrows &&
              ((e.$prevArrow = d(e.options.prevArrow).addClass("slick-arrow")),
              (e.$nextArrow = d(e.options.nextArrow).addClass("slick-arrow")),
              e.slideCount > e.options.slidesToShow
                ? (e.$prevArrow
                    .removeClass("slick-hidden")
                    .removeAttr("aria-hidden tabindex"),
                  e.$nextArrow
                    .removeClass("slick-hidden")
                    .removeAttr("aria-hidden tabindex"),
                  e.htmlExpr.test(e.options.prevArrow) &&
                    e.$prevArrow.prependTo(e.options.appendArrows),
                  e.htmlExpr.test(e.options.nextArrow) &&
                    e.$nextArrow.appendTo(e.options.appendArrows),
                  !0 !== e.options.infinite &&
                    e.$prevArrow
                      .addClass("slick-disabled")
                      .attr("aria-disabled", "true"))
                : e.$prevArrow
                    .add(e.$nextArrow)
                    .addClass("slick-hidden")
                    .attr({ "aria-disabled": "true", tabindex: "-1" }));
          }),
          (r.prototype.buildDots = function () {
            var e,
              t,
              i = this;
            if (
              !0 === i.options.dots &&
              i.slideCount > i.options.slidesToShow
            ) {
              for (
                i.$slider.addClass("slick-dotted"),
                  t = d("<ul />").addClass(i.options.dotsClass),
                  e = 0;
                e <= i.getDotCount();
                e += 1
              )
                t.append(
                  d("<li />").append(i.options.customPaging.call(this, i, e))
                );
              (i.$dots = t.appendTo(i.options.appendDots)),
                i.$dots
                  .find("li")
                  .first()
                  .addClass("slick-active")
                  .attr("aria-hidden", "false");
            }
          }),
          (r.prototype.buildOut = function () {
            var e = this;
            (e.$slides = e.$slider
              .children(e.options.slide + ":not(.slick-cloned)")
              .addClass("slick-slide")),
              (e.slideCount = e.$slides.length),
              e.$slides.each(function (e, t) {
                d(t)
                  .attr("data-slick-index", e)
                  .data("originalStyling", d(t).attr("style") || "");
              }),
              e.$slider.addClass("slick-slider"),
              (e.$slideTrack =
                0 === e.slideCount
                  ? d(
                      '<div class="slick-track" aria-label="'.concat(
                        theme.strings.imageSlider
                          ? theme.strings.imageSlider
                          : "",
                        '"/>'
                      )
                    ).appendTo(e.$slider)
                  : e.$slides
                      .wrapAll(
                        '<div class="slick-track" aria-label="'.concat(
                          theme.strings.imageSlider
                            ? theme.strings.imageSlider
                            : "",
                          '"/>'
                        )
                      )
                      .parent()),
              (e.$list = e.$slideTrack
                .wrap('<div aria-live="polite" class="slick-list"/>')
                .parent()),
              e.$slideTrack.css("opacity", 0),
              (!0 !== e.options.centerMode && !0 !== e.options.swipeToSlide) ||
                (e.options.slidesToScroll = 1),
              d("img[data-lazy]", e.$slider)
                .not("[src]")
                .addClass("slick-loading"),
              e.setupInfinite(),
              e.buildArrows(),
              e.buildDots(),
              e.updateDots(),
              e.setSlideClasses(
                "number" == typeof e.currentSlide ? e.currentSlide : 0
              ),
              !0 === e.options.draggable && e.$list.addClass("draggable");
          }),
          (r.prototype.buildRows = function () {
            var e,
              t,
              i,
              n,
              s,
              r,
              o,
              a = this;
            if (
              ((n = document.createDocumentFragment()),
              (r = a.$slider.children()),
              1 < a.options.rows)
            ) {
              for (
                o = a.options.slidesPerRow * a.options.rows,
                  s = Math.ceil(r.length / o),
                  e = 0;
                e < s;
                e++
              ) {
                var l = document.createElement("div");
                for (t = 0; t < a.options.rows; t++) {
                  var d = document.createElement("div");
                  for (i = 0; i < a.options.slidesPerRow; i++) {
                    var c = e * o + (t * a.options.slidesPerRow + i);
                    r.get(c) && d.appendChild(r.get(c));
                  }
                  l.appendChild(d);
                }
                n.appendChild(l);
              }
              a.$slider.empty().append(n),
                a.$slider
                  .children()
                  .children()
                  .children()
                  .css({
                    width: 100 / a.options.slidesPerRow + "%",
                    display: "inline-block",
                  });
            }
          }),
          (r.prototype.checkResponsive = function (e, t) {
            var i,
              n,
              s,
              r = this,
              o = !1,
              a = r.$slider.width(),
              l = window.innerWidth || d(window).width();
            if (
              ("window" === r.respondTo
                ? (s = l)
                : "slider" === r.respondTo
                ? (s = a)
                : "min" === r.respondTo && (s = Math.min(l, a)),
              r.options.responsive &&
                r.options.responsive.length &&
                null !== r.options.responsive)
            ) {
              for (i in ((n = null), r.breakpoints))
                r.breakpoints.hasOwnProperty(i) &&
                  (!1 === r.originalSettings.mobileFirst
                    ? s < r.breakpoints[i] && (n = r.breakpoints[i])
                    : s > r.breakpoints[i] && (n = r.breakpoints[i]));
              null !== n
                ? (null !== r.activeBreakpoint &&
                    n === r.activeBreakpoint &&
                    !t) ||
                  ((r.activeBreakpoint = n),
                  "unslick" === r.breakpointSettings[n]
                    ? r.unslick(n)
                    : ((r.options = d.extend(
                        {},
                        r.originalSettings,
                        r.breakpointSettings[n]
                      )),
                      !0 === e && (r.currentSlide = r.options.initialSlide),
                      r.refresh(e)),
                  (o = n))
                : null !== r.activeBreakpoint &&
                  ((r.activeBreakpoint = null),
                  (r.options = r.originalSettings),
                  !0 === e && (r.currentSlide = r.options.initialSlide),
                  r.refresh(e),
                  (o = n)),
                e || !1 === o || r.$slider.trigger("breakpoint", [r, o]);
            }
          }),
          (r.prototype.changeSlide = function (e, t) {
            var i,
              n,
              s = this,
              r = d(e.currentTarget);
            switch (
              (r.is("a") && e.preventDefault(),
              r.is("li") || (r = r.closest("li")),
              (i =
                s.slideCount % s.options.slidesToScroll != 0
                  ? 0
                  : (s.slideCount - s.currentSlide) % s.options.slidesToScroll),
              e.data.message)
            ) {
              case "previous":
                (n =
                  0 == i
                    ? s.options.slidesToScroll
                    : s.options.slidesToShow - i),
                  s.slideCount > s.options.slidesToShow &&
                    s.slideHandler(s.currentSlide - n, !1, t);
                break;
              case "next":
                (n = 0 == i ? s.options.slidesToScroll : i),
                  s.slideCount > s.options.slidesToShow &&
                    s.slideHandler(s.currentSlide + n, !1, t);
                break;
              case "index":
                var o =
                  0 === e.data.index
                    ? 0
                    : e.data.index || r.index() * s.options.slidesToScroll;
                s.slideHandler(s.checkNavigable(o), !1, t),
                  r.children().trigger("focus");
                break;
              default:
                return;
            }
          }),
          (r.prototype.checkNavigable = function (e) {
            var t, i;
            if (((i = 0), e > (t = this.getNavigableIndexes())[t.length - 1]))
              e = t[t.length - 1];
            else
              for (var n in t) {
                if (e < t[n]) {
                  e = i;
                  break;
                }
                i = t[n];
              }
            return e;
          }),
          (r.prototype.cleanUpEvents = function () {
            var e = this;
            e.options.dots &&
              null !== e.$dots &&
              d("li", e.$dots)
                .off("click.slick", e.changeSlide)
                .off("mouseenter.slick", d.proxy(e.interrupt, e, !0))
                .off("mouseleave.slick", d.proxy(e.interrupt, e, !1)),
              e.$slider.off("focus.slick blur.slick"),
              !0 === e.options.arrows &&
                e.slideCount > e.options.slidesToShow &&
                (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide),
                e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide)),
              e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
              e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
              e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
              e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
              e.$list.off("click.slick", e.clickHandler),
              d(document).off(e.visibilityChange, e.visibility),
              e.cleanUpSlideEvents(),
              !0 === e.options.accessibility &&
                e.$list.off("keydown.slick", e.keyHandler),
              !0 === e.options.focusOnSelect &&
                d(e.$slideTrack).children().off("click.slick", e.selectHandler),
              d(window).off(
                "orientationchange.slick.slick-" + e.instanceUid,
                e.orientationChange
              ),
              d(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
              d("[draggable!=true]", e.$slideTrack).off(
                "dragstart",
                e.preventDefault
              ),
              d(window).off("load.slick.slick-" + e.instanceUid, e.setPosition),
              d(document).off(
                "ready.slick.slick-" + e.instanceUid,
                e.setPosition
              );
          }),
          (r.prototype.cleanUpSlideEvents = function () {
            this.$list.off(
              "mouseenter.slick",
              d.proxy(this.interrupt, this, !0)
            ),
              this.$list.off(
                "mouseleave.slick",
                d.proxy(this.interrupt, this, !1)
              );
          }),
          (r.prototype.cleanUpRows = function () {
            var e;
            1 < this.options.rows &&
              ((e = this.$slides.children().children()).removeAttr("style"),
              this.$slider.empty().append(e));
          }),
          (r.prototype.clickHandler = function (e) {
            !1 === this.shouldClick &&
              (e.stopImmediatePropagation(),
              e.stopPropagation(),
              e.preventDefault());
          }),
          (r.prototype.destroy = function (e) {
            var t = this;
            t.autoPlayClear(),
              (t.touchObject = {}),
              t.cleanUpEvents(),
              d(".slick-cloned", t.$slider).detach(),
              t.$dots && t.$dots.remove(),
              t.$prevArrow &&
                t.$prevArrow.length &&
                (t.$prevArrow
                  .removeClass("slick-disabled slick-arrow slick-hidden")
                  .removeAttr("aria-hidden aria-disabled tabindex")
                  .css("display", ""),
                t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()),
              t.$nextArrow &&
                t.$nextArrow.length &&
                (t.$nextArrow
                  .removeClass("slick-disabled slick-arrow slick-hidden")
                  .removeAttr("aria-hidden aria-disabled tabindex")
                  .css("display", ""),
                t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()),
              t.$slides &&
                (t.$slides
                  .removeClass(
                    "slick-slide slick-active slick-center slick-visible slick-current"
                  )
                  .removeAttr("aria-hidden")
                  .removeAttr("data-slick-index")
                  .each(function () {
                    d(this).attr("style", d(this).data("originalStyling"));
                  }),
                t.$slideTrack.children(this.options.slide).detach(),
                t.$slideTrack.detach(),
                t.$list.detach(),
                t.$slider.append(t.$slides)),
              t.cleanUpRows(),
              t.$slider.removeClass("slick-slider"),
              t.$slider.removeClass("slick-initialized"),
              t.$slider.removeClass("slick-dotted"),
              (t.unslicked = !0),
              e || t.$slider.trigger("destroy", [t]);
          }),
          (r.prototype.disableTransition = function (e) {
            var t = {};
            (t[this.transitionType] = ""),
              !1 === this.options.fade
                ? this.$slideTrack.css(t)
                : this.$slides.eq(e).css(t);
          }),
          (r.prototype.fadeSlide = function (e, t) {
            var i = this;
            !1 === i.cssTransitions
              ? (i.$slides.eq(e).css({ zIndex: i.options.zIndex }),
                i.$slides
                  .eq(e)
                  .animate(
                    { opacity: 1 },
                    i.options.speed,
                    i.options.easing,
                    t
                  ))
              : (i.applyTransition(e),
                i.$slides.eq(e).css({ opacity: 1, zIndex: i.options.zIndex }),
                t &&
                  setTimeout(function () {
                    i.disableTransition(e), t.call();
                  }, i.options.speed));
          }),
          (r.prototype.fadeSlideOut = function (e) {
            !1 === this.cssTransitions
              ? this.$slides
                  .eq(e)
                  .animate(
                    { opacity: 0, zIndex: this.options.zIndex - 2 },
                    this.options.speed,
                    this.options.easing
                  )
              : (this.applyTransition(e),
                this.$slides
                  .eq(e)
                  .css({ opacity: 0, zIndex: this.options.zIndex - 2 }));
          }),
          (r.prototype.filterSlides = r.prototype.slickFilter =
            function (e) {
              null !== e &&
                ((this.$slidesCache = this.$slides),
                this.unload(),
                this.$slideTrack.children(this.options.slide).detach(),
                this.$slidesCache.filter(e).appendTo(this.$slideTrack),
                this.reinit());
            }),
          (r.prototype.focusHandler = function () {
            var i = this;
            i.$slider
              .off("focus.slick blur.slick")
              .on(
                "focus.slick blur.slick",
                "*:not(.slick-arrow)",
                function (e) {
                  var t = d(this);
                  setTimeout(function () {
                    i.options.pauseOnFocus &&
                      ((i.focussed = t.is(":focus")), i.autoPlay());
                  }, 0);
                }
              );
          }),
          (r.prototype.getCurrent = r.prototype.slickCurrentSlide =
            function () {
              return this.currentSlide;
            }),
          (r.prototype.getDotCount = function () {
            var e = this,
              t = 0,
              i = 0,
              n = 0;
            if (!0 === e.options.infinite)
              for (; t < e.slideCount; )
                ++n,
                  (t = i + e.options.slidesToScroll),
                  (i +=
                    e.options.slidesToScroll <= e.options.slidesToShow
                      ? e.options.slidesToScroll
                      : e.options.slidesToShow);
            else if (!0 === e.options.centerMode) n = e.slideCount;
            else if (e.options.asNavFor)
              for (; t < e.slideCount; )
                ++n,
                  (t = i + e.options.slidesToScroll),
                  (i +=
                    e.options.slidesToScroll <= e.options.slidesToShow
                      ? e.options.slidesToScroll
                      : e.options.slidesToShow);
            else
              n =
                1 +
                Math.ceil(
                  (e.slideCount - e.options.slidesToShow) /
                    e.options.slidesToScroll
                );
            return n - 1;
          }),
          (r.prototype.getLeft = function (e) {
            var t,
              i,
              n,
              s = this,
              r = 0;
            return (
              (s.slideOffset = 0),
              (i = s.$slides.first().outerHeight(!0)),
              !0 === s.options.infinite
                ? (s.slideCount > s.options.slidesToShow &&
                    ((s.slideOffset =
                      s.slideWidth * s.options.slidesToShow * -1),
                    (r = i * s.options.slidesToShow * -1)),
                  s.slideCount % s.options.slidesToScroll != 0 &&
                    e + s.options.slidesToScroll > s.slideCount &&
                    s.slideCount > s.options.slidesToShow &&
                    (r =
                      e > s.slideCount
                        ? ((s.slideOffset =
                            (s.options.slidesToShow - (e - s.slideCount)) *
                            s.slideWidth *
                            -1),
                          (s.options.slidesToShow - (e - s.slideCount)) *
                            i *
                            -1)
                        : ((s.slideOffset =
                            (s.slideCount % s.options.slidesToScroll) *
                            s.slideWidth *
                            -1),
                          (s.slideCount % s.options.slidesToScroll) * i * -1)))
                : e + s.options.slidesToShow > s.slideCount &&
                  ((s.slideOffset =
                    (e + s.options.slidesToShow - s.slideCount) * s.slideWidth),
                  (r = (e + s.options.slidesToShow - s.slideCount) * i)),
              s.slideCount <= s.options.slidesToShow && (r = s.slideOffset = 0),
              !0 === s.options.centerMode && !0 === s.options.infinite
                ? (s.slideOffset +=
                    s.slideWidth * Math.floor(s.options.slidesToShow / 2) -
                    s.slideWidth)
                : !0 === s.options.centerMode &&
                  ((s.slideOffset = 0),
                  (s.slideOffset +=
                    s.slideWidth * Math.floor(s.options.slidesToShow / 2))),
              (t =
                !1 === s.options.vertical
                  ? e * s.slideWidth * -1 + s.slideOffset
                  : e * i * -1 + r),
              !0 === s.options.variableWidth &&
                ((n =
                  s.slideCount <= s.options.slidesToShow ||
                  !1 === s.options.infinite
                    ? s.$slideTrack.children(".slick-slide").eq(e)
                    : s.$slideTrack
                        .children(".slick-slide")
                        .eq(e + s.options.slidesToShow)),
                (t =
                  !0 === s.options.rtl
                    ? n[0]
                      ? -1 *
                        (s.$slideTrack.width() - n[0].offsetLeft - n.width())
                      : 0
                    : n[0]
                    ? -1 * n[0].offsetLeft
                    : 0),
                !0 === s.options.centerMode &&
                  ((n =
                    s.slideCount <= s.options.slidesToShow ||
                    !1 === s.options.infinite
                      ? s.$slideTrack.children(".slick-slide").eq(e)
                      : s.$slideTrack
                          .children(".slick-slide")
                          .eq(e + s.options.slidesToShow + 1)),
                  (t =
                    !0 === s.options.rtl
                      ? n[0]
                        ? -1 *
                          (s.$slideTrack.width() - n[0].offsetLeft - n.width())
                        : 0
                      : n[0]
                      ? -1 * n[0].offsetLeft
                      : 0),
                  (t += (s.$list.width() - n.outerWidth()) / 2))),
              t
            );
          }),
          (r.prototype.getOption = r.prototype.slickGetOption =
            function (e) {
              return this.options[e];
            }),
          (r.prototype.getNavigableIndexes = function () {
            var e,
              t = this,
              i = 0,
              n = 0,
              s = [];
            for (
              e =
                !1 === t.options.infinite
                  ? t.slideCount
                  : ((i = -1 * t.options.slidesToScroll),
                    (n = -1 * t.options.slidesToScroll),
                    2 * t.slideCount);
              i < e;

            )
              s.push(i),
                (i = n + t.options.slidesToScroll),
                (n +=
                  t.options.slidesToScroll <= t.options.slidesToShow
                    ? t.options.slidesToScroll
                    : t.options.slidesToShow);
            return s;
          }),
          (r.prototype.getSlick = function () {
            return this;
          }),
          (r.prototype.getSlideCount = function () {
            var i,
              n,
              s = this;
            return (
              (n =
                !0 === s.options.centerMode
                  ? s.slideWidth * Math.floor(s.options.slidesToShow / 2)
                  : 0),
              !0 === s.options.swipeToSlide
                ? (s.$slideTrack.find(".slick-slide").each(function (e, t) {
                    return t.offsetLeft - n + d(t).outerWidth() / 2 >
                      -1 * s.swipeLeft
                      ? ((i = t), !1)
                      : void 0;
                  }),
                  Math.abs(d(i).attr("data-slick-index") - s.currentSlide) || 1)
                : s.options.slidesToScroll
            );
          }),
          (r.prototype.goTo = r.prototype.slickGoTo =
            function (e, t) {
              this.changeSlide(
                { data: { message: "index", index: parseInt(e) } },
                t
              );
            }),
          (r.prototype.init = function (e) {
            var t = this;
            d(t.$slider).hasClass("slick-initialized") ||
              (d(t.$slider).addClass("slick-initialized"),
              t.buildRows(),
              t.buildOut(),
              t.setProps(),
              t.startLoad(),
              t.loadSlider(),
              t.initializeEvents(),
              t.updateArrows(),
              t.updateDots(),
              t.checkResponsive(!0),
              t.focusHandler()),
              e && t.$slider.trigger("init", [t]),
              !0 === t.options.accessibility && t.initADA(),
              t.options.autoplay && ((t.paused = !1), t.autoPlay());
          }),
          (r.prototype.initADA = function () {
            var t = this;
            t.$slides
              .add(t.$slideTrack.find(".slick-cloned"))
              .attr({ "aria-hidden": "true", tabindex: "-1" })
              .find("a, input, button, select")
              .attr({ tabindex: "-1" }),
              t.$slideTrack.attr("role", "listbox"),
              t.$slides
                .not(t.$slideTrack.find(".slick-cloned"))
                .each(function (e) {
                  d(this).attr({ role: "option" });
                }),
              null !== t.$dots &&
                t.$dots
                  .attr("aria-hidden", "true")
                  .find("li")
                  .each(function (e) {
                    d(this).attr({
                      role: "presentation",
                      "aria-selected": "false",
                      "aria-controls": "navigation" + t.instanceUid + e,
                      id: "slick-slide" + t.instanceUid + e,
                    });
                  })
                  .first()
                  .attr("aria-selected", "true")
                  .end()
                  .find("button")
                  .attr("role", "button")
                  .end()
                  .closest("div")
                  .attr("role", "toolbar"),
              t.activateADA();
          }),
          (r.prototype.initArrowEvents = function () {
            !0 === this.options.arrows &&
              this.slideCount > this.options.slidesToShow &&
              (this.$prevArrow
                .off("click.slick")
                .on("click.slick", { message: "previous" }, this.changeSlide),
              this.$nextArrow
                .off("click.slick")
                .on("click.slick", { message: "next" }, this.changeSlide));
          }),
          (r.prototype.initDotEvents = function () {
            var e = this;
            !0 === e.options.dots &&
              e.slideCount > e.options.slidesToShow &&
              d("li", e.$dots).on(
                "click.slick",
                { message: "index" },
                e.changeSlide
              ),
              !0 === e.options.dots &&
                !0 === e.options.pauseOnDotsHover &&
                d("li", e.$dots)
                  .on("mouseenter.slick", d.proxy(e.interrupt, e, !0))
                  .on("mouseleave.slick", d.proxy(e.interrupt, e, !1));
          }),
          (r.prototype.initSlideEvents = function () {
            this.options.pauseOnHover &&
              (this.$list.on(
                "mouseenter.slick",
                d.proxy(this.interrupt, this, !0)
              ),
              this.$list.on(
                "mouseleave.slick",
                d.proxy(this.interrupt, this, !1)
              ));
          }),
          (r.prototype.initializeEvents = function () {
            var e = this;
            e.initArrowEvents(),
              e.initDotEvents(),
              e.initSlideEvents(),
              e.$list.on(
                "touchstart.slick mousedown.slick",
                { action: "start" },
                e.swipeHandler
              ),
              e.$list.on(
                "touchmove.slick mousemove.slick",
                { action: "move" },
                e.swipeHandler
              ),
              e.$list.on(
                "touchend.slick mouseup.slick",
                { action: "end" },
                e.swipeHandler
              ),
              e.$list.on(
                "touchcancel.slick mouseleave.slick",
                { action: "end" },
                e.swipeHandler
              ),
              e.$list.on("click.slick", e.clickHandler),
              d(document).on(e.visibilityChange, d.proxy(e.visibility, e)),
              !0 === e.options.accessibility &&
                e.$list.on("keydown.slick", e.keyHandler),
              !0 === e.options.focusOnSelect &&
                d(e.$slideTrack).children().on("click.slick", e.selectHandler),
              d(window).on(
                "orientationchange.slick.slick-" + e.instanceUid,
                d.proxy(e.orientationChange, e)
              ),
              d(window).on(
                "resize.slick.slick-" + e.instanceUid,
                d.proxy(e.resize, e)
              ),
              d("[draggable!=true]", e.$slideTrack).on(
                "dragstart",
                e.preventDefault
              ),
              d(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
              d(document).on(
                "ready.slick.slick-" + e.instanceUid,
                e.setPosition
              );
          }),
          (r.prototype.initUI = function () {
            !0 === this.options.arrows &&
              this.slideCount > this.options.slidesToShow &&
              (this.$prevArrow.show(), this.$nextArrow.show()),
              !0 === this.options.dots &&
                this.slideCount > this.options.slidesToShow &&
                this.$dots.show();
          }),
          (r.prototype.keyHandler = function (e) {
            e.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
              (37 === e.keyCode && !0 === this.options.accessibility
                ? this.changeSlide({
                    data: {
                      message: !0 === this.options.rtl ? "next" : "previous",
                    },
                  })
                : 39 === e.keyCode &&
                  !0 === this.options.accessibility &&
                  this.changeSlide({
                    data: {
                      message: !0 === this.options.rtl ? "previous" : "next",
                    },
                  }));
          }),
          (r.prototype.lazyLoad = function () {
            function e(e) {
              d("img[data-lazy]", e).each(function () {
                var e = d(this),
                  t = d(this).attr("data-lazy"),
                  i = document.createElement("img");
                (i.onload = function () {
                  e.animate({ opacity: 0 }, 100, function () {
                    e.attr("src", t).animate({ opacity: 1 }, 200, function () {
                      e.removeAttr("data-lazy").removeClass("slick-loading");
                    }),
                      n.$slider.trigger("lazyLoaded", [n, e, t]);
                  });
                }),
                  (i.onerror = function () {
                    e
                      .removeAttr("data-lazy")
                      .removeClass("slick-loading")
                      .addClass("slick-lazyload-error"),
                      n.$slider.trigger("lazyLoadError", [n, e, t]);
                  }),
                  (i.src = t);
              });
            }
            var t,
              i,
              n = this;
            !0 === n.options.centerMode
              ? (i =
                  !0 === n.options.infinite
                    ? (t = n.currentSlide + (n.options.slidesToShow / 2 + 1)) +
                      n.options.slidesToShow +
                      2
                    : ((t = Math.max(
                        0,
                        n.currentSlide - (n.options.slidesToShow / 2 + 1)
                      )),
                      n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide))
              : ((t = n.options.infinite
                  ? n.options.slidesToShow + n.currentSlide
                  : n.currentSlide),
                (i = Math.ceil(t + n.options.slidesToShow)),
                !0 === n.options.fade &&
                  (0 < t && t--, i <= n.slideCount && i++)),
              e(n.$slider.find(".slick-slide").slice(t, i)),
              n.slideCount <= n.options.slidesToShow
                ? e(n.$slider.find(".slick-slide"))
                : n.currentSlide >= n.slideCount - n.options.slidesToShow
                ? e(
                    n.$slider
                      .find(".slick-cloned")
                      .slice(0, n.options.slidesToShow)
                  )
                : 0 === n.currentSlide &&
                  e(
                    n.$slider
                      .find(".slick-cloned")
                      .slice(-1 * n.options.slidesToShow)
                  );
          }),
          (r.prototype.loadSlider = function () {
            this.setPosition(),
              this.$slideTrack.css({ opacity: 1 }),
              this.$slider.removeClass("slick-loading"),
              this.initUI(),
              "progressive" === this.options.lazyLoad &&
                this.progressiveLazyLoad();
          }),
          (r.prototype.next = r.prototype.slickNext =
            function () {
              this.changeSlide({ data: { message: "next" } });
            }),
          (r.prototype.orientationChange = function () {
            this.checkResponsive(), this.setPosition();
          }),
          (r.prototype.pause = r.prototype.slickPause =
            function () {
              this.autoPlayClear(), (this.paused = !0);
            }),
          (r.prototype.play = r.prototype.slickPlay =
            function () {
              this.autoPlay(),
                (this.options.autoplay = !0),
                (this.paused = !1),
                (this.focussed = !1),
                (this.interrupted = !1);
            }),
          (r.prototype.postSlide = function (e) {
            var t = this;
            t.unslicked ||
              (t.$slider.trigger("afterChange", [t, e]),
              (t.animating = !1),
              t.setPosition(),
              (t.swipeLeft = null),
              t.options.autoplay && t.autoPlay(),
              !0 === t.options.accessibility && t.initADA());
          }),
          (r.prototype.prev = r.prototype.slickPrev =
            function () {
              this.changeSlide({ data: { message: "previous" } });
            }),
          (r.prototype.preventDefault = function (e) {
            e.preventDefault();
          }),
          (r.prototype.progressiveLazyLoad = function (e) {
            e = e || 1;
            var t,
              i,
              n,
              s = this,
              r = d("img[data-lazy]", s.$slider);
            r.length
              ? ((t = r.first()),
                (i = t.attr("data-lazy")),
                ((n = document.createElement("img")).onload = function () {
                  t
                    .attr("src", i)
                    .removeAttr("data-lazy")
                    .removeClass("slick-loading"),
                    !0 === s.options.adaptiveHeight && s.setPosition(),
                    s.$slider.trigger("lazyLoaded", [s, t, i]),
                    s.progressiveLazyLoad();
                }),
                (n.onerror = function () {
                  e < 3
                    ? setTimeout(function () {
                        s.progressiveLazyLoad(e + 1);
                      }, 500)
                    : (t
                        .removeAttr("data-lazy")
                        .removeClass("slick-loading")
                        .addClass("slick-lazyload-error"),
                      s.$slider.trigger("lazyLoadError", [s, t, i]),
                      s.progressiveLazyLoad());
                }),
                (n.src = i))
              : s.$slider.trigger("allImagesLoaded", [s]);
          }),
          (r.prototype.refresh = function (e) {
            var t,
              i,
              n = this;
            (i = n.slideCount - n.options.slidesToShow),
              !n.options.infinite && n.currentSlide > i && (n.currentSlide = i),
              n.slideCount <= n.options.slidesToShow && (n.currentSlide = 0),
              (t = n.currentSlide),
              n.destroy(!0),
              d.extend(n, n.initials, { currentSlide: t }),
              n.init(),
              e || n.changeSlide({ data: { message: "index", index: t } }, !1);
          }),
          (r.prototype.registerBreakpoints = function () {
            var e,
              t,
              i,
              n = this,
              s = n.options.responsive || null;
            if ("array" === d.type(s) && s.length) {
              for (e in ((n.respondTo = n.options.respondTo || "window"), s))
                if (
                  ((i = n.breakpoints.length - 1),
                  (t = s[e].breakpoint),
                  s.hasOwnProperty(e))
                ) {
                  for (; 0 <= i; )
                    n.breakpoints[i] &&
                      n.breakpoints[i] === t &&
                      n.breakpoints.splice(i, 1),
                      i--;
                  n.breakpoints.push(t),
                    (n.breakpointSettings[t] = s[e].settings);
                }
              n.breakpoints.sort(function (e, t) {
                return n.options.mobileFirst ? e - t : t - e;
              });
            }
          }),
          (r.prototype.reinit = function () {
            var e = this;
            (e.$slides = e.$slideTrack
              .children(e.options.slide)
              .addClass("slick-slide")),
              (e.slideCount = e.$slides.length),
              e.currentSlide >= e.slideCount &&
                0 !== e.currentSlide &&
                (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
              e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
              e.registerBreakpoints(),
              e.setProps(),
              e.setupInfinite(),
              e.buildArrows(),
              e.updateArrows(),
              e.initArrowEvents(),
              e.buildDots(),
              e.updateDots(),
              e.initDotEvents(),
              e.cleanUpSlideEvents(),
              e.initSlideEvents(),
              e.checkResponsive(!1, !0),
              !0 === e.options.focusOnSelect &&
                d(e.$slideTrack).children().on("click.slick", e.selectHandler),
              e.setSlideClasses(
                "number" == typeof e.currentSlide ? e.currentSlide : 0
              ),
              e.setPosition(),
              e.focusHandler(),
              (e.paused = !e.options.autoplay),
              e.autoPlay(),
              e.$slider.trigger("reInit", [e]);
          }),
          (r.prototype.resize = function () {
            var e = this;
            d(window).width() !== e.windowWidth &&
              (clearTimeout(e.windowDelay),
              (e.windowDelay = window.setTimeout(function () {
                (e.windowWidth = d(window).width()),
                  e.checkResponsive(),
                  e.unslicked || e.setPosition();
              }, 50)));
          }),
          (r.prototype.removeSlide = r.prototype.slickRemove =
            function (e, t, i) {
              var n = this;
              return (
                (e =
                  "boolean" == typeof e
                    ? !0 === (t = e)
                      ? 0
                      : n.slideCount - 1
                    : !0 === t
                    ? --e
                    : e),
                !(n.slideCount < 1 || e < 0 || e > n.slideCount - 1) &&
                  (n.unload(),
                  !0 === i
                    ? n.$slideTrack.children().remove()
                    : n.$slideTrack.children(this.options.slide).eq(e).remove(),
                  (n.$slides = n.$slideTrack.children(this.options.slide)),
                  n.$slideTrack.children(this.options.slide).detach(),
                  n.$slideTrack.append(n.$slides),
                  (n.$slidesCache = n.$slides),
                  void n.reinit())
              );
            }),
          (r.prototype.setCSS = function (e) {
            var t,
              i,
              n = this,
              s = {};
            !0 === n.options.rtl && (e = -e),
              (t = "left" == n.positionProp ? Math.ceil(e) + "px" : "0px"),
              (i = "top" == n.positionProp ? Math.ceil(e) + "px" : "0px"),
              (s[n.positionProp] = e),
              !1 === n.transformsEnabled ||
                (!(s = {}) === n.cssTransitions
                  ? (s[n.animType] = "translate(" + t + ", " + i + ")")
                  : (s[n.animType] = "translate3d(" + t + ", " + i + ", 0px)")),
              n.$slideTrack.css(s);
          }),
          (r.prototype.setDimensions = function () {
            var e = this;
            !1 === e.options.vertical
              ? !0 === e.options.centerMode &&
                e.$list.css({ padding: "0px " + e.options.centerPadding })
              : (e.$list.height(
                  e.$slides.first().outerHeight(!0) * e.options.slidesToShow
                ),
                !0 === e.options.centerMode &&
                  e.$list.css({ padding: e.options.centerPadding + " 0px" })),
              (e.listWidth = e.$list.width()),
              (e.listHeight = e.$list.height()),
              !1 === e.options.vertical && !1 === e.options.variableWidth
                ? ((e.slideWidth = Math.ceil(
                    e.listWidth / e.options.slidesToShow
                  )),
                  e.$slideTrack.width(
                    Math.ceil(
                      e.slideWidth *
                        e.$slideTrack.children(".slick-slide").length
                    )
                  ))
                : !0 === e.options.variableWidth
                ? e.$slideTrack.width(5e3 * e.slideCount)
                : ((e.slideWidth = Math.ceil(e.listWidth)),
                  e.$slideTrack.height(
                    Math.ceil(
                      e.$slides.first().outerHeight(!0) *
                        e.$slideTrack.children(".slick-slide").length
                    )
                  ));
            var t =
              e.$slides.first().outerWidth(!0) - e.$slides.first().width();
            !1 === e.options.variableWidth &&
              e.$slideTrack.children(".slick-slide").width(e.slideWidth - t);
          }),
          (r.prototype.setFade = function () {
            var i,
              n = this;
            n.$slides.each(function (e, t) {
              (i = n.slideWidth * e * -1),
                !0 === n.options.rtl
                  ? d(t).css({
                      position: "relative",
                      right: i,
                      top: 0,
                      zIndex: n.options.zIndex - 2,
                      opacity: 0,
                    })
                  : d(t).css({
                      position: "relative",
                      left: i,
                      top: 0,
                      zIndex: n.options.zIndex - 2,
                      opacity: 0,
                    });
            }),
              n.$slides
                .eq(n.currentSlide)
                .css({ zIndex: n.options.zIndex - 1, opacity: 1 });
          }),
          (r.prototype.setHeight = function () {
            if (
              1 === this.options.slidesToShow &&
              !0 === this.options.adaptiveHeight &&
              !1 === this.options.vertical
            ) {
              var e = this.$slides.eq(this.currentSlide).outerHeight(!0);
              this.$list.css("height", e);
            }
          }),
          (r.prototype.setOption = r.prototype.slickSetOption =
            function () {
              var e,
                t,
                i,
                n,
                s,
                r = this,
                o = !1;
              if (
                ("object" === d.type(arguments[0])
                  ? ((i = arguments[0]), (o = arguments[1]), (s = "multiple"))
                  : "string" === d.type(arguments[0]) &&
                    ((n = arguments[1]),
                    (o = arguments[2]),
                    "responsive" === (i = arguments[0]) &&
                    "array" === d.type(arguments[1])
                      ? (s = "responsive")
                      : void 0 !== arguments[1] && (s = "single")),
                "single" === s)
              )
                r.options[i] = n;
              else if ("multiple" === s)
                d.each(i, function (e, t) {
                  r.options[e] = t;
                });
              else if ("responsive" === s)
                for (t in n)
                  if ("array" !== d.type(r.options.responsive))
                    r.options.responsive = [n[t]];
                  else {
                    for (e = r.options.responsive.length - 1; 0 <= e; )
                      r.options.responsive[e].breakpoint === n[t].breakpoint &&
                        r.options.responsive.splice(e, 1),
                        e--;
                    r.options.responsive.push(n[t]);
                  }
              o && (r.unload(), r.reinit());
            }),
          (r.prototype.setPosition = function () {
            this.setDimensions(),
              this.setHeight(),
              !1 === this.options.fade
                ? this.setCSS(this.getLeft(this.currentSlide))
                : this.setFade(),
              this.$slider.trigger("setPosition", [this]);
          }),
          (r.prototype.setProps = function () {
            var e = this,
              t = document.body.style;
            (e.positionProp = !0 === e.options.vertical ? "top" : "left"),
              "top" === e.positionProp
                ? e.$slider.addClass("slick-vertical")
                : e.$slider.removeClass("slick-vertical"),
              (void 0 === t.WebkitTransition &&
                void 0 === t.MozTransition &&
                void 0 === t.msTransition) ||
                !0 !== e.options.useCSS ||
                (e.cssTransitions = !0),
              e.options.fade &&
                ("number" == typeof e.options.zIndex
                  ? e.options.zIndex < 3 && (e.options.zIndex = 3)
                  : (e.options.zIndex = e.defaults.zIndex)),
              void 0 !== t.OTransform &&
                ((e.animType = "OTransform"),
                (e.transformType = "-o-transform"),
                (e.transitionType = "OTransition"),
                void 0 === t.perspectiveProperty &&
                  void 0 === t.webkitPerspective &&
                  (e.animType = !1)),
              void 0 !== t.MozTransform &&
                ((e.animType = "MozTransform"),
                (e.transformType = "-moz-transform"),
                (e.transitionType = "MozTransition"),
                void 0 === t.perspectiveProperty &&
                  void 0 === t.MozPerspective &&
                  (e.animType = !1)),
              void 0 !== t.webkitTransform &&
                ((e.animType = "webkitTransform"),
                (e.transformType = "-webkit-transform"),
                (e.transitionType = "webkitTransition"),
                void 0 === t.perspectiveProperty &&
                  void 0 === t.webkitPerspective &&
                  (e.animType = !1)),
              void 0 !== t.msTransform &&
                ((e.animType = "msTransform"),
                (e.transformType = "-ms-transform"),
                (e.transitionType = "msTransition"),
                void 0 === t.msTransform && (e.animType = !1)),
              void 0 !== t.transform &&
                !1 !== e.animType &&
                ((e.animType = "transform"),
                (e.transformType = "transform"),
                (e.transitionType = "transition")),
              (e.transformsEnabled =
                e.options.useTransform &&
                null !== e.animType &&
                !1 !== e.animType);
          }),
          (r.prototype.setSlideClasses = function (e) {
            var t,
              i,
              n,
              s,
              r = this;
            (i = r.$slider
              .find(".slick-slide")
              .removeClass("slick-active slick-center slick-current")
              .attr("aria-hidden", "true")),
              r.$slides.eq(e).addClass("slick-current"),
              !0 === r.options.centerMode
                ? ((t = Math.floor(r.options.slidesToShow / 2)),
                  !0 === r.options.infinite &&
                    (t <= e && e <= r.slideCount - 1 - t
                      ? r.$slides
                          .slice(e - t, e + t + 1)
                          .addClass("slick-active")
                          .attr("aria-hidden", "false")
                      : ((n = r.options.slidesToShow + e),
                        i
                          .slice(n - t + 1, n + t + 2)
                          .addClass("slick-active")
                          .attr("aria-hidden", "false")),
                    0 === e
                      ? i
                          .eq(i.length - 1 - r.options.slidesToShow)
                          .addClass("slick-center")
                      : e === r.slideCount - 1 &&
                        i.eq(r.options.slidesToShow).addClass("slick-center")),
                  r.$slides.eq(e).addClass("slick-center"))
                : 0 <= e && e <= r.slideCount - r.options.slidesToShow
                ? r.$slides
                    .slice(e, e + r.options.slidesToShow)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")
                : i.length <= r.options.slidesToShow
                ? i.addClass("slick-active").attr("aria-hidden", "false")
                : ((s = r.slideCount % r.options.slidesToShow),
                  (n =
                    !0 === r.options.infinite ? r.options.slidesToShow + e : e),
                  r.options.slidesToShow == r.options.slidesToScroll &&
                  r.slideCount - e < r.options.slidesToShow
                    ? i
                        .slice(n - (r.options.slidesToShow - s), n + s)
                        .addClass("slick-active")
                        .attr("aria-hidden", "false")
                    : i
                        .slice(n, n + r.options.slidesToShow)
                        .addClass("slick-active")
                        .attr("aria-hidden", "false")),
              "ondemand" === r.options.lazyLoad && r.lazyLoad();
          }),
          (r.prototype.setupInfinite = function () {
            var e,
              t,
              i,
              n = this;
            if (
              (!0 === n.options.fade && (n.options.centerMode = !1),
              !0 === n.options.infinite &&
                !1 === n.options.fade &&
                ((t = null), n.slideCount > n.options.slidesToShow))
            ) {
              for (
                i =
                  !0 === n.options.centerMode
                    ? n.options.slidesToShow + 1
                    : n.options.slidesToShow,
                  e = n.slideCount;
                e > n.slideCount - i;
                --e
              )
                (t = e - 1),
                  d(n.$slides[t])
                    .clone(!0)
                    .attr("id", "")
                    .attr("data-slick-index", t - n.slideCount)
                    .prependTo(n.$slideTrack)
                    .addClass("slick-cloned");
              for (e = 0; e < i; e += 1)
                (t = e),
                  d(n.$slides[t])
                    .clone(!0)
                    .attr("id", "")
                    .attr("data-slick-index", t + n.slideCount)
                    .appendTo(n.$slideTrack)
                    .addClass("slick-cloned");
              n.$slideTrack
                .find(".slick-cloned")
                .find("[id]")
                .each(function () {
                  d(this).attr("id", "");
                });
            }
          }),
          (r.prototype.interrupt = function (e) {
            e || this.autoPlay(), (this.interrupted = e);
          }),
          (r.prototype.selectHandler = function (e) {
            var t = d(e.target).is(".slick-slide")
                ? d(e.target)
                : d(e.target).parents(".slick-slide"),
              i = parseInt(t.attr("data-slick-index"));
            return (
              (i = i || 0),
              this.slideCount <= this.options.slidesToShow
                ? (this.setSlideClasses(i), void this.asNavFor(i))
                : void this.slideHandler(i)
            );
          }),
          (r.prototype.slideHandler = function (e, t, i) {
            var n,
              s,
              r,
              o,
              a,
              l = null,
              d = this;
            return (
              (t = t || !1),
              (!0 === d.animating && !0 === d.options.waitForAnimate) ||
              (!0 === d.options.fade && d.currentSlide === e) ||
              d.slideCount <= d.options.slidesToShow
                ? void 0
                : (!1 === t && d.asNavFor(e),
                  (n = e),
                  (l = d.getLeft(n)),
                  (o = d.getLeft(d.currentSlide)),
                  (d.currentLeft = null === d.swipeLeft ? o : d.swipeLeft),
                  (!1 === d.options.infinite &&
                    !1 === d.options.centerMode &&
                    (e < 0 ||
                      e > d.getDotCount() * d.options.slidesToScroll)) ||
                  (!1 === d.options.infinite &&
                    !0 === d.options.centerMode &&
                    (e < 0 || e > d.slideCount - d.options.slidesToScroll))
                    ? void (
                        !1 === d.options.fade &&
                        ((n = d.currentSlide),
                        !0 !== i
                          ? d.animateSlide(o, function () {
                              d.postSlide(n);
                            })
                          : d.postSlide(n))
                      )
                    : (d.options.autoplay && clearInterval(d.autoPlayTimer),
                      (s =
                        n < 0
                          ? d.slideCount % d.options.slidesToScroll != 0
                            ? d.slideCount -
                              (d.slideCount % d.options.slidesToScroll)
                            : d.slideCount + n
                          : n >= d.slideCount
                          ? d.slideCount % d.options.slidesToScroll != 0
                            ? 0
                            : n - d.slideCount
                          : n),
                      (d.animating = !0),
                      d.$slider.trigger("beforeChange", [d, d.currentSlide, s]),
                      (r = d.currentSlide),
                      (d.currentSlide = s),
                      d.setSlideClasses(d.currentSlide),
                      d.options.asNavFor &&
                        (a = (a = d.getNavTarget()).slick("getSlick"))
                          .slideCount <= a.options.slidesToShow &&
                        a.setSlideClasses(d.currentSlide),
                      d.updateDots(),
                      d.updateArrows(),
                      !0 === d.options.fade
                        ? (!0 !== i
                            ? (d.fadeSlideOut(r),
                              d.fadeSlide(s, function () {
                                d.postSlide(s);
                              }))
                            : d.postSlide(s),
                          void d.animateHeight())
                        : void (!0 !== i
                            ? d.animateSlide(l, function () {
                                d.postSlide(s);
                              })
                            : d.postSlide(s))))
            );
          }),
          (r.prototype.startLoad = function () {
            var e = this;
            !0 === e.options.arrows &&
              e.slideCount > e.options.slidesToShow &&
              (e.$prevArrow.hide(), e.$nextArrow.hide()),
              !0 === e.options.dots &&
                e.slideCount > e.options.slidesToShow &&
                e.$dots.hide(),
              e.$slider.addClass("slick-loading");
          }),
          (r.prototype.swipeDirection = function () {
            var e, t, i, n;
            return (
              (e = this.touchObject.startX - this.touchObject.curX),
              (t = this.touchObject.startY - this.touchObject.curY),
              (i = Math.atan2(t, e)),
              (n = Math.round((180 * i) / Math.PI)) < 0 &&
                (n = 360 - Math.abs(n)),
              (n <= 45 && 0 <= n) || (n <= 360 && 315 <= n)
                ? !1 === this.options.rtl
                  ? "left"
                  : "right"
                : 135 <= n && n <= 225
                ? !1 === this.options.rtl
                  ? "right"
                  : "left"
                : !0 === this.options.verticalSwiping
                ? 35 <= n && n <= 135
                  ? "down"
                  : "up"
                : "vertical"
            );
          }),
          (r.prototype.swipeEnd = function (e) {
            var t,
              i,
              n = this;
            if (
              ((n.dragging = !1),
              (n.interrupted = !1),
              (n.shouldClick = !(10 < n.touchObject.swipeLength)),
              void 0 === n.touchObject.curX)
            )
              return !1;
            if (
              (!0 === n.touchObject.edgeHit &&
                n.$slider.trigger("edge", [n, n.swipeDirection()]),
              n.touchObject.swipeLength >= n.touchObject.minSwipe)
            ) {
              switch ((i = n.swipeDirection())) {
                case "left":
                case "down":
                  (t = n.options.swipeToSlide
                    ? n.checkNavigable(n.currentSlide + n.getSlideCount())
                    : n.currentSlide + n.getSlideCount()),
                    (n.currentDirection = 0);
                  break;
                case "right":
                case "up":
                  (t = n.options.swipeToSlide
                    ? n.checkNavigable(n.currentSlide - n.getSlideCount())
                    : n.currentSlide - n.getSlideCount()),
                    (n.currentDirection = 1);
              }
              "vertical" != i &&
                (n.slideHandler(t),
                (n.touchObject = {}),
                n.$slider.trigger("swipe", [n, i]));
            } else
              n.touchObject.startX !== n.touchObject.curX &&
                (n.slideHandler(n.currentSlide), (n.touchObject = {}));
          }),
          (r.prototype.swipeHandler = function (e) {
            var t = this;
            if (
              !(
                !1 === t.options.swipe ||
                ("ontouchend" in document && !1 === t.options.swipe) ||
                (!1 === t.options.draggable && -1 !== e.type.indexOf("mouse"))
              )
            )
              switch (
                ((t.touchObject.fingerCount =
                  e.originalEvent && void 0 !== e.originalEvent.touches
                    ? e.originalEvent.touches.length
                    : 1),
                (t.touchObject.minSwipe =
                  t.listWidth / t.options.touchThreshold),
                !0 === t.options.verticalSwiping &&
                  (t.touchObject.minSwipe =
                    t.listHeight / t.options.touchThreshold),
                e.data.action)
              ) {
                case "start":
                  t.swipeStart(e);
                  break;
                case "move":
                  t.swipeMove(e);
                  break;
                case "end":
                  t.swipeEnd(e);
              }
          }),
          (r.prototype.swipeMove = function (e) {
            var t,
              i,
              n,
              s,
              r,
              o = this;
            return (
              (r = void 0 !== e.originalEvent ? e.originalEvent.touches : null),
              !(!o.dragging || (r && 1 !== r.length)) &&
                ((t = o.getLeft(o.currentSlide)),
                (o.touchObject.curX = void 0 !== r ? r[0].pageX : e.clientX),
                (o.touchObject.curY = void 0 !== r ? r[0].pageY : e.clientY),
                (o.touchObject.swipeLength = Math.round(
                  Math.sqrt(
                    Math.pow(o.touchObject.curX - o.touchObject.startX, 2)
                  )
                )),
                !0 === o.options.verticalSwiping &&
                  (o.touchObject.swipeLength = Math.round(
                    Math.sqrt(
                      Math.pow(o.touchObject.curY - o.touchObject.startY, 2)
                    )
                  )),
                "vertical" !== (i = o.swipeDirection())
                  ? (void 0 !== e.originalEvent &&
                      4 < o.touchObject.swipeLength &&
                      e.preventDefault(),
                    (s =
                      (!1 === o.options.rtl ? 1 : -1) *
                      (o.touchObject.curX > o.touchObject.startX ? 1 : -1)),
                    !0 === o.options.verticalSwiping &&
                      (s = o.touchObject.curY > o.touchObject.startY ? 1 : -1),
                    (n = o.touchObject.swipeLength),
                    (o.touchObject.edgeHit = !1) === o.options.infinite &&
                      ((0 === o.currentSlide && "right" === i) ||
                        (o.currentSlide >= o.getDotCount() && "left" === i)) &&
                      ((n = o.touchObject.swipeLength * o.options.edgeFriction),
                      (o.touchObject.edgeHit = !0)),
                    !1 === o.options.vertical
                      ? (o.swipeLeft = t + n * s)
                      : (o.swipeLeft =
                          t + n * (o.$list.height() / o.listWidth) * s),
                    !0 === o.options.verticalSwiping &&
                      (o.swipeLeft = t + n * s),
                    !0 !== o.options.fade &&
                      !1 !== o.options.touchMove &&
                      (!0 === o.animating
                        ? ((o.swipeLeft = null), !1)
                        : void o.setCSS(o.swipeLeft)))
                  : void 0)
            );
          }),
          (r.prototype.swipeStart = function (e) {
            var t,
              i = this;
            return (
              (i.interrupted = !0),
              1 !== i.touchObject.fingerCount ||
              i.slideCount <= i.options.slidesToShow
                ? !(i.touchObject = {})
                : (void 0 !== e.originalEvent &&
                    void 0 !== e.originalEvent.touches &&
                    (t = e.originalEvent.touches[0]),
                  (i.touchObject.startX = i.touchObject.curX =
                    void 0 !== t ? t.pageX : e.clientX),
                  (i.touchObject.startY = i.touchObject.curY =
                    void 0 !== t ? t.pageY : e.clientY),
                  void (i.dragging = !0))
            );
          }),
          (r.prototype.unfilterSlides = r.prototype.slickUnfilter =
            function () {
              null !== this.$slidesCache &&
                (this.unload(),
                this.$slideTrack.children(this.options.slide).detach(),
                this.$slidesCache.appendTo(this.$slideTrack),
                this.reinit());
            }),
          (r.prototype.unload = function () {
            var e = this;
            d(".slick-cloned", e.$slider).remove(),
              e.$dots && e.$dots.remove(),
              e.$prevArrow &&
                e.htmlExpr.test(e.options.prevArrow) &&
                e.$prevArrow.remove(),
              e.$nextArrow &&
                e.htmlExpr.test(e.options.nextArrow) &&
                e.$nextArrow.remove(),
              e.$slides
                .removeClass(
                  "slick-slide slick-active slick-visible slick-current"
                )
                .attr("aria-hidden", "true")
                .css("width", "");
          }),
          (r.prototype.unslick = function (e) {
            this.$slider.trigger("unslick", [this, e]), this.destroy();
          }),
          (r.prototype.updateArrows = function () {
            var e = this;
            Math.floor(e.options.slidesToShow / 2),
              !0 === e.options.arrows &&
                e.slideCount > e.options.slidesToShow &&
                !e.options.infinite &&
                (e.$prevArrow
                  .removeClass("slick-disabled")
                  .attr("aria-disabled", "false"),
                e.$nextArrow
                  .removeClass("slick-disabled")
                  .attr("aria-disabled", "false"),
                0 === e.currentSlide
                  ? (e.$prevArrow
                      .addClass("slick-disabled")
                      .attr("aria-disabled", "true"),
                    e.$nextArrow
                      .removeClass("slick-disabled")
                      .attr("aria-disabled", "false"))
                  : ((e.currentSlide >= e.slideCount - e.options.slidesToShow &&
                      !1 === e.options.centerMode) ||
                      (e.currentSlide >= e.slideCount - 1 &&
                        !0 === e.options.centerMode)) &&
                    (e.$nextArrow
                      .addClass("slick-disabled")
                      .attr("aria-disabled", "true"),
                    e.$prevArrow
                      .removeClass("slick-disabled")
                      .attr("aria-disabled", "false")));
          }),
          (r.prototype.updateDots = function () {
            null !== this.$dots &&
              (this.$dots
                .find("li")
                .removeClass("slick-active")
                .attr("aria-hidden", "true"),
              this.$dots
                .find("li")
                .eq(Math.floor(this.currentSlide / this.options.slidesToScroll))
                .addClass("slick-active")
                .attr("aria-hidden", "false"));
          }),
          (r.prototype.visibility = function () {
            this.options.autoplay &&
              (document[this.hidden]
                ? (this.interrupted = !0)
                : (this.interrupted = !1));
          }),
          (d.fn.slick = function () {
            var e,
              t,
              i = arguments[0],
              n = Array.prototype.slice.call(arguments, 1),
              s = this.length;
            for (e = 0; e < s; e++)
              if (
                ("object" == _typeof(i) || void 0 === i
                  ? (this[e].slick = new r(this[e], i))
                  : (t = this[e].slick[i].apply(this[e].slick, n)),
                void 0 !== t)
              )
                return t;
            return this;
          });
      }),
      (b = jQuery),
      (w = document),
      (x = window),
      (re = {
        html: !1,
        photo: !1,
        iframe: !1,
        inline: !1,
        transition: "elastic",
        speed: 300,
        fadeOut: 300,
        width: !1,
        initialWidth: "600",
        innerWidth: !1,
        maxWidth: !1,
        height: !1,
        initialHeight: "450",
        innerHeight: !1,
        maxHeight: !1,
        scalePhotos: !0,
        scrolling: !0,
        opacity: 0.9,
        preloading: !0,
        className: !1,
        overlayClose: !0,
        escKey: !0,
        arrowKey: !0,
        top: !1,
        bottom: !1,
        left: !1,
        right: !1,
        fixed: !1,
        data: void 0,
        closeButton: !0,
        fastIframe: !0,
        open: !1,
        reposition: !0,
        loop: !0,
        slideshow: !1,
        slideshowAuto: !0,
        slideshowSpeed: 2500,
        slideshowStart: "start slideshow",
        slideshowStop: "stop slideshow",
        photoRegex: /\.(gif|png|jp(e|g|eg)|bmp|ico|webp|jxr|svg)((#|\?).*)?$/i,
        retinaImage: !1,
        retinaUrl: !1,
        retinaSuffix: "@2x.$1",
        current: "image {current} of {total}",
        previous: "previous",
        next: "next",
        close: "close",
        xhrError: "This content failed to load.",
        imgError: "This image failed to load.",
        returnFocus: !0,
        trapFocus: !0,
        onOpen: !1,
        onLoad: !1,
        onComplete: !1,
        onCleanup: !1,
        onClosed: !1,
        rel: function () {
          return this.rel;
        },
        href: function () {
          return b(this).attr("href");
        },
        title: function () {
          return this.title;
        },
        createImg: function () {
          var i = new Image(),
            e = b(this).data("cbox-img-attrs");
          return (
            "object" == _typeof(e) &&
              b.each(e, function (e, t) {
                i[e] = t;
              }),
            i
          );
        },
        createIframe: function () {
          var i = w.createElement("iframe"),
            e = b(this).data("cbox-iframe-attrs");
          return (
            "object" == _typeof(e) &&
              b.each(e, function (e, t) {
                i[e] = t;
              }),
            "frameBorder" in i && (i.frameBorder = 0),
            "allowTransparency" in i && (i.allowTransparency = "true"),
            (i.name = new Date().getTime()),
            (i.allowFullscreen = !0),
            i
          );
        },
      }),
      (oe = "colorbox"),
      (le = (ae = "cbox") + "Element"),
      (de = ae + "_open"),
      (ce = ae + "_load"),
      (ue = ae + "_complete"),
      (pe = ae + "_cleanup"),
      (he = ae + "_closed"),
      (fe = ae + "_purge"),
      (me = b("<a/>")),
      (ge = "div"),
      (ve = 0),
      (ye = {}),
      (ne = ae + "Slideshow_"),
      (se = "click." + ae),
      (be = function () {
        te
          ? F.get("slideshow") || (me.unbind(pe, Xe), Xe())
          : F.get("slideshow") &&
            M[1] &&
            ((te = !0),
            me.one(pe, Xe),
            (F.get("slideshowAuto") ? We : Ge)(),
            N.show());
      }),
      b[oe] ||
        (b(qe),
        ((J =
          b.fn[oe] =
          b[oe] =
            function (t, e) {
              var i = this;
              return (
                (t = t || {}),
                b.isFunction(i) && ((i = b("<a/>")), (t.open = !0)),
                i[0] &&
                  (qe(),
                  S &&
                    (ee ||
                      ((ee = !0),
                      H.click(function () {
                        J.next();
                      }),
                      j.click(function () {
                        J.prev();
                      }),
                      R.click(function () {
                        J.close();
                      }),
                      T.click(function () {
                        F.get("overlayClose") && J.close();
                      }),
                      b(w).bind("keydown." + ae, function (e) {
                        var t = e.keyCode;
                        V &&
                          F.get("escKey") &&
                          27 === t &&
                          (e.preventDefault(), J.close()),
                          V &&
                            F.get("arrowKey") &&
                            M[1] &&
                            !e.altKey &&
                            (37 === t
                              ? (e.preventDefault(), j.click())
                              : 39 === t && (e.preventDefault(), H.click()));
                      }),
                      b.isFunction(b.fn.on)
                        ? b(w).on("click." + ae, "." + le, n)
                        : b("." + le).live("click." + ae, n)),
                    1) &&
                    (e && (t.onComplete = e),
                    i
                      .each(function () {
                        var e = b.data(this, oe) || {};
                        b.data(this, oe, b.extend(e, t));
                      })
                      .addClass(le),
                    new _e(i[0], t).get("open") && Re(i[0]))),
                i
              );
              function n(e) {
                1 < e.which ||
                  e.shiftKey ||
                  e.altKey ||
                  e.metaKey ||
                  e.ctrlKey ||
                  (e.preventDefault(), Re(this));
              }
            }).position = function (t, e) {
          function i() {
            (k[0].style.width =
              z[0].style.width =
              E[0].style.width =
                parseInt(S[0].style.width, 10) - W + "px"),
              (E[0].style.height =
                $[0].style.height =
                A[0].style.height =
                  parseInt(S[0].style.height, 10) - B + "px");
          }
          var n,
            s,
            r,
            o = 0,
            a = 0,
            l = S.offset();
          if (
            (D.unbind("resize." + ae),
            S.css({ top: -9e4, left: -9e4 }),
            (s = D.scrollTop()),
            (r = D.scrollLeft()),
            F.get("fixed")
              ? ((l.top -= s), (l.left -= r), S.css({ position: "fixed" }))
              : ((o = s), (a = r), S.css({ position: "absolute" })),
            (a +=
              !1 !== F.get("right")
                ? Math.max(D.width() - F.w - X - W - Le(F.get("right"), "x"), 0)
                : !1 !== F.get("left")
                ? Le(F.get("left"), "x")
                : Math.round(Math.max(D.width() - F.w - X - W, 0) / 2)),
            (o +=
              !1 !== F.get("bottom")
                ? Math.max(De() - F.h - G - B - Le(F.get("bottom"), "y"), 0)
                : !1 !== F.get("top")
                ? Le(F.get("top"), "y")
                : Math.round(Math.max(De() - F.h - G - B, 0) / 2)),
            S.css({ top: l.top, left: l.left, visibility: "visible" }),
            (C[0].style.width = C[0].style.height = "9999px"),
            (n = { width: F.w + X + W, height: F.h + G + B, top: o, left: a }),
            t)
          ) {
            var d = 0;
            b.each(n, function (e) {
              return n[e] !== ye[e] ? void (d = t) : void 0;
            }),
              (t = d);
          }
          (ye = n),
            t || S.css(n),
            S.dequeue().animate(n, {
              duration: t || 0,
              complete: function () {
                i(),
                  (K = !1),
                  (C[0].style.width = F.w + X + W + "px"),
                  (C[0].style.height = F.h + G + B + "px"),
                  F.get("reposition") &&
                    setTimeout(function () {
                      D.bind("resize." + ae, J.position);
                    }, 1),
                  b.isFunction(e) && e();
              },
              step: i,
            });
        }),
        (J.resize = function (e) {
          var t;
          V &&
            ((e = e || {}).width && (F.w = Le(e.width, "x") - X - W),
            e.innerWidth && (F.w = Le(e.innerWidth, "x")),
            _.css({ width: F.w }),
            e.height && (F.h = Le(e.height, "y") - G - B),
            e.innerHeight && (F.h = Le(e.innerHeight, "y")),
            e.innerHeight ||
              e.height ||
              ((t = _.scrollTop()),
              _.css({ height: "auto" }),
              (F.h = _.height())),
            _.css({ height: F.h }),
            t && _.scrollTop(t),
            J.position("none" === F.get("transition") ? 0 : F.get("speed")));
        }),
        (J.prep = function (e) {
          if (V) {
            var t,
              s = "none" === F.get("transition") ? 0 : F.get("speed");
            _.remove(),
              (_ = Me(ge, "LoadedContent").append(e))
                .hide()
                .appendTo(P.show())
                .css({
                  width:
                    ((F.w = F.w || _.width()),
                    (F.w = F.mw && F.mw < F.w ? F.mw : F.w),
                    F.w),
                  overflow: F.get("scrolling") ? "auto" : "hidden",
                })
                .css({
                  height:
                    ((F.h = F.h || _.height()),
                    (F.h = F.mh && F.mh < F.h ? F.mh : F.h),
                    F.h),
                })
                .prependTo(E),
              P.hide(),
              b(U).css({ float: "none" }),
              He(F.get("className")),
              (t = function () {
                function e() {
                  !1 === b.support.opacity &&
                    S[0].style.removeAttribute("filter");
                }
                var t,
                  i,
                  n = M.length;
                V &&
                  ((i = function () {
                    clearTimeout(Q), L.hide(), je(ue), F.get("onComplete");
                  }),
                  O.html(F.get("title")).show(),
                  _.show(),
                  1 < n
                    ? ("string" == typeof F.get("current") &&
                        I.html(
                          F.get("current")
                            .replace("{current}", Y + 1)
                            .replace("{total}", n)
                        ).show(),
                      H[F.get("loop") || Y < n - 1 ? "show" : "hide"]().html(
                        F.get("next")
                      ),
                      j[F.get("loop") || Y ? "show" : "hide"]().html(
                        F.get("previous")
                      ),
                      be(),
                      F.get("preloading") &&
                        b.each([Pe(-1), Pe(1)], function () {
                          var e = M[this],
                            t = new _e(e, b.data(e, oe)),
                            i = t.get("href");
                          i &&
                            Oe(t, i) &&
                            ((i = Ie(t, i)), (w.createElement("img").src = i));
                        }))
                    : q.hide(),
                  F.get("iframe")
                    ? ((t = F.get("createIframe")),
                      F.get("scrolling") || (t.scrolling = "no"),
                      b(t)
                        .attr({ src: F.get("href"), class: ae + "Iframe" })
                        .one("load", i)
                        .appendTo(_),
                      me.one(fe, function () {
                        t.src = "//about:blank";
                      }),
                      F.get("fastIframe") && b(t).trigger("load"))
                    : i(),
                  "fade" === F.get("transition") ? S.fadeTo(s, 1, e) : e());
              }),
              "fade" === F.get("transition")
                ? S.fadeTo(s, 0, function () {
                    J.position(0, t);
                  })
                : J.position(s, t);
          }
        }),
        (J.next = function () {
          !K && M[1] && (F.get("loop") || M[Y + 1]) && ((Y = Pe(1)), Re(M[Y]));
        }),
        (J.prev = function () {
          !K && M[1] && (F.get("loop") || Y) && ((Y = Pe(-1)), Re(M[Y]));
        }),
        (J.close = function () {
          V &&
            !Z &&
            ((V = !(Z = !0)),
            je(pe),
            F.get("onCleanup"),
            D.unbind("." + ae),
            T.fadeTo(F.get("fadeOut") || 0, 0),
            S.stop().fadeTo(F.get("fadeOut") || 0, 0, function () {
              S.hide(),
                T.hide(),
                je(fe),
                _.remove(),
                setTimeout(function () {
                  (Z = !1), je(he), F.get("onClosed");
                }, 1);
            }));
        }),
        (J.remove = function () {
          S &&
            (S.stop(),
            b[oe].close(),
            S.stop(!1, !0).remove(),
            T.remove(),
            (Z = !1),
            (S = null),
            b("." + le)
              .removeData(oe)
              .removeClass(le),
            b(w)
              .unbind("click." + ae)
              .unbind("keydown." + ae));
        }),
        (J.element = function () {
          return b(F.el);
        }),
        (J.settings = re)),
      (function () {
        for (
          var e = [
              { base: "A", letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ" },
              { base: "AA", letters: "Ꜳ" },
              { base: "AE", letters: "ÆǼǢ" },
              { base: "AO", letters: "Ꜵ" },
              { base: "AU", letters: "Ꜷ" },
              { base: "AV", letters: "ꜸꜺ" },
              { base: "AY", letters: "Ꜽ" },
              { base: "B", letters: "BⒷＢḂḄḆɃƂƁ" },
              { base: "C", letters: "CⒸＣĆĈĊČÇḈƇȻꜾ" },
              { base: "D", letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹÐ" },
              { base: "DZ", letters: "ǱǄ" },
              { base: "Dz", letters: "ǲǅ" },
              { base: "E", letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ" },
              { base: "F", letters: "FⒻＦḞƑꝻ" },
              { base: "G", letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ" },
              { base: "H", letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ" },
              { base: "I", letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ" },
              { base: "J", letters: "JⒿＪĴɈ" },
              { base: "K", letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ" },
              { base: "L", letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ" },
              { base: "LJ", letters: "Ǉ" },
              { base: "Lj", letters: "ǈ" },
              { base: "M", letters: "MⓂＭḾṀṂⱮƜ" },
              { base: "N", letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ" },
              { base: "NJ", letters: "Ǌ" },
              { base: "Nj", letters: "ǋ" },
              {
                base: "O",
                letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ",
              },
              { base: "OI", letters: "Ƣ" },
              { base: "OO", letters: "Ꝏ" },
              { base: "OU", letters: "Ȣ" },
              { base: "OE", letters: "Œ" },
              { base: "oe", letters: "œ" },
              { base: "P", letters: "PⓅＰṔṖƤⱣꝐꝒꝔ" },
              { base: "Q", letters: "QⓆＱꝖꝘɊ" },
              { base: "R", letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ" },
              { base: "S", letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ" },
              { base: "T", letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ" },
              { base: "TZ", letters: "Ꜩ" },
              { base: "U", letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ" },
              { base: "V", letters: "VⓋＶṼṾƲꝞɅ" },
              { base: "VY", letters: "Ꝡ" },
              { base: "W", letters: "WⓌＷẀẂŴẆẄẈⱲ" },
              { base: "X", letters: "XⓍＸẊẌ" },
              { base: "Y", letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ" },
              { base: "Z", letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ" },
              { base: "a", letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ" },
              { base: "aa", letters: "ꜳ" },
              { base: "ae", letters: "æǽǣ" },
              { base: "ao", letters: "ꜵ" },
              { base: "au", letters: "ꜷ" },
              { base: "av", letters: "ꜹꜻ" },
              { base: "ay", letters: "ꜽ" },
              { base: "b", letters: "bⓑｂḃḅḇƀƃɓ" },
              { base: "c", letters: "cⓒｃćĉċčçḉƈȼꜿↄ" },
              { base: "d", letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ" },
              { base: "dz", letters: "ǳǆ" },
              { base: "e", letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ" },
              { base: "f", letters: "fⓕｆḟƒꝼ" },
              { base: "g", letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ" },
              { base: "h", letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ" },
              { base: "hv", letters: "ƕ" },
              { base: "i", letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı" },
              { base: "j", letters: "jⓙｊĵǰɉ" },
              { base: "k", letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ" },
              { base: "l", letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ" },
              { base: "lj", letters: "ǉ" },
              { base: "m", letters: "mⓜｍḿṁṃɱɯ" },
              { base: "n", letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ" },
              { base: "nj", letters: "ǌ" },
              {
                base: "o",
                letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ",
              },
              { base: "oi", letters: "ƣ" },
              { base: "ou", letters: "ȣ" },
              { base: "oo", letters: "ꝏ" },
              { base: "p", letters: "pⓟｐṕṗƥᵽꝑꝓꝕ" },
              { base: "q", letters: "qⓠｑɋꝗꝙ" },
              { base: "r", letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ" },
              { base: "s", letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ" },
              { base: "t", letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ" },
              { base: "tz", letters: "ꜩ" },
              { base: "u", letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ" },
              { base: "v", letters: "vⓥｖṽṿʋꝟʌ" },
              { base: "vy", letters: "ꝡ" },
              { base: "w", letters: "wⓦｗẁẃŵẇẅẘẉⱳ" },
              { base: "x", letters: "xⓧｘẋẍ" },
              { base: "y", letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ" },
              { base: "z", letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ" },
            ],
            t = {},
            i = 0;
          i < e.length;
          i++
        )
          for (var n = e[i].letters, s = 0; s < n.length; s++)
            t[n[s]] = e[i].base;
        window.removeDiacritics = function (e) {
          return "string" != typeof e
            ? (console.warn(
                "Invalid parameter passed to window.removeDiacritics (".concat(
                  _typeof(e),
                  ")"
                ),
                e
              ),
              e)
            : e.replace(/[^\u0000-\u007E]/g, function (e) {
                return t[e] || e;
              });
        };
      })(),
      (we = function (u) {
        var e = (function () {
            if (u && u.fn && u.fn.select2 && u.fn.select2.amd)
              var e = u.fn.select2.amd;
            var t, i, n, h, r, o, f, m, g, v, y, b, s, a, w, l;
            function x(e, t) {
              return s.call(e, t);
            }
            function d(e, t) {
              var i,
                n,
                s,
                r,
                o,
                a,
                l,
                d,
                c,
                u,
                p,
                h = t && t.split("/"),
                f = y.map,
                m = (f && f["*"]) || {};
              if (e) {
                for (
                  o = (e = e.split("/")).length - 1,
                    y.nodeIdCompat &&
                      w.test(e[o]) &&
                      (e[o] = e[o].replace(w, "")),
                    "." === e[0].charAt(0) &&
                      h &&
                      (e = h.slice(0, h.length - 1).concat(e)),
                    c = 0;
                  c < e.length;
                  c++
                )
                  if ("." === (p = e[c])) e.splice(c, 1), --c;
                  else if (".." === p) {
                    if (
                      0 === c ||
                      (1 === c && ".." === e[2]) ||
                      ".." === e[c - 1]
                    )
                      continue;
                    0 < c && (e.splice(c - 1, 2), (c -= 2));
                  }
                e = e.join("/");
              }
              if ((h || m) && f) {
                for (c = (i = e.split("/")).length; 0 < c; --c) {
                  if (((n = i.slice(0, c).join("/")), h))
                    for (u = h.length; 0 < u; --u)
                      if ((s = (s = f[h.slice(0, u).join("/")]) && s[n])) {
                        (r = s), (a = c);
                        break;
                      }
                  if (r) break;
                  !l && m && m[n] && ((l = m[n]), (d = c));
                }
                !r && l && ((r = l), (a = d)),
                  r && (i.splice(0, a, r), (e = i.join("/")));
              }
              return e;
            }
            function T(t, i) {
              return function () {
                var e = a.call(arguments, 0);
                return (
                  "string" != typeof e[0] && 1 === e.length && e.push(null),
                  o.apply(h, e.concat([t, i]))
                );
              };
            }
            function S(t) {
              return function (e) {
                g[t] = e;
              };
            }
            function C(e) {
              if (x(v, e)) {
                var t = v[e];
                delete v[e], (b[e] = !0), r.apply(h, t);
              }
              if (!x(g, e) && !x(b, e)) throw new Error("No " + e);
              return g[e];
            }
            function c(e) {
              var t,
                i = e ? e.indexOf("!") : -1;
              return (
                -1 < i &&
                  ((t = e.substring(0, i)), (e = e.substring(i + 1, e.length))),
                [t, e]
              );
            }
            function E(e) {
              return e ? c(e) : [];
            }
            return (
              (e && e.requirejs) ||
                (e ? (i = e) : (e = {}),
                (g = {}),
                (v = {}),
                (y = {}),
                (b = {}),
                (s = Object.prototype.hasOwnProperty),
                (a = [].slice),
                (w = /\.js$/),
                (f = function (e, t) {
                  var i,
                    n,
                    s = c(e),
                    r = s[0],
                    o = t[1];
                  return (
                    (e = s[1]),
                    r && (i = C((r = d(r, o)))),
                    r
                      ? (e =
                          i && i.normalize
                            ? i.normalize(
                                e,
                                ((n = o),
                                function (e) {
                                  return d(e, n);
                                })
                              )
                            : d(e, o))
                      : ((r = (s = c((e = d(e, o))))[0]),
                        (e = s[1]),
                        r && (i = C(r))),
                    { f: r ? r + "!" + e : e, n: e, pr: r, p: i }
                  );
                }),
                (m = {
                  require: function (e) {
                    return T(e);
                  },
                  exports: function (e) {
                    var t = g[e];
                    return void 0 !== t ? t : (g[e] = {});
                  },
                  module: function (e) {
                    return {
                      id: e,
                      uri: "",
                      exports: g[e],
                      config:
                        ((t = e),
                        function () {
                          return (y && y.config && y.config[t]) || {};
                        }),
                    };
                    var t;
                  },
                }),
                (r = function (e, t, i, n) {
                  var s,
                    r,
                    o,
                    a,
                    l,
                    d,
                    c,
                    u = [],
                    p = _typeof(i);
                  if (
                    ((d = E((n = n || e))), "undefined" == p || "function" == p)
                  ) {
                    for (
                      t =
                        !t.length && i.length
                          ? ["require", "exports", "module"]
                          : t,
                        l = 0;
                      l < t.length;
                      l += 1
                    )
                      if ("require" === (r = (a = f(t[l], d)).f))
                        u[l] = m.require(e);
                      else if ("exports" === r) (u[l] = m.exports(e)), (c = !0);
                      else if ("module" === r) s = u[l] = m.module(e);
                      else if (x(g, r) || x(v, r) || x(b, r)) u[l] = C(r);
                      else {
                        if (!a.p) throw new Error(e + " missing " + r);
                        a.p.load(a.n, T(n, !0), S(r), {}), (u[l] = g[r]);
                      }
                    (o = i ? i.apply(g[e], u) : void 0),
                      e &&
                        (s && s.exports !== h && s.exports !== g[e]
                          ? (g[e] = s.exports)
                          : (o === h && c) || (g[e] = o));
                  } else e && (g[e] = i);
                }),
                (t =
                  i =
                  o =
                    function (e, t, i, n, s) {
                      if ("string" == typeof e)
                        return m[e] ? m[e](t) : C(f(e, E(t)).f);
                      if (!e.splice) {
                        if (((y = e).deps && o(y.deps, y.callback), !t)) return;
                        t.splice ? ((e = t), (t = i), (i = null)) : (e = h);
                      }
                      return (
                        (t = t || function () {}),
                        "function" == typeof i && ((i = n), (n = s)),
                        n
                          ? r(h, e, t, i)
                          : setTimeout(function () {
                              r(h, e, t, i);
                            }, 4),
                        o
                      );
                    }),
                (o.config = function (e) {
                  return o(e);
                }),
                (t._defined = g),
                ((n = function (e, t, i) {
                  if ("string" != typeof e)
                    throw new Error(
                      "See almond README: incorrect module build, no module name"
                    );
                  t.splice || ((i = t), (t = [])),
                    x(g, e) || x(v, e) || (v[e] = [e, t, i]);
                }).amd = { jQuery: !0 }),
                (e.requirejs = t),
                (e.require = i),
                (e.define = n)),
              e.define("almond", function () {}),
              e.define("jquery", [], function () {
                var e = u || p;
                return (
                  null == e &&
                    console &&
                    console.error &&
                    console.error(
                      "Select2: An instance of jQuery or a jQuery-compatible library was not found. Make sure that you are including jQuery before Select2 on your web page."
                    ),
                  e
                );
              }),
              e.define("select2/utils", ["jquery"], function (r) {
                var s = {};
                function c(e) {
                  var t = e.prototype,
                    i = [];
                  for (var n in t)
                    "function" == typeof t[n] &&
                      "constructor" !== n &&
                      i.push(n);
                  return i;
                }
                function e() {
                  this.listeners = {};
                }
                (s.Extend = function (e, t) {
                  var i = {}.hasOwnProperty;
                  function n() {
                    this.constructor = e;
                  }
                  for (var s in t) i.call(t, s) && (e[s] = t[s]);
                  return (
                    (n.prototype = t.prototype),
                    (e.prototype = new n()),
                    (e.__super__ = t.prototype),
                    e
                  );
                }),
                  (s.Decorate = function (n, s) {
                    var e = c(s),
                      t = c(n);
                    function r() {
                      var e = Array.prototype.unshift,
                        t = s.prototype.constructor.length,
                        i = n.prototype.constructor;
                      0 < t &&
                        (e.call(arguments, n.prototype.constructor),
                        (i = s.prototype.constructor)),
                        i.apply(this, arguments);
                    }
                    (s.displayName = n.displayName),
                      (r.prototype = new (function () {
                        this.constructor = r;
                      })());
                    for (var i = 0; i < t.length; i++) {
                      var o = t[i];
                      r.prototype[o] = n.prototype[o];
                    }
                    function a(e) {
                      var t = function () {};
                      e in r.prototype && (t = r.prototype[e]);
                      var i = s.prototype[e];
                      return function () {
                        return (
                          Array.prototype.unshift.call(arguments, t),
                          i.apply(this, arguments)
                        );
                      };
                    }
                    for (var l = 0; l < e.length; l++) {
                      var d = e[l];
                      r.prototype[d] = a(d);
                    }
                    return r;
                  }),
                  (e.prototype.on = function (e, t) {
                    (this.listeners = this.listeners || {}),
                      e in this.listeners
                        ? this.listeners[e].push(t)
                        : (this.listeners[e] = [t]);
                  }),
                  (e.prototype.trigger = function (e) {
                    var t = Array.prototype.slice,
                      i = t.call(arguments, 1);
                    (this.listeners = this.listeners || {}),
                      null == i && (i = []),
                      0 === i.length && i.push({}),
                      (i[0]._type = e) in this.listeners &&
                        this.invoke(this.listeners[e], t.call(arguments, 1)),
                      "*" in this.listeners &&
                        this.invoke(this.listeners["*"], arguments);
                  }),
                  (e.prototype.invoke = function (e, t) {
                    for (var i = 0, n = e.length; i < n; i++)
                      e[i].apply(this, t);
                  }),
                  (s.Observable = e),
                  (s.generateChars = function (e) {
                    for (var t = "", i = 0; i < e; i++)
                      t += Math.floor(36 * Math.random()).toString(36);
                    return t;
                  }),
                  (s.bind = function (e, t) {
                    return function () {
                      e.apply(t, arguments);
                    };
                  }),
                  (s._convertData = function (e) {
                    for (var t in e) {
                      var i = t.split("-"),
                        n = e;
                      if (1 !== i.length) {
                        for (var s = 0; s < i.length; s++) {
                          var r = i[s];
                          (r =
                            r.substring(0, 1).toLowerCase() + r.substring(1)) in
                            n || (n[r] = {}),
                            s == i.length - 1 && (n[r] = e[t]),
                            (n = n[r]);
                        }
                        delete e[t];
                      }
                    }
                    return e;
                  }),
                  (s.hasScroll = function (e, t) {
                    var i = r(t),
                      n = t.style.overflowX,
                      s = t.style.overflowY;
                    return (
                      (n !== s || ("hidden" !== s && "visible" !== s)) &&
                      ("scroll" === n ||
                        "scroll" === s ||
                        i.innerHeight() < t.scrollHeight ||
                        i.innerWidth() < t.scrollWidth)
                    );
                  }),
                  (s.escapeMarkup = function (e) {
                    var t = {
                      "\\": "&#92;",
                      "&": "&amp;",
                      "<": "&lt;",
                      ">": "&gt;",
                      '"': "&quot;",
                      "'": "&#39;",
                      "/": "&#47;",
                    };
                    return "string" != typeof e
                      ? e
                      : String(e).replace(/[&<>"'\/\\]/g, function (e) {
                          return t[e];
                        });
                  }),
                  (s.appendMany = function (e, t) {
                    if ("1.7" === r.fn.jquery.substr(0, 3)) {
                      var i = r();
                      r.map(t, function (e) {
                        i = i.add(e);
                      }),
                        (t = i);
                    }
                    e.append(t);
                  }),
                  (s.__cache = {});
                var i = 0;
                return (
                  (s.GetUniqueElementId = function (e) {
                    var t = e.getAttribute("data-select2-id");
                    return (
                      null == t &&
                        (e.id
                          ? ((t = e.id), e.setAttribute("data-select2-id", t))
                          : (e.setAttribute("data-select2-id", ++i),
                            (t = i.toString()))),
                      t
                    );
                  }),
                  (s.StoreData = function (e, t, i) {
                    var n = s.GetUniqueElementId(e);
                    s.__cache[n] || (s.__cache[n] = {}), (s.__cache[n][t] = i);
                  }),
                  (s.GetData = function (e, t) {
                    var i = s.GetUniqueElementId(e);
                    return t
                      ? s.__cache[i] && null != s.__cache[i][t]
                        ? s.__cache[i][t]
                        : r(e).data(t)
                      : s.__cache[i];
                  }),
                  (s.RemoveData = function (e) {
                    var t = s.GetUniqueElementId(e);
                    null != s.__cache[t] && delete s.__cache[t],
                      e.removeAttribute("data-select2-id");
                  }),
                  s
                );
              }),
              e.define(
                "select2/results",
                ["jquery", "./utils"],
                function (h, f) {
                  function n(e, t, i) {
                    (this.$element = e),
                      (this.data = i),
                      (this.options = t),
                      n.__super__.constructor.call(this);
                  }
                  return (
                    f.Extend(n, f.Observable),
                    (n.prototype.render = function () {
                      var e = h(
                        '<ul class="select2-results__options" role="listbox"></ul>'
                      );
                      return (
                        this.options.get("multiple") &&
                          e.attr("aria-multiselectable", "true"),
                        (this.$results = e)
                      );
                    }),
                    (n.prototype.clear = function () {
                      this.$results.empty();
                    }),
                    (n.prototype.displayMessage = function (e) {
                      var t = this.options.get("escapeMarkup");
                      this.clear(), this.hideLoading();
                      var i = h(
                          '<li role="alert" aria-live="assertive" class="select2-results__option"></li>'
                        ),
                        n = this.options.get("translations").get(e.message);
                      i.append(t(n(e.args))),
                        (i[0].className += " select2-results__message"),
                        this.$results.append(i);
                    }),
                    (n.prototype.hideMessages = function () {
                      this.$results.find(".select2-results__message").remove();
                    }),
                    (n.prototype.append = function (e) {
                      this.hideLoading();
                      var t = [];
                      if (null != e.results && 0 !== e.results.length) {
                        e.results = this.sort(e.results);
                        for (var i = 0; i < e.results.length; i++) {
                          var n = e.results[i],
                            s = this.option(n);
                          t.push(s);
                        }
                        this.$results.append(t);
                      } else
                        0 === this.$results.children().length &&
                          this.trigger("results:message", {
                            message: "noResults",
                          });
                    }),
                    (n.prototype.position = function (e, t) {
                      t.find(".select2-results").append(e);
                    }),
                    (n.prototype.sort = function (e) {
                      return this.options.get("sorter")(e);
                    }),
                    (n.prototype.highlightFirstItem = function () {
                      var e = this.$results.find(
                          ".select2-results__option[aria-selected]"
                        ),
                        t = e.filter("[aria-selected=true]");
                      0 < t.length
                        ? t.first().trigger("mouseenter")
                        : e.first().trigger("mouseenter"),
                        this.ensureHighlightVisible();
                    }),
                    (n.prototype.setClasses = function () {
                      var t = this;
                      this.data.current(function (e) {
                        var n = h.map(e, function (e) {
                          return e.id.toString();
                        });
                        t.$results
                          .find(".select2-results__option[aria-selected]")
                          .each(function () {
                            var e = h(this),
                              t = f.GetData(this, "data"),
                              i = "" + t.id;
                            (null != t.element && t.element.selected) ||
                            (null == t.element && -1 < h.inArray(i, n))
                              ? e.attr("aria-selected", "true")
                              : e.attr("aria-selected", "false");
                          });
                      });
                    }),
                    (n.prototype.showLoading = function (e) {
                      this.hideLoading();
                      var t = {
                          disabled: !0,
                          loading: !0,
                          text: this.options
                            .get("translations")
                            .get("searching")(e),
                        },
                        i = this.option(t);
                      (i.className += " loading-results"),
                        this.$results.prepend(i);
                    }),
                    (n.prototype.hideLoading = function () {
                      this.$results.find(".loading-results").remove();
                    }),
                    (n.prototype.option = function (e) {
                      var t = document.createElement("li");
                      t.className = "select2-results__option";
                      var i = { role: "option", "aria-selected": "false" },
                        n =
                          window.Element.prototype.matches ||
                          window.Element.prototype.msMatchesSelector ||
                          window.Element.prototype.webkitMatchesSelector;
                      for (var s in (((null != e.element &&
                        n.call(e.element, ":disabled")) ||
                        (null == e.element && e.disabled)) &&
                        (delete i["aria-selected"],
                        (i["aria-disabled"] = "true")),
                      null == e.id && delete i["aria-selected"],
                      null != e._resultId && (t.id = e._resultId),
                      e.title && (t.title = e.title),
                      e.children &&
                        ((i.role = "group"),
                        (i["aria-label"] = e.text),
                        delete i["aria-selected"]),
                      i)) {
                        var r = i[s];
                        t.setAttribute(s, r);
                      }
                      if (e.children) {
                        var o = h(t),
                          a = document.createElement("strong");
                        (a.className = "select2-results__group"),
                          h(a),
                          this.template(e, a);
                        for (var l = [], d = 0; d < e.children.length; d++) {
                          var c = e.children[d],
                            u = this.option(c);
                          l.push(u);
                        }
                        var p = h("<ul></ul>", {
                          class:
                            "select2-results__options select2-results__options--nested",
                        });
                        p.append(l), o.append(a), o.append(p);
                      } else this.template(e, t);
                      return f.StoreData(t, "data", e), t;
                    }),
                    (n.prototype.bind = function (t, e) {
                      var l = this,
                        i = t.id + "-results";
                      this.$results.attr("id", i),
                        t.on("results:all", function (e) {
                          l.clear(),
                            l.append(e.data),
                            t.isOpen() &&
                              (l.setClasses(), l.highlightFirstItem());
                        }),
                        t.on("results:append", function (e) {
                          l.append(e.data), t.isOpen() && l.setClasses();
                        }),
                        t.on("query", function (e) {
                          l.hideMessages(), l.showLoading(e);
                        }),
                        t.on("select", function () {
                          t.isOpen() &&
                            (l.setClasses(),
                            l.options.get("scrollAfterSelect") &&
                              l.highlightFirstItem());
                        }),
                        t.on("unselect", function () {
                          t.isOpen() &&
                            (l.setClasses(),
                            l.options.get("scrollAfterSelect") &&
                              l.highlightFirstItem());
                        }),
                        t.on("open", function () {
                          l.$results.attr("aria-expanded", "true"),
                            l.$results.attr("aria-hidden", "false"),
                            l.setClasses(),
                            l.ensureHighlightVisible();
                        }),
                        t.on("close", function () {
                          l.$results.attr("aria-expanded", "false"),
                            l.$results.attr("aria-hidden", "true"),
                            l.$results.removeAttr("aria-activedescendant");
                        }),
                        t.on("results:toggle", function () {
                          var e = l.getHighlightedResults();
                          0 !== e.length && e.trigger("mouseup");
                        }),
                        t.on("results:select", function () {
                          var e = l.getHighlightedResults();
                          if (0 !== e.length) {
                            var t = f.GetData(e[0], "data");
                            "true" == e.attr("aria-selected")
                              ? l.trigger("close", {})
                              : l.trigger("select", { data: t });
                          }
                        }),
                        t.on("results:previous", function () {
                          var e = l.getHighlightedResults(),
                            t = l.$results.find("[aria-selected]"),
                            i = t.index(e);
                          if (!(i <= 0)) {
                            var n = i - 1;
                            0 === e.length && (n = 0);
                            var s = t.eq(n);
                            s.trigger("mouseenter");
                            var r = l.$results.offset().top,
                              o = s.offset().top,
                              a = l.$results.scrollTop() + (o - r);
                            0 === n
                              ? l.$results.scrollTop(0)
                              : o - r < 0 && l.$results.scrollTop(a);
                          }
                        }),
                        t.on("results:next", function () {
                          var e = l.getHighlightedResults(),
                            t = l.$results.find("[aria-selected]"),
                            i = t.index(e) + 1;
                          if (!(i >= t.length)) {
                            var n = t.eq(i);
                            n.trigger("mouseenter");
                            var s =
                                l.$results.offset().top +
                                l.$results.outerHeight(!1),
                              r = n.offset().top + n.outerHeight(!1),
                              o = l.$results.scrollTop() + r - s;
                            0 === i
                              ? l.$results.scrollTop(0)
                              : s < r && l.$results.scrollTop(o);
                          }
                        }),
                        t.on("results:focus", function (e) {
                          e.element.addClass(
                            "select2-results__option--highlighted"
                          );
                        }),
                        t.on("results:message", function (e) {
                          l.displayMessage(e);
                        }),
                        h.fn.mousewheel &&
                          this.$results.on("mousewheel", function (e) {
                            var t = l.$results.scrollTop(),
                              i = l.$results.get(0).scrollHeight - t + e.deltaY,
                              n = 0 < e.deltaY && t - e.deltaY <= 0,
                              s = e.deltaY < 0 && i <= l.$results.height();
                            n
                              ? (l.$results.scrollTop(0),
                                e.preventDefault(),
                                e.stopPropagation())
                              : s &&
                                (l.$results.scrollTop(
                                  l.$results.get(0).scrollHeight -
                                    l.$results.height()
                                ),
                                e.preventDefault(),
                                e.stopPropagation());
                          }),
                        this.$results.on(
                          "mouseup",
                          ".select2-results__option[aria-selected]",
                          function (e) {
                            var t = h(this),
                              i = f.GetData(this, "data");
                            "true" !== t.attr("aria-selected")
                              ? l.trigger("select", {
                                  originalEvent: e,
                                  data: i,
                                })
                              : l.options.get("multiple")
                              ? l.trigger("unselect", {
                                  originalEvent: e,
                                  data: i,
                                })
                              : l.trigger("close", {});
                          }
                        ),
                        this.$results.on(
                          "mouseenter",
                          ".select2-results__option[aria-selected]",
                          function (e) {
                            var t = f.GetData(this, "data");
                            l
                              .getHighlightedResults()
                              .removeClass(
                                "select2-results__option--highlighted"
                              ),
                              l.trigger("results:focus", {
                                data: t,
                                element: h(this),
                              });
                          }
                        );
                    }),
                    (n.prototype.getHighlightedResults = function () {
                      return this.$results.find(
                        ".select2-results__option--highlighted"
                      );
                    }),
                    (n.prototype.destroy = function () {
                      this.$results.remove();
                    }),
                    (n.prototype.ensureHighlightVisible = function () {
                      var e = this.getHighlightedResults();
                      if (0 !== e.length) {
                        var t = this.$results.find("[aria-selected]").index(e),
                          i = this.$results.offset().top,
                          n = e.offset().top,
                          s = this.$results.scrollTop() + (n - i),
                          r = n - i;
                        (s -= 2 * e.outerHeight(!1)),
                          t <= 2
                            ? this.$results.scrollTop(0)
                            : (r > this.$results.outerHeight() || r < 0) &&
                              this.$results.scrollTop(s);
                      }
                    }),
                    (n.prototype.template = function (e, t) {
                      var i = this.options.get("templateResult"),
                        n = this.options.get("escapeMarkup"),
                        s = i(e, t);
                      null == s
                        ? (t.style.display = "none")
                        : "string" == typeof s
                        ? (t.innerHTML = n(s))
                        : h(t).append(s);
                    }),
                    n
                  );
                }
              ),
              e.define("select2/keys", [], function () {
                return {
                  BACKSPACE: 8,
                  TAB: 9,
                  ENTER: 13,
                  SHIFT: 16,
                  CTRL: 17,
                  ALT: 18,
                  ESC: 27,
                  SPACE: 32,
                  PAGE_UP: 33,
                  PAGE_DOWN: 34,
                  END: 35,
                  HOME: 36,
                  LEFT: 37,
                  UP: 38,
                  RIGHT: 39,
                  DOWN: 40,
                  DELETE: 46,
                };
              }),
              e.define(
                "select2/selection/base",
                ["jquery", "../utils", "../keys"],
                function (i, n, s) {
                  function r(e, t) {
                    (this.$element = e),
                      (this.options = t),
                      r.__super__.constructor.call(this);
                  }
                  return (
                    n.Extend(r, n.Observable),
                    (r.prototype.render = function () {
                      var e = i(
                        '<span class="select2-selection" role="combobox"  aria-haspopup="true" aria-expanded="false"></span>'
                      );
                      return (
                        (this._tabindex = 0),
                        null != n.GetData(this.$element[0], "old-tabindex")
                          ? (this._tabindex = n.GetData(
                              this.$element[0],
                              "old-tabindex"
                            ))
                          : null != this.$element.attr("tabindex") &&
                            (this._tabindex = this.$element.attr("tabindex")),
                        e.attr("title", this.$element.attr("title")),
                        e.attr("tabindex", this._tabindex),
                        e.attr("aria-disabled", "false"),
                        (this.$selection = e)
                      );
                    }),
                    (r.prototype.bind = function (e, t) {
                      var i = this,
                        n = e.id + "-results";
                      (this.container = e),
                        this.$selection.on("focus", function (e) {
                          i.trigger("focus", e);
                        }),
                        this.$selection.on("blur", function (e) {
                          i._handleBlur(e);
                        }),
                        this.$selection.on("keydown", function (e) {
                          i.trigger("keypress", e),
                            e.which === s.SPACE && e.preventDefault();
                        }),
                        e.on("results:focus", function (e) {
                          i.$selection.attr(
                            "aria-activedescendant",
                            e.data._resultId
                          );
                        }),
                        e.on("selection:update", function (e) {
                          i.update(e.data);
                        }),
                        e.on("open", function () {
                          i.$selection.attr("aria-expanded", "true"),
                            i.$selection.attr("aria-owns", n),
                            i._attachCloseHandler(e);
                        }),
                        e.on("close", function () {
                          i.$selection.attr("aria-expanded", "false"),
                            i.$selection.removeAttr("aria-activedescendant"),
                            i.$selection.removeAttr("aria-owns"),
                            i.$selection.trigger("focus"),
                            i._detachCloseHandler(e);
                        }),
                        e.on("enable", function () {
                          i.$selection.attr("tabindex", i._tabindex),
                            i.$selection.attr("aria-disabled", "false");
                        }),
                        e.on("disable", function () {
                          i.$selection.attr("tabindex", "-1"),
                            i.$selection.attr("aria-disabled", "true");
                        });
                    }),
                    (r.prototype._handleBlur = function (e) {
                      var t = this;
                      window.setTimeout(function () {
                        document.activeElement == t.$selection[0] ||
                          i.contains(t.$selection[0], document.activeElement) ||
                          t.trigger("blur", e);
                      }, 1);
                    }),
                    (r.prototype._attachCloseHandler = function (e) {
                      i(document.body).on(
                        "mousedown.select2." + e.id,
                        function (e) {
                          var t = i(e.target).closest(".select2");
                          i(".select2.select2-container--open").each(
                            function () {
                              this != t[0] &&
                                n.GetData(this, "element").select2("close");
                            }
                          );
                        }
                      );
                    }),
                    (r.prototype._detachCloseHandler = function (e) {
                      i(document.body).off("mousedown.select2." + e.id);
                    }),
                    (r.prototype.position = function (e, t) {
                      t.find(".selection").append(e);
                    }),
                    (r.prototype.destroy = function () {
                      this._detachCloseHandler(this.container);
                    }),
                    (r.prototype.update = function (e) {
                      throw new Error(
                        "The `update` method must be defined in child classes."
                      );
                    }),
                    r
                  );
                }
              ),
              e.define(
                "select2/selection/single",
                ["jquery", "./base", "../utils", "../keys"],
                function (e, t, i, n) {
                  function s() {
                    s.__super__.constructor.apply(this, arguments);
                  }
                  return (
                    i.Extend(s, t),
                    (s.prototype.render = function () {
                      var e = s.__super__.render.call(this);
                      return (
                        e.addClass("select2-selection--single"),
                        e.html(
                          '<span class="select2-selection__rendered"></span><span class="select2-selection__arrow " role="presentation"><b role="presentation"></b></span>'
                        ),
                        e
                      );
                    }),
                    (s.prototype.bind = function (t, e) {
                      var i = this;
                      s.__super__.bind.apply(this, arguments);
                      var n = t.id + "-container";
                      this.$selection
                        .find(".select2-selection__rendered")
                        .attr("id", n)
                        .attr("role", "textbox")
                        .attr("aria-readonly", "true"),
                        this.$selection.attr("aria-labelledby", n),
                        this.$selection.on("mousedown", function (e) {
                          1 === e.which &&
                            i.trigger("toggle", { originalEvent: e });
                        }),
                        this.$selection.on("focus", function (e) {}),
                        this.$selection.on("blur", function (e) {}),
                        t.on("focus", function (e) {
                          t.isOpen() || i.$selection.trigger("focus");
                        });
                    }),
                    (s.prototype.clear = function () {
                      var e = this.$selection.find(
                        ".select2-selection__rendered"
                      );
                      e.empty(), e.removeAttr("title");
                    }),
                    (s.prototype.display = function (e, t) {
                      var i = this.options.get("templateSelection");
                      return this.options.get("escapeMarkup")(i(e, t));
                    }),
                    (s.prototype.selectionContainer = function () {
                      return e("<span></span>");
                    }),
                    (s.prototype.update = function (e) {
                      if (0 !== e.length) {
                        var t = e[0],
                          i = this.$selection.find(
                            ".select2-selection__rendered"
                          ),
                          n = this.display(t, i);
                        i.empty().append(n);
                        var s = t.title || t.text;
                        s ? i.attr("title", s) : i.removeAttr("title");
                      } else this.clear();
                    }),
                    s
                  );
                }
              ),
              e.define(
                "select2/selection/multiple",
                ["jquery", "./base", "../utils"],
                function (s, e, l) {
                  function i(e, t) {
                    i.__super__.constructor.apply(this, arguments);
                  }
                  return (
                    l.Extend(i, e),
                    (i.prototype.render = function () {
                      var e = i.__super__.render.call(this);
                      return (
                        e.addClass("select2-selection--multiple"),
                        e.html('<ul class="select2-selection__rendered"></ul>'),
                        e
                      );
                    }),
                    (i.prototype.bind = function (e, t) {
                      var n = this;
                      i.__super__.bind.apply(this, arguments),
                        this.$selection.on("click", function (e) {
                          n.trigger("toggle", { originalEvent: e });
                        }),
                        this.$selection.on(
                          "click",
                          ".select2-selection__choice__remove",
                          function (e) {
                            if (!n.options.get("disabled")) {
                              var t = s(this).parent(),
                                i = l.GetData(t[0], "data");
                              n.trigger("unselect", {
                                originalEvent: e,
                                data: i,
                              });
                            }
                          }
                        );
                    }),
                    (i.prototype.clear = function () {
                      var e = this.$selection.find(
                        ".select2-selection__rendered"
                      );
                      e.empty(), e.removeAttr("title");
                    }),
                    (i.prototype.display = function (e, t) {
                      var i = this.options.get("templateSelection");
                      return this.options.get("escapeMarkup")(i(e, t));
                    }),
                    (i.prototype.selectionContainer = function () {
                      return s(
                        '<li class="select2-selection__choice"><span class="select2-selection__choice__remove" role="presentation">&times;</span></li>'
                      );
                    }),
                    (i.prototype.update = function (e) {
                      if ((this.clear(), 0 !== e.length)) {
                        for (var t = [], i = 0; i < e.length; i++) {
                          var n = e[i],
                            s = this.selectionContainer(),
                            r = this.display(n, s);
                          s.append(r);
                          var o = n.title || n.text;
                          o && s.attr("title", o),
                            l.StoreData(s[0], "data", n),
                            t.push(s);
                        }
                        var a = this.$selection.find(
                          ".select2-selection__rendered"
                        );
                        l.appendMany(a, t);
                      }
                    }),
                    i
                  );
                }
              ),
              e.define(
                "select2/selection/placeholder",
                ["../utils"],
                function (e) {
                  function t(e, t, i) {
                    (this.placeholder = this.normalizePlaceholder(
                      i.get("placeholder")
                    )),
                      e.call(this, t, i);
                  }
                  return (
                    (t.prototype.normalizePlaceholder = function (e, t) {
                      return (
                        "string" == typeof t && (t = { id: "", text: t }), t
                      );
                    }),
                    (t.prototype.createPlaceholder = function (e, t) {
                      var i = this.selectionContainer();
                      return (
                        i.html(this.display(t)),
                        i
                          .addClass("select2-selection__placeholder")
                          .removeClass("select2-selection__choice"),
                        i
                      );
                    }),
                    (t.prototype.update = function (e, t) {
                      var i = 1 == t.length && t[0].id != this.placeholder.id;
                      if (1 < t.length || i) return e.call(this, t);
                      this.clear();
                      var n = this.createPlaceholder(this.placeholder);
                      this.$selection
                        .find(".select2-selection__rendered")
                        .append(n);
                    }),
                    t
                  );
                }
              ),
              e.define(
                "select2/selection/allowClear",
                ["jquery", "../keys", "../utils"],
                function (s, n, a) {
                  function e() {}
                  return (
                    (e.prototype.bind = function (e, t, i) {
                      var n = this;
                      e.call(this, t, i),
                        null == this.placeholder &&
                          this.options.get("debug") &&
                          window.console &&
                          console.error &&
                          console.error(
                            "Select2: The `allowClear` option should be used in combination with the `placeholder` option."
                          ),
                        this.$selection.on(
                          "mousedown",
                          ".select2-selection__clear",
                          function (e) {
                            n._handleClear(e);
                          }
                        ),
                        t.on("keypress", function (e) {
                          n._handleKeyboardClear(e, t);
                        });
                    }),
                    (e.prototype._handleClear = function (e, t) {
                      if (!this.options.get("disabled")) {
                        var i = this.$selection.find(
                          ".select2-selection__clear"
                        );
                        if (0 !== i.length) {
                          t.stopPropagation();
                          var n = a.GetData(i[0], "data"),
                            s = this.$element.val();
                          this.$element.val(this.placeholder.id);
                          var r = { data: n };
                          if ((this.trigger("clear", r), r.prevented))
                            this.$element.val(s);
                          else {
                            for (var o = 0; o < n.length; o++)
                              if (
                                ((r = { data: n[o] }),
                                this.trigger("unselect", r),
                                r.prevented)
                              )
                                return void this.$element.val(s);
                            this.$element.trigger("change"),
                              this.trigger("toggle", {});
                          }
                        }
                      }
                    }),
                    (e.prototype._handleKeyboardClear = function (e, t, i) {
                      i.isOpen() ||
                        (t.which != n.DELETE && t.which != n.BACKSPACE) ||
                        this._handleClear(t);
                    }),
                    (e.prototype.update = function (e, t) {
                      if (
                        (e.call(this, t),
                        !(
                          0 <
                            this.$selection.find(
                              ".select2-selection__placeholder"
                            ).length || 0 === t.length
                        ))
                      ) {
                        var i = this.options
                            .get("translations")
                            .get("removeAllItems"),
                          n = s(
                            '<span class="select2-selection__clear" title="' +
                              i() +
                              '">&times;</span>'
                          );
                        a.StoreData(n[0], "data", t),
                          this.$selection
                            .find(".select2-selection__rendered")
                            .prepend(n);
                      }
                    }),
                    e
                  );
                }
              ),
              e.define(
                "select2/selection/search",
                ["jquery", "../utils", "../keys"],
                function (n, a, l) {
                  function e(e, t, i) {
                    e.call(this, t, i);
                  }
                  return (
                    (e.prototype.render = function (e) {
                      var t = n(
                        '<li class="select2-search select2-search--inline"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></li>'
                      );
                      (this.$searchContainer = t),
                        (this.$search = t.find("input"));
                      var i = e.call(this);
                      return this._transferTabIndex(), i;
                    }),
                    (e.prototype.bind = function (e, t, i) {
                      var n = this,
                        s = t.id + "-results";
                      e.call(this, t, i),
                        t.on("open", function () {
                          n.$search.attr("aria-controls", s),
                            n.$search.trigger("focus");
                        }),
                        t.on("close", function () {
                          n.$search.val(""),
                            n.$search.removeAttr("aria-controls"),
                            n.$search.removeAttr("aria-activedescendant"),
                            n.$search.trigger("focus");
                        }),
                        t.on("enable", function () {
                          n.$search.prop("disabled", !1), n._transferTabIndex();
                        }),
                        t.on("disable", function () {
                          n.$search.prop("disabled", !0);
                        }),
                        t.on("focus", function (e) {
                          n.$search.trigger("focus");
                        }),
                        t.on("results:focus", function (e) {
                          e.data._resultId
                            ? n.$search.attr(
                                "aria-activedescendant",
                                e.data._resultId
                              )
                            : n.$search.removeAttr("aria-activedescendant");
                        }),
                        this.$selection.on(
                          "focusin",
                          ".select2-search--inline",
                          function (e) {
                            n.trigger("focus", e);
                          }
                        ),
                        this.$selection.on(
                          "focusout",
                          ".select2-search--inline",
                          function (e) {
                            n._handleBlur(e);
                          }
                        ),
                        this.$selection.on(
                          "keydown",
                          ".select2-search--inline",
                          function (e) {
                            if (
                              (e.stopPropagation(),
                              n.trigger("keypress", e),
                              (n._keyUpPrevented = e.isDefaultPrevented()),
                              e.which === l.BACKSPACE && "" === n.$search.val())
                            ) {
                              var t = n.$searchContainer.prev(
                                ".select2-selection__choice"
                              );
                              if (0 < t.length) {
                                var i = a.GetData(t[0], "data");
                                n.searchRemoveChoice(i), e.preventDefault();
                              }
                            }
                          }
                        ),
                        this.$selection.on(
                          "click",
                          ".select2-search--inline",
                          function (e) {
                            n.$search.val() && e.stopPropagation();
                          }
                        );
                      var r = document.documentMode,
                        o = r && r <= 11;
                      this.$selection.on(
                        "input.searchcheck",
                        ".select2-search--inline",
                        function (e) {
                          o
                            ? n.$selection.off("input.search input.searchcheck")
                            : n.$selection.off("keyup.search");
                        }
                      ),
                        this.$selection.on(
                          "keyup.search input.search",
                          ".select2-search--inline",
                          function (e) {
                            if (o && "input" === e.type)
                              n.$selection.off(
                                "input.search input.searchcheck"
                              );
                            else {
                              var t = e.which;
                              t != l.SHIFT &&
                                t != l.CTRL &&
                                t != l.ALT &&
                                t != l.TAB &&
                                n.handleSearch(e);
                            }
                          }
                        );
                    }),
                    (e.prototype._transferTabIndex = function (e) {
                      this.$search.attr(
                        "tabindex",
                        this.$selection.attr("tabindex")
                      ),
                        this.$selection.attr("tabindex", "-1");
                    }),
                    (e.prototype.createPlaceholder = function (e, t) {
                      this.$search.attr("placeholder", t.text);
                    }),
                    (e.prototype.update = function (e, t) {
                      var i = this.$search[0] == document.activeElement;
                      this.$search.attr("placeholder", ""),
                        e.call(this, t),
                        this.$selection
                          .find(".select2-selection__rendered")
                          .append(this.$searchContainer),
                        this.resizeSearch(),
                        i && this.$search.trigger("focus");
                    }),
                    (e.prototype.handleSearch = function () {
                      if ((this.resizeSearch(), !this._keyUpPrevented)) {
                        var e = this.$search.val();
                        this.trigger("query", { term: e });
                      }
                      this._keyUpPrevented = !1;
                    }),
                    (e.prototype.searchRemoveChoice = function (e, t) {
                      this.trigger("unselect", { data: t }),
                        this.$search.val(t.text),
                        this.handleSearch();
                    }),
                    (e.prototype.resizeSearch = function () {
                      this.$search.css("width", "25px");
                      var e = "";
                      (e =
                        "" !== this.$search.attr("placeholder")
                          ? this.$selection
                              .find(".select2-selection__rendered")
                              .width()
                          : 0.75 * (this.$search.val().length + 1) + "em"),
                        this.$search.css("width", e);
                    }),
                    e
                  );
                }
              ),
              e.define(
                "select2/selection/eventRelay",
                ["jquery"],
                function (o) {
                  function e() {}
                  return (
                    (e.prototype.bind = function (e, t, i) {
                      var n = this,
                        s = [
                          "open",
                          "opening",
                          "close",
                          "closing",
                          "select",
                          "selecting",
                          "unselect",
                          "unselecting",
                          "clear",
                          "clearing",
                        ],
                        r = [
                          "opening",
                          "closing",
                          "selecting",
                          "unselecting",
                          "clearing",
                        ];
                      e.call(this, t, i),
                        t.on("*", function (e, t) {
                          if (-1 !== o.inArray(e, s)) {
                            t = t || {};
                            var i = o.Event("select2:" + e, { params: t });
                            n.$element.trigger(i),
                              -1 !== o.inArray(e, r) &&
                                (t.prevented = i.isDefaultPrevented());
                          }
                        });
                    }),
                    e
                  );
                }
              ),
              e.define(
                "select2/translation",
                ["jquery", "require"],
                function (t, i) {
                  function n(e) {
                    this.dict = e || {};
                  }
                  return (
                    (n.prototype.all = function () {
                      return this.dict;
                    }),
                    (n.prototype.get = function (e) {
                      return this.dict[e];
                    }),
                    (n.prototype.extend = function (e) {
                      this.dict = t.extend({}, e.all(), this.dict);
                    }),
                    (n._cache = {}),
                    (n.loadPath = function (e) {
                      if (!(e in n._cache)) {
                        var t = i(e);
                        n._cache[e] = t;
                      }
                      return new n(n._cache[e]);
                    }),
                    n
                  );
                }
              ),
              e.define("select2/diacritics", [], function () {
                return {
                  "Ⓐ": "A",
                  Ａ: "A",
                  À: "A",
                  Á: "A",
                  Â: "A",
                  Ầ: "A",
                  Ấ: "A",
                  Ẫ: "A",
                  Ẩ: "A",
                  Ã: "A",
                  Ā: "A",
                  Ă: "A",
                  Ằ: "A",
                  Ắ: "A",
                  Ẵ: "A",
                  Ẳ: "A",
                  Ȧ: "A",
                  Ǡ: "A",
                  Ä: "A",
                  Ǟ: "A",
                  Ả: "A",
                  Å: "A",
                  Ǻ: "A",
                  Ǎ: "A",
                  Ȁ: "A",
                  Ȃ: "A",
                  Ạ: "A",
                  Ậ: "A",
                  Ặ: "A",
                  Ḁ: "A",
                  Ą: "A",
                  Ⱥ: "A",
                  Ɐ: "A",
                  Ꜳ: "AA",
                  Æ: "AE",
                  Ǽ: "AE",
                  Ǣ: "AE",
                  Ꜵ: "AO",
                  Ꜷ: "AU",
                  Ꜹ: "AV",
                  Ꜻ: "AV",
                  Ꜽ: "AY",
                  "Ⓑ": "B",
                  Ｂ: "B",
                  Ḃ: "B",
                  Ḅ: "B",
                  Ḇ: "B",
                  Ƀ: "B",
                  Ƃ: "B",
                  Ɓ: "B",
                  "Ⓒ": "C",
                  Ｃ: "C",
                  Ć: "C",
                  Ĉ: "C",
                  Ċ: "C",
                  Č: "C",
                  Ç: "C",
                  Ḉ: "C",
                  Ƈ: "C",
                  Ȼ: "C",
                  Ꜿ: "C",
                  "Ⓓ": "D",
                  Ｄ: "D",
                  Ḋ: "D",
                  Ď: "D",
                  Ḍ: "D",
                  Ḑ: "D",
                  Ḓ: "D",
                  Ḏ: "D",
                  Đ: "D",
                  Ƌ: "D",
                  Ɗ: "D",
                  Ɖ: "D",
                  Ꝺ: "D",
                  Ǳ: "DZ",
                  Ǆ: "DZ",
                  ǲ: "Dz",
                  ǅ: "Dz",
                  "Ⓔ": "E",
                  Ｅ: "E",
                  È: "E",
                  É: "E",
                  Ê: "E",
                  Ề: "E",
                  Ế: "E",
                  Ễ: "E",
                  Ể: "E",
                  Ẽ: "E",
                  Ē: "E",
                  Ḕ: "E",
                  Ḗ: "E",
                  Ĕ: "E",
                  Ė: "E",
                  Ë: "E",
                  Ẻ: "E",
                  Ě: "E",
                  Ȅ: "E",
                  Ȇ: "E",
                  Ẹ: "E",
                  Ệ: "E",
                  Ȩ: "E",
                  Ḝ: "E",
                  Ę: "E",
                  Ḙ: "E",
                  Ḛ: "E",
                  Ɛ: "E",
                  Ǝ: "E",
                  "Ⓕ": "F",
                  Ｆ: "F",
                  Ḟ: "F",
                  Ƒ: "F",
                  Ꝼ: "F",
                  "Ⓖ": "G",
                  Ｇ: "G",
                  Ǵ: "G",
                  Ĝ: "G",
                  Ḡ: "G",
                  Ğ: "G",
                  Ġ: "G",
                  Ǧ: "G",
                  Ģ: "G",
                  Ǥ: "G",
                  Ɠ: "G",
                  Ꞡ: "G",
                  Ᵹ: "G",
                  Ꝿ: "G",
                  "Ⓗ": "H",
                  Ｈ: "H",
                  Ĥ: "H",
                  Ḣ: "H",
                  Ḧ: "H",
                  Ȟ: "H",
                  Ḥ: "H",
                  Ḩ: "H",
                  Ḫ: "H",
                  Ħ: "H",
                  Ⱨ: "H",
                  Ⱶ: "H",
                  Ɥ: "H",
                  "Ⓘ": "I",
                  Ｉ: "I",
                  Ì: "I",
                  Í: "I",
                  Î: "I",
                  Ĩ: "I",
                  Ī: "I",
                  Ĭ: "I",
                  İ: "I",
                  Ï: "I",
                  Ḯ: "I",
                  Ỉ: "I",
                  Ǐ: "I",
                  Ȉ: "I",
                  Ȋ: "I",
                  Ị: "I",
                  Į: "I",
                  Ḭ: "I",
                  Ɨ: "I",
                  "Ⓙ": "J",
                  Ｊ: "J",
                  Ĵ: "J",
                  Ɉ: "J",
                  "Ⓚ": "K",
                  Ｋ: "K",
                  Ḱ: "K",
                  Ǩ: "K",
                  Ḳ: "K",
                  Ķ: "K",
                  Ḵ: "K",
                  Ƙ: "K",
                  Ⱪ: "K",
                  Ꝁ: "K",
                  Ꝃ: "K",
                  Ꝅ: "K",
                  Ꞣ: "K",
                  "Ⓛ": "L",
                  Ｌ: "L",
                  Ŀ: "L",
                  Ĺ: "L",
                  Ľ: "L",
                  Ḷ: "L",
                  Ḹ: "L",
                  Ļ: "L",
                  Ḽ: "L",
                  Ḻ: "L",
                  Ł: "L",
                  Ƚ: "L",
                  Ɫ: "L",
                  Ⱡ: "L",
                  Ꝉ: "L",
                  Ꝇ: "L",
                  Ꞁ: "L",
                  Ǉ: "LJ",
                  ǈ: "Lj",
                  "Ⓜ": "M",
                  Ｍ: "M",
                  Ḿ: "M",
                  Ṁ: "M",
                  Ṃ: "M",
                  Ɱ: "M",
                  Ɯ: "M",
                  "Ⓝ": "N",
                  Ｎ: "N",
                  Ǹ: "N",
                  Ń: "N",
                  Ñ: "N",
                  Ṅ: "N",
                  Ň: "N",
                  Ṇ: "N",
                  Ņ: "N",
                  Ṋ: "N",
                  Ṉ: "N",
                  Ƞ: "N",
                  Ɲ: "N",
                  Ꞑ: "N",
                  Ꞥ: "N",
                  Ǌ: "NJ",
                  ǋ: "Nj",
                  "Ⓞ": "O",
                  Ｏ: "O",
                  Ò: "O",
                  Ó: "O",
                  Ô: "O",
                  Ồ: "O",
                  Ố: "O",
                  Ỗ: "O",
                  Ổ: "O",
                  Õ: "O",
                  Ṍ: "O",
                  Ȭ: "O",
                  Ṏ: "O",
                  Ō: "O",
                  Ṑ: "O",
                  Ṓ: "O",
                  Ŏ: "O",
                  Ȯ: "O",
                  Ȱ: "O",
                  Ö: "O",
                  Ȫ: "O",
                  Ỏ: "O",
                  Ő: "O",
                  Ǒ: "O",
                  Ȍ: "O",
                  Ȏ: "O",
                  Ơ: "O",
                  Ờ: "O",
                  Ớ: "O",
                  Ỡ: "O",
                  Ở: "O",
                  Ợ: "O",
                  Ọ: "O",
                  Ộ: "O",
                  Ǫ: "O",
                  Ǭ: "O",
                  Ø: "O",
                  Ǿ: "O",
                  Ɔ: "O",
                  Ɵ: "O",
                  Ꝋ: "O",
                  Ꝍ: "O",
                  Œ: "OE",
                  Ƣ: "OI",
                  Ꝏ: "OO",
                  Ȣ: "OU",
                  "Ⓟ": "P",
                  Ｐ: "P",
                  Ṕ: "P",
                  Ṗ: "P",
                  Ƥ: "P",
                  Ᵽ: "P",
                  Ꝑ: "P",
                  Ꝓ: "P",
                  Ꝕ: "P",
                  "Ⓠ": "Q",
                  Ｑ: "Q",
                  Ꝗ: "Q",
                  Ꝙ: "Q",
                  Ɋ: "Q",
                  "Ⓡ": "R",
                  Ｒ: "R",
                  Ŕ: "R",
                  Ṙ: "R",
                  Ř: "R",
                  Ȑ: "R",
                  Ȓ: "R",
                  Ṛ: "R",
                  Ṝ: "R",
                  Ŗ: "R",
                  Ṟ: "R",
                  Ɍ: "R",
                  Ɽ: "R",
                  Ꝛ: "R",
                  Ꞧ: "R",
                  Ꞃ: "R",
                  "Ⓢ": "S",
                  Ｓ: "S",
                  ẞ: "S",
                  Ś: "S",
                  Ṥ: "S",
                  Ŝ: "S",
                  Ṡ: "S",
                  Š: "S",
                  Ṧ: "S",
                  Ṣ: "S",
                  Ṩ: "S",
                  Ș: "S",
                  Ş: "S",
                  Ȿ: "S",
                  Ꞩ: "S",
                  Ꞅ: "S",
                  "Ⓣ": "T",
                  Ｔ: "T",
                  Ṫ: "T",
                  Ť: "T",
                  Ṭ: "T",
                  Ț: "T",
                  Ţ: "T",
                  Ṱ: "T",
                  Ṯ: "T",
                  Ŧ: "T",
                  Ƭ: "T",
                  Ʈ: "T",
                  Ⱦ: "T",
                  Ꞇ: "T",
                  Ꜩ: "TZ",
                  "Ⓤ": "U",
                  Ｕ: "U",
                  Ù: "U",
                  Ú: "U",
                  Û: "U",
                  Ũ: "U",
                  Ṹ: "U",
                  Ū: "U",
                  Ṻ: "U",
                  Ŭ: "U",
                  Ü: "U",
                  Ǜ: "U",
                  Ǘ: "U",
                  Ǖ: "U",
                  Ǚ: "U",
                  Ủ: "U",
                  Ů: "U",
                  Ű: "U",
                  Ǔ: "U",
                  Ȕ: "U",
                  Ȗ: "U",
                  Ư: "U",
                  Ừ: "U",
                  Ứ: "U",
                  Ữ: "U",
                  Ử: "U",
                  Ự: "U",
                  Ụ: "U",
                  Ṳ: "U",
                  Ų: "U",
                  Ṷ: "U",
                  Ṵ: "U",
                  Ʉ: "U",
                  "Ⓥ": "V",
                  Ｖ: "V",
                  Ṽ: "V",
                  Ṿ: "V",
                  Ʋ: "V",
                  Ꝟ: "V",
                  Ʌ: "V",
                  Ꝡ: "VY",
                  "Ⓦ": "W",
                  Ｗ: "W",
                  Ẁ: "W",
                  Ẃ: "W",
                  Ŵ: "W",
                  Ẇ: "W",
                  Ẅ: "W",
                  Ẉ: "W",
                  Ⱳ: "W",
                  "Ⓧ": "X",
                  Ｘ: "X",
                  Ẋ: "X",
                  Ẍ: "X",
                  "Ⓨ": "Y",
                  Ｙ: "Y",
                  Ỳ: "Y",
                  Ý: "Y",
                  Ŷ: "Y",
                  Ỹ: "Y",
                  Ȳ: "Y",
                  Ẏ: "Y",
                  Ÿ: "Y",
                  Ỷ: "Y",
                  Ỵ: "Y",
                  Ƴ: "Y",
                  Ɏ: "Y",
                  Ỿ: "Y",
                  "Ⓩ": "Z",
                  Ｚ: "Z",
                  Ź: "Z",
                  Ẑ: "Z",
                  Ż: "Z",
                  Ž: "Z",
                  Ẓ: "Z",
                  Ẕ: "Z",
                  Ƶ: "Z",
                  Ȥ: "Z",
                  Ɀ: "Z",
                  Ⱬ: "Z",
                  Ꝣ: "Z",
                  "ⓐ": "a",
                  ａ: "a",
                  ẚ: "a",
                  à: "a",
                  á: "a",
                  â: "a",
                  ầ: "a",
                  ấ: "a",
                  ẫ: "a",
                  ẩ: "a",
                  ã: "a",
                  ā: "a",
                  ă: "a",
                  ằ: "a",
                  ắ: "a",
                  ẵ: "a",
                  ẳ: "a",
                  ȧ: "a",
                  ǡ: "a",
                  ä: "a",
                  ǟ: "a",
                  ả: "a",
                  å: "a",
                  ǻ: "a",
                  ǎ: "a",
                  ȁ: "a",
                  ȃ: "a",
                  ạ: "a",
                  ậ: "a",
                  ặ: "a",
                  ḁ: "a",
                  ą: "a",
                  ⱥ: "a",
                  ɐ: "a",
                  ꜳ: "aa",
                  æ: "ae",
                  ǽ: "ae",
                  ǣ: "ae",
                  ꜵ: "ao",
                  ꜷ: "au",
                  ꜹ: "av",
                  ꜻ: "av",
                  ꜽ: "ay",
                  "ⓑ": "b",
                  ｂ: "b",
                  ḃ: "b",
                  ḅ: "b",
                  ḇ: "b",
                  ƀ: "b",
                  ƃ: "b",
                  ɓ: "b",
                  "ⓒ": "c",
                  ｃ: "c",
                  ć: "c",
                  ĉ: "c",
                  ċ: "c",
                  č: "c",
                  ç: "c",
                  ḉ: "c",
                  ƈ: "c",
                  ȼ: "c",
                  ꜿ: "c",
                  ↄ: "c",
                  "ⓓ": "d",
                  ｄ: "d",
                  ḋ: "d",
                  ď: "d",
                  ḍ: "d",
                  ḑ: "d",
                  ḓ: "d",
                  ḏ: "d",
                  đ: "d",
                  ƌ: "d",
                  ɖ: "d",
                  ɗ: "d",
                  ꝺ: "d",
                  ǳ: "dz",
                  ǆ: "dz",
                  "ⓔ": "e",
                  ｅ: "e",
                  è: "e",
                  é: "e",
                  ê: "e",
                  ề: "e",
                  ế: "e",
                  ễ: "e",
                  ể: "e",
                  ẽ: "e",
                  ē: "e",
                  ḕ: "e",
                  ḗ: "e",
                  ĕ: "e",
                  ė: "e",
                  ë: "e",
                  ẻ: "e",
                  ě: "e",
                  ȅ: "e",
                  ȇ: "e",
                  ẹ: "e",
                  ệ: "e",
                  ȩ: "e",
                  ḝ: "e",
                  ę: "e",
                  ḙ: "e",
                  ḛ: "e",
                  ɇ: "e",
                  ɛ: "e",
                  ǝ: "e",
                  "ⓕ": "f",
                  ｆ: "f",
                  ḟ: "f",
                  ƒ: "f",
                  ꝼ: "f",
                  "ⓖ": "g",
                  ｇ: "g",
                  ǵ: "g",
                  ĝ: "g",
                  ḡ: "g",
                  ğ: "g",
                  ġ: "g",
                  ǧ: "g",
                  ģ: "g",
                  ǥ: "g",
                  ɠ: "g",
                  ꞡ: "g",
                  ᵹ: "g",
                  ꝿ: "g",
                  "ⓗ": "h",
                  ｈ: "h",
                  ĥ: "h",
                  ḣ: "h",
                  ḧ: "h",
                  ȟ: "h",
                  ḥ: "h",
                  ḩ: "h",
                  ḫ: "h",
                  ẖ: "h",
                  ħ: "h",
                  ⱨ: "h",
                  ⱶ: "h",
                  ɥ: "h",
                  ƕ: "hv",
                  "ⓘ": "i",
                  ｉ: "i",
                  ì: "i",
                  í: "i",
                  î: "i",
                  ĩ: "i",
                  ī: "i",
                  ĭ: "i",
                  ï: "i",
                  ḯ: "i",
                  ỉ: "i",
                  ǐ: "i",
                  ȉ: "i",
                  ȋ: "i",
                  ị: "i",
                  į: "i",
                  ḭ: "i",
                  ɨ: "i",
                  ı: "i",
                  "ⓙ": "j",
                  ｊ: "j",
                  ĵ: "j",
                  ǰ: "j",
                  ɉ: "j",
                  "ⓚ": "k",
                  ｋ: "k",
                  ḱ: "k",
                  ǩ: "k",
                  ḳ: "k",
                  ķ: "k",
                  ḵ: "k",
                  ƙ: "k",
                  ⱪ: "k",
                  ꝁ: "k",
                  ꝃ: "k",
                  ꝅ: "k",
                  ꞣ: "k",
                  "ⓛ": "l",
                  ｌ: "l",
                  ŀ: "l",
                  ĺ: "l",
                  ľ: "l",
                  ḷ: "l",
                  ḹ: "l",
                  ļ: "l",
                  ḽ: "l",
                  ḻ: "l",
                  ſ: "l",
                  ł: "l",
                  ƚ: "l",
                  ɫ: "l",
                  ⱡ: "l",
                  ꝉ: "l",
                  ꞁ: "l",
                  ꝇ: "l",
                  ǉ: "lj",
                  "ⓜ": "m",
                  ｍ: "m",
                  ḿ: "m",
                  ṁ: "m",
                  ṃ: "m",
                  ɱ: "m",
                  ɯ: "m",
                  "ⓝ": "n",
                  ｎ: "n",
                  ǹ: "n",
                  ń: "n",
                  ñ: "n",
                  ṅ: "n",
                  ň: "n",
                  ṇ: "n",
                  ņ: "n",
                  ṋ: "n",
                  ṉ: "n",
                  ƞ: "n",
                  ɲ: "n",
                  ŉ: "n",
                  ꞑ: "n",
                  ꞥ: "n",
                  ǌ: "nj",
                  "ⓞ": "o",
                  ｏ: "o",
                  ò: "o",
                  ó: "o",
                  ô: "o",
                  ồ: "o",
                  ố: "o",
                  ỗ: "o",
                  ổ: "o",
                  õ: "o",
                  ṍ: "o",
                  ȭ: "o",
                  ṏ: "o",
                  ō: "o",
                  ṑ: "o",
                  ṓ: "o",
                  ŏ: "o",
                  ȯ: "o",
                  ȱ: "o",
                  ö: "o",
                  ȫ: "o",
                  ỏ: "o",
                  ő: "o",
                  ǒ: "o",
                  ȍ: "o",
                  ȏ: "o",
                  ơ: "o",
                  ờ: "o",
                  ớ: "o",
                  ỡ: "o",
                  ở: "o",
                  ợ: "o",
                  ọ: "o",
                  ộ: "o",
                  ǫ: "o",
                  ǭ: "o",
                  ø: "o",
                  ǿ: "o",
                  ɔ: "o",
                  ꝋ: "o",
                  ꝍ: "o",
                  ɵ: "o",
                  œ: "oe",
                  ƣ: "oi",
                  ȣ: "ou",
                  ꝏ: "oo",
                  "ⓟ": "p",
                  ｐ: "p",
                  ṕ: "p",
                  ṗ: "p",
                  ƥ: "p",
                  ᵽ: "p",
                  ꝑ: "p",
                  ꝓ: "p",
                  ꝕ: "p",
                  "ⓠ": "q",
                  ｑ: "q",
                  ɋ: "q",
                  ꝗ: "q",
                  ꝙ: "q",
                  "ⓡ": "r",
                  ｒ: "r",
                  ŕ: "r",
                  ṙ: "r",
                  ř: "r",
                  ȑ: "r",
                  ȓ: "r",
                  ṛ: "r",
                  ṝ: "r",
                  ŗ: "r",
                  ṟ: "r",
                  ɍ: "r",
                  ɽ: "r",
                  ꝛ: "r",
                  ꞧ: "r",
                  ꞃ: "r",
                  "ⓢ": "s",
                  ｓ: "s",
                  ß: "s",
                  ś: "s",
                  ṥ: "s",
                  ŝ: "s",
                  ṡ: "s",
                  š: "s",
                  ṧ: "s",
                  ṣ: "s",
                  ṩ: "s",
                  ș: "s",
                  ş: "s",
                  ȿ: "s",
                  ꞩ: "s",
                  ꞅ: "s",
                  ẛ: "s",
                  "ⓣ": "t",
                  ｔ: "t",
                  ṫ: "t",
                  ẗ: "t",
                  ť: "t",
                  ṭ: "t",
                  ț: "t",
                  ţ: "t",
                  ṱ: "t",
                  ṯ: "t",
                  ŧ: "t",
                  ƭ: "t",
                  ʈ: "t",
                  ⱦ: "t",
                  ꞇ: "t",
                  ꜩ: "tz",
                  "ⓤ": "u",
                  ｕ: "u",
                  ù: "u",
                  ú: "u",
                  û: "u",
                  ũ: "u",
                  ṹ: "u",
                  ū: "u",
                  ṻ: "u",
                  ŭ: "u",
                  ü: "u",
                  ǜ: "u",
                  ǘ: "u",
                  ǖ: "u",
                  ǚ: "u",
                  ủ: "u",
                  ů: "u",
                  ű: "u",
                  ǔ: "u",
                  ȕ: "u",
                  ȗ: "u",
                  ư: "u",
                  ừ: "u",
                  ứ: "u",
                  ữ: "u",
                  ử: "u",
                  ự: "u",
                  ụ: "u",
                  ṳ: "u",
                  ų: "u",
                  ṷ: "u",
                  ṵ: "u",
                  ʉ: "u",
                  "ⓥ": "v",
                  ｖ: "v",
                  ṽ: "v",
                  ṿ: "v",
                  ʋ: "v",
                  ꝟ: "v",
                  ʌ: "v",
                  ꝡ: "vy",
                  "ⓦ": "w",
                  ｗ: "w",
                  ẁ: "w",
                  ẃ: "w",
                  ŵ: "w",
                  ẇ: "w",
                  ẅ: "w",
                  ẘ: "w",
                  ẉ: "w",
                  ⱳ: "w",
                  "ⓧ": "x",
                  ｘ: "x",
                  ẋ: "x",
                  ẍ: "x",
                  "ⓨ": "y",
                  ｙ: "y",
                  ỳ: "y",
                  ý: "y",
                  ŷ: "y",
                  ỹ: "y",
                  ȳ: "y",
                  ẏ: "y",
                  ÿ: "y",
                  ỷ: "y",
                  ẙ: "y",
                  ỵ: "y",
                  ƴ: "y",
                  ɏ: "y",
                  ỿ: "y",
                  "ⓩ": "z",
                  ｚ: "z",
                  ź: "z",
                  ẑ: "z",
                  ż: "z",
                  ž: "z",
                  ẓ: "z",
                  ẕ: "z",
                  ƶ: "z",
                  ȥ: "z",
                  ɀ: "z",
                  ⱬ: "z",
                  ꝣ: "z",
                  Ά: "Α",
                  Έ: "Ε",
                  Ή: "Η",
                  Ί: "Ι",
                  Ϊ: "Ι",
                  Ό: "Ο",
                  Ύ: "Υ",
                  Ϋ: "Υ",
                  Ώ: "Ω",
                  ά: "α",
                  έ: "ε",
                  ή: "η",
                  ί: "ι",
                  ϊ: "ι",
                  ΐ: "ι",
                  ό: "ο",
                  ύ: "υ",
                  ϋ: "υ",
                  ΰ: "υ",
                  ώ: "ω",
                  ς: "σ",
                  "’": "'",
                };
              }),
              e.define("select2/data/base", ["../utils"], function (n) {
                function i(e, t) {
                  i.__super__.constructor.call(this);
                }
                return (
                  n.Extend(i, n.Observable),
                  (i.prototype.current = function (e) {
                    throw new Error(
                      "The `current` method must be defined in child classes."
                    );
                  }),
                  (i.prototype.query = function (e, t) {
                    throw new Error(
                      "The `query` method must be defined in child classes."
                    );
                  }),
                  (i.prototype.bind = function (e, t) {}),
                  (i.prototype.destroy = function () {}),
                  (i.prototype.generateResultId = function (e, t) {
                    var i = e.id + "-result-";
                    return (
                      (i += n.generateChars(4)),
                      null != t.id
                        ? (i += "-" + t.id.toString())
                        : (i += "-" + n.generateChars(4)),
                      i
                    );
                  }),
                  i
                );
              }),
              e.define(
                "select2/data/select",
                ["./base", "../utils", "jquery"],
                function (e, a, l) {
                  function i(e, t) {
                    (this.$element = e),
                      (this.options = t),
                      i.__super__.constructor.call(this);
                  }
                  return (
                    a.Extend(i, e),
                    (i.prototype.current = function (e) {
                      var i = [],
                        n = this;
                      this.$element.find(":selected").each(function () {
                        var e = l(this),
                          t = n.item(e);
                        i.push(t);
                      }),
                        e(i);
                    }),
                    (i.prototype.select = function (s) {
                      var r = this;
                      if (((s.selected = !0), l(s.element).is("option")))
                        return (
                          (s.element.selected = !0),
                          void this.$element.trigger("change")
                        );
                      if (this.$element.prop("multiple"))
                        this.current(function (e) {
                          var t = [];
                          (s = [s]).push.apply(s, e);
                          for (var i = 0; i < s.length; i++) {
                            var n = s[i].id;
                            -1 === l.inArray(n, t) && t.push(n);
                          }
                          r.$element.val(t), r.$element.trigger("change");
                        });
                      else {
                        var e = s.id;
                        this.$element.val(e), this.$element.trigger("change");
                      }
                    }),
                    (i.prototype.unselect = function (s) {
                      var r = this;
                      if (this.$element.prop("multiple")) {
                        if (((s.selected = !1), l(s.element).is("option")))
                          return (
                            (s.element.selected = !1),
                            void this.$element.trigger("change")
                          );
                        this.current(function (e) {
                          for (var t = [], i = 0; i < e.length; i++) {
                            var n = e[i].id;
                            n !== s.id && -1 === l.inArray(n, t) && t.push(n);
                          }
                          r.$element.val(t), r.$element.trigger("change");
                        });
                      }
                    }),
                    (i.prototype.bind = function (e, t) {
                      var i = this;
                      (this.container = e).on("select", function (e) {
                        i.select(e.data);
                      }),
                        e.on("unselect", function (e) {
                          i.unselect(e.data);
                        });
                    }),
                    (i.prototype.destroy = function () {
                      this.$element.find("*").each(function () {
                        a.RemoveData(this);
                      });
                    }),
                    (i.prototype.query = function (n, e) {
                      var s = [],
                        r = this;
                      this.$element.children().each(function () {
                        var e = l(this);
                        if (e.is("option") || e.is("optgroup")) {
                          var t = r.item(e),
                            i = r.matches(n, t);
                          null !== i && s.push(i);
                        }
                      }),
                        e({ results: s });
                    }),
                    (i.prototype.addOptions = function (e) {
                      a.appendMany(this.$element, e);
                    }),
                    (i.prototype.option = function (e) {
                      var t;
                      e.children
                        ? ((t = document.createElement("optgroup")).label =
                            e.text)
                        : void 0 !==
                          (t = document.createElement("option")).textContent
                        ? (t.textContent = e.text)
                        : (t.innerText = e.text),
                        void 0 !== e.id && (t.value = e.id),
                        e.disabled && (t.disabled = !0),
                        e.selected && (t.selected = !0),
                        e.title && (t.title = e.title);
                      var i = l(t),
                        n = this._normalizeItem(e);
                      return (n.element = t), a.StoreData(t, "data", n), i;
                    }),
                    (i.prototype.item = function (e) {
                      var t = {};
                      if (null != (t = a.GetData(e[0], "data"))) return t;
                      if (e.is("option"))
                        t = {
                          id: e.val(),
                          text: e.text(),
                          disabled: e.prop("disabled"),
                          selected: e.prop("selected"),
                          title: e.prop("title"),
                        };
                      else if (e.is("optgroup")) {
                        t = {
                          text: e.prop("label"),
                          children: [],
                          title: e.prop("title"),
                        };
                        for (
                          var i = e.children("option"), n = [], s = 0;
                          s < i.length;
                          s++
                        ) {
                          var r = l(i[s]),
                            o = this.item(r);
                          n.push(o);
                        }
                        t.children = n;
                      }
                      return (
                        ((t = this._normalizeItem(t)).element = e[0]),
                        a.StoreData(e[0], "data", t),
                        t
                      );
                    }),
                    (i.prototype._normalizeItem = function (e) {
                      return (
                        e !== Object(e) && (e = { id: e, text: e }),
                        null != (e = l.extend({}, { text: "" }, e)).id &&
                          (e.id = e.id.toString()),
                        null != e.text && (e.text = e.text.toString()),
                        null == e._resultId &&
                          e.id &&
                          null != this.container &&
                          (e._resultId = this.generateResultId(
                            this.container,
                            e
                          )),
                        l.extend({}, { selected: !1, disabled: !1 }, e)
                      );
                    }),
                    (i.prototype.matches = function (e, t) {
                      return this.options.get("matcher")(e, t);
                    }),
                    i
                  );
                }
              ),
              e.define(
                "select2/data/array",
                ["./select", "../utils", "jquery"],
                function (e, f, m) {
                  function n(e, t) {
                    (this._dataToConvert = t.get("data") || []),
                      n.__super__.constructor.call(this, e, t);
                  }
                  return (
                    f.Extend(n, e),
                    (n.prototype.bind = function (e, t) {
                      n.__super__.bind.call(this, e, t),
                        this.addOptions(
                          this.convertToOptions(this._dataToConvert)
                        );
                    }),
                    (n.prototype.select = function (i) {
                      var e = this.$element
                        .find("option")
                        .filter(function (e, t) {
                          return t.value == i.id.toString();
                        });
                      0 === e.length &&
                        ((e = this.option(i)), this.addOptions(e)),
                        n.__super__.select.call(this, i);
                    }),
                    (n.prototype.convertToOptions = function (e) {
                      var t = this,
                        i = this.$element.find("option"),
                        n = i
                          .map(function () {
                            return t.item(m(this)).id;
                          })
                          .get(),
                        s = [];
                      function r(e) {
                        return function () {
                          return m(this).val() == e.id;
                        };
                      }
                      for (var o = 0; o < e.length; o++) {
                        var a = this._normalizeItem(e[o]);
                        if (0 <= m.inArray(a.id, n)) {
                          var l = i.filter(r(a)),
                            d = this.item(l),
                            c = m.extend(!0, {}, a, d),
                            u = this.option(c);
                          l.replaceWith(u);
                        } else {
                          var p = this.option(a);
                          if (a.children) {
                            var h = this.convertToOptions(a.children);
                            f.appendMany(p, h);
                          }
                          s.push(p);
                        }
                      }
                      return s;
                    }),
                    n
                  );
                }
              ),
              e.define(
                "select2/data/ajax",
                ["./array", "../utils", "jquery"],
                function (e, t, r) {
                  function i(e, t) {
                    (this.ajaxOptions = this._applyDefaults(t.get("ajax"))),
                      null != this.ajaxOptions.processResults &&
                        (this.processResults = this.ajaxOptions.processResults),
                      i.__super__.constructor.call(this, e, t);
                  }
                  return (
                    t.Extend(i, e),
                    (i.prototype._applyDefaults = function (e) {
                      var t = {
                        data: function (e) {
                          return r.extend({}, e, { q: e.term });
                        },
                        transport: function (e, t, i) {
                          var n = r.ajax(e);
                          return n.then(t), n.fail(i), n;
                        },
                      };
                      return r.extend({}, t, e, !0);
                    }),
                    (i.prototype.processResults = function (e) {
                      return e;
                    }),
                    (i.prototype.query = function (i, n) {
                      var s = this;
                      null != this._request &&
                        (r.isFunction(this._request.abort) &&
                          this._request.abort(),
                        (this._request = null));
                      var t = r.extend({ type: "GET" }, this.ajaxOptions);
                      function e() {
                        var e = t.transport(
                          t,
                          function (e) {
                            var t = s.processResults(e, i);
                            s.options.get("debug") &&
                              window.console &&
                              console.error &&
                              ((t && t.results && r.isArray(t.results)) ||
                                console.error(
                                  "Select2: The AJAX results did not return an array in the `results` key of the response."
                                )),
                              n(t);
                          },
                          function () {
                            ("status" in e &&
                              (0 === e.status || "0" === e.status)) ||
                              s.trigger("results:message", {
                                message: "errorLoading",
                              });
                          }
                        );
                        s._request = e;
                      }
                      "function" == typeof t.url &&
                        (t.url = t.url.call(this.$element, i)),
                        "function" == typeof t.data &&
                          (t.data = t.data.call(this.$element, i)),
                        this.ajaxOptions.delay && null != i.term
                          ? (this._queryTimeout &&
                              window.clearTimeout(this._queryTimeout),
                            (this._queryTimeout = window.setTimeout(
                              e,
                              this.ajaxOptions.delay
                            )))
                          : e();
                    }),
                    i
                  );
                }
              ),
              e.define("select2/data/tags", ["jquery"], function (c) {
                function e(e, t, i) {
                  var n = i.get("tags"),
                    s = i.get("createTag");
                  void 0 !== s && (this.createTag = s);
                  var r = i.get("insertTag");
                  if (
                    (void 0 !== r && (this.insertTag = r),
                    e.call(this, t, i),
                    c.isArray(n))
                  )
                    for (var o = 0; o < n.length; o++) {
                      var a = n[o],
                        l = this._normalizeItem(a),
                        d = this.option(l);
                      this.$element.append(d);
                    }
                }
                return (
                  (e.prototype.query = function (e, d, c) {
                    var u = this;
                    this._removeOldTags(),
                      null != d.term && null == d.page
                        ? e.call(this, d, function e(t, i) {
                            for (var n = t.results, s = 0; s < n.length; s++) {
                              var r = n[s],
                                o =
                                  null != r.children &&
                                  !e({ results: r.children }, !0);
                              if (
                                (r.text || "").toUpperCase() ===
                                  (d.term || "").toUpperCase() ||
                                o
                              )
                                return !i && ((t.data = n), void c(t));
                            }
                            if (i) return !0;
                            var a = u.createTag(d);
                            if (null != a) {
                              var l = u.option(a);
                              l.attr("data-select2-tag", !0),
                                u.addOptions([l]),
                                u.insertTag(n, a);
                            }
                            (t.results = n), c(t);
                          })
                        : e.call(this, d, c);
                  }),
                  (e.prototype.createTag = function (e, t) {
                    var i = c.trim(t.term);
                    return "" === i ? null : { id: i, text: i };
                  }),
                  (e.prototype.insertTag = function (e, t, i) {
                    t.unshift(i);
                  }),
                  (e.prototype._removeOldTags = function (e) {
                    this.$element
                      .find("option[data-select2-tag]")
                      .each(function () {
                        this.selected || c(this).remove();
                      });
                  }),
                  e
                );
              }),
              e.define("select2/data/tokenizer", ["jquery"], function (u) {
                function e(e, t, i) {
                  var n = i.get("tokenizer");
                  void 0 !== n && (this.tokenizer = n), e.call(this, t, i);
                }
                return (
                  (e.prototype.bind = function (e, t, i) {
                    e.call(this, t, i),
                      (this.$search =
                        t.dropdown.$search ||
                        t.selection.$search ||
                        i.find(".select2-search__field"));
                  }),
                  (e.prototype.query = function (e, t, i) {
                    var s = this;
                    t.term = t.term || "";
                    var n = this.tokenizer(t, this.options, function (e) {
                      var t,
                        i = s._normalizeItem(e);
                      if (
                        !s.$element.find("option").filter(function () {
                          return u(this).val() === i.id;
                        }).length
                      ) {
                        var n = s.option(i);
                        n.attr("data-select2-tag", !0),
                          s._removeOldTags(),
                          s.addOptions([n]);
                      }
                      (t = i), s.trigger("select", { data: t });
                    });
                    n.term !== t.term &&
                      (this.$search.length &&
                        (this.$search.val(n.term),
                        this.$search.trigger("focus")),
                      (t.term = n.term)),
                      e.call(this, t, i);
                  }),
                  (e.prototype.tokenizer = function (e, t, i, n) {
                    for (
                      var s = i.get("tokenSeparators") || [],
                        r = t.term,
                        o = 0,
                        a =
                          this.createTag ||
                          function (e) {
                            return { id: e.term, text: e.term };
                          };
                      o < r.length;

                    ) {
                      var l = r[o];
                      if (-1 !== u.inArray(l, s)) {
                        var d = r.substr(0, o),
                          c = a(u.extend({}, t, { term: d }));
                        null != c
                          ? (n(c), (r = r.substr(o + 1) || ""), (o = 0))
                          : o++;
                      } else o++;
                    }
                    return { term: r };
                  }),
                  e
                );
              }),
              e.define("select2/data/minimumInputLength", [], function () {
                function e(e, t, i) {
                  (this.minimumInputLength = i.get("minimumInputLength")),
                    e.call(this, t, i);
                }
                return (
                  (e.prototype.query = function (e, t, i) {
                    (t.term = t.term || ""),
                      t.term.length < this.minimumInputLength
                        ? this.trigger("results:message", {
                            message: "inputTooShort",
                            args: {
                              minimum: this.minimumInputLength,
                              input: t.term,
                              params: t,
                            },
                          })
                        : e.call(this, t, i);
                  }),
                  e
                );
              }),
              e.define("select2/data/maximumInputLength", [], function () {
                function e(e, t, i) {
                  (this.maximumInputLength = i.get("maximumInputLength")),
                    e.call(this, t, i);
                }
                return (
                  (e.prototype.query = function (e, t, i) {
                    (t.term = t.term || ""),
                      0 < this.maximumInputLength &&
                      t.term.length > this.maximumInputLength
                        ? this.trigger("results:message", {
                            message: "inputTooLong",
                            args: {
                              maximum: this.maximumInputLength,
                              input: t.term,
                              params: t,
                            },
                          })
                        : e.call(this, t, i);
                  }),
                  e
                );
              }),
              e.define("select2/data/maximumSelectionLength", [], function () {
                function e(e, t, i) {
                  (this.maximumSelectionLength = i.get(
                    "maximumSelectionLength"
                  )),
                    e.call(this, t, i);
                }
                return (
                  (e.prototype.bind = function (e, t, i) {
                    var n = this;
                    e.call(this, t, i),
                      t.on("select", function () {
                        n._checkIfMaximumSelected();
                      });
                  }),
                  (e.prototype.query = function (e, t, i) {
                    var n = this;
                    this._checkIfMaximumSelected(function () {
                      e.call(n, t, i);
                    });
                  }),
                  (e.prototype._checkIfMaximumSelected = function (e, i) {
                    var n = this;
                    this.current(function (e) {
                      var t = null != e ? e.length : 0;
                      0 < n.maximumSelectionLength &&
                      t >= n.maximumSelectionLength
                        ? n.trigger("results:message", {
                            message: "maximumSelected",
                            args: { maximum: n.maximumSelectionLength },
                          })
                        : i && i();
                    });
                  }),
                  e
                );
              }),
              e.define(
                "select2/dropdown",
                ["jquery", "./utils"],
                function (t, e) {
                  function i(e, t) {
                    (this.$element = e),
                      (this.options = t),
                      i.__super__.constructor.call(this);
                  }
                  return (
                    e.Extend(i, e.Observable),
                    (i.prototype.render = function () {
                      var e = t(
                        '<span class="select2-dropdown"><span class="select2-results"></span></span>'
                      );
                      return (
                        e.attr("dir", this.options.get("dir")),
                        (this.$dropdown = e)
                      );
                    }),
                    (i.prototype.bind = function () {}),
                    (i.prototype.position = function (e, t) {}),
                    (i.prototype.destroy = function () {
                      this.$dropdown.remove();
                    }),
                    i
                  );
                }
              ),
              e.define(
                "select2/dropdown/search",
                ["jquery", "../utils"],
                function (r, e) {
                  function t() {}
                  return (
                    (t.prototype.render = function (e) {
                      var t = e.call(this),
                        i = r(
                          '<span class="select2-search select2-search--dropdown"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></span>'
                        );
                      return (
                        (this.$searchContainer = i),
                        (this.$search = i.find("input")),
                        t.prepend(i),
                        t
                      );
                    }),
                    (t.prototype.bind = function (e, t, i) {
                      var n = this,
                        s = t.id + "-results";
                      e.call(this, t, i),
                        this.$search.on("keydown", function (e) {
                          n.trigger("keypress", e),
                            (n._keyUpPrevented = e.isDefaultPrevented());
                        }),
                        this.$search.on("input", function (e) {
                          r(this).off("keyup");
                        }),
                        this.$search.on("keyup input", function (e) {
                          n.handleSearch(e);
                        }),
                        t.on("open", function () {
                          n.$search.attr("tabindex", 0),
                            n.$search.attr("aria-controls", s),
                            n.$search.trigger("focus"),
                            window.setTimeout(function () {
                              n.$search.trigger("focus");
                            }, 0);
                        }),
                        t.on("close", function () {
                          n.$search.attr("tabindex", -1),
                            n.$search.removeAttr("aria-controls"),
                            n.$search.removeAttr("aria-activedescendant"),
                            n.$search.val(""),
                            n.$search.trigger("blur");
                        }),
                        t.on("focus", function () {
                          t.isOpen() || n.$search.trigger("focus");
                        }),
                        t.on("results:all", function (e) {
                          (null != e.query.term && "" !== e.query.term) ||
                            (n.showSearch(e)
                              ? n.$searchContainer.removeClass(
                                  "select2-search--hide"
                                )
                              : n.$searchContainer.addClass(
                                  "select2-search--hide"
                                ));
                        }),
                        t.on("results:focus", function (e) {
                          e.data._resultId
                            ? n.$search.attr(
                                "aria-activedescendant",
                                e.data._resultId
                              )
                            : n.$search.removeAttr("aria-activedescendant");
                        });
                    }),
                    (t.prototype.handleSearch = function (e) {
                      if (!this._keyUpPrevented) {
                        var t = this.$search.val();
                        this.trigger("query", { term: t });
                      }
                      this._keyUpPrevented = !1;
                    }),
                    (t.prototype.showSearch = function (e, t) {
                      return !0;
                    }),
                    t
                  );
                }
              ),
              e.define("select2/dropdown/hidePlaceholder", [], function () {
                function e(e, t, i, n) {
                  (this.placeholder = this.normalizePlaceholder(
                    i.get("placeholder")
                  )),
                    e.call(this, t, i, n);
                }
                return (
                  (e.prototype.append = function (e, t) {
                    (t.results = this.removePlaceholder(t.results)),
                      e.call(this, t);
                  }),
                  (e.prototype.normalizePlaceholder = function (e, t) {
                    return "string" == typeof t && (t = { id: "", text: t }), t;
                  }),
                  (e.prototype.removePlaceholder = function (e, t) {
                    for (var i = t.slice(0), n = t.length - 1; 0 <= n; n--) {
                      var s = t[n];
                      this.placeholder.id === s.id && i.splice(n, 1);
                    }
                    return i;
                  }),
                  e
                );
              }),
              e.define(
                "select2/dropdown/infiniteScroll",
                ["jquery"],
                function (i) {
                  function e(e, t, i, n) {
                    (this.lastParams = {}),
                      e.call(this, t, i, n),
                      (this.$loadingMore = this.createLoadingMore()),
                      (this.loading = !1);
                  }
                  return (
                    (e.prototype.append = function (e, t) {
                      this.$loadingMore.remove(),
                        (this.loading = !1),
                        e.call(this, t),
                        this.showLoadingMore(t) &&
                          (this.$results.append(this.$loadingMore),
                          this.loadMoreIfNeeded());
                    }),
                    (e.prototype.bind = function (e, t, i) {
                      var n = this;
                      e.call(this, t, i),
                        t.on("query", function (e) {
                          (n.lastParams = e), (n.loading = !0);
                        }),
                        t.on("query:append", function (e) {
                          (n.lastParams = e), (n.loading = !0);
                        }),
                        this.$results.on(
                          "scroll",
                          this.loadMoreIfNeeded.bind(this)
                        );
                    }),
                    (e.prototype.loadMoreIfNeeded = function () {
                      var e = i.contains(
                        document.documentElement,
                        this.$loadingMore[0]
                      );
                      if (!this.loading && e) {
                        var t =
                          this.$results.offset().top +
                          this.$results.outerHeight(!1);
                        this.$loadingMore.offset().top +
                          this.$loadingMore.outerHeight(!1) <=
                          t + 50 && this.loadMore();
                      }
                    }),
                    (e.prototype.loadMore = function () {
                      this.loading = !0;
                      var e = i.extend({}, { page: 1 }, this.lastParams);
                      e.page++, this.trigger("query:append", e);
                    }),
                    (e.prototype.showLoadingMore = function (e, t) {
                      return t.pagination && t.pagination.more;
                    }),
                    (e.prototype.createLoadingMore = function () {
                      var e = i(
                          '<li class="select2-results__option select2-results__option--load-more"role="option" aria-disabled="true"></li>'
                        ),
                        t = this.options.get("translations").get("loadingMore");
                      return e.html(t(this.lastParams)), e;
                    }),
                    e
                  );
                }
              ),
              e.define(
                "select2/dropdown/attachBody",
                ["jquery", "../utils"],
                function (f, a) {
                  function e(e, t, i) {
                    (this.$dropdownParent = f(
                      i.get("dropdownParent") || document.body
                    )),
                      e.call(this, t, i);
                  }
                  return (
                    (e.prototype.bind = function (e, t, i) {
                      var n = this;
                      e.call(this, t, i),
                        t.on("open", function () {
                          n._showDropdown(),
                            n._attachPositioningHandler(t),
                            n._bindContainerResultHandlers(t);
                        }),
                        t.on("close", function () {
                          n._hideDropdown(), n._detachPositioningHandler(t);
                        }),
                        this.$dropdownContainer.on("mousedown", function (e) {
                          e.stopPropagation();
                        });
                    }),
                    (e.prototype.destroy = function (e) {
                      e.call(this), this.$dropdownContainer.remove();
                    }),
                    (e.prototype.position = function (e, t, i) {
                      t.attr("class", i.attr("class")),
                        t.removeClass("select2"),
                        t.addClass("select2-container--open"),
                        t.css({ position: "absolute", top: -999999 }),
                        (this.$container = i);
                    }),
                    (e.prototype.render = function (e) {
                      var t = f("<span></span>"),
                        i = e.call(this);
                      return t.append(i), (this.$dropdownContainer = t);
                    }),
                    (e.prototype._hideDropdown = function (e) {
                      this.$dropdownContainer.detach();
                    }),
                    (e.prototype._bindContainerResultHandlers = function (
                      e,
                      t
                    ) {
                      if (!this._containerResultsHandlersBound) {
                        var i = this;
                        t.on("results:all", function () {
                          i._positionDropdown(), i._resizeDropdown();
                        }),
                          t.on("results:append", function () {
                            i._positionDropdown(), i._resizeDropdown();
                          }),
                          t.on("results:message", function () {
                            i._positionDropdown(), i._resizeDropdown();
                          }),
                          t.on("select", function () {
                            i._positionDropdown(), i._resizeDropdown();
                          }),
                          t.on("unselect", function () {
                            i._positionDropdown(), i._resizeDropdown();
                          }),
                          (this._containerResultsHandlersBound = !0);
                      }
                    }),
                    (e.prototype._attachPositioningHandler = function (e, t) {
                      var i = this,
                        n = "scroll.select2." + t.id,
                        s = "resize.select2." + t.id,
                        r = "orientationchange.select2." + t.id,
                        o = this.$container.parents().filter(a.hasScroll);
                      o.each(function () {
                        a.StoreData(this, "select2-scroll-position", {
                          x: f(this).scrollLeft(),
                          y: f(this).scrollTop(),
                        });
                      }),
                        o.on(n, function (e) {
                          var t = a.GetData(this, "select2-scroll-position");
                          f(this).scrollTop(t.y);
                        }),
                        f(window).on(n + " " + s + " " + r, function (e) {
                          i._positionDropdown(), i._resizeDropdown();
                        });
                    }),
                    (e.prototype._detachPositioningHandler = function (e, t) {
                      var i = "scroll.select2." + t.id,
                        n = "resize.select2." + t.id,
                        s = "orientationchange.select2." + t.id;
                      this.$container.parents().filter(a.hasScroll).off(i),
                        f(window).off(i + " " + n + " " + s);
                    }),
                    (e.prototype._positionDropdown = function () {
                      var e = f(window),
                        t = this.$dropdown.hasClass("select2-dropdown--above"),
                        i = this.$dropdown.hasClass("select2-dropdown--below"),
                        n = null,
                        s = this.$container.offset();
                      s.bottom = s.top + this.$container.outerHeight(!1);
                      var r = { height: this.$container.outerHeight(!1) };
                      (r.top = s.top), (r.bottom = s.top + r.height);
                      var o = this.$dropdown.outerHeight(!1),
                        a = e.scrollTop(),
                        l = e.scrollTop() + e.height(),
                        d = a < s.top - o,
                        c = l > s.bottom + o,
                        u = { left: s.left, top: r.bottom },
                        p = this.$dropdownParent;
                      "static" === p.css("position") && (p = p.offsetParent());
                      var h = { top: 0, left: 0 };
                      (f.contains(document.body, p[0]) || p[0].isConnected) &&
                        (h = p.offset()),
                        (u.top -= h.top),
                        (u.left -= h.left),
                        t || i || (n = "below"),
                        c || !d || t
                          ? !d && c && t && (n = "below")
                          : (n = "above"),
                        ("above" == n || (t && "below" !== n)) &&
                          (u.top = r.top - h.top - o),
                        null != n &&
                          (this.$dropdown
                            .removeClass(
                              "select2-dropdown--below select2-dropdown--above"
                            )
                            .addClass("select2-dropdown--" + n),
                          this.$container
                            .removeClass(
                              "select2-container--below select2-container--above"
                            )
                            .addClass("select2-container--" + n)),
                        this.$dropdownContainer.css(u);
                    }),
                    (e.prototype._resizeDropdown = function () {
                      var e = { width: this.$container.outerWidth(!1) + "px" };
                      this.options.get("dropdownAutoWidth") &&
                        ((e.minWidth = e.width),
                        (e.position = "relative"),
                        (e.width = "auto")),
                        this.$dropdown.css(e);
                    }),
                    (e.prototype._showDropdown = function (e) {
                      this.$dropdownContainer.appendTo(this.$dropdownParent),
                        this._positionDropdown(),
                        this._resizeDropdown();
                    }),
                    e
                  );
                }
              ),
              e.define(
                "select2/dropdown/minimumResultsForSearch",
                [],
                function () {
                  function e(e, t, i, n) {
                    (this.minimumResultsForSearch = i.get(
                      "minimumResultsForSearch"
                    )),
                      this.minimumResultsForSearch < 0 &&
                        (this.minimumResultsForSearch = 1 / 0),
                      e.call(this, t, i, n);
                  }
                  return (
                    (e.prototype.showSearch = function (e, t) {
                      return (
                        !(
                          (function e(t) {
                            for (var i = 0, n = 0; n < t.length; n++) {
                              var s = t[n];
                              s.children ? (i += e(s.children)) : i++;
                            }
                            return i;
                          })(t.data.results) < this.minimumResultsForSearch
                        ) && e.call(this, t)
                      );
                    }),
                    e
                  );
                }
              ),
              e.define(
                "select2/dropdown/selectOnClose",
                ["../utils"],
                function (r) {
                  function e() {}
                  return (
                    (e.prototype.bind = function (e, t, i) {
                      var n = this;
                      e.call(this, t, i),
                        t.on("close", function (e) {
                          n._handleSelectOnClose(e);
                        });
                    }),
                    (e.prototype._handleSelectOnClose = function (e, t) {
                      if (t && null != t.originalSelect2Event) {
                        var i = t.originalSelect2Event;
                        if ("select" === i._type || "unselect" === i._type)
                          return;
                      }
                      var n = this.getHighlightedResults();
                      if (!(n.length < 1)) {
                        var s = r.GetData(n[0], "data");
                        (null != s.element && s.element.selected) ||
                          (null == s.element && s.selected) ||
                          this.trigger("select", { data: s });
                      }
                    }),
                    e
                  );
                }
              ),
              e.define("select2/dropdown/closeOnSelect", [], function () {
                function e() {}
                return (
                  (e.prototype.bind = function (e, t, i) {
                    var n = this;
                    e.call(this, t, i),
                      t.on("select", function (e) {
                        n._selectTriggered(e);
                      }),
                      t.on("unselect", function (e) {
                        n._selectTriggered(e);
                      });
                  }),
                  (e.prototype._selectTriggered = function (e, t) {
                    var i = t.originalEvent;
                    (i && (i.ctrlKey || i.metaKey)) ||
                      this.trigger("close", {
                        originalEvent: i,
                        originalSelect2Event: t,
                      });
                  }),
                  e
                );
              }),
              e.define("select2/i18n/en", [], function () {
                return {
                  errorLoading: function () {
                    return "The results could not be loaded.";
                  },
                  inputTooLong: function (e) {
                    var t = e.input.length - e.maximum,
                      i = "Please delete " + t + " character";
                    return 1 != t && (i += "s"), i;
                  },
                  inputTooShort: function (e) {
                    return (
                      "Please enter " +
                      (e.minimum - e.input.length) +
                      " or more characters"
                    );
                  },
                  loadingMore: function () {
                    return "Loading more results…";
                  },
                  maximumSelected: function (e) {
                    var t = "You can only select " + e.maximum + " item";
                    return 1 != e.maximum && (t += "s"), t;
                  },
                  noResults: function () {
                    return "No results found";
                  },
                  searching: function () {
                    return "Searching…";
                  },
                  removeAllItems: function () {
                    return "Remove all items";
                  },
                };
              }),
              e.define(
                "select2/defaults",
                [
                  "jquery",
                  "require",
                  "./results",
                  "./selection/single",
                  "./selection/multiple",
                  "./selection/placeholder",
                  "./selection/allowClear",
                  "./selection/search",
                  "./selection/eventRelay",
                  "./utils",
                  "./translation",
                  "./diacritics",
                  "./data/select",
                  "./data/array",
                  "./data/ajax",
                  "./data/tags",
                  "./data/tokenizer",
                  "./data/minimumInputLength",
                  "./data/maximumInputLength",
                  "./data/maximumSelectionLength",
                  "./dropdown",
                  "./dropdown/search",
                  "./dropdown/hidePlaceholder",
                  "./dropdown/infiniteScroll",
                  "./dropdown/attachBody",
                  "./dropdown/minimumResultsForSearch",
                  "./dropdown/selectOnClose",
                  "./dropdown/closeOnSelect",
                  "./i18n/en",
                ],
                function (
                  d,
                  c,
                  u,
                  p,
                  h,
                  f,
                  m,
                  g,
                  v,
                  y,
                  o,
                  t,
                  b,
                  w,
                  x,
                  T,
                  S,
                  C,
                  E,
                  k,
                  $,
                  A,
                  z,
                  M,
                  D,
                  _,
                  P,
                  L,
                  e
                ) {
                  function i() {
                    this.reset();
                  }
                  return (
                    (i.prototype.apply = function (e) {
                      if (
                        null ==
                        (e = d.extend(!0, {}, this.defaults, e)).dataAdapter
                      ) {
                        if (
                          (null != e.ajax
                            ? (e.dataAdapter = x)
                            : null != e.data
                            ? (e.dataAdapter = w)
                            : (e.dataAdapter = b),
                          0 < e.minimumInputLength &&
                            (e.dataAdapter = y.Decorate(e.dataAdapter, C)),
                          0 < e.maximumInputLength &&
                            (e.dataAdapter = y.Decorate(e.dataAdapter, E)),
                          0 < e.maximumSelectionLength &&
                            (e.dataAdapter = y.Decorate(e.dataAdapter, k)),
                          e.tags &&
                            (e.dataAdapter = y.Decorate(e.dataAdapter, T)),
                          (null == e.tokenSeparators && null == e.tokenizer) ||
                            (e.dataAdapter = y.Decorate(e.dataAdapter, S)),
                          null != e.query)
                        ) {
                          var t = c(e.amdBase + "compat/query");
                          e.dataAdapter = y.Decorate(e.dataAdapter, t);
                        }
                        if (null != e.initSelection) {
                          var i = c(e.amdBase + "compat/initSelection");
                          e.dataAdapter = y.Decorate(e.dataAdapter, i);
                        }
                      }
                      if (
                        (null == e.resultsAdapter &&
                          ((e.resultsAdapter = u),
                          null != e.ajax &&
                            (e.resultsAdapter = y.Decorate(
                              e.resultsAdapter,
                              M
                            )),
                          null != e.placeholder &&
                            (e.resultsAdapter = y.Decorate(
                              e.resultsAdapter,
                              z
                            )),
                          e.selectOnClose &&
                            (e.resultsAdapter = y.Decorate(
                              e.resultsAdapter,
                              P
                            ))),
                        null == e.dropdownAdapter)
                      ) {
                        if (e.multiple) e.dropdownAdapter = $;
                        else {
                          var n = y.Decorate($, A);
                          e.dropdownAdapter = n;
                        }
                        if (
                          (0 !== e.minimumResultsForSearch &&
                            (e.dropdownAdapter = y.Decorate(
                              e.dropdownAdapter,
                              _
                            )),
                          e.closeOnSelect &&
                            (e.dropdownAdapter = y.Decorate(
                              e.dropdownAdapter,
                              L
                            )),
                          null != e.dropdownCssClass ||
                            null != e.dropdownCss ||
                            null != e.adaptDropdownCssClass)
                        ) {
                          var s = c(e.amdBase + "compat/dropdownCss");
                          e.dropdownAdapter = y.Decorate(e.dropdownAdapter, s);
                        }
                        e.dropdownAdapter = y.Decorate(e.dropdownAdapter, D);
                      }
                      if (null == e.selectionAdapter) {
                        if (
                          (e.multiple
                            ? (e.selectionAdapter = h)
                            : (e.selectionAdapter = p),
                          null != e.placeholder &&
                            (e.selectionAdapter = y.Decorate(
                              e.selectionAdapter,
                              f
                            )),
                          e.allowClear &&
                            (e.selectionAdapter = y.Decorate(
                              e.selectionAdapter,
                              m
                            )),
                          e.multiple &&
                            (e.selectionAdapter = y.Decorate(
                              e.selectionAdapter,
                              g
                            )),
                          null != e.containerCssClass ||
                            null != e.containerCss ||
                            null != e.adaptContainerCssClass)
                        ) {
                          var r = c(e.amdBase + "compat/containerCss");
                          e.selectionAdapter = y.Decorate(
                            e.selectionAdapter,
                            r
                          );
                        }
                        e.selectionAdapter = y.Decorate(e.selectionAdapter, v);
                      }
                      (e.language = this._resolveLanguage(e.language)),
                        e.language.push("en");
                      for (var o = [], a = 0; a < e.language.length; a++) {
                        var l = e.language[a];
                        -1 === o.indexOf(l) && o.push(l);
                      }
                      return (
                        (e.language = o),
                        (e.translations = this._processTranslations(
                          e.language,
                          e.debug
                        )),
                        e
                      );
                    }),
                    (i.prototype.reset = function () {
                      function a(e) {
                        return e.replace(/[^\u0000-\u007E]/g, function (e) {
                          return t[e] || e;
                        });
                      }
                      this.defaults = {
                        amdBase: "./",
                        amdLanguageBase: "./i18n/",
                        closeOnSelect: !0,
                        debug: !1,
                        dropdownAutoWidth: !1,
                        escapeMarkup: y.escapeMarkup,
                        language: {},
                        matcher: function e(t, i) {
                          if ("" === d.trim(t.term)) return i;
                          if (i.children && 0 < i.children.length) {
                            for (
                              var n = d.extend(!0, {}, i),
                                s = i.children.length - 1;
                              0 <= s;
                              s--
                            )
                              null == e(t, i.children[s]) &&
                                n.children.splice(s, 1);
                            return 0 < n.children.length ? n : e(t, n);
                          }
                          var r = a(i.text).toUpperCase(),
                            o = a(t.term).toUpperCase();
                          return -1 < r.indexOf(o) ? i : null;
                        },
                        minimumInputLength: 0,
                        maximumInputLength: 0,
                        maximumSelectionLength: 0,
                        minimumResultsForSearch: 0,
                        selectOnClose: !1,
                        scrollAfterSelect: !1,
                        sorter: function (e) {
                          return e;
                        },
                        templateResult: function (e) {
                          return e.text;
                        },
                        templateSelection: function (e) {
                          return e.text;
                        },
                        theme: "default",
                        width: "resolve",
                      };
                    }),
                    (i.prototype.applyFromElement = function (e, t) {
                      var i = e.language,
                        n = this.defaults.language,
                        s = t.prop("lang"),
                        r = t.closest("[lang]").prop("lang"),
                        o = Array.prototype.concat.call(
                          this._resolveLanguage(s),
                          this._resolveLanguage(i),
                          this._resolveLanguage(n),
                          this._resolveLanguage(r)
                        );
                      return (e.language = o), e;
                    }),
                    (i.prototype._resolveLanguage = function (e) {
                      if (!e) return [];
                      if (d.isEmptyObject(e)) return [];
                      if (d.isPlainObject(e)) return [e];
                      var t;
                      t = d.isArray(e) ? e : [e];
                      for (var i = [], n = 0; n < t.length; n++)
                        if (
                          (i.push(t[n]),
                          "string" == typeof t[n] && 0 < t[n].indexOf("-"))
                        ) {
                          var s = t[n].split("-")[0];
                          i.push(s);
                        }
                      return i;
                    }),
                    (i.prototype._processTranslations = function (e, t) {
                      for (var i = new o(), n = 0; n < e.length; n++) {
                        var s = new o(),
                          r = e[n];
                        if ("string" == typeof r)
                          try {
                            s = o.loadPath(r);
                          } catch (e) {
                            try {
                              (r = this.defaults.amdLanguageBase + r),
                                (s = o.loadPath(r));
                            } catch (e) {
                              t &&
                                window.console &&
                                console.warn &&
                                console.warn(
                                  'Select2: The language file for "' +
                                    r +
                                    '" could not be automatically loaded. A fallback will be used instead.'
                                );
                            }
                          }
                        else s = d.isPlainObject(r) ? new o(r) : r;
                        i.extend(s);
                      }
                      return i;
                    }),
                    (i.prototype.set = function (e, t) {
                      var i = {};
                      i[d.camelCase(e)] = t;
                      var n = y._convertData(i);
                      d.extend(!0, this.defaults, n);
                    }),
                    new i()
                  );
                }
              ),
              e.define(
                "select2/options",
                ["require", "jquery", "./defaults", "./utils"],
                function (n, c, s, u) {
                  function e(e, t) {
                    if (
                      ((this.options = e),
                      null != t && this.fromElement(t),
                      null != t &&
                        (this.options = s.applyFromElement(this.options, t)),
                      (this.options = s.apply(this.options)),
                      t && t.is("input"))
                    ) {
                      var i = n(this.get("amdBase") + "compat/inputData");
                      this.options.dataAdapter = u.Decorate(
                        this.options.dataAdapter,
                        i
                      );
                    }
                  }
                  return (
                    (e.prototype.fromElement = function (e) {
                      var t = ["select2"];
                      null == this.options.multiple &&
                        (this.options.multiple = e.prop("multiple")),
                        null == this.options.disabled &&
                          (this.options.disabled = e.prop("disabled")),
                        null == this.options.dir &&
                          (e.prop("dir")
                            ? (this.options.dir = e.prop("dir"))
                            : e.closest("[dir]").prop("dir")
                            ? (this.options.dir = e
                                .closest("[dir]")
                                .prop("dir"))
                            : (this.options.dir = "ltr")),
                        e.prop("disabled", this.options.disabled),
                        e.prop("multiple", this.options.multiple),
                        u.GetData(e[0], "select2Tags") &&
                          (this.options.debug &&
                            window.console &&
                            console.warn &&
                            console.warn(
                              'Select2: The `data-select2-tags` attribute has been changed to use the `data-data` and `data-tags="true"` attributes and will be removed in future versions of Select2.'
                            ),
                          u.StoreData(
                            e[0],
                            "data",
                            u.GetData(e[0], "select2Tags")
                          ),
                          u.StoreData(e[0], "tags", !0)),
                        u.GetData(e[0], "ajaxUrl") &&
                          (this.options.debug &&
                            window.console &&
                            console.warn &&
                            console.warn(
                              "Select2: The `data-ajax-url` attribute has been changed to `data-ajax--url` and support for the old attribute will be removed in future versions of Select2."
                            ),
                          e.attr("ajax--url", u.GetData(e[0], "ajaxUrl")),
                          u.StoreData(
                            e[0],
                            "ajax-Url",
                            u.GetData(e[0], "ajaxUrl")
                          ));
                      var i = {};
                      function n(e, t) {
                        return t.toUpperCase();
                      }
                      for (var s = 0; s < e[0].attributes.length; s++) {
                        var r = e[0].attributes[s].name;
                        if ("data-" == r.substr(0, "data-".length)) {
                          var o = r.substring("data-".length),
                            a = u.GetData(e[0], o);
                          i[o.replace(/-([a-z])/g, n)] = a;
                        }
                      }
                      c.fn.jquery &&
                        "1." == c.fn.jquery.substr(0, 2) &&
                        e[0].dataset &&
                        (i = c.extend(!0, {}, e[0].dataset, i));
                      var l = c.extend(!0, {}, u.GetData(e[0]), i);
                      for (var d in (l = u._convertData(l)))
                        -1 < c.inArray(d, t) ||
                          (c.isPlainObject(this.options[d])
                            ? c.extend(this.options[d], l[d])
                            : (this.options[d] = l[d]));
                      return this;
                    }),
                    (e.prototype.get = function (e) {
                      return this.options[e];
                    }),
                    (e.prototype.set = function (e, t) {
                      this.options[e] = t;
                    }),
                    e
                  );
                }
              ),
              e.define(
                "select2/core",
                ["jquery", "./options", "./utils", "./keys"],
                function (s, d, c, n) {
                  function u(e, t) {
                    null != c.GetData(e[0], "select2") &&
                      c.GetData(e[0], "select2").destroy(),
                      (this.$element = e),
                      (this.id = this._generateId(e)),
                      (t = t || {}),
                      (this.options = new d(t, e)),
                      u.__super__.constructor.call(this);
                    var i = e.attr("tabindex") || 0;
                    c.StoreData(e[0], "old-tabindex", i),
                      e.attr("tabindex", "-1");
                    var n = this.options.get("dataAdapter");
                    this.dataAdapter = new n(e, this.options);
                    var s = this.render();
                    this._placeContainer(s);
                    var r = this.options.get("selectionAdapter");
                    (this.selection = new r(e, this.options)),
                      (this.$selection = this.selection.render()),
                      this.selection.position(this.$selection, s);
                    var o = this.options.get("dropdownAdapter");
                    (this.dropdown = new o(e, this.options)),
                      (this.$dropdown = this.dropdown.render()),
                      this.dropdown.position(this.$dropdown, s);
                    var a = this.options.get("resultsAdapter");
                    (this.results = new a(e, this.options, this.dataAdapter)),
                      (this.$results = this.results.render()),
                      this.results.position(this.$results, this.$dropdown);
                    var l = this;
                    this._bindAdapters(),
                      this._registerDomEvents(),
                      this._registerDataEvents(),
                      this._registerSelectionEvents(),
                      this._registerDropdownEvents(),
                      this._registerResultsEvents(),
                      this._registerEvents(),
                      this.dataAdapter.current(function (e) {
                        l.trigger("selection:update", { data: e });
                      }),
                      e.addClass("select2-hidden-accessible"),
                      e.attr("aria-hidden", "true"),
                      this._syncAttributes(),
                      c.StoreData(e[0], "select2", this),
                      e.data("select2", this);
                  }
                  return (
                    c.Extend(u, c.Observable),
                    (u.prototype._generateId = function (e) {
                      return (
                        "select2-" +
                        (null != e.attr("id")
                          ? e.attr("id")
                          : null != e.attr("name")
                          ? e.attr("name") + "-" + c.generateChars(2)
                          : c.generateChars(4)
                        ).replace(/(:|\.|\[|\]|,)/g, "")
                      );
                    }),
                    (u.prototype._placeContainer = function (e) {
                      e.insertAfter(this.$element);
                      var t = this._resolveWidth(
                        this.$element,
                        this.options.get("width")
                      );
                      null != t && e.css("width", t);
                    }),
                    (u.prototype._resolveWidth = function (e, t) {
                      var i =
                        /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;
                      if ("resolve" == t) {
                        var n = this._resolveWidth(e, "style");
                        return null != n ? n : this._resolveWidth(e, "element");
                      }
                      if ("element" == t) {
                        var s = e.outerWidth(!1);
                        return s <= 0 ? "auto" : s + "px";
                      }
                      if ("style" != t)
                        return "computedstyle" != t
                          ? t
                          : window.getComputedStyle(e[0]).width;
                      var r = e.attr("style");
                      if ("string" != typeof r) return null;
                      for (
                        var o = r.split(";"), a = 0, l = o.length;
                        a < l;
                        a += 1
                      ) {
                        var d = o[a].replace(/\s/g, "").match(i);
                        if (null !== d && 1 <= d.length) return d[1];
                      }
                      return null;
                    }),
                    (u.prototype._bindAdapters = function () {
                      this.dataAdapter.bind(this, this.$container),
                        this.selection.bind(this, this.$container),
                        this.dropdown.bind(this, this.$container),
                        this.results.bind(this, this.$container);
                    }),
                    (u.prototype._registerDomEvents = function () {
                      var t = this;
                      this.$element.on("change.select2", function () {
                        t.dataAdapter.current(function (e) {
                          t.trigger("selection:update", { data: e });
                        });
                      }),
                        this.$element.on("focus.select2", function (e) {
                          t.trigger("focus", e);
                        }),
                        (this._syncA = c.bind(this._syncAttributes, this)),
                        (this._syncS = c.bind(this._syncSubtree, this)),
                        this.$element[0].attachEvent &&
                          this.$element[0].attachEvent(
                            "onpropertychange",
                            this._syncA
                          );
                      var e =
                        window.MutationObserver ||
                        window.WebKitMutationObserver ||
                        window.MozMutationObserver;
                      null != e
                        ? ((this._observer = new e(function (e) {
                            s.each(e, t._syncA), s.each(e, t._syncS);
                          })),
                          this._observer.observe(this.$element[0], {
                            attributes: !0,
                            childList: !0,
                            subtree: !1,
                          }))
                        : this.$element[0].addEventListener &&
                          (this.$element[0].addEventListener(
                            "DOMAttrModified",
                            t._syncA,
                            !1
                          ),
                          this.$element[0].addEventListener(
                            "DOMNodeInserted",
                            t._syncS,
                            !1
                          ),
                          this.$element[0].addEventListener(
                            "DOMNodeRemoved",
                            t._syncS,
                            !1
                          ));
                    }),
                    (u.prototype._registerDataEvents = function () {
                      var i = this;
                      this.dataAdapter.on("*", function (e, t) {
                        i.trigger(e, t);
                      });
                    }),
                    (u.prototype._registerSelectionEvents = function () {
                      var i = this,
                        n = ["toggle", "focus"];
                      this.selection.on("toggle", function () {
                        i.toggleDropdown();
                      }),
                        this.selection.on("focus", function (e) {
                          i.focus(e);
                        }),
                        this.selection.on("*", function (e, t) {
                          -1 === s.inArray(e, n) && i.trigger(e, t);
                        });
                    }),
                    (u.prototype._registerDropdownEvents = function () {
                      var i = this;
                      this.dropdown.on("*", function (e, t) {
                        i.trigger(e, t);
                      });
                    }),
                    (u.prototype._registerResultsEvents = function () {
                      var i = this;
                      this.results.on("*", function (e, t) {
                        i.trigger(e, t);
                      });
                    }),
                    (u.prototype._registerEvents = function () {
                      var i = this;
                      this.on("open", function () {
                        i.$container.addClass("select2-container--open");
                      }),
                        this.on("close", function () {
                          i.$container.removeClass("select2-container--open");
                        }),
                        this.on("enable", function () {
                          i.$container.removeClass(
                            "select2-container--disabled"
                          );
                        }),
                        this.on("disable", function () {
                          i.$container.addClass("select2-container--disabled");
                        }),
                        this.on("blur", function () {
                          i.$container.removeClass("select2-container--focus");
                        }),
                        this.on("query", function (t) {
                          i.isOpen() || i.trigger("open", {}),
                            this.dataAdapter.query(t, function (e) {
                              i.trigger("results:all", { data: e, query: t });
                            });
                        }),
                        this.on("query:append", function (t) {
                          this.dataAdapter.query(t, function (e) {
                            i.trigger("results:append", { data: e, query: t });
                          });
                        }),
                        this.on("keypress", function (e) {
                          var t = e.which;
                          i.isOpen()
                            ? t === n.ESC ||
                              t === n.TAB ||
                              (t === n.UP && e.altKey)
                              ? (i.close(), e.preventDefault())
                              : t === n.ENTER
                              ? (i.trigger("results:select", {}),
                                e.preventDefault())
                              : t === n.SPACE && e.ctrlKey
                              ? (i.trigger("results:toggle", {}),
                                e.preventDefault())
                              : t === n.UP
                              ? (i.trigger("results:previous", {}),
                                e.preventDefault())
                              : t === n.DOWN &&
                                (i.trigger("results:next", {}),
                                e.preventDefault())
                            : (t === n.ENTER ||
                                t === n.SPACE ||
                                (t === n.DOWN && e.altKey)) &&
                              (i.open(), e.preventDefault());
                        });
                    }),
                    (u.prototype._syncAttributes = function () {
                      this.options.set(
                        "disabled",
                        this.$element.prop("disabled")
                      ),
                        this.options.get("disabled")
                          ? (this.isOpen() && this.close(),
                            this.trigger("disable", {}))
                          : this.trigger("enable", {});
                    }),
                    (u.prototype._syncSubtree = function (e, t) {
                      var i = !1,
                        n = this;
                      if (
                        !e ||
                        !e.target ||
                        "OPTION" === e.target.nodeName ||
                        "OPTGROUP" === e.target.nodeName
                      ) {
                        if (t)
                          if (t.addedNodes && 0 < t.addedNodes.length)
                            for (var s = 0; s < t.addedNodes.length; s++)
                              t.addedNodes[s].selected && (i = !0);
                          else
                            t.removedNodes &&
                              0 < t.removedNodes.length &&
                              (i = !0);
                        else i = !0;
                        i &&
                          this.dataAdapter.current(function (e) {
                            n.trigger("selection:update", { data: e });
                          });
                      }
                    }),
                    (u.prototype.trigger = function (e, t) {
                      var i = u.__super__.trigger,
                        n = {
                          open: "opening",
                          close: "closing",
                          select: "selecting",
                          unselect: "unselecting",
                          clear: "clearing",
                        };
                      if ((void 0 === t && (t = {}), e in n)) {
                        var s = n[e],
                          r = { prevented: !1, name: e, args: t };
                        if ((i.call(this, s, r), r.prevented))
                          return void (t.prevented = !0);
                      }
                      i.call(this, e, t);
                    }),
                    (u.prototype.toggleDropdown = function () {
                      this.options.get("disabled") ||
                        (this.isOpen() ? this.close() : this.open());
                    }),
                    (u.prototype.open = function () {
                      this.isOpen() || this.trigger("query", {});
                    }),
                    (u.prototype.close = function () {
                      this.isOpen() && this.trigger("close", {});
                    }),
                    (u.prototype.isOpen = function () {
                      return this.$container.hasClass(
                        "select2-container--open"
                      );
                    }),
                    (u.prototype.hasFocus = function () {
                      return this.$container.hasClass(
                        "select2-container--focus"
                      );
                    }),
                    (u.prototype.focus = function (e) {
                      this.hasFocus() ||
                        (this.$container.addClass("select2-container--focus"),
                        this.trigger("focus", {}));
                    }),
                    (u.prototype.enable = function (e) {
                      this.options.get("debug") &&
                        window.console &&
                        console.warn &&
                        console.warn(
                          'Select2: The `select2("enable")` method has been deprecated and will be removed in later Select2 versions. Use $element.prop("disabled") instead.'
                        ),
                        (null != e && 0 !== e.length) || (e = [!0]);
                      var t = !e[0];
                      this.$element.prop("disabled", t);
                    }),
                    (u.prototype.data = function () {
                      this.options.get("debug") &&
                        0 < arguments.length &&
                        window.console &&
                        console.warn &&
                        console.warn(
                          'Select2: Data can no longer be set using `select2("data")`. You should consider setting the value instead using `$element.val()`.'
                        );
                      var t = [];
                      return (
                        this.dataAdapter.current(function (e) {
                          t = e;
                        }),
                        t
                      );
                    }),
                    (u.prototype.val = function (e) {
                      if (
                        (this.options.get("debug") &&
                          window.console &&
                          console.warn &&
                          console.warn(
                            'Select2: The `select2("val")` method has been deprecated and will be removed in later Select2 versions. Use $element.val() instead.'
                          ),
                        null == e || 0 === e.length)
                      )
                        return this.$element.val();
                      var t = e[0];
                      s.isArray(t) &&
                        (t = s.map(t, function (e) {
                          return e.toString();
                        })),
                        this.$element.val(t).trigger("change");
                    }),
                    (u.prototype.destroy = function () {
                      this.$container.remove(),
                        this.$element[0].detachEvent &&
                          this.$element[0].detachEvent(
                            "onpropertychange",
                            this._syncA
                          ),
                        null != this._observer
                          ? (this._observer.disconnect(),
                            (this._observer = null))
                          : this.$element[0].removeEventListener &&
                            (this.$element[0].removeEventListener(
                              "DOMAttrModified",
                              this._syncA,
                              !1
                            ),
                            this.$element[0].removeEventListener(
                              "DOMNodeInserted",
                              this._syncS,
                              !1
                            ),
                            this.$element[0].removeEventListener(
                              "DOMNodeRemoved",
                              this._syncS,
                              !1
                            )),
                        (this._syncA = null),
                        (this._syncS = null),
                        this.$element.off(".select2"),
                        this.$element.attr(
                          "tabindex",
                          c.GetData(this.$element[0], "old-tabindex")
                        ),
                        this.$element.removeClass("select2-hidden-accessible"),
                        this.$element.attr("aria-hidden", "false"),
                        c.RemoveData(this.$element[0]),
                        this.$element.removeData("select2"),
                        this.dataAdapter.destroy(),
                        this.selection.destroy(),
                        this.dropdown.destroy(),
                        this.results.destroy(),
                        (this.dataAdapter = null),
                        (this.selection = null),
                        (this.dropdown = null),
                        (this.results = null);
                    }),
                    (u.prototype.render = function () {
                      var e = s(
                        '<span class="select2 select2-container"><span class="selection"></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>'
                      );
                      return (
                        e.attr("dir", this.options.get("dir")),
                        (this.$container = e),
                        this.$container.addClass(
                          "select2-container--" + this.options.get("theme")
                        ),
                        c.StoreData(e[0], "element", this.$element),
                        e
                      );
                    }),
                    u
                  );
                }
              ),
              e.define("select2/compat/utils", ["jquery"], function (o) {
                return {
                  syncCssClasses: function (e, t, i) {
                    var n,
                      s,
                      r = [];
                    (n = o.trim(e.attr("class"))) &&
                      o((n = "" + n).split(/\s+/)).each(function () {
                        0 === this.indexOf("select2-") && r.push(this);
                      }),
                      (n = o.trim(t.attr("class"))) &&
                        o((n = "" + n).split(/\s+/)).each(function () {
                          0 !== this.indexOf("select2-") &&
                            null != (s = i(this)) &&
                            r.push(s);
                        }),
                      e.attr("class", r.join(" "));
                  },
                };
              }),
              e.define(
                "select2/compat/containerCss",
                ["jquery", "./utils"],
                function (o, a) {
                  function l(e) {
                    return null;
                  }
                  function e() {}
                  return (
                    (e.prototype.render = function (e) {
                      var t = e.call(this),
                        i = this.options.get("containerCssClass") || "";
                      o.isFunction(i) && (i = i(this.$element));
                      var n = this.options.get("adaptContainerCssClass");
                      if (((n = n || l), -1 !== i.indexOf(":all:"))) {
                        i = i.replace(":all:", "");
                        var s = n;
                        n = function (e) {
                          var t = s(e);
                          return null != t ? t + " " + e : e;
                        };
                      }
                      var r = this.options.get("containerCss") || {};
                      return (
                        o.isFunction(r) && (r = r(this.$element)),
                        a.syncCssClasses(t, this.$element, n),
                        t.css(r),
                        t.addClass(i),
                        t
                      );
                    }),
                    e
                  );
                }
              ),
              e.define(
                "select2/compat/dropdownCss",
                ["jquery", "./utils"],
                function (o, a) {
                  function l(e) {
                    return null;
                  }
                  function e() {}
                  return (
                    (e.prototype.render = function (e) {
                      var t = e.call(this),
                        i = this.options.get("dropdownCssClass") || "";
                      o.isFunction(i) && (i = i(this.$element));
                      var n = this.options.get("adaptDropdownCssClass");
                      if (((n = n || l), -1 !== i.indexOf(":all:"))) {
                        i = i.replace(":all:", "");
                        var s = n;
                        n = function (e) {
                          var t = s(e);
                          return null != t ? t + " " + e : e;
                        };
                      }
                      var r = this.options.get("dropdownCss") || {};
                      return (
                        o.isFunction(r) && (r = r(this.$element)),
                        a.syncCssClasses(t, this.$element, n),
                        t.css(r),
                        t.addClass(i),
                        t
                      );
                    }),
                    e
                  );
                }
              ),
              e.define(
                "select2/compat/initSelection",
                ["jquery"],
                function (n) {
                  function e(e, t, i) {
                    i.get("debug") &&
                      window.console &&
                      console.warn &&
                      console.warn(
                        "Select2: The `initSelection` option has been deprecated in favor of a custom data adapter that overrides the `current` method. This method is now called multiple times instead of a single time when the instance is initialized. Support will be removed for the `initSelection` option in future versions of Select2"
                      ),
                      (this.initSelection = i.get("initSelection")),
                      (this._isInitialized = !1),
                      e.call(this, t, i);
                  }
                  return (
                    (e.prototype.current = function (e, t) {
                      var i = this;
                      this._isInitialized
                        ? e.call(this, t)
                        : this.initSelection.call(
                            null,
                            this.$element,
                            function (e) {
                              (i._isInitialized = !0),
                                n.isArray(e) || (e = [e]),
                                t(e);
                            }
                          );
                    }),
                    e
                  );
                }
              ),
              e.define(
                "select2/compat/inputData",
                ["jquery", "../utils"],
                function (o, n) {
                  function e(e, t, i) {
                    (this._currentData = []),
                      (this._valueSeparator = i.get("valueSeparator") || ","),
                      "hidden" === t.prop("type") &&
                        i.get("debug") &&
                        console &&
                        console.warn &&
                        console.warn(
                          "Select2: Using a hidden input with Select2 is no longer supported and may stop working in the future. It is recommended to use a `<select>` element instead."
                        ),
                      e.call(this, t, i);
                  }
                  return (
                    (e.prototype.current = function (e, t) {
                      function n(e, t) {
                        var i = [];
                        return (
                          e.selected || -1 !== o.inArray(e.id, t)
                            ? ((e.selected = !0), i.push(e))
                            : (e.selected = !1),
                          e.children && i.push.apply(i, n(e.children, t)),
                          i
                        );
                      }
                      for (
                        var i = [], s = 0;
                        s < this._currentData.length;
                        s++
                      ) {
                        var r = this._currentData[s];
                        i.push.apply(
                          i,
                          n(r, this.$element.val().split(this._valueSeparator))
                        );
                      }
                      t(i);
                    }),
                    (e.prototype.select = function (e, t) {
                      if (this.options.get("multiple")) {
                        var i = this.$element.val();
                        (i += this._valueSeparator + t.id),
                          this.$element.val(i),
                          this.$element.trigger("change");
                      } else
                        this.current(function (e) {
                          o.map(e, function (e) {
                            e.selected = !1;
                          });
                        }),
                          this.$element.val(t.id),
                          this.$element.trigger("change");
                    }),
                    (e.prototype.unselect = function (e, s) {
                      var r = this;
                      (s.selected = !1),
                        this.current(function (e) {
                          for (var t = [], i = 0; i < e.length; i++) {
                            var n = e[i];
                            s.id != n.id && t.push(n.id);
                          }
                          r.$element.val(t.join(r._valueSeparator)),
                            r.$element.trigger("change");
                        });
                    }),
                    (e.prototype.query = function (e, t, i) {
                      for (
                        var n = [], s = 0;
                        s < this._currentData.length;
                        s++
                      ) {
                        var r = this._currentData[s],
                          o = this.matches(t, r);
                        null !== o && n.push(o);
                      }
                      i({ results: n });
                    }),
                    (e.prototype.addOptions = function (e, t) {
                      var i = o.map(t, function (e) {
                        return n.GetData(e[0], "data");
                      });
                      this._currentData.push.apply(this._currentData, i);
                    }),
                    e
                  );
                }
              ),
              e.define("select2/compat/matcher", ["jquery"], function (o) {
                return function (r) {
                  return function (e, t) {
                    var i = o.extend(!0, {}, t);
                    if (null == e.term || "" === o.trim(e.term)) return i;
                    if (t.children) {
                      for (var n = t.children.length - 1; 0 <= n; n--) {
                        var s = t.children[n];
                        r(e.term, s.text, s) || i.children.splice(n, 1);
                      }
                      if (0 < i.children.length) return i;
                    }
                    return r(e.term, t.text, t) ? i : null;
                  };
                };
              }),
              e.define("select2/compat/query", [], function () {
                function e(e, t, i) {
                  i.get("debug") &&
                    window.console &&
                    console.warn &&
                    console.warn(
                      "Select2: The `query` option has been deprecated in favor of a custom data adapter that overrides the `query` method. Support will be removed for the `query` option in future versions of Select2."
                    ),
                    e.call(this, t, i);
                }
                return (
                  (e.prototype.query = function (e, t, i) {
                    (t.callback = i), this.options.get("query").call(null, t);
                  }),
                  e
                );
              }),
              e.define("select2/dropdown/attachContainer", [], function () {
                function e(e, t, i) {
                  e.call(this, t, i);
                }
                return (
                  (e.prototype.position = function (e, t, i) {
                    i.find(".dropdown-wrapper").append(t),
                      t.addClass("select2-dropdown--below"),
                      i.addClass("select2-container--below");
                  }),
                  e
                );
              }),
              e.define("select2/dropdown/stopPropagation", [], function () {
                function e() {}
                return (
                  (e.prototype.bind = function (e, t, i) {
                    e.call(this, t, i),
                      this.$dropdown.on(
                        [
                          "blur",
                          "change",
                          "click",
                          "dblclick",
                          "focus",
                          "focusin",
                          "focusout",
                          "input",
                          "keydown",
                          "keyup",
                          "keypress",
                          "mousedown",
                          "mouseenter",
                          "mouseleave",
                          "mousemove",
                          "mouseover",
                          "mouseup",
                          "search",
                          "touchend",
                          "touchstart",
                        ].join(" "),
                        function (e) {
                          e.stopPropagation();
                        }
                      );
                  }),
                  e
                );
              }),
              e.define("select2/selection/stopPropagation", [], function () {
                function e() {}
                return (
                  (e.prototype.bind = function (e, t, i) {
                    e.call(this, t, i),
                      this.$selection.on(
                        [
                          "blur",
                          "change",
                          "click",
                          "dblclick",
                          "focus",
                          "focusin",
                          "focusout",
                          "input",
                          "keydown",
                          "keyup",
                          "keypress",
                          "mousedown",
                          "mouseenter",
                          "mouseleave",
                          "mousemove",
                          "mouseover",
                          "mouseup",
                          "search",
                          "touchend",
                          "touchstart",
                        ].join(" "),
                        function (e) {
                          e.stopPropagation();
                        }
                      );
                  }),
                  e
                );
              }),
              (l = function (p) {
                var h,
                  f,
                  e = [
                    "wheel",
                    "mousewheel",
                    "DOMMouseScroll",
                    "MozMousePixelScroll",
                  ],
                  t =
                    "onwheel" in document || 9 <= document.documentMode
                      ? ["wheel"]
                      : ["mousewheel", "DomMouseScroll", "MozMousePixelScroll"],
                  m = Array.prototype.slice;
                if (p.event.fixHooks)
                  for (var i = e.length; i; )
                    p.event.fixHooks[e[--i]] = p.event.mouseHooks;
                var g = (p.event.special.mousewheel = {
                  version: "3.1.12",
                  setup: function () {
                    if (this.addEventListener)
                      for (var e = t.length; e; )
                        this.addEventListener(t[--e], n, !1);
                    else this.onmousewheel = n;
                    p.data(
                      this,
                      "mousewheel-line-height",
                      g.getLineHeight(this)
                    ),
                      p.data(
                        this,
                        "mousewheel-page-height",
                        g.getPageHeight(this)
                      );
                  },
                  teardown: function () {
                    if (this.removeEventListener)
                      for (var e = t.length; e; )
                        this.removeEventListener(t[--e], n, !1);
                    else this.onmousewheel = null;
                    p.removeData(this, "mousewheel-line-height"),
                      p.removeData(this, "mousewheel-page-height");
                  },
                  getLineHeight: function (e) {
                    var t = p(e),
                      i =
                        t["offsetParent" in p.fn ? "offsetParent" : "parent"]();
                    return (
                      i.length || (i = p("body")),
                      parseInt(i.css("fontSize"), 10) ||
                        parseInt(t.css("fontSize"), 10) ||
                        16
                    );
                  },
                  getPageHeight: function (e) {
                    return p(e).height();
                  },
                  settings: { adjustOldDeltas: !0, normalizeOffset: !0 },
                });
                function n(e) {
                  var t,
                    i = e || window.event,
                    n = m.call(arguments, 1),
                    s = 0,
                    r = 0,
                    o = 0,
                    a = 0,
                    l = 0;
                  if (
                    (((e = p.event.fix(i)).type = "mousewheel"),
                    "detail" in i && (o = -1 * i.detail),
                    "wheelDelta" in i && (o = i.wheelDelta),
                    "wheelDeltaY" in i && (o = i.wheelDeltaY),
                    "wheelDeltaX" in i && (r = -1 * i.wheelDeltaX),
                    "axis" in i &&
                      i.axis === i.HORIZONTAL_AXIS &&
                      ((r = -1 * o), (o = 0)),
                    (s = 0 === o ? r : o),
                    "deltaY" in i && (s = o = -1 * i.deltaY),
                    "deltaX" in i && ((r = i.deltaX), 0 === o && (s = -1 * r)),
                    0 !== o || 0 !== r)
                  ) {
                    if (1 === i.deltaMode) {
                      var d = p.data(this, "mousewheel-line-height");
                      (s *= d), (o *= d), (r *= d);
                    } else if (2 === i.deltaMode) {
                      var c = p.data(this, "mousewheel-page-height");
                      (s *= c), (o *= c), (r *= c);
                    }
                    if (
                      ((t = Math.max(Math.abs(o), Math.abs(r))),
                      (!f || t < f) && y(i, (f = t)) && (f /= 40),
                      y(i, t) && ((s /= 40), (r /= 40), (o /= 40)),
                      (s = Math[1 <= s ? "floor" : "ceil"](s / f)),
                      (r = Math[1 <= r ? "floor" : "ceil"](r / f)),
                      (o = Math[1 <= o ? "floor" : "ceil"](o / f)),
                      g.settings.normalizeOffset && this.getBoundingClientRect)
                    ) {
                      var u = this.getBoundingClientRect();
                      (a = e.clientX - u.left), (l = e.clientY - u.top);
                    }
                    return (
                      (e.deltaX = r),
                      (e.deltaY = o),
                      (e.deltaFactor = f),
                      (e.offsetX = a),
                      (e.offsetY = l),
                      (e.deltaMode = 0),
                      n.unshift(e, s, r, o),
                      h && clearTimeout(h),
                      (h = setTimeout(v, 200)),
                      (p.event.dispatch || p.event.handle).apply(this, n)
                    );
                  }
                }
                function v() {
                  f = null;
                }
                function y(e, t) {
                  return (
                    g.settings.adjustOldDeltas &&
                    "mousewheel" === e.type &&
                    t % 120 == 0
                  );
                }
                p.fn.extend({
                  mousewheel: function (e) {
                    return e
                      ? this.bind("mousewheel", e)
                      : this.trigger("mousewheel");
                  },
                  unmousewheel: function (e) {
                    return this.unbind("mousewheel", e);
                  },
                });
              }),
              "function" == typeof e.define && e.define.amd
                ? e.define("jquery-mousewheel", ["jquery"], l)
                : "object" ==
                  ("undefined" == typeof exports
                    ? "undefined"
                    : _typeof(exports))
                ? (module.exports = l)
                : l(u),
              e.define(
                "jquery.select2",
                [
                  "jquery",
                  "jquery-mousewheel",
                  "./select2/core",
                  "./select2/defaults",
                  "./select2/utils",
                ],
                function (s, e, r, t, o) {
                  if (null == s.fn.select2) {
                    var a = ["open", "close", "destroy"];
                    s.fn.select2 = function (t) {
                      if ("object" == _typeof((t = t || {})))
                        return (
                          this.each(function () {
                            var e = s.extend(!0, {}, t);
                            new r(s(this), e);
                          }),
                          this
                        );
                      if ("string" != typeof t)
                        throw new Error("Invalid arguments for Select2: " + t);
                      var i,
                        n = Array.prototype.slice.call(arguments, 1);
                      return (
                        this.each(function () {
                          var e = o.GetData(this, "select2");
                          null == e &&
                            window.console &&
                            console.error &&
                            console.error(
                              "The select2('" +
                                t +
                                "') method was called on an element that is not using Select2."
                            ),
                            (i = e[t].apply(e, n));
                        }),
                        -1 < s.inArray(t, a) ? this : i
                      );
                    };
                  }
                  return (
                    null == s.fn.select2.defaults &&
                      (s.fn.select2.defaults = t),
                    r
                  );
                }
              ),
              { define: e.define, require: e.require }
            );
          })(),
          t = e.require("jquery.select2");
        return (u.fn.select2.amd = e), t;
      }),
      "object" ==
        ("undefined" == typeof module ? "undefined" : _typeof(module)) &&
      module.exports
        ? (module.exports = function (e, t) {
            return (
              void 0 === t &&
                (t =
                  "undefined" != typeof window
                    ? require("jquery")
                    : require("jquery")(e)),
              we(t),
              t
            );
          })
        : we(jQuery),
      (Se = p.event),
      (Ce = window.innerWidth),
      (xe = Se.special.debouncedresize =
        {
          setup: function () {
            p(this).on("resize", xe.handler);
          },
          teardown: function () {
            p(this).off("resize", xe.handler);
          },
          handler: function (e, t) {
            function i() {
              (e.type = "debouncedresize"),
                Se.dispatch.apply(n, s),
                Ce !== window.innerWidth &&
                  ((e.type = "debouncedresizewidth"),
                  Se.dispatch.apply(n, s),
                  (Ce = window.innerWidth));
            }
            var n = this,
              s = arguments;
            Te && clearTimeout(Te),
              t ? i() : (Te = setTimeout(i, xe.threshold));
          },
          threshold: 150,
        });
  })(theme.jQuery);
